import * as L from "react";
import ut, { createContext as Y1, useContext as G1, forwardRef as qi, memo as wc, useRef as Dy, useMemo as Yi, useEffect as zo, useState as Gi, useCallback as Ku, useLayoutEffect as jL, createElement as tC } from "react";
function Q1(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var nC = { exports: {} }, Jv = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZR;
function zL() {
  if (ZR) return Jv;
  ZR = 1;
  var a = ut, u = Symbol.for("react.element"), s = Symbol.for("react.fragment"), f = Object.prototype.hasOwnProperty, p = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(x, C, E) {
    var R, T = {}, O = null, N = null;
    E !== void 0 && (O = "" + E), C.key !== void 0 && (O = "" + C.key), C.ref !== void 0 && (N = C.ref);
    for (R in C) f.call(C, R) && !h.hasOwnProperty(R) && (T[R] = C[R]);
    if (x && x.defaultProps) for (R in C = x.defaultProps, C) T[R] === void 0 && (T[R] = C[R]);
    return { $$typeof: u, type: x, key: O, ref: N, props: T, _owner: p.current };
  }
  return Jv.Fragment = s, Jv.jsx = m, Jv.jsxs = m, Jv;
}
var eh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JR;
function IL() {
  return JR || (JR = 1, process.env.NODE_ENV !== "production" && function() {
    var a = ut, u = Symbol.for("react.element"), s = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), p = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), x = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), R = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), j = Symbol.iterator, k = "@@iterator";
    function A(H) {
      if (H === null || typeof H != "object")
        return null;
      var ye = j && H[j] || H[k];
      return typeof ye == "function" ? ye : null;
    }
    var z = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(H) {
      {
        for (var ye = arguments.length, Le = new Array(ye > 1 ? ye - 1 : 0), lt = 1; lt < ye; lt++)
          Le[lt - 1] = arguments[lt];
        I("error", H, Le);
      }
    }
    function I(H, ye, Le) {
      {
        var lt = z.ReactDebugCurrentFrame, St = lt.getStackAddendum();
        St !== "" && (ye += "%s", Le = Le.concat([St]));
        var ht = Le.map(function(_t) {
          return String(_t);
        });
        ht.unshift("Warning: " + ye), Function.prototype.apply.call(console[H], console, ht);
      }
    }
    var V = !1, B = !1, ae = !1, Z = !1, pe = !1, de;
    de = Symbol.for("react.module.reference");
    function me(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === f || H === h || pe || H === p || H === E || H === R || Z || H === N || V || B || ae || typeof H == "object" && H !== null && (H.$$typeof === O || H.$$typeof === T || H.$$typeof === m || H.$$typeof === x || H.$$typeof === C || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === de || H.getModuleId !== void 0));
    }
    function Te(H, ye, Le) {
      var lt = H.displayName;
      if (lt)
        return lt;
      var St = ye.displayName || ye.name || "";
      return St !== "" ? Le + "(" + St + ")" : Le;
    }
    function ve(H) {
      return H.displayName || "Context";
    }
    function ce(H) {
      if (H == null)
        return null;
      if (typeof H.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof H == "function")
        return H.displayName || H.name || null;
      if (typeof H == "string")
        return H;
      switch (H) {
        case f:
          return "Fragment";
        case s:
          return "Portal";
        case h:
          return "Profiler";
        case p:
          return "StrictMode";
        case E:
          return "Suspense";
        case R:
          return "SuspenseList";
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case x:
            var ye = H;
            return ve(ye) + ".Consumer";
          case m:
            var Le = H;
            return ve(Le._context) + ".Provider";
          case C:
            return Te(H, H.render, "ForwardRef");
          case T:
            var lt = H.displayName || null;
            return lt !== null ? lt : ce(H.type) || "Memo";
          case O: {
            var St = H, ht = St._payload, _t = St._init;
            try {
              return ce(_t(ht));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ee = Object.assign, Ue = 0, Re, Ke, oe, le, W, ie, we;
    function je() {
    }
    je.__reactDisabledLog = !0;
    function ke() {
      {
        if (Ue === 0) {
          Re = console.log, Ke = console.info, oe = console.warn, le = console.error, W = console.group, ie = console.groupCollapsed, we = console.groupEnd;
          var H = {
            configurable: !0,
            enumerable: !0,
            value: je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: H,
            log: H,
            warn: H,
            error: H,
            group: H,
            groupCollapsed: H,
            groupEnd: H
          });
        }
        Ue++;
      }
    }
    function et() {
      {
        if (Ue--, Ue === 0) {
          var H = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ee({}, H, {
              value: Re
            }),
            info: Ee({}, H, {
              value: Ke
            }),
            warn: Ee({}, H, {
              value: oe
            }),
            error: Ee({}, H, {
              value: le
            }),
            group: Ee({}, H, {
              value: W
            }),
            groupCollapsed: Ee({}, H, {
              value: ie
            }),
            groupEnd: Ee({}, H, {
              value: we
            })
          });
        }
        Ue < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = z.ReactCurrentDispatcher, Oe;
    function Me(H, ye, Le) {
      {
        if (Oe === void 0)
          try {
            throw Error();
          } catch (St) {
            var lt = St.stack.trim().match(/\n( *(at )?)/);
            Oe = lt && lt[1] || "";
          }
        return `
` + Oe + H;
      }
    }
    var Ie = !1, $e;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Qe();
    }
    function re(H, ye) {
      if (!H || Ie)
        return "";
      {
        var Le = $e.get(H);
        if (Le !== void 0)
          return Le;
      }
      var lt;
      Ie = !0;
      var St = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ht;
      ht = Pe.current, Pe.current = null, ke();
      try {
        if (ye) {
          var _t = function() {
            throw Error();
          };
          if (Object.defineProperty(_t.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_t, []);
            } catch (bt) {
              lt = bt;
            }
            Reflect.construct(H, [], _t);
          } else {
            try {
              _t.call();
            } catch (bt) {
              lt = bt;
            }
            H.call(_t.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            lt = bt;
          }
          H();
        }
      } catch (bt) {
        if (bt && lt && typeof bt.stack == "string") {
          for (var Rt = bt.stack.split(`
`), Bn = lt.stack.split(`
`), sn = Rt.length - 1, dn = Bn.length - 1; sn >= 1 && dn >= 0 && Rt[sn] !== Bn[dn]; )
            dn--;
          for (; sn >= 1 && dn >= 0; sn--, dn--)
            if (Rt[sn] !== Bn[dn]) {
              if (sn !== 1 || dn !== 1)
                do
                  if (sn--, dn--, dn < 0 || Rt[sn] !== Bn[dn]) {
                    var br = `
` + Rt[sn].replace(" at new ", " at ");
                    return H.displayName && br.includes("<anonymous>") && (br = br.replace("<anonymous>", H.displayName)), typeof H == "function" && $e.set(H, br), br;
                  }
                while (sn >= 1 && dn >= 0);
              break;
            }
        }
      } finally {
        Ie = !1, Pe.current = ht, et(), Error.prepareStackTrace = St;
      }
      var Ra = H ? H.displayName || H.name : "", _a = Ra ? Me(Ra) : "";
      return typeof H == "function" && $e.set(H, _a), _a;
    }
    function qe(H, ye, Le) {
      return re(H, !1);
    }
    function vt(H) {
      var ye = H.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function Tt(H, ye, Le) {
      if (H == null)
        return "";
      if (typeof H == "function")
        return re(H, vt(H));
      if (typeof H == "string")
        return Me(H);
      switch (H) {
        case E:
          return Me("Suspense");
        case R:
          return Me("SuspenseList");
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case C:
            return qe(H.render);
          case T:
            return Tt(H.type, ye, Le);
          case O: {
            var lt = H, St = lt._payload, ht = lt._init;
            try {
              return Tt(ht(St), ye, Le);
            } catch {
            }
          }
        }
      return "";
    }
    var $t = Object.prototype.hasOwnProperty, xn = {}, Gn = z.ReactDebugCurrentFrame;
    function ln(H) {
      if (H) {
        var ye = H._owner, Le = Tt(H.type, H._source, ye ? ye.type : null);
        Gn.setExtraStackFrame(Le);
      } else
        Gn.setExtraStackFrame(null);
    }
    function er(H, ye, Le, lt, St) {
      {
        var ht = Function.call.bind($t);
        for (var _t in H)
          if (ht(H, _t)) {
            var Rt = void 0;
            try {
              if (typeof H[_t] != "function") {
                var Bn = Error((lt || "React class") + ": " + Le + " type `" + _t + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[_t] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Bn.name = "Invariant Violation", Bn;
              }
              Rt = H[_t](ye, _t, lt, Le, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (sn) {
              Rt = sn;
            }
            Rt && !(Rt instanceof Error) && (ln(St), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", lt || "React class", Le, _t, typeof Rt), ln(null)), Rt instanceof Error && !(Rt.message in xn) && (xn[Rt.message] = !0, ln(St), F("Failed %s type: %s", Le, Rt.message), ln(null));
          }
      }
    }
    var Sn = Array.isArray;
    function Dn(H) {
      return Sn(H);
    }
    function tr(H) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, Le = ye && H[Symbol.toStringTag] || H.constructor.name || "Object";
        return Le;
      }
    }
    function Io(H) {
      try {
        return Fn(H), !1;
      } catch {
        return !0;
      }
    }
    function Fn(H) {
      return "" + H;
    }
    function xr(H) {
      if (Io(H))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tr(H)), Fn(H);
    }
    var eo = z.ReactCurrentOwner, Uo = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mo, _e;
    function Ze(H) {
      if ($t.call(H, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(H, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return H.ref !== void 0;
    }
    function gt(H) {
      if ($t.call(H, "key")) {
        var ye = Object.getOwnPropertyDescriptor(H, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return H.key !== void 0;
    }
    function At(H, ye) {
      typeof H.ref == "string" && eo.current;
    }
    function en(H, ye) {
      {
        var Le = function() {
          mo || (mo = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Le.isReactWarning = !0, Object.defineProperty(H, "key", {
          get: Le,
          configurable: !0
        });
      }
    }
    function Qn(H, ye) {
      {
        var Le = function() {
          _e || (_e = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Le.isReactWarning = !0, Object.defineProperty(H, "ref", {
          get: Le,
          configurable: !0
        });
      }
    }
    var un = function(H, ye, Le, lt, St, ht, _t) {
      var Rt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: u,
        // Built-in properties that belong on the element
        type: H,
        key: ye,
        ref: Le,
        props: _t,
        // Record the component responsible for creating this element.
        _owner: ht
      };
      return Rt._store = {}, Object.defineProperty(Rt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Rt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: lt
      }), Object.defineProperty(Rt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: St
      }), Object.freeze && (Object.freeze(Rt.props), Object.freeze(Rt)), Rt;
    };
    function Kn(H, ye, Le, lt, St) {
      {
        var ht, _t = {}, Rt = null, Bn = null;
        Le !== void 0 && (xr(Le), Rt = "" + Le), gt(ye) && (xr(ye.key), Rt = "" + ye.key), Ze(ye) && (Bn = ye.ref, At(ye, St));
        for (ht in ye)
          $t.call(ye, ht) && !Uo.hasOwnProperty(ht) && (_t[ht] = ye[ht]);
        if (H && H.defaultProps) {
          var sn = H.defaultProps;
          for (ht in sn)
            _t[ht] === void 0 && (_t[ht] = sn[ht]);
        }
        if (Rt || Bn) {
          var dn = typeof H == "function" ? H.displayName || H.name || "Unknown" : H;
          Rt && en(_t, dn), Bn && Qn(_t, dn);
        }
        return un(H, Rt, Bn, St, lt, eo.current, _t);
      }
    }
    var tn = z.ReactCurrentOwner, Yt = z.ReactDebugCurrentFrame;
    function Gt(H) {
      if (H) {
        var ye = H._owner, Le = Tt(H.type, H._source, ye ? ye.type : null);
        Yt.setExtraStackFrame(Le);
      } else
        Yt.setExtraStackFrame(null);
    }
    var to;
    to = !1;
    function Sr(H) {
      return typeof H == "object" && H !== null && H.$$typeof === u;
    }
    function ta() {
      {
        if (tn.current) {
          var H = ce(tn.current.type);
          if (H)
            return `

Check the render method of \`` + H + "`.";
        }
        return "";
      }
    }
    function Jl(H) {
      return "";
    }
    var li = {};
    function Ji(H) {
      {
        var ye = ta();
        if (!ye) {
          var Le = typeof H == "string" ? H : H.displayName || H.name;
          Le && (ye = `

Check the top-level render call using <` + Le + ">.");
        }
        return ye;
      }
    }
    function eu(H, ye) {
      {
        if (!H._store || H._store.validated || H.key != null)
          return;
        H._store.validated = !0;
        var Le = Ji(ye);
        if (li[Le])
          return;
        li[Le] = !0;
        var lt = "";
        H && H._owner && H._owner !== tn.current && (lt = " It was passed a child from " + ce(H._owner.type) + "."), Gt(H), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Le, lt), Gt(null);
      }
    }
    function tu(H, ye) {
      {
        if (typeof H != "object")
          return;
        if (Dn(H))
          for (var Le = 0; Le < H.length; Le++) {
            var lt = H[Le];
            Sr(lt) && eu(lt, ye);
          }
        else if (Sr(H))
          H._store && (H._store.validated = !0);
        else if (H) {
          var St = A(H);
          if (typeof St == "function" && St !== H.entries)
            for (var ht = St.call(H), _t; !(_t = ht.next()).done; )
              Sr(_t.value) && eu(_t.value, ye);
        }
      }
    }
    function ts(H) {
      {
        var ye = H.type;
        if (ye == null || typeof ye == "string")
          return;
        var Le;
        if (typeof ye == "function")
          Le = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === C || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === T))
          Le = ye.propTypes;
        else
          return;
        if (Le) {
          var lt = ce(ye);
          er(Le, H.props, "prop", lt, H);
        } else if (ye.PropTypes !== void 0 && !to) {
          to = !0;
          var St = ce(ye);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", St || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function wa(H) {
      {
        for (var ye = Object.keys(H.props), Le = 0; Le < ye.length; Le++) {
          var lt = ye[Le];
          if (lt !== "children" && lt !== "key") {
            Gt(H), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", lt), Gt(null);
            break;
          }
        }
        H.ref !== null && (Gt(H), F("Invalid attribute `ref` supplied to `React.Fragment`."), Gt(null));
      }
    }
    var Fo = {};
    function jr(H, ye, Le, lt, St, ht) {
      {
        var _t = me(H);
        if (!_t) {
          var Rt = "";
          (H === void 0 || typeof H == "object" && H !== null && Object.keys(H).length === 0) && (Rt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Bn = Jl();
          Bn ? Rt += Bn : Rt += ta();
          var sn;
          H === null ? sn = "null" : Dn(H) ? sn = "array" : H !== void 0 && H.$$typeof === u ? (sn = "<" + (ce(H.type) || "Unknown") + " />", Rt = " Did you accidentally export a JSX literal instead of a component?") : sn = typeof H, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", sn, Rt);
        }
        var dn = Kn(H, ye, Le, St, ht);
        if (dn == null)
          return dn;
        if (_t) {
          var br = ye.children;
          if (br !== void 0)
            if (lt)
              if (Dn(br)) {
                for (var Ra = 0; Ra < br.length; Ra++)
                  tu(br[Ra], H);
                Object.freeze && Object.freeze(br);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              tu(br, H);
        }
        if ($t.call(ye, "key")) {
          var _a = ce(H), bt = Object.keys(ye).filter(function(ns) {
            return ns !== "key";
          }), Ct = bt.length > 0 ? "{key: someKey, " + bt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Fo[_a + Ct]) {
            var Oa = bt.length > 0 ? "{" + bt.join(": ..., ") + ": ...}" : "{}";
            F(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ct, _a, Oa, _a), Fo[_a + Ct] = !0;
          }
        }
        return H === f ? wa(dn) : ts(dn), dn;
      }
    }
    function ui(H, ye, Le) {
      return jr(H, ye, Le, !0);
    }
    function Ta(H, ye, Le) {
      return jr(H, ye, Le, !1);
    }
    var si = Ta, ci = ui;
    eh.Fragment = f, eh.jsx = si, eh.jsxs = ci;
  }()), eh;
}
process.env.NODE_ENV === "production" ? nC.exports = zL() : nC.exports = IL();
var D = nC.exports;
const UL = (a) => /* @__PURE__ */ D.jsx("div", { ...a, className: `ui-flex ui-items-center ui-justify-center ${a.className}`, children: "₹" });
var Td = /* @__PURE__ */ ((a) => (a.REGULAR = "REGULAR", a.MEDIUM = "MEDIUM", a.LARGE = "LARGE", a))(Td || {}), Gl = /* @__PURE__ */ ((a) => (a.COUNT_BASED = "COUNT_BASED", a.PRICE_BASED = "PRICE_BASED", a))(Gl || {}), Sc = /* @__PURE__ */ ((a) => (a.STATIC = "STATIC", a.DYNAMIC = "DYNAMIC", a))(Sc || {});
const gy = {
  FREEBIE: "FREEBIE",
  FREE_SHIPPING: "FREE_SHIPPING",
  PERCENT_OFF: "PERCENT_OFF",
  FLAT_OFF: "FLAT_OFF"
}, K1 = Y1({
  milestones: [],
  total: 0,
  achievedMilestoneIdx: 0,
  totalMilestones: 0,
  currentProgress: 0,
  customizations: {
    type: Sc.DYNAMIC,
    category: Gl.PRICE_BASED,
    completedMessage: "",
    completedMessage_enabled: !1,
    textonProgressBar_header: !1,
    textonProgressBar_amount: !1,
    textonProgressBar_title: !1,
    textonProgressBar_headerColor: "#2c874a",
    textonProgressBar_amountColor: "#2c874a",
    textonProgressBar_titleColor: "#2c874a",
    width: Td.REGULAR,
    filledColor: "#2c874a",
    emptyColor: "#ffffff"
  }
}), FL = ({
  children: a,
  milestones: u,
  achievedMilestoneIdx: s = 1,
  totalMilestones: f,
  currentProgress: p,
  total: h,
  customizations: m,
  onMilestoneReached: x
}) => /* @__PURE__ */ D.jsx(
  K1.Provider,
  {
    value: {
      achievedMilestoneIdx: s,
      totalMilestones: f,
      currentProgress: p,
      milestones: u,
      total: h,
      customizations: m,
      onMilestoneReached: x
    },
    children: a
  }
), Ad = () => {
  const a = G1(K1);
  if (!a)
    throw new Error("useProgressBar must be used within a ProgressBarProvider");
  return a;
};
var rC = { exports: {} }, yy = { exports: {} }, Xt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e1;
function BL() {
  if (e1) return Xt;
  e1 = 1;
  var a = typeof Symbol == "function" && Symbol.for, u = a ? Symbol.for("react.element") : 60103, s = a ? Symbol.for("react.portal") : 60106, f = a ? Symbol.for("react.fragment") : 60107, p = a ? Symbol.for("react.strict_mode") : 60108, h = a ? Symbol.for("react.profiler") : 60114, m = a ? Symbol.for("react.provider") : 60109, x = a ? Symbol.for("react.context") : 60110, C = a ? Symbol.for("react.async_mode") : 60111, E = a ? Symbol.for("react.concurrent_mode") : 60111, R = a ? Symbol.for("react.forward_ref") : 60112, T = a ? Symbol.for("react.suspense") : 60113, O = a ? Symbol.for("react.suspense_list") : 60120, N = a ? Symbol.for("react.memo") : 60115, j = a ? Symbol.for("react.lazy") : 60116, k = a ? Symbol.for("react.block") : 60121, A = a ? Symbol.for("react.fundamental") : 60117, z = a ? Symbol.for("react.responder") : 60118, F = a ? Symbol.for("react.scope") : 60119;
  function I(B) {
    if (typeof B == "object" && B !== null) {
      var ae = B.$$typeof;
      switch (ae) {
        case u:
          switch (B = B.type, B) {
            case C:
            case E:
            case f:
            case h:
            case p:
            case T:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case x:
                case R:
                case j:
                case N:
                case m:
                  return B;
                default:
                  return ae;
              }
          }
        case s:
          return ae;
      }
    }
  }
  function V(B) {
    return I(B) === E;
  }
  return Xt.AsyncMode = C, Xt.ConcurrentMode = E, Xt.ContextConsumer = x, Xt.ContextProvider = m, Xt.Element = u, Xt.ForwardRef = R, Xt.Fragment = f, Xt.Lazy = j, Xt.Memo = N, Xt.Portal = s, Xt.Profiler = h, Xt.StrictMode = p, Xt.Suspense = T, Xt.isAsyncMode = function(B) {
    return V(B) || I(B) === C;
  }, Xt.isConcurrentMode = V, Xt.isContextConsumer = function(B) {
    return I(B) === x;
  }, Xt.isContextProvider = function(B) {
    return I(B) === m;
  }, Xt.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === u;
  }, Xt.isForwardRef = function(B) {
    return I(B) === R;
  }, Xt.isFragment = function(B) {
    return I(B) === f;
  }, Xt.isLazy = function(B) {
    return I(B) === j;
  }, Xt.isMemo = function(B) {
    return I(B) === N;
  }, Xt.isPortal = function(B) {
    return I(B) === s;
  }, Xt.isProfiler = function(B) {
    return I(B) === h;
  }, Xt.isStrictMode = function(B) {
    return I(B) === p;
  }, Xt.isSuspense = function(B) {
    return I(B) === T;
  }, Xt.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === f || B === E || B === h || B === p || B === T || B === O || typeof B == "object" && B !== null && (B.$$typeof === j || B.$$typeof === N || B.$$typeof === m || B.$$typeof === x || B.$$typeof === R || B.$$typeof === A || B.$$typeof === z || B.$$typeof === F || B.$$typeof === k);
  }, Xt.typeOf = I, Xt;
}
var Zt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t1;
function HL() {
  return t1 || (t1 = 1, process.env.NODE_ENV !== "production" && function() {
    var a = typeof Symbol == "function" && Symbol.for, u = a ? Symbol.for("react.element") : 60103, s = a ? Symbol.for("react.portal") : 60106, f = a ? Symbol.for("react.fragment") : 60107, p = a ? Symbol.for("react.strict_mode") : 60108, h = a ? Symbol.for("react.profiler") : 60114, m = a ? Symbol.for("react.provider") : 60109, x = a ? Symbol.for("react.context") : 60110, C = a ? Symbol.for("react.async_mode") : 60111, E = a ? Symbol.for("react.concurrent_mode") : 60111, R = a ? Symbol.for("react.forward_ref") : 60112, T = a ? Symbol.for("react.suspense") : 60113, O = a ? Symbol.for("react.suspense_list") : 60120, N = a ? Symbol.for("react.memo") : 60115, j = a ? Symbol.for("react.lazy") : 60116, k = a ? Symbol.for("react.block") : 60121, A = a ? Symbol.for("react.fundamental") : 60117, z = a ? Symbol.for("react.responder") : 60118, F = a ? Symbol.for("react.scope") : 60119;
    function I(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === f || re === E || re === h || re === p || re === T || re === O || typeof re == "object" && re !== null && (re.$$typeof === j || re.$$typeof === N || re.$$typeof === m || re.$$typeof === x || re.$$typeof === R || re.$$typeof === A || re.$$typeof === z || re.$$typeof === F || re.$$typeof === k);
    }
    function V(re) {
      if (typeof re == "object" && re !== null) {
        var qe = re.$$typeof;
        switch (qe) {
          case u:
            var vt = re.type;
            switch (vt) {
              case C:
              case E:
              case f:
              case h:
              case p:
              case T:
                return vt;
              default:
                var Tt = vt && vt.$$typeof;
                switch (Tt) {
                  case x:
                  case R:
                  case j:
                  case N:
                  case m:
                    return Tt;
                  default:
                    return qe;
                }
            }
          case s:
            return qe;
        }
      }
    }
    var B = C, ae = E, Z = x, pe = m, de = u, me = R, Te = f, ve = j, ce = N, Ee = s, Ue = h, Re = p, Ke = T, oe = !1;
    function le(re) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(re) || V(re) === C;
    }
    function W(re) {
      return V(re) === E;
    }
    function ie(re) {
      return V(re) === x;
    }
    function we(re) {
      return V(re) === m;
    }
    function je(re) {
      return typeof re == "object" && re !== null && re.$$typeof === u;
    }
    function ke(re) {
      return V(re) === R;
    }
    function et(re) {
      return V(re) === f;
    }
    function Pe(re) {
      return V(re) === j;
    }
    function Oe(re) {
      return V(re) === N;
    }
    function Me(re) {
      return V(re) === s;
    }
    function Ie(re) {
      return V(re) === h;
    }
    function $e(re) {
      return V(re) === p;
    }
    function Qe(re) {
      return V(re) === T;
    }
    Zt.AsyncMode = B, Zt.ConcurrentMode = ae, Zt.ContextConsumer = Z, Zt.ContextProvider = pe, Zt.Element = de, Zt.ForwardRef = me, Zt.Fragment = Te, Zt.Lazy = ve, Zt.Memo = ce, Zt.Portal = Ee, Zt.Profiler = Ue, Zt.StrictMode = Re, Zt.Suspense = Ke, Zt.isAsyncMode = le, Zt.isConcurrentMode = W, Zt.isContextConsumer = ie, Zt.isContextProvider = we, Zt.isElement = je, Zt.isForwardRef = ke, Zt.isFragment = et, Zt.isLazy = Pe, Zt.isMemo = Oe, Zt.isPortal = Me, Zt.isProfiler = Ie, Zt.isStrictMode = $e, Zt.isSuspense = Qe, Zt.isValidElementType = I, Zt.typeOf = V;
  }()), Zt;
}
var n1;
function q1() {
  return n1 || (n1 = 1, process.env.NODE_ENV === "production" ? yy.exports = BL() : yy.exports = HL()), yy.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var j0, r1;
function $L() {
  if (r1) return j0;
  r1 = 1;
  var a = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function f(h) {
    if (h == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(h);
  }
  function p() {
    try {
      if (!Object.assign)
        return !1;
      var h = new String("abc");
      if (h[5] = "de", Object.getOwnPropertyNames(h)[0] === "5")
        return !1;
      for (var m = {}, x = 0; x < 10; x++)
        m["_" + String.fromCharCode(x)] = x;
      var C = Object.getOwnPropertyNames(m).map(function(R) {
        return m[R];
      });
      if (C.join("") !== "0123456789")
        return !1;
      var E = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(R) {
        E[R] = R;
      }), Object.keys(Object.assign({}, E)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return j0 = p() ? Object.assign : function(h, m) {
    for (var x, C = f(h), E, R = 1; R < arguments.length; R++) {
      x = Object(arguments[R]);
      for (var T in x)
        u.call(x, T) && (C[T] = x[T]);
      if (a) {
        E = a(x);
        for (var O = 0; O < E.length; O++)
          s.call(x, E[O]) && (C[E[O]] = x[E[O]]);
      }
    }
    return C;
  }, j0;
}
var z0, o1;
function RC() {
  if (o1) return z0;
  o1 = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return z0 = a, z0;
}
var I0, a1;
function X1() {
  return a1 || (a1 = 1, I0 = Function.call.bind(Object.prototype.hasOwnProperty)), I0;
}
var U0, i1;
function VL() {
  if (i1) return U0;
  i1 = 1;
  var a = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var u = RC(), s = {}, f = X1();
    a = function(h) {
      var m = "Warning: " + h;
      typeof console < "u" && console.error(m);
      try {
        throw new Error(m);
      } catch {
      }
    };
  }
  function p(h, m, x, C, E) {
    if (process.env.NODE_ENV !== "production") {
      for (var R in h)
        if (f(h, R)) {
          var T;
          try {
            if (typeof h[R] != "function") {
              var O = Error(
                (C || "React class") + ": " + x + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw O.name = "Invariant Violation", O;
            }
            T = h[R](m, R, C, x, null, u);
          } catch (j) {
            T = j;
          }
          if (T && !(T instanceof Error) && a(
            (C || "React class") + ": type specification of " + x + " `" + R + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof T + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), T instanceof Error && !(T.message in s)) {
            s[T.message] = !0;
            var N = E ? E() : "";
            a(
              "Failed " + x + " type: " + T.message + (N ?? "")
            );
          }
        }
    }
  }
  return p.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (s = {});
  }, U0 = p, U0;
}
var F0, l1;
function WL() {
  if (l1) return F0;
  l1 = 1;
  var a = q1(), u = $L(), s = RC(), f = X1(), p = VL(), h = function() {
  };
  process.env.NODE_ENV !== "production" && (h = function(x) {
    var C = "Warning: " + x;
    typeof console < "u" && console.error(C);
    try {
      throw new Error(C);
    } catch {
    }
  });
  function m() {
    return null;
  }
  return F0 = function(x, C) {
    var E = typeof Symbol == "function" && Symbol.iterator, R = "@@iterator";
    function T(W) {
      var ie = W && (E && W[E] || W[R]);
      if (typeof ie == "function")
        return ie;
    }
    var O = "<<anonymous>>", N = {
      array: z("array"),
      bigint: z("bigint"),
      bool: z("boolean"),
      func: z("function"),
      number: z("number"),
      object: z("object"),
      string: z("string"),
      symbol: z("symbol"),
      any: F(),
      arrayOf: I,
      element: V(),
      elementType: B(),
      instanceOf: ae,
      node: me(),
      objectOf: pe,
      oneOf: Z,
      oneOfType: de,
      shape: ve,
      exact: ce
    };
    function j(W, ie) {
      return W === ie ? W !== 0 || 1 / W === 1 / ie : W !== W && ie !== ie;
    }
    function k(W, ie) {
      this.message = W, this.data = ie && typeof ie == "object" ? ie : {}, this.stack = "";
    }
    k.prototype = Error.prototype;
    function A(W) {
      if (process.env.NODE_ENV !== "production")
        var ie = {}, we = 0;
      function je(et, Pe, Oe, Me, Ie, $e, Qe) {
        if (Me = Me || O, $e = $e || Oe, Qe !== s) {
          if (C) {
            var re = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw re.name = "Invariant Violation", re;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var qe = Me + ":" + Oe;
            !ie[qe] && // Avoid spamming the console because they are often not actionable except for lib authors
            we < 3 && (h(
              "You are manually calling a React.PropTypes validation function for the `" + $e + "` prop on `" + Me + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ie[qe] = !0, we++);
          }
        }
        return Pe[Oe] == null ? et ? Pe[Oe] === null ? new k("The " + Ie + " `" + $e + "` is marked as required " + ("in `" + Me + "`, but its value is `null`.")) : new k("The " + Ie + " `" + $e + "` is marked as required in " + ("`" + Me + "`, but its value is `undefined`.")) : null : W(Pe, Oe, Me, Ie, $e);
      }
      var ke = je.bind(null, !1);
      return ke.isRequired = je.bind(null, !0), ke;
    }
    function z(W) {
      function ie(we, je, ke, et, Pe, Oe) {
        var Me = we[je], Ie = Re(Me);
        if (Ie !== W) {
          var $e = Ke(Me);
          return new k(
            "Invalid " + et + " `" + Pe + "` of type " + ("`" + $e + "` supplied to `" + ke + "`, expected ") + ("`" + W + "`."),
            { expectedType: W }
          );
        }
        return null;
      }
      return A(ie);
    }
    function F() {
      return A(m);
    }
    function I(W) {
      function ie(we, je, ke, et, Pe) {
        if (typeof W != "function")
          return new k("Property `" + Pe + "` of component `" + ke + "` has invalid PropType notation inside arrayOf.");
        var Oe = we[je];
        if (!Array.isArray(Oe)) {
          var Me = Re(Oe);
          return new k("Invalid " + et + " `" + Pe + "` of type " + ("`" + Me + "` supplied to `" + ke + "`, expected an array."));
        }
        for (var Ie = 0; Ie < Oe.length; Ie++) {
          var $e = W(Oe, Ie, ke, et, Pe + "[" + Ie + "]", s);
          if ($e instanceof Error)
            return $e;
        }
        return null;
      }
      return A(ie);
    }
    function V() {
      function W(ie, we, je, ke, et) {
        var Pe = ie[we];
        if (!x(Pe)) {
          var Oe = Re(Pe);
          return new k("Invalid " + ke + " `" + et + "` of type " + ("`" + Oe + "` supplied to `" + je + "`, expected a single ReactElement."));
        }
        return null;
      }
      return A(W);
    }
    function B() {
      function W(ie, we, je, ke, et) {
        var Pe = ie[we];
        if (!a.isValidElementType(Pe)) {
          var Oe = Re(Pe);
          return new k("Invalid " + ke + " `" + et + "` of type " + ("`" + Oe + "` supplied to `" + je + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return A(W);
    }
    function ae(W) {
      function ie(we, je, ke, et, Pe) {
        if (!(we[je] instanceof W)) {
          var Oe = W.name || O, Me = le(we[je]);
          return new k("Invalid " + et + " `" + Pe + "` of type " + ("`" + Me + "` supplied to `" + ke + "`, expected ") + ("instance of `" + Oe + "`."));
        }
        return null;
      }
      return A(ie);
    }
    function Z(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? h(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : h("Invalid argument supplied to oneOf, expected an array.")), m;
      function ie(we, je, ke, et, Pe) {
        for (var Oe = we[je], Me = 0; Me < W.length; Me++)
          if (j(Oe, W[Me]))
            return null;
        var Ie = JSON.stringify(W, function(Qe, re) {
          var qe = Ke(re);
          return qe === "symbol" ? String(re) : re;
        });
        return new k("Invalid " + et + " `" + Pe + "` of value `" + String(Oe) + "` " + ("supplied to `" + ke + "`, expected one of " + Ie + "."));
      }
      return A(ie);
    }
    function pe(W) {
      function ie(we, je, ke, et, Pe) {
        if (typeof W != "function")
          return new k("Property `" + Pe + "` of component `" + ke + "` has invalid PropType notation inside objectOf.");
        var Oe = we[je], Me = Re(Oe);
        if (Me !== "object")
          return new k("Invalid " + et + " `" + Pe + "` of type " + ("`" + Me + "` supplied to `" + ke + "`, expected an object."));
        for (var Ie in Oe)
          if (f(Oe, Ie)) {
            var $e = W(Oe, Ie, ke, et, Pe + "." + Ie, s);
            if ($e instanceof Error)
              return $e;
          }
        return null;
      }
      return A(ie);
    }
    function de(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && h("Invalid argument supplied to oneOfType, expected an instance of array."), m;
      for (var ie = 0; ie < W.length; ie++) {
        var we = W[ie];
        if (typeof we != "function")
          return h(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(we) + " at index " + ie + "."
          ), m;
      }
      function je(ke, et, Pe, Oe, Me) {
        for (var Ie = [], $e = 0; $e < W.length; $e++) {
          var Qe = W[$e], re = Qe(ke, et, Pe, Oe, Me, s);
          if (re == null)
            return null;
          re.data && f(re.data, "expectedType") && Ie.push(re.data.expectedType);
        }
        var qe = Ie.length > 0 ? ", expected one of type [" + Ie.join(", ") + "]" : "";
        return new k("Invalid " + Oe + " `" + Me + "` supplied to " + ("`" + Pe + "`" + qe + "."));
      }
      return A(je);
    }
    function me() {
      function W(ie, we, je, ke, et) {
        return Ee(ie[we]) ? null : new k("Invalid " + ke + " `" + et + "` supplied to " + ("`" + je + "`, expected a ReactNode."));
      }
      return A(W);
    }
    function Te(W, ie, we, je, ke) {
      return new k(
        (W || "React class") + ": " + ie + " type `" + we + "." + je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ke + "`."
      );
    }
    function ve(W) {
      function ie(we, je, ke, et, Pe) {
        var Oe = we[je], Me = Re(Oe);
        if (Me !== "object")
          return new k("Invalid " + et + " `" + Pe + "` of type `" + Me + "` " + ("supplied to `" + ke + "`, expected `object`."));
        for (var Ie in W) {
          var $e = W[Ie];
          if (typeof $e != "function")
            return Te(ke, et, Pe, Ie, Ke($e));
          var Qe = $e(Oe, Ie, ke, et, Pe + "." + Ie, s);
          if (Qe)
            return Qe;
        }
        return null;
      }
      return A(ie);
    }
    function ce(W) {
      function ie(we, je, ke, et, Pe) {
        var Oe = we[je], Me = Re(Oe);
        if (Me !== "object")
          return new k("Invalid " + et + " `" + Pe + "` of type `" + Me + "` " + ("supplied to `" + ke + "`, expected `object`."));
        var Ie = u({}, we[je], W);
        for (var $e in Ie) {
          var Qe = W[$e];
          if (f(W, $e) && typeof Qe != "function")
            return Te(ke, et, Pe, $e, Ke(Qe));
          if (!Qe)
            return new k(
              "Invalid " + et + " `" + Pe + "` key `" + $e + "` supplied to `" + ke + "`.\nBad object: " + JSON.stringify(we[je], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(W), null, "  ")
            );
          var re = Qe(Oe, $e, ke, et, Pe + "." + $e, s);
          if (re)
            return re;
        }
        return null;
      }
      return A(ie);
    }
    function Ee(W) {
      switch (typeof W) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !W;
        case "object":
          if (Array.isArray(W))
            return W.every(Ee);
          if (W === null || x(W))
            return !0;
          var ie = T(W);
          if (ie) {
            var we = ie.call(W), je;
            if (ie !== W.entries) {
              for (; !(je = we.next()).done; )
                if (!Ee(je.value))
                  return !1;
            } else
              for (; !(je = we.next()).done; ) {
                var ke = je.value;
                if (ke && !Ee(ke[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Ue(W, ie) {
      return W === "symbol" ? !0 : ie ? ie["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ie instanceof Symbol : !1;
    }
    function Re(W) {
      var ie = typeof W;
      return Array.isArray(W) ? "array" : W instanceof RegExp ? "object" : Ue(ie, W) ? "symbol" : ie;
    }
    function Ke(W) {
      if (typeof W > "u" || W === null)
        return "" + W;
      var ie = Re(W);
      if (ie === "object") {
        if (W instanceof Date)
          return "date";
        if (W instanceof RegExp)
          return "regexp";
      }
      return ie;
    }
    function oe(W) {
      var ie = Ke(W);
      switch (ie) {
        case "array":
        case "object":
          return "an " + ie;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ie;
        default:
          return ie;
      }
    }
    function le(W) {
      return !W.constructor || !W.constructor.name ? O : W.constructor.name;
    }
    return N.checkPropTypes = p, N.resetWarningCache = p.resetWarningCache, N.PropTypes = N, N;
  }, F0;
}
var B0, u1;
function YL() {
  if (u1) return B0;
  u1 = 1;
  var a = RC();
  function u() {
  }
  function s() {
  }
  return s.resetWarningCache = u, B0 = function() {
    function f(m, x, C, E, R, T) {
      if (T !== a) {
        var O = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw O.name = "Invariant Violation", O;
      }
    }
    f.isRequired = f;
    function p() {
      return f;
    }
    var h = {
      array: f,
      bigint: f,
      bool: f,
      func: f,
      number: f,
      object: f,
      string: f,
      symbol: f,
      any: f,
      arrayOf: p,
      element: f,
      elementType: f,
      instanceOf: p,
      node: f,
      objectOf: p,
      oneOf: p,
      oneOfType: p,
      shape: p,
      exact: p,
      checkPropTypes: s,
      resetWarningCache: u
    };
    return h.PropTypes = h, h;
  }, B0;
}
if (process.env.NODE_ENV !== "production") {
  var GL = q1(), QL = !0;
  rC.exports = WL()(GL.isElement, QL);
} else
  rC.exports = YL()();
var KL = rC.exports;
const Ht = /* @__PURE__ */ Q1(KL);
function oC() {
  return oC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, oC.apply(this, arguments);
}
function qL(a, u) {
  if (a == null) return {};
  var s = XL(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function XL(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var _C = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = qL(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", oC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
_C.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
_C.displayName = "Check";
function aC() {
  return aC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, aC.apply(this, arguments);
}
function ZL(a, u) {
  if (a == null) return {};
  var s = JL(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function JL(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var By = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = ZL(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", aC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
});
By.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
By.displayName = "ChevronLeft";
function iC() {
  return iC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, iC.apply(this, arguments);
}
function ej(a, u) {
  if (a == null) return {};
  var s = tj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function tj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var Hy = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = ej(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", iC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
});
Hy.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
Hy.displayName = "ChevronRight";
function lC() {
  return lC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, lC.apply(this, arguments);
}
function nj(a, u) {
  if (a == null) return {};
  var s = rj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function rj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var OC = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = nj(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", lC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ ut.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
OC.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
OC.displayName = "Copy";
function uC() {
  return uC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, uC.apply(this, arguments);
}
function oj(a, u) {
  if (a == null) return {};
  var s = aj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function aj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var $y = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = oj(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", uC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), /* @__PURE__ */ ut.createElement("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "5"
  }), /* @__PURE__ */ ut.createElement("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "7"
  }), /* @__PURE__ */ ut.createElement("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), /* @__PURE__ */ ut.createElement("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  }));
});
$y.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
$y.displayName = "Gift";
function sC() {
  return sC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, sC.apply(this, arguments);
}
function ij(a, u) {
  if (a == null) return {};
  var s = lj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function lj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var DC = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = ij(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", sC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("line", {
    x1: "19",
    y1: "5",
    x2: "5",
    y2: "19"
  }), /* @__PURE__ */ ut.createElement("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "2.5"
  }), /* @__PURE__ */ ut.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "2.5"
  }));
});
DC.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
DC.displayName = "Percent";
function cC() {
  return cC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, cC.apply(this, arguments);
}
function uj(a, u) {
  if (a == null) return {};
  var s = sj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function sj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var kC = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = uj(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", cC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("rect", {
    x: "1",
    y: "3",
    width: "15",
    height: "13"
  }), /* @__PURE__ */ ut.createElement("polygon", {
    points: "16 8 20 8 23 11 23 16 16 16 16 8"
  }), /* @__PURE__ */ ut.createElement("circle", {
    cx: "5.5",
    cy: "18.5",
    r: "2.5"
  }), /* @__PURE__ */ ut.createElement("circle", {
    cx: "18.5",
    cy: "18.5",
    r: "2.5"
  }));
});
kC.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
kC.displayName = "Truck";
function fC() {
  return fC = Object.assign || function(a) {
    for (var u = 1; u < arguments.length; u++) {
      var s = arguments[u];
      for (var f in s)
        Object.prototype.hasOwnProperty.call(s, f) && (a[f] = s[f]);
    }
    return a;
  }, fC.apply(this, arguments);
}
function cj(a, u) {
  if (a == null) return {};
  var s = fj(a, u), f, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      f = h[p], !(u.indexOf(f) >= 0) && Object.prototype.propertyIsEnumerable.call(a, f) && (s[f] = a[f]);
  }
  return s;
}
function fj(a, u) {
  if (a == null) return {};
  var s = {}, f = Object.keys(a), p, h;
  for (h = 0; h < f.length; h++)
    p = f[h], !(u.indexOf(p) >= 0) && (s[p] = a[p]);
  return s;
}
var MC = qi(function(a, u) {
  var s = a.color, f = s === void 0 ? "currentColor" : s, p = a.size, h = p === void 0 ? 24 : p, m = cj(a, ["color", "size"]);
  return /* @__PURE__ */ ut.createElement("svg", fC({
    ref: u,
    xmlns: "http://www.w3.org/2000/svg",
    width: h,
    height: h,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: f,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, m), /* @__PURE__ */ ut.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ ut.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
});
MC.propTypes = {
  color: Ht.string,
  size: Ht.oneOfType([Ht.string, Ht.number])
};
MC.displayName = "X";
const dj = (a) => function(s) {
  return a.replace(/{{([^{}]*)}}/g, function(p, h) {
    const m = s[h];
    return typeof m == "string" || typeof m == "number" ? m : p;
  });
}, ky = {
  isEnabled: !1,
  milestones: [],
  customizations: {
    type: Sc.STATIC,
    category: Gl.PRICE_BASED,
    completedMessage: "You have successfully reached the milestone",
    completedMessage_enabled: !0,
    textonProgressBar_header: !0,
    textonProgressBar_headerColor: "#2c874a",
    textonProgressBar_amount: !0,
    textonProgressBar_amountColor: "#2c874a",
    textonProgressBar_title: !0,
    textonProgressBar_titleColor: "#2c874a",
    width: Td.MEDIUM,
    filledColor: "#2c874a",
    emptyColor: "#ffffff"
  }
}, pj = {
  ...ky,
  customizations: {
    ...ky.customizations,
    category: Gl.COUNT_BASED
  }
}, vj = {
  ...ky,
  customizations: {
    ...ky.customizations,
    category: Gl.PRICE_BASED
  }
}, s1 = (a) => {
  const {
    enable: u,
    category: s,
    milestones: f,
    complete_message: p,
    text_title_color: h,
    progress_bar_type: m,
    text_amount_color: x,
    text_header_color: C,
    text_title_enable: E,
    text_amount_enable: R,
    text_header_enable: T,
    milestone_empty_color: O,
    milestone_filled_color: N,
    progress_bar_width: j,
    complete_message_enable: k
  } = a, A = f.map((z, F) => ({
    ...z,
    milestone: F
  }));
  return {
    isEnabled: u,
    milestones: A,
    customizations: {
      type: m,
      category: s,
      completedMessage: p,
      completedMessage_enabled: k,
      textonProgressBar_header: T,
      textonProgressBar_headerColor: C,
      textonProgressBar_amount: R,
      textonProgressBar_amountColor: x,
      textonProgressBar_title: E,
      textonProgressBar_titleColor: h,
      filledColor: N,
      emptyColor: O,
      width: j
    }
  };
}, z3 = (a) => {
  const u = a, s = u.filter(
    (h) => h.category === Gl.COUNT_BASED
  ), f = u.filter(
    (h) => h.category === Gl.PRICE_BASED
  ), p = {
    countBased: pj,
    amountBased: vj
  };
  return s.length > 0 && s[0] && (p.countBased = s1(
    s[0]
  )), f.length > 0 && f[0] && (p.amountBased = s1(
    f[0]
  )), p;
}, I3 = (a) => {
  const { isEnabled: u, milestones: s, customizations: f } = a;
  return {
    enable: u,
    category: f.category,
    // TODO: add this back when we enable pricebased
    // category: MilestoneCategory.PRICE_BASED,
    milestones: s,
    complete_message: f.completedMessage,
    complete_message_enable: f.completedMessage_enabled,
    progress_bar_type: f.type,
    progress_bar_width: f.width,
    text_title_color: f.textonProgressBar_titleColor,
    text_amount_color: f.textonProgressBar_amountColor,
    text_header_color: f.textonProgressBar_headerColor,
    text_title_enable: f.textonProgressBar_title,
    text_amount_enable: f.textonProgressBar_amount,
    text_header_enable: f.textonProgressBar_header,
    milestone_empty_color: f.emptyColor,
    milestone_filled_color: f.filledColor
  };
};
function hj(a, u = 90) {
  a = a.replace(/^#/, ""), a.length === 3 && (a = a.split("").map((m) => m + m).join(""));
  const s = parseInt(a.slice(0, 2), 16), f = parseInt(a.slice(2, 4), 16), p = parseInt(a.slice(4, 6), 16);
  return 0.299 * s + 0.587 * f + 0.114 * p > u;
}
function mj(a, u) {
  const s = parseInt(a.slice(1, 3), 16), f = parseInt(a.slice(3, 5), 16), p = parseInt(a.slice(5, 7), 16);
  return u ? "rgba(" + s + ", " + f + ", " + p + ", " + u + ")" : "rgb(" + s + ", " + f + ", " + p + ")";
}
const NC = {
  width: {
    [Td.LARGE]: 10,
    [Td.MEDIUM]: 6,
    [Td.REGULAR]: 4
  },
  partPercentageOfMilestones: {
    1: [100],
    2: [50, 50],
    3: [20, 80 / 2, 80 / 2],
    4: [10, 90 / 3, 90 / 3, 90 / 3],
    5: [10, 90 / 4, 90 / 4, 90 / 4, 90 / 4]
  }
}, gj = (a, u) => {
  var f;
  const s = (f = NC.partPercentageOfMilestones[a]) == null ? void 0 : f[u];
  if (!s)
    throw new Error("Invalid milestone length or index");
  return s;
}, Z1 = (a, u) => {
  var f;
  const s = (f = NC.partPercentageOfMilestones[a]) == null ? void 0 : f.slice(0, u + 1).reduce((p, h) => p + h, 0);
  if (!s)
    throw new Error("Invalid milestone length or index");
  return s;
}, yj = (a, u, s) => {
  var m;
  let f = 0, p = 0;
  const h = u.findIndex((x) => x.milestone_amount > a);
  if (h === -1)
    f = u.length - 1, p = 100, u.length === 1 && (p = 100);
  else {
    const x = u[h];
    f = h - 1;
    const C = x == null ? void 0 : x.milestone_amount;
    let E = 0;
    if (h > 0 && (E = ((m = u[h - 1]) == null ? void 0 : m.milestone_amount) ?? 0), s === Sc.DYNAMIC)
      return p = a / (C ?? 0) * 100, { achievedMilestoneIdx: f, currentProgress: p };
    const R = (a - E) / ((C ?? 0) - E), T = gj(u.length, h);
    h === 0 ? p = T * R : p = Z1(u.length, f) + T * R;
  }
  return { achievedMilestoneIdx: f, currentProgress: p };
}, c1 = {
  [gy.FLAT_OFF]: UL,
  [gy.FREE_SHIPPING]: kC,
  [gy.PERCENT_OFF]: DC,
  [gy.FREEBIE]: $y
}, xj = wc(
  ({
    children: a,
    milestones: u,
    total: s,
    customizations: f,
    onMilestoneReached: p
  }) => {
    const h = Dy(), { achievedMilestoneIdx: m, currentProgress: x } = Yi(
      () => yj(s, u, f.type),
      [s, u, f.type]
    );
    return zo(() => {
      p && h.current !== u[m] && p(u[m]), h.current = u[m];
    }, [m]), /* @__PURE__ */ D.jsx(
      FL,
      {
        total: s,
        milestones: u,
        achievedMilestoneIdx: m,
        totalMilestones: u.length,
        currentProgress: x,
        customizations: f,
        onMilestoneReached: p,
        children: a
      }
    );
  }
), Sj = wc(
  ({ children: a }) => {
    const { currentProgress: u, totalMilestones: s, customizations: f } = Ad(), p = NC.width[f.width], m = hj(f.filledColor) ? "#ffffff40" : "#00000040";
    return /* @__PURE__ */ D.jsx("div", { className: "ui-flex ui-flex-col ui-w-full ui-justify-center ui-items-center", children: /* @__PURE__ */ D.jsxs("ul", { className: "ui-z-10 ui-flex ui-w-full ui-items-center ui-relative", children: [
      /* @__PURE__ */ D.jsx(
        "div",
        {
          style: {
            "--progress-bar-filled-color": f.filledColor,
            "--progress-bar-shadow-color": m,
            "--progress-width": `${u}%`,
            "--progress-height": `${p}px`
          },
          className: "ui-progress-bar-rail ui-absolute"
        }
      ),
      a
    ] }) });
  }
), bj = wc(({ index: a }) => {
  const { achievedMilestoneIdx: u, milestones: s, total: f, customizations: p } = Ad(), h = s[a], m = Yi(() => {
    const E = h.milestone_amount - f;
    return Number.isInteger(E) ? E.toString() : E.toFixed(2);
  }, [f, h]), x = p.category === Gl.COUNT_BASED, C = Yi(
    () => dj(h.milestone_header)({
      // TODO: remove value once backend changes also removes price
      price: x ? `${m}` : `₹${m}`,
      value: `${m}`
    }),
    [m, h]
  );
  return u === a - 1 && p.textonProgressBar_header ? /* @__PURE__ */ D.jsx(
    "p",
    {
      className: "ui-p-3 ui-pt-0 ui-text-center ui-text-sm ui-font-semibold ui-text-yay-dark",
      style: { color: p.textonProgressBar_headerColor },
      children: C
    }
  ) : u === s.length - 1 && u === a && p.completedMessage_enabled ? /* @__PURE__ */ D.jsx(
    "p",
    {
      className: "ui-p-3 ui-pt-0 ui-text-center ui-text-sm ui-font-semibold ui-text-yay-dark",
      style: { color: p.textonProgressBar_headerColor },
      children: p.completedMessage
    }
  ) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}), Cj = wc(() => {
  const { milestones: a } = Ad();
  return /* @__PURE__ */ D.jsx(D.Fragment, { children: a.map((u, s) => /* @__PURE__ */ D.jsx(bj, { index: s }, u.milestone)) });
}), J1 = wc(({ index: a }) => {
  const { achievedMilestoneIdx: u, totalMilestones: s, milestones: f, customizations: p } = Ad(), { milestone_type: h, milestone_amount: m, milestone_text: x } = f[a] ?? {}, C = u >= a, E = p.category === Gl.COUNT_BASED, R = Yi(
    () => E ? m : `₹${m}`,
    [E, m]
  );
  let T = $y;
  h && c1[h] && (T = c1[h]);
  let O = `${Z1(s, a)}%`;
  p.type === Sc.DYNAMIC && (O = "100%");
  const N = Yi(() => p.textonProgressBar_amount && p.textonProgressBar_title || p.textonProgressBar_amount ? "72px" : "60px", [p]);
  return /* @__PURE__ */ D.jsx(
    "li",
    {
      style: {
        left: O,
        height: N
      },
      className: `ui-relative ui-flex ui-flex-col ui-items-center ui-text-xxs ui-font-medium ${C ? "ui-text-yay-dark" : "ui-text-gray-dark"}`,
      children: /* @__PURE__ */ D.jsxs(
        "div",
        {
          style: { height: N },
          className: "ui-absolute ui-flex ui-w-[100px] ui-flex-col ui-items-center ui-justify-between",
          children: [
            /* @__PURE__ */ D.jsx(
              "p",
              {
                style: { color: p.textonProgressBar_amountColor },
                className: "ui-h-3",
                children: p.textonProgressBar_amount && R
              }
            ),
            /* @__PURE__ */ D.jsx(
              T,
              {
                size: "48",
                viewBox: "-12 -12 48 48",
                style: {
                  backgroundColor: C ? p.filledColor : p.emptyColor,
                  boxShadow: "0px 2px 2px 0px #0000001A"
                },
                className: `ui-h-5 ui-w-5 ui-rounded-full ui-bg-white 
            ${C ? "ui-bg-yay-dark ui-text-white ui-shadow-sm ui-border-[1px] ui-border-[#ffffff] " : "ui-border-[1px] ui-border-calabon-lighter ui-text-[#c1c1c1]"}`
              }
            ),
            /* @__PURE__ */ D.jsx(
              "p",
              {
                className: "ui-w-full ui-truncate ui-text-center ui-h-3",
                style: { color: p.textonProgressBar_titleColor },
                children: p.textonProgressBar_title && x
              }
            )
          ]
        }
      )
    }
  );
}), Ej = wc(() => {
  const { milestones: a } = Ad();
  return /* @__PURE__ */ D.jsx(D.Fragment, { children: a.map((u, s) => /* @__PURE__ */ D.jsx(J1, { index: s }, u.milestone)) });
}), wj = wc(() => {
  const { achievedMilestoneIdx: a, milestones: u } = Ad();
  let s = a + 1;
  return s === u.length && (s = a), /* @__PURE__ */ D.jsx(J1, { index: s });
}), U3 = ({
  total: a,
  milestones: u,
  customizations: s,
  onMilestoneReached: f
}) => {
  const p = Yi(() => {
    switch (s.type) {
      case Sc.DYNAMIC:
        return /* @__PURE__ */ D.jsx(wj, {});
      case Sc.STATIC:
        return /* @__PURE__ */ D.jsx(Ej, {});
    }
  }, [s.type]), h = mj(s.filledColor, 0.1);
  return u.length === 0 ? /* @__PURE__ */ D.jsx(D.Fragment, {}) : /* @__PURE__ */ D.jsx(
    xj,
    {
      milestones: u,
      total: a,
      customizations: s,
      onMilestoneReached: f,
      children: /* @__PURE__ */ D.jsxs(
        "div",
        {
          style: {
            background: `linear-gradient(0deg, ${h} 0%, transparent 100%)`
          },
          className: "ui-px-3 ui-py-3 ui-border-t ui-border-t-gray-lighter",
          children: [
            (s.textonProgressBar_header || s.completedMessage_enabled) && /* @__PURE__ */ D.jsx(Cj, {}),
            /* @__PURE__ */ D.jsx("div", { className: "ui-w-[90%]", children: /* @__PURE__ */ D.jsx(Sj, { children: p }) })
          ]
        }
      )
    }
  );
}, F3 = ({
  size: a = 10,
  x: u = [-1, 1],
  y: s = [0.25, 1],
  duration: f = 2e3,
  infinite: p = !1,
  delay: h = [0, 50],
  colorRange: m = [0, 360],
  colorArray: x = [],
  amount: C = 50,
  iterationCount: E = 1,
  fallDistance: R = "100px",
  rounded: T = !1,
  cone: O = !1,
  noGravity: N = !1,
  xSpread: j = 0,
  destroyOnComplete: k = !0,
  disableForReducedMotion: A = !1
}) => {
  const [z, F] = Gi(!1);
  zo(() => {
    if (!k || p || E === "infinite") return;
    const B = setTimeout(
      () => F(!0),
      (f + h[1]) * E
    );
    return () => clearTimeout(B);
  }, [f, h, E, p, k]);
  const I = (B, ae) => Math.random() * (ae - B) + B, V = () => x.length ? x[Math.floor(Math.random() * x.length)] : `hsl(${Math.floor(
    I(m[0], m[1])
  )}, 75%, 50%)`;
  return z ? null : /* @__PURE__ */ D.jsxs(
    "div",
    {
      className: `ui-confetti-holder ${T ? "ui-rounded" : ""} ${N ? "no-gravity" : ""}`,
      children: [
        /* @__PURE__ */ D.jsx(
          "div",
          {
            className: "confetti-gradient",
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
              pointerEvents: "none",
              zIndex: 1
            }
          }
        ),
        Array.from({ length: C }).map((B, ae) => /* @__PURE__ */ D.jsx(
          "div",
          {
            className: "ui-confetti",
            style: {
              "--fall-distance": R,
              "--size": `${a}px`,
              "--color": V(),
              "--skew": `${I(-45, 45)}deg,${I(
                -45,
                45
              )}deg`,
              "--rotation-xyz": `${I(-10, 10)}, ${I(
                -10,
                10
              )}, ${I(-10, 10)}`,
              "--rotation-deg": `${I(0, 360)}deg`,
              "--translate-y-multiplier": I(s[0], s[1]),
              "--translate-x-multiplier": I(u[0], u[1]),
              "--scale": 0.1 * I(2, 10),
              "--transition-duration": p ? `calc(${f}ms * var(--scale))` : `${f}ms`,
              "--transition-delay": `${I(h[0], h[1])}ms`,
              "--transition-iteration-count": p ? "infinite" : E,
              "--x-spread": 1 - j,
              borderRadius: T ? "50%" : "0"
            }
          },
          ae
        ))
      ]
    }
  );
};
var Tj = /* @__PURE__ */ ((a) => (a.LOGIN = "login", a))(Tj || {}), dC = /* @__PURE__ */ ((a) => (a.PRE_LOGIN = "pre_login", a.POST_LOGIN = "post_login", a))(dC || {}), e_ = /* @__PURE__ */ ((a) => (a.MOBILE = "mobile", a.DESKTOP = "desktop", a))(e_ || {}), Ea = /* @__PURE__ */ ((a) => (a.SSO = "SSO", a.PRIMARY_BUTTON = "PRIMARY_BUTTON", a.BANNER = "BANNER", a.TITLE_AND_SUBTITLE = "TITLE_AND_SUBTITLE", a.NONE = "NONE", a.CARD = "CARD", a.CARDS = "CARDS", a.POST_LOGIN_SSO = "POST_LOGIN_SSO", a.POST_LOGIN_PRIMARY_BUTTON = "POST_LOGIN_PRIMARY_BUTTON", a.POST_LOGIN_TITLE_AND_SUBTITLE = "POST_LOGIN_TITLE_AND_SUBTITLE", a.POST_LOGIN_DISCOUNT_CODE = "POST_LOGIN_DISCOUNT_CODE", a))(Ea || {}), Rj = /* @__PURE__ */ ((a) => (a.BACKGROUND_COLOR = "BACKGROUND_COLOR", a.TEXT_COLOR = "TEXT_COLOR", a.BORDER_COLOR = "BORDER_COLOR", a.BORDER_WIDTH = "BORDER_WIDTH", a.BORDER_RADIUS = "BORDER_RADIUS", a))(Rj || {}), vh = /* @__PURE__ */ ((a) => (a.POPUP = "POPUP", a.CONFIG = "CONFIG", a.NONE = "NONE", a))(vh || {});
function _j(a) {
  return Object.prototype.toString.call(a) === "[object Object]";
}
function f1(a) {
  return _j(a) || Array.isArray(a);
}
function Oj() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function AC(a, u) {
  const s = Object.keys(a), f = Object.keys(u);
  if (s.length !== f.length) return !1;
  const p = JSON.stringify(Object.keys(a.breakpoints || {})), h = JSON.stringify(Object.keys(u.breakpoints || {}));
  return p !== h ? !1 : s.every((m) => {
    const x = a[m], C = u[m];
    return typeof x == "function" ? `${x}` == `${C}` : !f1(x) || !f1(C) ? x === C : AC(x, C);
  });
}
function d1(a) {
  return a.concat().sort((u, s) => u.name > s.name ? 1 : -1).map((u) => u.options);
}
function Dj(a, u) {
  if (a.length !== u.length) return !1;
  const s = d1(a), f = d1(u);
  return s.every((p, h) => {
    const m = f[h];
    return AC(p, m);
  });
}
function PC(a) {
  return typeof a == "number";
}
function pC(a) {
  return typeof a == "string";
}
function Vy(a) {
  return typeof a == "boolean";
}
function p1(a) {
  return Object.prototype.toString.call(a) === "[object Object]";
}
function On(a) {
  return Math.abs(a);
}
function LC(a) {
  return Math.sign(a);
}
function ah(a, u) {
  return On(a - u);
}
function kj(a, u) {
  if (a === 0 || u === 0 || On(a) <= On(u)) return 0;
  const s = ah(On(a), On(u));
  return On(s / a);
}
function Mj(a) {
  return Math.round(a * 100) / 100;
}
function ih(a) {
  return lh(a).map(Number);
}
function ti(a) {
  return a[hh(a)];
}
function hh(a) {
  return Math.max(0, a.length - 1);
}
function jC(a, u) {
  return u === hh(a);
}
function v1(a, u = 0) {
  return Array.from(Array(a), (s, f) => u + f);
}
function lh(a) {
  return Object.keys(a);
}
function t_(a, u) {
  return [a, u].reduce((s, f) => (lh(f).forEach((p) => {
    const h = s[p], m = f[p], x = p1(h) && p1(m);
    s[p] = x ? t_(h, m) : m;
  }), s), {});
}
function vC(a, u) {
  return typeof u.MouseEvent < "u" && a instanceof u.MouseEvent;
}
function Nj(a, u) {
  const s = {
    start: f,
    center: p,
    end: h
  };
  function f() {
    return 0;
  }
  function p(C) {
    return h(C) / 2;
  }
  function h(C) {
    return u - C;
  }
  function m(C, E) {
    return pC(a) ? s[a](C) : a(u, C, E);
  }
  return {
    measure: m
  };
}
function uh() {
  let a = [];
  function u(p, h, m, x = {
    passive: !0
  }) {
    let C;
    if ("addEventListener" in p)
      p.addEventListener(h, m, x), C = () => p.removeEventListener(h, m, x);
    else {
      const E = p;
      E.addListener(m), C = () => E.removeListener(m);
    }
    return a.push(C), f;
  }
  function s() {
    a = a.filter((p) => p());
  }
  const f = {
    add: u,
    clear: s
  };
  return f;
}
function Aj(a, u, s, f) {
  const p = uh(), h = 1e3 / 60;
  let m = null, x = 0, C = 0;
  function E() {
    p.add(a, "visibilitychange", () => {
      a.hidden && j();
    });
  }
  function R() {
    N(), p.clear();
  }
  function T(A) {
    if (!C) return;
    m || (m = A, s(), s());
    const z = A - m;
    for (m = A, x += z; x >= h; )
      s(), x -= h;
    const F = x / h;
    f(F), C && (C = u.requestAnimationFrame(T));
  }
  function O() {
    C || (C = u.requestAnimationFrame(T));
  }
  function N() {
    u.cancelAnimationFrame(C), m = null, x = 0, C = 0;
  }
  function j() {
    m = null, x = 0;
  }
  return {
    init: E,
    destroy: R,
    start: O,
    stop: N,
    update: s,
    render: f
  };
}
function Pj(a, u) {
  const s = u === "rtl", f = a === "y", p = f ? "y" : "x", h = f ? "x" : "y", m = !f && s ? -1 : 1, x = R(), C = T();
  function E(j) {
    const {
      height: k,
      width: A
    } = j;
    return f ? k : A;
  }
  function R() {
    return f ? "top" : s ? "right" : "left";
  }
  function T() {
    return f ? "bottom" : s ? "left" : "right";
  }
  function O(j) {
    return j * m;
  }
  return {
    scroll: p,
    cross: h,
    startEdge: x,
    endEdge: C,
    measureSize: E,
    direction: O
  };
}
function bc(a = 0, u = 0) {
  const s = On(a - u);
  function f(E) {
    return E < a;
  }
  function p(E) {
    return E > u;
  }
  function h(E) {
    return f(E) || p(E);
  }
  function m(E) {
    return h(E) ? f(E) ? a : u : E;
  }
  function x(E) {
    return s ? E - s * Math.ceil((E - u) / s) : E;
  }
  return {
    length: s,
    max: u,
    min: a,
    constrain: m,
    reachedAny: h,
    reachedMax: p,
    reachedMin: f,
    removeOffset: x
  };
}
function n_(a, u, s) {
  const {
    constrain: f
  } = bc(0, a), p = a + 1;
  let h = m(u);
  function m(O) {
    return s ? On((p + O) % p) : f(O);
  }
  function x() {
    return h;
  }
  function C(O) {
    return h = m(O), T;
  }
  function E(O) {
    return R().set(x() + O);
  }
  function R() {
    return n_(a, x(), s);
  }
  const T = {
    get: x,
    set: C,
    add: E,
    clone: R
  };
  return T;
}
function Lj(a, u, s, f, p, h, m, x, C, E, R, T, O, N, j, k, A, z, F) {
  const {
    cross: I,
    direction: V
  } = a, B = ["INPUT", "SELECT", "TEXTAREA"], ae = {
    passive: !1
  }, Z = uh(), pe = uh(), de = bc(50, 225).constrain(N.measure(20)), me = {
    mouse: 300,
    touch: 400
  }, Te = {
    mouse: 500,
    touch: 600
  }, ve = j ? 43 : 25;
  let ce = !1, Ee = 0, Ue = 0, Re = !1, Ke = !1, oe = !1, le = !1;
  function W(re) {
    if (!F) return;
    function qe(Tt) {
      (Vy(F) || F(re, Tt)) && Pe(Tt);
    }
    const vt = u;
    Z.add(vt, "dragstart", (Tt) => Tt.preventDefault(), ae).add(vt, "touchmove", () => {
    }, ae).add(vt, "touchend", () => {
    }).add(vt, "touchstart", qe).add(vt, "mousedown", qe).add(vt, "touchcancel", Me).add(vt, "contextmenu", Me).add(vt, "click", Ie, !0);
  }
  function ie() {
    Z.clear(), pe.clear();
  }
  function we() {
    const re = le ? s : u;
    pe.add(re, "touchmove", Oe, ae).add(re, "touchend", Me).add(re, "mousemove", Oe, ae).add(re, "mouseup", Me);
  }
  function je(re) {
    const qe = re.nodeName || "";
    return B.includes(qe);
  }
  function ke() {
    return (j ? Te : me)[le ? "mouse" : "touch"];
  }
  function et(re, qe) {
    const vt = T.add(LC(re) * -1), Tt = R.byDistance(re, !j).distance;
    return j || On(re) < de ? Tt : A && qe ? Tt * 0.5 : R.byIndex(vt.get(), 0).distance;
  }
  function Pe(re) {
    const qe = vC(re, f);
    le = qe, oe = j && qe && !re.buttons && ce, ce = ah(p.get(), m.get()) >= 2, !(qe && re.button !== 0) && (je(re.target) || (Re = !0, h.pointerDown(re), E.useFriction(0).useDuration(0), p.set(m), we(), Ee = h.readPoint(re), Ue = h.readPoint(re, I), O.emit("pointerDown")));
  }
  function Oe(re) {
    if (!vC(re, f) && re.touches.length >= 2) return Me(re);
    const vt = h.readPoint(re), Tt = h.readPoint(re, I), $t = ah(vt, Ee), xn = ah(Tt, Ue);
    if (!Ke && !le && (!re.cancelable || (Ke = $t > xn, !Ke)))
      return Me(re);
    const Gn = h.pointerMove(re);
    $t > k && (oe = !0), E.useFriction(0.3).useDuration(0.75), x.start(), p.add(V(Gn)), re.preventDefault();
  }
  function Me(re) {
    const vt = R.byDistance(0, !1).index !== T.get(), Tt = h.pointerUp(re) * ke(), $t = et(V(Tt), vt), xn = kj(Tt, $t), Gn = ve - 10 * xn, ln = z + xn / 50;
    Ke = !1, Re = !1, pe.clear(), E.useDuration(Gn).useFriction(ln), C.distance($t, !j), le = !1, O.emit("pointerUp");
  }
  function Ie(re) {
    oe && (re.stopPropagation(), re.preventDefault(), oe = !1);
  }
  function $e() {
    return Re;
  }
  return {
    init: W,
    destroy: ie,
    pointerDown: $e
  };
}
function jj(a, u) {
  let f, p;
  function h(T) {
    return T.timeStamp;
  }
  function m(T, O) {
    const j = `client${(O || a.scroll) === "x" ? "X" : "Y"}`;
    return (vC(T, u) ? T : T.touches[0])[j];
  }
  function x(T) {
    return f = T, p = T, m(T);
  }
  function C(T) {
    const O = m(T) - m(p), N = h(T) - h(f) > 170;
    return p = T, N && (f = T), O;
  }
  function E(T) {
    if (!f || !p) return 0;
    const O = m(p) - m(f), N = h(T) - h(f), j = h(T) - h(p) > 170, k = O / N;
    return N && !j && On(k) > 0.1 ? k : 0;
  }
  return {
    pointerDown: x,
    pointerMove: C,
    pointerUp: E,
    readPoint: m
  };
}
function zj() {
  function a(s) {
    const {
      offsetTop: f,
      offsetLeft: p,
      offsetWidth: h,
      offsetHeight: m
    } = s;
    return {
      top: f,
      right: p + h,
      bottom: f + m,
      left: p,
      width: h,
      height: m
    };
  }
  return {
    measure: a
  };
}
function Ij(a) {
  function u(f) {
    return a * (f / 100);
  }
  return {
    measure: u
  };
}
function Uj(a, u, s, f, p, h, m) {
  const x = [a].concat(f);
  let C, E, R = [], T = !1;
  function O(A) {
    return p.measureSize(m.measure(A));
  }
  function N(A) {
    if (!h) return;
    E = O(a), R = f.map(O);
    function z(F) {
      for (const I of F) {
        if (T) return;
        const V = I.target === a, B = f.indexOf(I.target), ae = V ? E : R[B], Z = O(V ? a : f[B]);
        if (On(Z - ae) >= 0.5) {
          A.reInit(), u.emit("resize");
          break;
        }
      }
    }
    C = new ResizeObserver((F) => {
      (Vy(h) || h(A, F)) && z(F);
    }), s.requestAnimationFrame(() => {
      x.forEach((F) => C.observe(F));
    });
  }
  function j() {
    T = !0, C && C.disconnect();
  }
  return {
    init: N,
    destroy: j
  };
}
function Fj(a, u, s, f, p, h) {
  let m = 0, x = 0, C = p, E = h, R = a.get(), T = 0;
  function O() {
    const ae = f.get() - a.get(), Z = !C;
    let pe = 0;
    return Z ? (m = 0, s.set(f), a.set(f), pe = ae) : (s.set(a), m += ae / C, m *= E, R += m, a.add(m), pe = R - T), x = LC(pe), T = R, B;
  }
  function N() {
    const ae = f.get() - u.get();
    return On(ae) < 1e-3;
  }
  function j() {
    return C;
  }
  function k() {
    return x;
  }
  function A() {
    return m;
  }
  function z() {
    return I(p);
  }
  function F() {
    return V(h);
  }
  function I(ae) {
    return C = ae, B;
  }
  function V(ae) {
    return E = ae, B;
  }
  const B = {
    direction: k,
    duration: j,
    velocity: A,
    seek: O,
    settled: N,
    useBaseFriction: F,
    useBaseDuration: z,
    useFriction: V,
    useDuration: I
  };
  return B;
}
function Bj(a, u, s, f, p) {
  const h = p.measure(10), m = p.measure(50), x = bc(0.1, 0.99);
  let C = !1;
  function E() {
    return !(C || !a.reachedAny(s.get()) || !a.reachedAny(u.get()));
  }
  function R(N) {
    if (!E()) return;
    const j = a.reachedMin(u.get()) ? "min" : "max", k = On(a[j] - u.get()), A = s.get() - u.get(), z = x.constrain(k / m);
    s.subtract(A * z), !N && On(A) < h && (s.set(a.constrain(s.get())), f.useDuration(25).useBaseFriction());
  }
  function T(N) {
    C = !N;
  }
  return {
    shouldConstrain: E,
    constrain: R,
    toggleActive: T
  };
}
function Hj(a, u, s, f, p) {
  const h = bc(-u + a, 0), m = T(), x = R(), C = O();
  function E(j, k) {
    return ah(j, k) <= 1;
  }
  function R() {
    const j = m[0], k = ti(m), A = m.lastIndexOf(j), z = m.indexOf(k) + 1;
    return bc(A, z);
  }
  function T() {
    return s.map((j, k) => {
      const {
        min: A,
        max: z
      } = h, F = h.constrain(j), I = !k, V = jC(s, k);
      return I ? z : V || E(A, F) ? A : E(z, F) ? z : F;
    }).map((j) => parseFloat(j.toFixed(3)));
  }
  function O() {
    if (u <= a + p) return [h.max];
    if (f === "keepSnaps") return m;
    const {
      min: j,
      max: k
    } = x;
    return m.slice(j, k);
  }
  return {
    snapsContained: C,
    scrollContainLimit: x
  };
}
function $j(a, u, s) {
  const f = u[0], p = s ? f - a : ti(u);
  return {
    limit: bc(p, f)
  };
}
function Vj(a, u, s, f) {
  const h = u.min + 0.1, m = u.max + 0.1, {
    reachedMin: x,
    reachedMax: C
  } = bc(h, m);
  function E(O) {
    return O === 1 ? C(s.get()) : O === -1 ? x(s.get()) : !1;
  }
  function R(O) {
    if (!E(O)) return;
    const N = a * (O * -1);
    f.forEach((j) => j.add(N));
  }
  return {
    loop: R
  };
}
function Wj(a) {
  const {
    max: u,
    length: s
  } = a;
  function f(h) {
    const m = h - u;
    return s ? m / -s : 0;
  }
  return {
    get: f
  };
}
function Yj(a, u, s, f, p) {
  const {
    startEdge: h,
    endEdge: m
  } = a, {
    groupSlides: x
  } = p, C = T().map(u.measure), E = O(), R = N();
  function T() {
    return x(f).map((k) => ti(k)[m] - k[0][h]).map(On);
  }
  function O() {
    return f.map((k) => s[h] - k[h]).map((k) => -On(k));
  }
  function N() {
    return x(E).map((k) => k[0]).map((k, A) => k + C[A]);
  }
  return {
    snaps: E,
    snapsAligned: R
  };
}
function Gj(a, u, s, f, p, h) {
  const {
    groupSlides: m
  } = p, {
    min: x,
    max: C
  } = f, E = R();
  function R() {
    const O = m(h), N = !a || u === "keepSnaps";
    return s.length === 1 ? [h] : N ? O : O.slice(x, C).map((j, k, A) => {
      const z = !k, F = jC(A, k);
      if (z) {
        const I = ti(A[0]) + 1;
        return v1(I);
      }
      if (F) {
        const I = hh(h) - ti(A)[0] + 1;
        return v1(I, ti(A)[0]);
      }
      return j;
    });
  }
  return {
    slideRegistry: E
  };
}
function Qj(a, u, s, f, p) {
  const {
    reachedAny: h,
    removeOffset: m,
    constrain: x
  } = f;
  function C(j) {
    return j.concat().sort((k, A) => On(k) - On(A))[0];
  }
  function E(j) {
    const k = a ? m(j) : x(j), A = u.map((F, I) => ({
      diff: R(F - k, 0),
      index: I
    })).sort((F, I) => On(F.diff) - On(I.diff)), {
      index: z
    } = A[0];
    return {
      index: z,
      distance: k
    };
  }
  function R(j, k) {
    const A = [j, j + s, j - s];
    if (!a) return j;
    if (!k) return C(A);
    const z = A.filter((F) => LC(F) === k);
    return z.length ? C(z) : ti(A) - s;
  }
  function T(j, k) {
    const A = u[j] - p.get(), z = R(A, k);
    return {
      index: j,
      distance: z
    };
  }
  function O(j, k) {
    const A = p.get() + j, {
      index: z,
      distance: F
    } = E(A), I = !a && h(A);
    if (!k || I) return {
      index: z,
      distance: j
    };
    const V = u[z] - F, B = j + R(V, 0);
    return {
      index: z,
      distance: B
    };
  }
  return {
    byDistance: O,
    byIndex: T,
    shortcut: R
  };
}
function Kj(a, u, s, f, p, h, m) {
  function x(T) {
    const O = T.distance, N = T.index !== u.get();
    h.add(O), O && (f.duration() ? a.start() : (a.update(), a.render(1), a.update())), N && (s.set(u.get()), u.set(T.index), m.emit("select"));
  }
  function C(T, O) {
    const N = p.byDistance(T, O);
    x(N);
  }
  function E(T, O) {
    const N = u.clone().set(T), j = p.byIndex(N.get(), O);
    x(j);
  }
  return {
    distance: C,
    index: E
  };
}
function qj(a, u, s, f, p, h, m, x) {
  const C = {
    passive: !0,
    capture: !0
  };
  let E = 0;
  function R(N) {
    if (!x) return;
    function j(k) {
      if ((/* @__PURE__ */ new Date()).getTime() - E > 10) return;
      m.emit("slideFocusStart"), a.scrollLeft = 0;
      const F = s.findIndex((I) => I.includes(k));
      PC(F) && (p.useDuration(0), f.index(F, 0), m.emit("slideFocus"));
    }
    h.add(document, "keydown", T, !1), u.forEach((k, A) => {
      h.add(k, "focus", (z) => {
        (Vy(x) || x(N, z)) && j(A);
      }, C);
    });
  }
  function T(N) {
    N.code === "Tab" && (E = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: R
  };
}
function rh(a) {
  let u = a;
  function s() {
    return u;
  }
  function f(C) {
    u = m(C);
  }
  function p(C) {
    u += m(C);
  }
  function h(C) {
    u -= m(C);
  }
  function m(C) {
    return PC(C) ? C : C.get();
  }
  return {
    get: s,
    set: f,
    add: p,
    subtract: h
  };
}
function r_(a, u) {
  const s = a.scroll === "x" ? m : x, f = u.style;
  let p = null, h = !1;
  function m(O) {
    return `translate3d(${O}px,0px,0px)`;
  }
  function x(O) {
    return `translate3d(0px,${O}px,0px)`;
  }
  function C(O) {
    if (h) return;
    const N = Mj(a.direction(O));
    N !== p && (f.transform = s(N), p = N);
  }
  function E(O) {
    h = !O;
  }
  function R() {
    h || (f.transform = "", u.getAttribute("style") || u.removeAttribute("style"));
  }
  return {
    clear: R,
    to: C,
    toggleActive: E
  };
}
function Xj(a, u, s, f, p, h, m, x, C) {
  const R = ih(p), T = ih(p).reverse(), O = z().concat(F());
  function N(Z, pe) {
    return Z.reduce((de, me) => de - p[me], pe);
  }
  function j(Z, pe) {
    return Z.reduce((de, me) => N(de, pe) > 0 ? de.concat([me]) : de, []);
  }
  function k(Z) {
    return h.map((pe, de) => ({
      start: pe - f[de] + 0.5 + Z,
      end: pe + u - 0.5 + Z
    }));
  }
  function A(Z, pe, de) {
    const me = k(pe);
    return Z.map((Te) => {
      const ve = de ? 0 : -s, ce = de ? s : 0, Ee = de ? "end" : "start", Ue = me[Te][Ee];
      return {
        index: Te,
        loopPoint: Ue,
        slideLocation: rh(-1),
        translate: r_(a, C[Te]),
        target: () => x.get() > Ue ? ve : ce
      };
    });
  }
  function z() {
    const Z = m[0], pe = j(T, Z);
    return A(pe, s, !1);
  }
  function F() {
    const Z = u - m[0] - 1, pe = j(R, Z);
    return A(pe, -s, !0);
  }
  function I() {
    return O.every(({
      index: Z
    }) => {
      const pe = R.filter((de) => de !== Z);
      return N(pe, u) <= 0.1;
    });
  }
  function V() {
    O.forEach((Z) => {
      const {
        target: pe,
        translate: de,
        slideLocation: me
      } = Z, Te = pe();
      Te !== me.get() && (de.to(Te), me.set(Te));
    });
  }
  function B() {
    O.forEach((Z) => Z.translate.clear());
  }
  return {
    canLoop: I,
    clear: B,
    loop: V,
    loopPoints: O
  };
}
function Zj(a, u, s) {
  let f, p = !1;
  function h(C) {
    if (!s) return;
    function E(R) {
      for (const T of R)
        if (T.type === "childList") {
          C.reInit(), u.emit("slidesChanged");
          break;
        }
    }
    f = new MutationObserver((R) => {
      p || (Vy(s) || s(C, R)) && E(R);
    }), f.observe(a, {
      childList: !0
    });
  }
  function m() {
    f && f.disconnect(), p = !0;
  }
  return {
    init: h,
    destroy: m
  };
}
function Jj(a, u, s, f) {
  const p = {};
  let h = null, m = null, x, C = !1;
  function E() {
    x = new IntersectionObserver((j) => {
      C || (j.forEach((k) => {
        const A = u.indexOf(k.target);
        p[A] = k;
      }), h = null, m = null, s.emit("slidesInView"));
    }, {
      root: a.parentElement,
      threshold: f
    }), u.forEach((j) => x.observe(j));
  }
  function R() {
    x && x.disconnect(), C = !0;
  }
  function T(j) {
    return lh(p).reduce((k, A) => {
      const z = parseInt(A), {
        isIntersecting: F
      } = p[z];
      return (j && F || !j && !F) && k.push(z), k;
    }, []);
  }
  function O(j = !0) {
    if (j && h) return h;
    if (!j && m) return m;
    const k = T(j);
    return j && (h = k), j || (m = k), k;
  }
  return {
    init: E,
    destroy: R,
    get: O
  };
}
function e2(a, u, s, f, p, h) {
  const {
    measureSize: m,
    startEdge: x,
    endEdge: C
  } = a, E = s[0] && p, R = j(), T = k(), O = s.map(m), N = A();
  function j() {
    if (!E) return 0;
    const F = s[0];
    return On(u[x] - F[x]);
  }
  function k() {
    if (!E) return 0;
    const F = h.getComputedStyle(ti(f));
    return parseFloat(F.getPropertyValue(`margin-${C}`));
  }
  function A() {
    return s.map((F, I, V) => {
      const B = !I, ae = jC(V, I);
      return B ? O[I] + R : ae ? O[I] + T : V[I + 1][x] - F[x];
    }).map(On);
  }
  return {
    slideSizes: O,
    slideSizesWithGaps: N,
    startGap: R,
    endGap: T
  };
}
function t2(a, u, s, f, p, h, m, x, C) {
  const {
    startEdge: E,
    endEdge: R,
    direction: T
  } = a, O = PC(s);
  function N(z, F) {
    return ih(z).filter((I) => I % F === 0).map((I) => z.slice(I, I + F));
  }
  function j(z) {
    return z.length ? ih(z).reduce((F, I, V) => {
      const B = ti(F) || 0, ae = B === 0, Z = I === hh(z), pe = p[E] - h[B][E], de = p[E] - h[I][R], me = !f && ae ? T(m) : 0, Te = !f && Z ? T(x) : 0, ve = On(de - Te - (pe + me));
      return V && ve > u + C && F.push(I), Z && F.push(z.length), F;
    }, []).map((F, I, V) => {
      const B = Math.max(V[I - 1] || 0);
      return z.slice(B, F);
    }) : [];
  }
  function k(z) {
    return O ? N(z, s) : j(z);
  }
  return {
    groupSlides: k
  };
}
function n2(a, u, s, f, p, h, m) {
  const {
    align: x,
    axis: C,
    direction: E,
    startIndex: R,
    loop: T,
    duration: O,
    dragFree: N,
    dragThreshold: j,
    inViewThreshold: k,
    slidesToScroll: A,
    skipSnaps: z,
    containScroll: F,
    watchResize: I,
    watchSlides: V,
    watchDrag: B,
    watchFocus: ae
  } = h, Z = 2, pe = zj(), de = pe.measure(u), me = s.map(pe.measure), Te = Pj(C, E), ve = Te.measureSize(de), ce = Ij(ve), Ee = Nj(x, ve), Ue = !T && !!F, Re = T || !!F, {
    slideSizes: Ke,
    slideSizesWithGaps: oe,
    startGap: le,
    endGap: W
  } = e2(Te, de, me, s, Re, p), ie = t2(Te, ve, A, T, de, me, le, W, Z), {
    snaps: we,
    snapsAligned: je
  } = Yj(Te, Ee, de, me, ie), ke = -ti(we) + ti(oe), {
    snapsContained: et,
    scrollContainLimit: Pe
  } = Hj(ve, ke, je, F, Z), Oe = Ue ? et : je, {
    limit: Me
  } = $j(ke, Oe, T), Ie = n_(hh(Oe), R, T), $e = Ie.clone(), Qe = ih(s), re = ({
    dragHandler: _e,
    scrollBody: Ze,
    scrollBounds: gt,
    options: {
      loop: At
    }
  }) => {
    At || gt.constrain(_e.pointerDown()), Ze.seek();
  }, qe = ({
    scrollBody: _e,
    translate: Ze,
    location: gt,
    offsetLocation: At,
    previousLocation: en,
    scrollLooper: Qn,
    slideLooper: un,
    dragHandler: Kn,
    animation: tn,
    eventHandler: Yt,
    scrollBounds: Gt,
    options: {
      loop: to
    }
  }, Sr) => {
    const ta = _e.settled(), Jl = !Gt.shouldConstrain(), li = to ? ta : ta && Jl;
    li && !Kn.pointerDown() && (tn.stop(), Yt.emit("settle")), li || Yt.emit("scroll");
    const Ji = gt.get() * Sr + en.get() * (1 - Sr);
    At.set(Ji), to && (Qn.loop(_e.direction()), un.loop()), Ze.to(At.get());
  }, vt = Aj(f, p, () => re(mo), (_e) => qe(mo, _e)), Tt = 0.68, $t = Oe[Ie.get()], xn = rh($t), Gn = rh($t), ln = rh($t), er = rh($t), Sn = Fj(xn, ln, Gn, er, O, Tt), Dn = Qj(T, Oe, ke, Me, er), tr = Kj(vt, Ie, $e, Sn, Dn, er, m), Io = Wj(Me), Fn = uh(), xr = Jj(u, s, m, k), {
    slideRegistry: eo
  } = Gj(Ue, F, Oe, Pe, ie, Qe), Uo = qj(a, s, eo, tr, Sn, Fn, m, ae), mo = {
    ownerDocument: f,
    ownerWindow: p,
    eventHandler: m,
    containerRect: de,
    slideRects: me,
    animation: vt,
    axis: Te,
    dragHandler: Lj(Te, a, f, p, er, jj(Te, p), xn, vt, tr, Sn, Dn, Ie, m, ce, N, j, z, Tt, B),
    eventStore: Fn,
    percentOfView: ce,
    index: Ie,
    indexPrevious: $e,
    limit: Me,
    location: xn,
    offsetLocation: ln,
    previousLocation: Gn,
    options: h,
    resizeHandler: Uj(u, m, p, s, Te, I, pe),
    scrollBody: Sn,
    scrollBounds: Bj(Me, ln, er, Sn, ce),
    scrollLooper: Vj(ke, Me, ln, [xn, ln, Gn, er]),
    scrollProgress: Io,
    scrollSnapList: Oe.map(Io.get),
    scrollSnaps: Oe,
    scrollTarget: Dn,
    scrollTo: tr,
    slideLooper: Xj(Te, ve, ke, Ke, oe, we, Oe, ln, s),
    slideFocus: Uo,
    slidesHandler: Zj(u, m, V),
    slidesInView: xr,
    slideIndexes: Qe,
    slideRegistry: eo,
    slidesToScroll: ie,
    target: er,
    translate: r_(Te, u)
  };
  return mo;
}
function r2() {
  let a = {}, u;
  function s(E) {
    u = E;
  }
  function f(E) {
    return a[E] || [];
  }
  function p(E) {
    return f(E).forEach((R) => R(u, E)), C;
  }
  function h(E, R) {
    return a[E] = f(E).concat([R]), C;
  }
  function m(E, R) {
    return a[E] = f(E).filter((T) => T !== R), C;
  }
  function x() {
    a = {};
  }
  const C = {
    init: s,
    emit: p,
    off: m,
    on: h,
    clear: x
  };
  return C;
}
const o2 = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function a2(a) {
  function u(h, m) {
    return t_(h, m || {});
  }
  function s(h) {
    const m = h.breakpoints || {}, x = lh(m).filter((C) => a.matchMedia(C).matches).map((C) => m[C]).reduce((C, E) => u(C, E), {});
    return u(h, x);
  }
  function f(h) {
    return h.map((m) => lh(m.breakpoints || {})).reduce((m, x) => m.concat(x), []).map(a.matchMedia);
  }
  return {
    mergeOptions: u,
    optionsAtMedia: s,
    optionsMediaQueries: f
  };
}
function i2(a) {
  let u = [];
  function s(h, m) {
    return u = m.filter(({
      options: x
    }) => a.optionsAtMedia(x).active !== !1), u.forEach((x) => x.init(h, a)), m.reduce((x, C) => Object.assign(x, {
      [C.name]: C
    }), {});
  }
  function f() {
    u = u.filter((h) => h.destroy());
  }
  return {
    init: s,
    destroy: f
  };
}
function My(a, u, s) {
  const f = a.ownerDocument, p = f.defaultView, h = a2(p), m = i2(h), x = uh(), C = r2(), {
    mergeOptions: E,
    optionsAtMedia: R,
    optionsMediaQueries: T
  } = h, {
    on: O,
    off: N,
    emit: j
  } = C, k = Te;
  let A = !1, z, F = E(o2, My.globalOptions), I = E(F), V = [], B, ae, Z;
  function pe() {
    const {
      container: Qe,
      slides: re
    } = I;
    ae = (pC(Qe) ? a.querySelector(Qe) : Qe) || a.children[0];
    const vt = pC(re) ? ae.querySelectorAll(re) : re;
    Z = [].slice.call(vt || ae.children);
  }
  function de(Qe) {
    const re = n2(a, ae, Z, f, p, Qe, C);
    if (Qe.loop && !re.slideLooper.canLoop()) {
      const qe = Object.assign({}, Qe, {
        loop: !1
      });
      return de(qe);
    }
    return re;
  }
  function me(Qe, re) {
    A || (F = E(F, Qe), I = R(F), V = re || V, pe(), z = de(I), T([F, ...V.map(({
      options: qe
    }) => qe)]).forEach((qe) => x.add(qe, "change", Te)), I.active && (z.translate.to(z.location.get()), z.animation.init(), z.slidesInView.init(), z.slideFocus.init($e), z.eventHandler.init($e), z.resizeHandler.init($e), z.slidesHandler.init($e), z.options.loop && z.slideLooper.loop(), ae.offsetParent && Z.length && z.dragHandler.init($e), B = m.init($e, V)));
  }
  function Te(Qe, re) {
    const qe = ie();
    ve(), me(E({
      startIndex: qe
    }, Qe), re), C.emit("reInit");
  }
  function ve() {
    z.dragHandler.destroy(), z.eventStore.clear(), z.translate.clear(), z.slideLooper.clear(), z.resizeHandler.destroy(), z.slidesHandler.destroy(), z.slidesInView.destroy(), z.animation.destroy(), m.destroy(), x.clear();
  }
  function ce() {
    A || (A = !0, x.clear(), ve(), C.emit("destroy"), C.clear());
  }
  function Ee(Qe, re, qe) {
    !I.active || A || (z.scrollBody.useBaseFriction().useDuration(re === !0 ? 0 : I.duration), z.scrollTo.index(Qe, qe || 0));
  }
  function Ue(Qe) {
    const re = z.index.add(1).get();
    Ee(re, Qe, -1);
  }
  function Re(Qe) {
    const re = z.index.add(-1).get();
    Ee(re, Qe, 1);
  }
  function Ke() {
    return z.index.add(1).get() !== ie();
  }
  function oe() {
    return z.index.add(-1).get() !== ie();
  }
  function le() {
    return z.scrollSnapList;
  }
  function W() {
    return z.scrollProgress.get(z.location.get());
  }
  function ie() {
    return z.index.get();
  }
  function we() {
    return z.indexPrevious.get();
  }
  function je() {
    return z.slidesInView.get();
  }
  function ke() {
    return z.slidesInView.get(!1);
  }
  function et() {
    return B;
  }
  function Pe() {
    return z;
  }
  function Oe() {
    return a;
  }
  function Me() {
    return ae;
  }
  function Ie() {
    return Z;
  }
  const $e = {
    canScrollNext: Ke,
    canScrollPrev: oe,
    containerNode: Me,
    internalEngine: Pe,
    destroy: ce,
    off: N,
    on: O,
    emit: j,
    plugins: et,
    previousScrollSnap: we,
    reInit: k,
    rootNode: Oe,
    scrollNext: Ue,
    scrollPrev: Re,
    scrollProgress: W,
    scrollSnapList: le,
    scrollTo: Ee,
    selectedScrollSnap: ie,
    slideNodes: Ie,
    slidesInView: je,
    slidesNotInView: ke
  };
  return me(u, s), setTimeout(() => C.emit("init"), 0), $e;
}
My.globalOptions = void 0;
function Dd(a = {}, u = []) {
  const s = Dy(a), f = Dy(u), [p, h] = Gi(), [m, x] = Gi(), C = Ku(() => {
    p && p.reInit(s.current, f.current);
  }, [p]);
  return zo(() => {
    AC(s.current, a) || (s.current = a, C());
  }, [a, C]), zo(() => {
    Dj(f.current, u) || (f.current = u, C());
  }, [u, C]), zo(() => {
    if (Oj() && m) {
      My.globalOptions = Dd.globalOptions;
      const E = My(m, s.current, f.current);
      return h(E), () => E.destroy();
    } else
      h(void 0);
  }, [m, h]), [x, p];
}
Dd.globalOptions = void 0;
const o_ = "ShopfloPopupFont";
async function l2(a) {
  const s = await new FontFace(o_, `url(${a.src})`, {
    display: "swap",
    style: a.style,
    weight: a.weight.toString(),
    unicodeRange: a.unicodeRange
  }).load();
  document.fonts.add(s);
}
async function u2(a) {
  const s = await new FontFace(o_, `url(${a})`, {
    display: "swap"
  }).load();
  document.fonts.add(s);
}
async function B3(a) {
  var u, s;
  switch (a.fontType.toLowerCase()) {
    case "google":
      (u = a.googleFontFaces) == null || u.forEach(
        (f) => {
          l2(f);
        }
      );
      break;
    case "custom":
      (s = a.customFontFaces) == null || s.forEach(
        (f) => {
          u2(f);
        }
      );
      break;
  }
}
function Qi(...a) {
  return a.filter(Boolean).join(" ");
}
const Ny = (a, u) => {
  const s = a.replace("#", ""), f = parseInt(s.substring(0, 2), 16), p = parseInt(s.substring(2, 4), 16), h = parseInt(s.substring(4, 6), 16);
  return `rgba(${f}, ${p}, ${h}, ${u})`;
}, s2 = (a) => {
  const [u, s] = Gi(!0), [f, p] = Gi(!0), h = Ku(() => {
    a && a.scrollPrev();
  }, [a]), m = Ku(() => {
    a && a.scrollNext();
  }, [a]), x = Ku((C) => {
    s(!C.canScrollPrev()), p(!C.canScrollNext());
  }, []);
  return zo(() => {
    a && (x(a), a.on("reInit", x).on("select", x));
  }, [a, x]), {
    prevBtnDisabled: u,
    nextBtnDisabled: f,
    onPrevButtonClick: h,
    onNextButtonClick: m
  };
}, c2 = (a) => {
  var x, C;
  const { children: u, styles: s, ...f } = a, p = (s == null ? void 0 : s.backgroundColor) || "#000000";
  let h = Ny(p, 1), m = Ny(p, 0);
  return p.includes("#") || (h = p, m = "#00000000"), /* @__PURE__ */ D.jsxs(
    "button",
    {
      className: "ui-w-14 ui-h-full ui-flex ui-items-center ui-justify-center",
      style: {
        backgroundImage: `linear-gradient(to right, ${h}, ${m})`
      },
      type: "button",
      ...f,
      children: [
        ((x = a.customizeUI) == null ? void 0 : x.iconRequired) && /* @__PURE__ */ D.jsx(
          "div",
          {
            className: Qi(
              "ui-p-2 ui-rounded-full ui-bg-gray-light ui-mb-4 ",
              (C = a.customizeUI) != null && C.isMobilePreview ? "ui-scale-50 ui-mr-6" : ""
            ),
            children: /* @__PURE__ */ D.jsx(By, {})
          }
        ),
        u
      ]
    }
  );
}, f2 = (a) => {
  var x, C;
  const { children: u, styles: s, ...f } = a, p = (s == null ? void 0 : s.backgroundColor) || "#000000";
  let h = Ny(p, 1), m = Ny(p, 0);
  return p.includes("#") || (h = p, m = "#00000000"), /* @__PURE__ */ D.jsxs(
    "button",
    {
      className: "ui-w-14 ui-h-full ui-flex ui-items-center ui-justify-center",
      style: {
        backgroundImage: `linear-gradient(to left, ${h}, ${m})`
      },
      type: "button",
      ...f,
      children: [
        ((x = a.customizeUI) == null ? void 0 : x.iconRequired) && /* @__PURE__ */ D.jsx(
          "div",
          {
            className: Qi(
              "ui-p-2 ui-rounded-full ui-bg-gray-light ui-mb-4 ",
              (C = a.customizeUI) != null && C.isMobilePreview ? "ui-scale-50 ui-ml-6" : ""
            ),
            children: /* @__PURE__ */ D.jsx(Hy, {})
          }
        ),
        u
      ]
    }
  );
}, d2 = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function p2(a, u) {
  const s = a.scrollSnapList();
  return typeof u == "number" ? s.map(() => u) : u(s, a);
}
function v2(a, u) {
  const s = a.rootNode();
  return u && u(s) || s;
}
function zC(a = {}) {
  let u, s, f, p, h = null, m = 0, x = !1, C = !1, E = !1, R = !1;
  function T(Ee, Ue) {
    s = Ee;
    const {
      mergeOptions: Re,
      optionsAtMedia: Ke
    } = Ue, oe = Re(d2, zC.globalOptions), le = Re(oe, a);
    if (u = Ke(le), s.scrollSnapList().length <= 1) return;
    R = u.jump, f = !1, p = p2(s, u.delay);
    const {
      eventStore: W,
      ownerDocument: ie
    } = s.internalEngine(), we = !!s.internalEngine().options.watchDrag, je = v2(s, u.rootNode);
    W.add(ie, "visibilitychange", z), we && s.on("pointerDown", I), we && !u.stopOnInteraction && s.on("pointerUp", V), u.stopOnMouseEnter && W.add(je, "mouseenter", B), u.stopOnMouseEnter && !u.stopOnInteraction && W.add(je, "mouseleave", ae), u.stopOnFocusIn && s.on("slideFocusStart", A), u.stopOnFocusIn && !u.stopOnInteraction && W.add(s.containerNode(), "focusout", k), u.playOnInit && k();
  }
  function O() {
    s.off("pointerDown", I).off("pointerUp", V).off("slideFocusStart", A), A(), f = !0, x = !1;
  }
  function N() {
    const {
      ownerWindow: Ee
    } = s.internalEngine();
    Ee.clearTimeout(m), m = Ee.setTimeout(Te, p[s.selectedScrollSnap()]), h = (/* @__PURE__ */ new Date()).getTime(), s.emit("autoplay:timerset");
  }
  function j() {
    const {
      ownerWindow: Ee
    } = s.internalEngine();
    Ee.clearTimeout(m), m = 0, h = null, s.emit("autoplay:timerstopped");
  }
  function k() {
    if (!f) {
      if (F()) {
        E = !0;
        return;
      }
      x || s.emit("autoplay:play"), N(), x = !0;
    }
  }
  function A() {
    f || (x && s.emit("autoplay:stop"), j(), x = !1);
  }
  function z() {
    if (F())
      return E = x, A();
    E && k();
  }
  function F() {
    const {
      ownerDocument: Ee
    } = s.internalEngine();
    return Ee.visibilityState === "hidden";
  }
  function I() {
    C || A();
  }
  function V() {
    C || k();
  }
  function B() {
    C = !0, A();
  }
  function ae() {
    C = !1, k();
  }
  function Z(Ee) {
    typeof Ee < "u" && (R = Ee), k();
  }
  function pe() {
    x && A();
  }
  function de() {
    x && k();
  }
  function me() {
    return x;
  }
  function Te() {
    const {
      index: Ee
    } = s.internalEngine(), Ue = Ee.clone().add(1).get(), Re = s.scrollSnapList().length - 1, Ke = u.stopOnLastSnap && Ue === Re;
    if (s.canScrollNext() ? s.scrollNext(R) : s.scrollTo(0, R), s.emit("autoplay:select"), Ke) return A();
    k();
  }
  function ve() {
    if (!h) return null;
    const Ee = p[s.selectedScrollSnap()], Ue = (/* @__PURE__ */ new Date()).getTime() - h;
    return Ee - Ue;
  }
  return {
    name: "autoplay",
    options: a,
    init: T,
    destroy: O,
    play: Z,
    stop: pe,
    reset: de,
    isPlaying: me,
    timeUntilNext: ve
  };
}
zC.globalOptions = void 0;
const h2 = (a) => {
  const [u, s] = Gi(!1), f = Ku(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoplay;
    h && h.stop();
  }, [a]), p = Ku(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoplay;
    h && h.play();
  }, [a]);
  return zo(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoplay;
    h && (s(h.isPlaying()), a.on("autoplay:play", () => s(!0)).on("autoplay:stop", () => s(!1)).on("reInit", () => s(h.isPlaying())));
  }, [a]), {
    autoplayIsPlaying: u,
    stopAutoPlay: f,
    resumeAutoPlay: p
  };
}, H3 = (a) => {
  var u, s, f, p, h, m, x, C, E, R, T, O, N, j, k, A, z, F, I, V, B, ae, Z, pe, de, me, Te, ve;
  return {
    shouldLoadFontFaces: a.should_load_font_faces,
    fontType: a.font_type,
    googleFontFaces: ((u = a.google_font_faces) == null ? void 0 : u.map((ce) => ({
      familyName: ce.family_name,
      src: ce.src,
      style: ce.style,
      weight: ce.weight,
      display: ce.display,
      unicodeRange: ce.unicode_range
    }))) ?? [],
    customFontFaces: (a == null ? void 0 : a.custom_font_faces) ?? [],
    logoUrl: a.logo_url,
    backgroundColor: a.background_color,
    popTriggerTime: a.pop_trigger_time,
    borderRadius: a.border_radius,
    primaryCTA: {
      text: a.primary_cta.text,
      color: a.primary_cta.color,
      backgroundColor: a.primary_cta.background_color
    },
    // Todo: Genish remove the optional chaining
    title: {
      text: (s = a.title) == null ? void 0 : s.text,
      color: (f = a.title) == null ? void 0 : f.color
    },
    subTitle: a.sub_title ? {
      text: (p = a.sub_title) == null ? void 0 : p.text,
      color: (h = a.sub_title) == null ? void 0 : h.color
    } : void 0,
    banner: {
      enabled: a.banner.enabled,
      backgroundColor: a.banner.background_color,
      textColor: a.banner.text_color,
      items: a.banner.items.map((ce) => ({
        type: ce.type,
        enabled: ce.enabled,
        textColor: ce.text_color,
        backgroundColor: ce.background_color ?? a.banner.background_color,
        htmlTextString: ce.html_text_string
      }))
    },
    card: {
      enabled: a.card.enabled,
      backgroundColor: a.card.background_color,
      backgroundImage: a.card.background_image,
      textColor: a.card.text_color,
      borderColor: a.card.border_color,
      borderWidth: a.card.border_width,
      borderRadius: a.card.border_radius,
      items: a.card.items.map((ce) => ({
        isTopIconTextOrImage: ce.is_top_icon_text_or_image,
        backgroundColor: ce.background_color,
        backgroundImage: ce.background_image,
        topIconText: ce.top_icon_text,
        topIconTextColor: ce.top_icon_text_color,
        topIconImage: ce.top_icon_image,
        title: ce.title,
        titleColor: ce.title_color,
        description: ce.description,
        descriptionColor: ce.description_color,
        borderColor: ce.border_color,
        borderWidth: ce.border_width,
        borderRadius: ce.border_radius
      }))
    },
    ...a.post_login && {
      postLogin: {
        backgroundColor: ((m = a.post_login) == null ? void 0 : m.background_color) ?? a.background_color ?? "",
        primaryCTA: {
          text: ((C = (x = a.post_login) == null ? void 0 : x.primary_cta) == null ? void 0 : C.text) ?? ((E = a.primary_cta) == null ? void 0 : E.text) ?? "",
          color: ((T = (R = a.post_login) == null ? void 0 : R.primary_cta) == null ? void 0 : T.color) ?? ((O = a.primary_cta) == null ? void 0 : O.color) ?? "",
          backgroundColor: ((j = (N = a.post_login) == null ? void 0 : N.primary_cta) == null ? void 0 : j.background_color) ?? ((k = a.primary_cta) == null ? void 0 : k.background_color) ?? ""
        },
        title: {
          text: ((z = (A = a.post_login) == null ? void 0 : A.title) == null ? void 0 : z.text) ?? ((F = a.title) == null ? void 0 : F.text) ?? "",
          color: ((V = (I = a.post_login) == null ? void 0 : I.title) == null ? void 0 : V.color) ?? ((B = a.title) == null ? void 0 : B.color) ?? ""
        },
        subtitle: {
          text: ((Z = (ae = a.post_login) == null ? void 0 : ae.sub_title) == null ? void 0 : Z.text) ?? ((pe = a.sub_title) == null ? void 0 : pe.text) ?? "",
          color: ((me = (de = a.post_login) == null ? void 0 : de.sub_title) == null ? void 0 : me.color) ?? ((Te = a.sub_title) == null ? void 0 : Te.color) ?? ""
        },
        discountCardEnabled: ((ve = a.post_login) == null ? void 0 : ve.discount_card_enabled) ?? !1
      }
    }
  };
}, qu = (a) => a ? (a == null ? void 0 : a.isPreview) && (a == null ? void 0 : a.device) === e_.MOBILE : !1, h1 = (a, u) => a ? a.replace(
  /(\d+)px/,
  (s, f) => `${Number(f) + u}px`
) : "0px", a_ = (a) => a.replace(/<[^>]*>/g, "").trim().length, sh = (a, u, s) => a_(a) === 0 && (u != null && u.isPreview) ? m2(s) : a, m2 = (a) => {
  switch (a) {
    case "title":
      return "";
    case "subTitle":
      return "";
    case "banner":
      return "• Add banner text •";
  }
}, g2 = (a) => {
  const u = Dy([]), { slides: s, options: f, styles: p, overRides: h } = a, [m, x] = Dd(f, [
    zC({
      playOnInit: !(h != null && h.isPreview),
      delay: 5e3,
      stopOnInteraction: !0,
      stopOnFocusIn: !0,
      stopOnMouseEnter: !0
    })
  ]), { stopAutoPlay: C, resumeAutoPlay: E } = h2(x), {
    prevBtnDisabled: R,
    nextBtnDisabled: T,
    onPrevButtonClick: O,
    onNextButtonClick: N
  } = s2(x);
  zo(() => {
    var k, A, z, F;
    if (h && x && ((k = h == null ? void 0 : h.focusedComponent) == null ? void 0 : k.type) === Ea.CARD && (((A = h == null ? void 0 : h.focusedComponent) == null ? void 0 : A.cardIndex) ?? -1) >= 0 ? (x.scrollTo(((z = h == null ? void 0 : h.focusedComponent) == null ? void 0 : z.cardIndex) ?? 0), u.current.forEach((I, V) => {
      var B, ae;
      V === ((B = h == null ? void 0 : h.focusedComponent) == null ? void 0 : B.cardIndex) ? (I == null || I.classList.add(
        "ui-border-2",
        "ui-border-primary-dark",
        "ui-shadow-lg",
        "ui-rounded-[inherit]"
      ), I && (I.style.borderRadius = h1(
        ((ae = p == null ? void 0 : p.card) == null ? void 0 : ae.borderRadius) || "0px",
        2
      ))) : (I == null || I.classList.remove("ui-border-2", "ui-border-primary-dark"), I && (I.style.borderRadius = "0px"));
    })) : u.current.forEach((I) => {
      I == null || I.classList.remove("ui-border-2", "ui-border-primary-dark"), I && (I.style.borderRadius = "0px");
    }), ((F = h == null ? void 0 : h.focusedComponent) == null ? void 0 : F.type) === Ea.CARDS && (h != null && h.focusedComponent.cardStyleType) && x) {
      const I = x == null ? void 0 : x.selectedScrollSnap();
      u.current.forEach((V, B) => {
        var ae;
        B === I ? (V == null || V.classList.add(
          "ui-border-2",
          "ui-border-primary-dark",
          "ui-shadow-lg",
          "ui-rounded-[inherit]"
        ), V && (V.style.borderRadius = h1(
          ((ae = p == null ? void 0 : p.card) == null ? void 0 : ae.borderRadius) || "0px",
          2
        ))) : (V == null || V.classList.remove("ui-border-2", "ui-border-primary-dark"), V && (V.style.borderRadius = "0px"));
      });
    }
  }, [h == null ? void 0 : h.focusedComponent]), zo(() => {
    x == null || x.on("select", (k) => {
      const A = k.selectedScrollSnap();
      u.current.forEach((z, F) => {
        F === A ? (z == null || z.classList.add("ui-scale-100"), z == null || z.classList.remove("ui-scale-90")) : (z == null || z.classList.remove("ui-scale-100"), z == null || z.classList.add("ui-scale-90"));
      });
    });
  }, [x]);
  const j = (k, A) => {
    A && (u.current[k] = A);
  };
  return zo(() => {
    u.current.forEach((k, A) => {
      A !== 0 && (k == null || k.classList.add("ui-scale-90"));
    });
  }, []), /* @__PURE__ */ D.jsxs(
    "section",
    {
      className: "embla ui-relative ui-mx-auto ui-border-red ui-border-5",
      onMouseEnter: () => {
        s.length > 1 && C();
      },
      onMouseLeave: () => {
        s.length > 1 && !(h != null && h.isPreview) && E();
      },
      onClick: () => {
        var k;
        if (h != null && h.isPreview) {
          const A = (x == null ? void 0 : x.selectedScrollSnap()) ?? 0;
          (k = h == null ? void 0 : h.setScrollToCard) == null || k.call(h, A);
        }
      },
      children: [
        /* @__PURE__ */ D.jsxs(
          "div",
          {
            className: "embla_viewport ui-overflow-x-hidden ui-relative ui-z-100",
            ref: m,
            children: [
              /* @__PURE__ */ D.jsx(
                "div",
                {
                  className: Qi(
                    "embla_container ui-flex ui-touch-pan-y ui-border-green ui-border-5",
                    s.length === 1 ? "ui-justify-center" : ""
                  ),
                  children: s.map((k, A) => /* @__PURE__ */ D.jsx(
                    "div",
                    {
                      className: Qi(
                        "embla_slide ui-transform ui-translate-x-0 ui-translate-y-0 ui-translate-z-0",
                        qu(h) ? "ui-flex-[0_0_100%] ui-px-8" : "ui-flex-[0_0_50%]"
                      ),
                      children: /* @__PURE__ */ D.jsx(
                        "div",
                        {
                          className: "ui-transition-transform ui-duration-300 ui-border-red ui-border-5",
                          ref: (z) => j(A, z),
                          children: k
                        }
                      )
                    },
                    A
                  ))
                }
              ),
              /* @__PURE__ */ D.jsx("div", { className: "ui-h-4 ui-w-full" })
            ]
          }
        ),
        /* @__PURE__ */ D.jsxs("div", { className: "ui-absolute ui-top-0 ui-left-0 ui-w-full ui-h-full ui-flex ui-items-center ui-justify-between", children: [
          /* @__PURE__ */ D.jsx(
            c2,
            {
              onClick: (k) => {
                k.stopPropagation(), O();
              },
              disabled: R,
              styles: p == null ? void 0 : p.button,
              customizeUI: {
                iconRequired: (h == null ? void 0 : h.isPreview) ?? !1,
                isMobilePreview: qu(h)
              }
            }
          ),
          /* @__PURE__ */ D.jsx(
            f2,
            {
              onClick: (k) => {
                k.stopPropagation(), N();
              },
              disabled: T,
              styles: p == null ? void 0 : p.button,
              customizeUI: {
                iconRequired: (h == null ? void 0 : h.isPreview) ?? !1,
                isMobilePreview: qu(h)
              }
            }
          )
        ] })
      ]
    }
  );
}, i_ = Y1(null), y2 = ({
  children: a,
  ...u
}) => /* @__PURE__ */ D.jsx(i_.Provider, { value: u, children: a }), Xi = () => {
  const a = G1(i_);
  if (!a)
    throw new Error(
      "useSSOMarketingPopupContext must be used within a SSOMarketingPopupProvider"
    );
  return a;
}, x2 = {
  loop: !0,
  align: "center"
}, S2 = () => {
  const {
    overRides: a,
    popup: { card: u, backgroundColor: s }
  } = Xi();
  if (!u.enabled)
    return null;
  const {
    backgroundColor: p,
    backgroundImage: h,
    textColor: m,
    borderColor: x,
    borderWidth: C,
    borderRadius: E
  } = u, R = Yi(() => {
    const T = u.items.map((O, N) => {
      const {
        isTopIconTextOrImage: j,
        topIconText: k,
        topIconImage: A,
        topIconTextColor: z,
        title: F,
        titleColor: I,
        description: V,
        descriptionColor: B
      } = O, ae = j === "text" && k, Z = j === "image", pe = O.borderColor || x, de = O.borderWidth || C, me = O.borderRadius || E, Te = O.backgroundColor || p, ve = O.backgroundImage || h;
      return /* @__PURE__ */ D.jsxs(
        "div",
        {
          style: {
            backgroundColor: Te,
            color: m,
            borderColor: pe,
            borderWidth: de,
            borderRadius: me
          },
          className: Qi(
            "ui-flex ui-flex-col ui-items-center xxs:ui-h-[140px] xxs:ui-w-[254px] ui-justify-center ui-relative ui-z-10 ui-shadow-[0px_2px_4px_0px_#00000040] ui-text-center ui-px-6 ui-py-8",
            O.topIconText ? "ui-space-y-2" : "",
            qu(a) ? "!ui-w-full ui-h-[110px]" : "ui-w-[240px] ui-h-[140px]"
          ),
          children: [
            ve && /* @__PURE__ */ D.jsx(
              "div",
              {
                style: {
                  backgroundImage: `url(${ve})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat"
                },
                className: "ui-h-full ui-w-full ui-absolute ui-top-0 ui-left-0 -ui-z-10"
              }
            ),
            ae && /* @__PURE__ */ D.jsx(
              "p",
              {
                className: Qi(
                  "ui-font-semibold",
                  qu(a) ? "ui-text-[20px]" : "ui-text-[30px]"
                ),
                style: { color: z || m },
                children: k
              }
            ),
            Z && /* @__PURE__ */ D.jsx(
              "img",
              {
                src: A,
                alt: k,
                className: "ui-max-w-14 ui-max-h-14 ui-pb-1"
              }
            ),
            /* @__PURE__ */ D.jsx(
              "h3",
              {
                className: "ui-text-sm ui-font-semibold",
                style: { color: I || m },
                children: F
              }
            ),
            V && /* @__PURE__ */ D.jsx(
              "p",
              {
                className: "ui-text-xs ui-font-medium ui-pt-2",
                style: { color: B || m },
                dangerouslySetInnerHTML: { __html: O.description ?? "" }
              }
            )
          ]
        },
        N
      );
    });
    return T.length === 2 ? [...T, ...T] : T;
  }, [u]);
  return /* @__PURE__ */ D.jsx(
    g2,
    {
      slides: R,
      options: x2,
      styles: {
        button: { backgroundColor: s },
        card: { borderRadius: E }
      },
      overRides: a
    }
  );
}, b2 = (a) => {
  const [u, s] = Gi(!1), f = Ku(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoScroll;
    h && h.stop();
  }, [a]), p = Ku(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoScroll;
    h && h.play();
  }, [a]);
  return zo(() => {
    var m;
    const h = (m = a == null ? void 0 : a.plugins()) == null ? void 0 : m.autoScroll;
    h && (s(h.isPlaying()), a.on("autoScroll:play", () => s(!0)).on("autoScroll:stop", () => s(!1)).on("reInit", () => s(h.isPlaying())));
  }, [a]), {
    stopAutoScroll: f,
    resumeAutoScroll: p,
    autoScrollIsPlaying: u
  };
}, C2 = {
  direction: "forward",
  speed: 2,
  startDelay: 1e3,
  active: !0,
  breakpoints: {},
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  rootNode: null
};
function E2(a, u) {
  const s = a.rootNode();
  return u && u(s) || s;
}
function IC(a = {}) {
  let u, s, f, p, h = 0, m = !1, x = !1, C;
  function E(de, me) {
    s = de;
    const {
      mergeOptions: Te,
      optionsAtMedia: ve
    } = me, ce = Te(C2, IC.globalOptions), Ee = Te(ce, a);
    if (u = ve(Ee), s.scrollSnapList().length <= 1) return;
    p = u.startDelay, f = !1, C = s.internalEngine().scrollBody;
    const {
      eventStore: Ue
    } = s.internalEngine(), Re = !!s.internalEngine().options.watchDrag, Ke = E2(s, u.rootNode);
    Re && s.on("pointerDown", j), Re && !u.stopOnInteraction && s.on("pointerUp", k), u.stopOnMouseEnter && Ue.add(Ke, "mouseenter", A), u.stopOnMouseEnter && !u.stopOnInteraction && Ue.add(Ke, "mouseleave", z), u.stopOnFocusIn && s.on("slideFocusStart", O), u.stopOnFocusIn && !u.stopOnInteraction && Ue.add(s.containerNode(), "focusout", T), u.playOnInit && T();
  }
  function R() {
    s.off("pointerDown", j).off("pointerUp", k).off("slideFocusStart", O).off("settle", F), O(), f = !0, m = !1;
  }
  function T() {
    if (f || m) return;
    s.emit("autoScroll:play");
    const de = s.internalEngine(), {
      ownerWindow: me
    } = de;
    h = me.setTimeout(() => {
      de.scrollBody = N(de), de.animation.start();
    }, p), m = !0;
  }
  function O() {
    if (f || !m) return;
    s.emit("autoScroll:stop");
    const de = s.internalEngine(), {
      ownerWindow: me
    } = de;
    de.scrollBody = C, me.clearTimeout(h), h = 0, m = !1;
  }
  function N(de) {
    const {
      location: me,
      previousLocation: Te,
      offsetLocation: ve,
      target: ce,
      scrollTarget: Ee,
      index: Ue,
      indexPrevious: Re,
      limit: {
        reachedMin: Ke,
        reachedMax: oe,
        constrain: le
      },
      options: {
        loop: W
      }
    } = de, ie = u.direction === "forward" ? -1 : 1, we = () => Ie;
    let je = 0, ke = 0, et = me.get(), Pe = 0, Oe = !1;
    function Me() {
      let $e = 0;
      Te.set(me), je = ie * u.speed, et += je, me.add(je), ce.set(me), $e = et - Pe, ke = Math.sign($e), Pe = et;
      const Qe = Ee.byDistance(0, !1).index;
      Ue.get() !== Qe && (Re.set(Ue.get()), Ue.set(Qe), s.emit("select"));
      const re = u.direction === "forward" ? Ke(ve.get()) : oe(ve.get());
      if (!W && re) {
        Oe = !0;
        const qe = le(me.get());
        me.set(qe), ce.set(me), O();
      }
      return Ie;
    }
    const Ie = {
      direction: () => ke,
      duration: () => -1,
      velocity: () => je,
      settled: () => Oe,
      seek: Me,
      useBaseFriction: we,
      useBaseDuration: we,
      useFriction: we,
      useDuration: we
    };
    return Ie;
  }
  function j() {
    x || O();
  }
  function k() {
    x || I();
  }
  function A() {
    x = !0, O();
  }
  function z() {
    x = !1, T();
  }
  function F() {
    s.off("settle", F), T();
  }
  function I() {
    s.on("settle", F);
  }
  function V(de) {
    typeof de < "u" && (p = de), T();
  }
  function B() {
    m && O();
  }
  function ae() {
    m && (O(), I());
  }
  function Z() {
    return m;
  }
  return {
    name: "autoScroll",
    options: a,
    init: E,
    destroy: R,
    play: V,
    stop: B,
    reset: ae,
    isPlaying: Z
  };
}
IC.globalOptions = void 0;
const w2 = (a) => {
  const { slides: u } = a, [s, f] = Dd({ loop: !0 }, [
    IC({
      playOnInit: !0,
      speed: 1
    })
  ]), { resumeAutoScroll: p, stopAutoScroll: h } = b2(f);
  zo(() => (p(), () => {
    h();
  }), []);
  const m = Yi(() => u.length > 4 ? u : [...u, ...u, ...u, ...u], [u]);
  return /* @__PURE__ */ D.jsx("section", { className: "embla ui-relative ui-mx-auto", children: /* @__PURE__ */ D.jsx(
    "div",
    {
      className: "embla_viewport ui-overflow-x-hidden ui-relative ui-z-100 -ui-",
      ref: s,
      children: /* @__PURE__ */ D.jsx("div", { className: "embla_container ui-flex ui-touch-pan-y", children: m.map((x, C) => /* @__PURE__ */ D.jsx(
        "div",
        {
          className: "embla_slide ui-flex-[0_0_auto] min-w-0 ui-transform ui-translate-x-0 ui-translate-y-0 ui-translate-z-0",
          children: /* @__PURE__ */ D.jsx("div", { className: "", children: x })
        },
        C
      )) })
    }
  ) });
}, T2 = {
  loop: !0
}, R2 = () => {
  var m;
  const {
    popup: {
      banner: {
        enabled: a,
        items: u,
        backgroundColor: s,
        textColor: f
      }
    },
    overRides: p
  } = Xi();
  if (!a) return /* @__PURE__ */ D.jsx(D.Fragment, {});
  if (u.length === 1) {
    const x = u[0], C = (x == null ? void 0 : x.backgroundColor) || s, E = (x == null ? void 0 : x.textColor) || f;
    return /* @__PURE__ */ D.jsx(
      "div",
      {
        className: "ui-w-full ui-text-center ui-pt-4",
        onClick: () => {
          var R;
          return (R = p == null ? void 0 : p.setFocusedComponent) == null ? void 0 : R.call(p, {
            type: Ea.BANNER,
            via: vh.POPUP
          });
        },
        children: /* @__PURE__ */ D.jsx(
          "p",
          {
            style: {
              backgroundColor: C,
              color: E
            },
            className: Qi(
              "ui-w-full ui-text-xs ui-py-2 ui-px-2 ui-text-center ",
              ((m = p == null ? void 0 : p.focusedComponent) == null ? void 0 : m.type) === Ea.BANNER ? "ui-border ui-border-primary-dark ui-shadow-xl" : "",
              a_((x == null ? void 0 : x.htmlTextString) || "") === 0 ? "h-[35px]" : ""
            ),
            dangerouslySetInnerHTML: {
              __html: sh(
                (x == null ? void 0 : x.htmlTextString) || "",
                p,
                "banner"
              )
            }
          }
        )
      }
    );
  }
  const h = Yi(() => u.map((x, C) => {
    const E = x.backgroundColor || s, R = x.textColor || f;
    return /* @__PURE__ */ D.jsx(
      "p",
      {
        style: {
          backgroundColor: E,
          color: R
        },
        className: "ui-w-full ui-text-xs ui-py-2 ui-px-2 ui-border-none",
        dangerouslySetInnerHTML: { __html: (x == null ? void 0 : x.htmlTextString) || "" }
      },
      C
    );
  }), [u]);
  return /* @__PURE__ */ D.jsx("div", { className: "ui-w-full ui-text-center ui-pt-4 ", children: /* @__PURE__ */ D.jsx(w2, { slides: h, options: T2 }) });
}, _2 = ({ children: a, ...u }) => /* @__PURE__ */ D.jsx(y2, { ...u, children: /* @__PURE__ */ D.jsx(O2, { children: a }) });
_2.displayName = "Banner";
const O2 = ({ children: a }) => {
  var x;
  const {
    popup: { backgroundColor: u, borderRadius: s, postLogin: f },
    currentWindow: p,
    overRides: h
  } = Xi(), m = () => p === dC.POST_LOGIN && f ? /* @__PURE__ */ D.jsx(D.Fragment, { children: /* @__PURE__ */ D.jsx(P2, { children: a }) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsx(S2, {}),
    /* @__PURE__ */ D.jsx(A2, {}),
    a
  ] });
  return /* @__PURE__ */ D.jsxs(
    "div",
    {
      style: {
        backgroundColor: p === dC.POST_LOGIN ? f == null ? void 0 : f.backgroundColor : u,
        borderRadius: s,
        fontFamily: '"ShopfloPopupFont", "Inter", Arial, Helvetica, sans-serif',
        boxShadow: "0px 2px 4px 0px #00000040"
      },
      className: Qi(
        "ui-w-full ui-h-full ui-overflow-x-hidden",
        ((x = h == null ? void 0 : h.focusedComponent) == null ? void 0 : x.type) === Ea.SSO ? "ui-border ui-border-primary-dark" : ""
      ),
      children: [
        /* @__PURE__ */ D.jsx(R2, {}),
        /* @__PURE__ */ D.jsxs("div", { className: "ui-w-full ui-h-full ui-pt-3", children: [
          /* @__PURE__ */ D.jsx(N2, {}),
          m()
        ] })
      ]
    }
  );
}, D2 = () => {
  const { onClose: a } = Xi();
  return /* @__PURE__ */ D.jsx("button", { onClick: a, children: /* @__PURE__ */ D.jsx(MC, { size: 24, color: "#4D4D4D" }) });
}, k2 = () => {
  const { overRides: a } = Xi();
  return /* @__PURE__ */ D.jsx(
    "h3",
    {
      className: `ui-text-coal-lighter ui-font-bold ui-border-2 ui-border-dashed ui-text-sm ui-rounded-md ui-border-gray-light ui-px-4 ui-py-2 ${qu(a) ? "100px" : "150px"}`,
      children: "Logo"
    }
  );
}, M2 = () => {
  const {
    overRides: a,
    popup: { logoUrl: u }
  } = Xi();
  return !u && (a != null && a.isPreview) ? /* @__PURE__ */ D.jsx(k2, {}) : /* @__PURE__ */ D.jsx("picture", { children: /* @__PURE__ */ D.jsx(
    "img",
    {
      src: u,
      alt: "merchant logo",
      className: "ui-float-left ui-h-[55px] ui-max-w-[200px] ui-bg-transparent ui-object-contain"
    }
  ) });
}, N2 = () => {
  const { overRides: a } = Xi();
  return /* @__PURE__ */ D.jsxs("div", { className: "ui-relative ui-flex ui-items-center ui-justify-center ui-w-full ui-pb-4", children: [
    /* @__PURE__ */ D.jsx(M2, {}),
    /* @__PURE__ */ D.jsx("span", { className: "ui-absolute ui-right-0 ui-pr-2 ui-top-0", children: a != null && a.isPreview ? /* @__PURE__ */ D.jsx(D.Fragment, {}) : /* @__PURE__ */ D.jsx(D2, {}) })
  ] });
}, A2 = () => {
  var p;
  const {
    popup: {
      title: { text: a, color: u },
      subTitle: s
    },
    overRides: f
  } = Xi();
  return /* @__PURE__ */ D.jsx(
    "div",
    {
      className: Qi(
        " ui-px-4 ui-pt-4 ui-flex ui-items-center ui-justify-center"
      ),
      onClick: (h) => {
        var m;
        (m = f == null ? void 0 : f.setFocusedComponent) == null || m.call(f, {
          type: Ea.TITLE_AND_SUBTITLE,
          via: vh.POPUP
        });
      },
      children: /* @__PURE__ */ D.jsxs(
        "div",
        {
          className: Qi(
            "ui-flex ui-flex-col w-fit",
            ((p = f == null ? void 0 : f.focusedComponent) == null ? void 0 : p.type) === Ea.TITLE_AND_SUBTITLE ? "ui-border ui-border-primary-dark ui-shadow-xl" : ""
          ),
          children: [
            /* @__PURE__ */ D.jsx(
              "p",
              {
                className: "ui-text-center ui-font-bold ui-text-lg xxs:ui-text-[24px]",
                style: { color: u },
                dangerouslySetInnerHTML: {
                  __html: sh(a || "", f, "title")
                }
              }
            ),
            s && /* @__PURE__ */ D.jsx(
              "p",
              {
                className: "ui-text-center ui-font-medium",
                style: {
                  color: s.color,
                  fontSize: qu(f) ? "12px" : "16px"
                },
                dangerouslySetInnerHTML: {
                  __html: sh(
                    s.text || "",
                    f,
                    "subTitle"
                  )
                }
              }
            )
          ]
        }
      )
    }
  );
}, P2 = ({ children: a }) => {
  var h;
  const {
    popup: { postLogin: u },
    overRides: s
  } = Xi();
  if (!u) return /* @__PURE__ */ D.jsx(D.Fragment, {});
  const { title: f, subtitle: p } = u;
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsxs(
      "div",
      {
        className: `ui-flex ui-flex-col ui-items-center ui-px-4 ui-space-y-4 ${((h = s == null ? void 0 : s.focusedComponent) == null ? void 0 : h.type) === Ea.POST_LOGIN_TITLE_AND_SUBTITLE ? "ui-border ui-border-primary-dark ui-shadow-xl" : ""}`,
        onClick: (m) => {
          var x;
          (x = s == null ? void 0 : s.setFocusedComponent) == null || x.call(s, {
            type: Ea.POST_LOGIN_TITLE_AND_SUBTITLE,
            via: vh.POPUP
          });
        },
        children: [
          /* @__PURE__ */ D.jsx(
            "p",
            {
              className: "ui-text-center ui-font-bold ui-text-lg xxs:ui-text-[24px]",
              style: { color: f.color },
              dangerouslySetInnerHTML: {
                __html: sh(f.text || "", s, "title")
              }
            }
          ),
          /* @__PURE__ */ D.jsx(
            "p",
            {
              className: "ui-text-center ui-font-medium",
              style: {
                color: p.color,
                fontSize: qu(s) ? "12px" : "16px"
              },
              dangerouslySetInnerHTML: {
                __html: sh(
                  p.text || "",
                  s,
                  "subTitle"
                )
              }
            }
          )
        ]
      }
    ),
    a
  ] });
}, $3 = ({
  code: a,
  title: u,
  description: s,
  tagText: f,
  tagBackgroundColor: p,
  tagTextColor: h,
  handleCopyCouponCode: m
}) => {
  var j;
  const {
    popup: {
      postLogin: x,
      backgroundColor: C,
      primaryCTA: { backgroundColor: E }
    },
    overRides: R
  } = Xi();
  if (!x) return /* @__PURE__ */ D.jsx(D.Fragment, {});
  const [T, O] = Gi(!1), N = () => {
    a && (m == null || m(a), navigator.clipboard.writeText(a), O(!0), setTimeout(() => {
      O(!1);
    }, 3e3));
  };
  return /* @__PURE__ */ D.jsxs(
    "div",
    {
      onClick: () => {
        var k;
        (k = R == null ? void 0 : R.setFocusedComponent) == null || k.call(R, {
          type: Ea.POST_LOGIN_DISCOUNT_CODE,
          via: vh.POPUP
        });
      },
      className: `ui-flex ui-flex-col ui-p-4 ui-pt-6 ui-rounded-lg ui-shadow-md ui-relative ui-w-full ui-bg-white ${((j = R == null ? void 0 : R.focusedComponent) == null ? void 0 : j.type) === Ea.POST_LOGIN_DISCOUNT_CODE && "border-2 border-primary-dark"}`,
      children: [
        /* @__PURE__ */ D.jsx("div", { className: "ui-absolute ui-top-0 ui-right-3", children: /* @__PURE__ */ D.jsx(
          "div",
          {
            className: "ui-rounded-b-lg ui-text-white ui-border-[1px] ui-border-t-0",
            style: {
              backgroundColor: p
            },
            children: /* @__PURE__ */ D.jsx(
              "p",
              {
                className: "ui-text-[8px] ui-py-[4px] ui-px-[8px] ",
                style: { color: h },
                children: f
              }
            )
          }
        ) }),
        /* @__PURE__ */ D.jsx("p", { className: "ui-font-bold ui-text-lg", children: u }),
        /* @__PURE__ */ D.jsx("p", { className: "ui-text-xs ui-mt-1", children: s }),
        /* @__PURE__ */ D.jsxs("div", { className: "ui-flex ui-flex-col ui-gap-1 ui-justify-center ui-items-center", children: [
          /* @__PURE__ */ D.jsx(
            "div",
            {
              className: "ui-text-primary-dark ui-border-dashed ui-border-1 ui-border-primary-dark ui-rounded-lg ui-p-2 ui-mt-4 ui-w-full",
              style: {
                backgroundColor: `${p}1A`,
                borderColor: p
              },
              children: /* @__PURE__ */ D.jsx(
                "p",
                {
                  className: "ui-text-xs ui-w-full ui-text-center",
                  style: { color: p },
                  children: a
                }
              )
            }
          ),
          /* @__PURE__ */ D.jsx(
            "button",
            {
              className: "ui-flex ui-flex-row ui-items-center ui-space-x-1 ui-mt-2 ui-text-xxs",
              onClick: N,
              children: T ? /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
                /* @__PURE__ */ D.jsx(_C, { size: 10, color: "#2c874a" }),
                /* @__PURE__ */ D.jsx("p", { className: "ui-text-yay-dark", children: "COPIED" })
              ] }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
                /* @__PURE__ */ D.jsx(OC, { size: 10, color: "#949494" }),
                /* @__PURE__ */ D.jsx("p", { className: "ui-text-gray-dark", children: "TAP TO COPY CODE" })
              ] })
            }
          )
        ] })
      ]
    }
  );
}, V3 = () => /* @__PURE__ */ D.jsxs("div", { className: "ui-flex ui-flex-col ui-p-4 ui-rounded-lg ui-shadow-md ui-relative ui-w-full ui-bg-white", children: [
  /* @__PURE__ */ D.jsx("div", { className: "ui-absolute ui-top-0 ui-right-3", children: /* @__PURE__ */ D.jsx("div", { className: "ui-rounded-b-lg ui-text-white ui-border-[1px] ui-border-t-0", children: /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-text-[8px] ui-py-2 ui-px-2 ui-w-24" }) }) }),
  /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-font-bold ui-text-lg ui-w-3/4 ui-h-6 ui-rounded ui-mt-2" }),
  /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-text-xs ui-mt-1 ui-w-full ui-h-4 ui-rounded" }),
  /* @__PURE__ */ D.jsxs("div", { className: "ui-flex ui-flex-col ui-gap-1 ui-justify-center ui-items-center", children: [
    /* @__PURE__ */ D.jsx("div", { className: "ui-border-dashed ui-border-1 ui-rounded-lg ui-p-2 ui-mt-4 ui-w-full", children: /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-text-xs ui-w-full ui-h-4 ui-text-center ui-rounded" }) }),
    /* @__PURE__ */ D.jsxs("div", { className: "ui-flex ui-flex-row ui-items-center ui-space-x-1 ui-mt-2 ui-text-xxs", children: [
      /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-h-3 ui-w-3 ui-rounded" }),
      /* @__PURE__ */ D.jsx("div", { className: "skeleton-loader ui-h-3 ui-w-24 ui-rounded" })
    ] })
  ] })
] }), W3 = (a, u) => {
  let s = parseInt(a.substring(1, 3), 16), f = parseInt(a.substring(3, 5), 16), p = parseInt(a.substring(5, 7), 16);
  s = parseInt((s * (100 + u) / 100).toString()), f = parseInt((f * (100 + u) / 100).toString()), p = parseInt((p * (100 + u) / 100).toString()), s = s < 255 ? s : 255, f = f < 255 ? f : 255, p = p < 255 ? p : 255, s = Math.round(s), f = Math.round(f), p = Math.round(p);
  const h = s.toString(16).length == 1 ? "0" + s.toString(16) : s.toString(16), m = f.toString(16).length == 1 ? "0" + f.toString(16) : f.toString(16), x = p.toString(16).length == 1 ? "0" + p.toString(16) : p.toString(16);
  return "#" + h + m + x;
}, Y3 = ({
  slides: a,
  activeSlide: u = -1
}) => {
  const [s, f] = Dd({ loop: !0 }), [p, h] = Dd({
    containScroll: "keepSnaps",
    dragFree: !0
  }), [m, x] = Gi(0), C = () => {
    !f || !h || (x(f.selectedScrollSnap()), h.scrollTo(f.selectedScrollSnap()));
  }, E = () => {
    f == null || f.scrollPrev(), C();
  }, R = () => {
    f == null || f.scrollNext(), C();
  };
  return zo(() => {
    f && u >= 0 && (f.scrollTo(u), x(u));
  }, [u, f]), /* @__PURE__ */ D.jsx("div", { className: "ui-p-2 ui-container ui-max-w-3xl ui-mx-auto ui-h-fit", children: /* @__PURE__ */ D.jsxs("div", { className: "ui-relative", children: [
    /* @__PURE__ */ D.jsx(
      "button",
      {
        onClick: E,
        className: "ui-h-8 ui-w-8 ui-rounded-full ui-flex ui-items-center ui-justify-center ui-bg-gray-light ui-absolute ui-top-1/2 ui--translate-y-1/2 ui-z-10 ui-shadow-md ui-left-[-15px]",
        children: /* @__PURE__ */ D.jsx(By, { size: 16 })
      }
    ),
    /* @__PURE__ */ D.jsx(
      "button",
      {
        onClick: R,
        className: "ui-h-8 ui-w-8 ui-rounded-full ui-flex ui-items-center ui-justify-center ui-bg-gray-light ui-absolute ui-top-1/2 ui--translate-y-1/2 ui-z-10 ui-shadow-md ui-right-[-15px]",
        children: /* @__PURE__ */ D.jsx(Hy, { size: 16 })
      }
    ),
    /* @__PURE__ */ D.jsx("div", { className: "ui-overflow-hidden", ref: s, children: /* @__PURE__ */ D.jsx("div", { className: "ui-flex", children: a.map((T, O) => /* @__PURE__ */ D.jsx(
      "div",
      {
        className: "ui-flex-[0_0_100%] ui-w-full ui-overflow-hidden",
        children: T
      },
      O
    )) }) })
  ] }) });
}, UC = "-", L2 = (a) => {
  const u = z2(a), {
    conflictingClassGroups: s,
    conflictingClassGroupModifiers: f
  } = a;
  return {
    getClassGroupId: (m) => {
      const x = m.split(UC);
      return x[0] === "" && x.length !== 1 && x.shift(), l_(x, u) || j2(m);
    },
    getConflictingClassGroupIds: (m, x) => {
      const C = s[m] || [];
      return x && f[m] ? [...C, ...f[m]] : C;
    }
  };
}, l_ = (a, u) => {
  var m;
  if (a.length === 0)
    return u.classGroupId;
  const s = a[0], f = u.nextPart.get(s), p = f ? l_(a.slice(1), f) : void 0;
  if (p)
    return p;
  if (u.validators.length === 0)
    return;
  const h = a.join(UC);
  return (m = u.validators.find(({
    validator: x
  }) => x(h))) == null ? void 0 : m.classGroupId;
}, m1 = /^\[(.+)\]$/, j2 = (a) => {
  if (m1.test(a)) {
    const u = m1.exec(a)[1], s = u == null ? void 0 : u.substring(0, u.indexOf(":"));
    if (s)
      return "arbitrary.." + s;
  }
}, z2 = (a) => {
  const {
    theme: u,
    prefix: s
  } = a, f = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return U2(Object.entries(a.classGroups), s).forEach(([h, m]) => {
    hC(m, f, h, u);
  }), f;
}, hC = (a, u, s, f) => {
  a.forEach((p) => {
    if (typeof p == "string") {
      const h = p === "" ? u : g1(u, p);
      h.classGroupId = s;
      return;
    }
    if (typeof p == "function") {
      if (I2(p)) {
        hC(p(f), u, s, f);
        return;
      }
      u.validators.push({
        validator: p,
        classGroupId: s
      });
      return;
    }
    Object.entries(p).forEach(([h, m]) => {
      hC(m, g1(u, h), s, f);
    });
  });
}, g1 = (a, u) => {
  let s = a;
  return u.split(UC).forEach((f) => {
    s.nextPart.has(f) || s.nextPart.set(f, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), s = s.nextPart.get(f);
  }), s;
}, I2 = (a) => a.isThemeGetter, U2 = (a, u) => u ? a.map(([s, f]) => {
  const p = f.map((h) => typeof h == "string" ? u + h : typeof h == "object" ? Object.fromEntries(Object.entries(h).map(([m, x]) => [u + m, x])) : h);
  return [s, p];
}) : a, F2 = (a) => {
  if (a < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let u = 0, s = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
  const p = (h, m) => {
    s.set(h, m), u++, u > a && (u = 0, f = s, s = /* @__PURE__ */ new Map());
  };
  return {
    get(h) {
      let m = s.get(h);
      if (m !== void 0)
        return m;
      if ((m = f.get(h)) !== void 0)
        return p(h, m), m;
    },
    set(h, m) {
      s.has(h) ? s.set(h, m) : p(h, m);
    }
  };
}, u_ = "!", B2 = (a) => {
  const {
    separator: u,
    experimentalParseClassName: s
  } = a, f = u.length === 1, p = u[0], h = u.length, m = (x) => {
    const C = [];
    let E = 0, R = 0, T;
    for (let A = 0; A < x.length; A++) {
      let z = x[A];
      if (E === 0) {
        if (z === p && (f || x.slice(A, A + h) === u)) {
          C.push(x.slice(R, A)), R = A + h;
          continue;
        }
        if (z === "/") {
          T = A;
          continue;
        }
      }
      z === "[" ? E++ : z === "]" && E--;
    }
    const O = C.length === 0 ? x : x.substring(R), N = O.startsWith(u_), j = N ? O.substring(1) : O, k = T && T > R ? T - R : void 0;
    return {
      modifiers: C,
      hasImportantModifier: N,
      baseClassName: j,
      maybePostfixModifierPosition: k
    };
  };
  return s ? (x) => s({
    className: x,
    parseClassName: m
  }) : m;
}, H2 = (a) => {
  if (a.length <= 1)
    return a;
  const u = [];
  let s = [];
  return a.forEach((f) => {
    f[0] === "[" ? (u.push(...s.sort(), f), s = []) : s.push(f);
  }), u.push(...s.sort()), u;
}, $2 = (a) => ({
  cache: F2(a.cacheSize),
  parseClassName: B2(a),
  ...L2(a)
}), V2 = /\s+/, W2 = (a, u) => {
  const {
    parseClassName: s,
    getClassGroupId: f,
    getConflictingClassGroupIds: p
  } = u, h = [], m = a.trim().split(V2);
  let x = "";
  for (let C = m.length - 1; C >= 0; C -= 1) {
    const E = m[C], {
      modifiers: R,
      hasImportantModifier: T,
      baseClassName: O,
      maybePostfixModifierPosition: N
    } = s(E);
    let j = !!N, k = f(j ? O.substring(0, N) : O);
    if (!k) {
      if (!j) {
        x = E + (x.length > 0 ? " " + x : x);
        continue;
      }
      if (k = f(O), !k) {
        x = E + (x.length > 0 ? " " + x : x);
        continue;
      }
      j = !1;
    }
    const A = H2(R).join(":"), z = T ? A + u_ : A, F = z + k;
    if (h.includes(F))
      continue;
    h.push(F);
    const I = p(k, j);
    for (let V = 0; V < I.length; ++V) {
      const B = I[V];
      h.push(z + B);
    }
    x = E + (x.length > 0 ? " " + x : x);
  }
  return x;
};
function Y2() {
  let a = 0, u, s, f = "";
  for (; a < arguments.length; )
    (u = arguments[a++]) && (s = s_(u)) && (f && (f += " "), f += s);
  return f;
}
const s_ = (a) => {
  if (typeof a == "string")
    return a;
  let u, s = "";
  for (let f = 0; f < a.length; f++)
    a[f] && (u = s_(a[f])) && (s && (s += " "), s += u);
  return s;
};
function G2(a, ...u) {
  let s, f, p, h = m;
  function m(C) {
    const E = u.reduce((R, T) => T(R), a());
    return s = $2(E), f = s.cache.get, p = s.cache.set, h = x, x(C);
  }
  function x(C) {
    const E = f(C);
    if (E)
      return E;
    const R = W2(C, s);
    return p(C, R), R;
  }
  return function() {
    return h(Y2.apply(null, arguments));
  };
}
const mn = (a) => {
  const u = (s) => s[a] || [];
  return u.isThemeGetter = !0, u;
}, c_ = /^\[(?:([a-z-]+):)?(.+)\]$/i, Q2 = /^\d+\/\d+$/, K2 = /* @__PURE__ */ new Set(["px", "full", "screen"]), q2 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, X2 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Z2 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, J2 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ez = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Wl = (a) => Rd(a) || K2.has(a) || Q2.test(a), Yu = (a) => Pd(a, "length", uz), Rd = (a) => !!a && !Number.isNaN(Number(a)), H0 = (a) => Pd(a, "number", Rd), th = (a) => !!a && Number.isInteger(Number(a)), tz = (a) => a.endsWith("%") && Rd(a.slice(0, -1)), wt = (a) => c_.test(a), Gu = (a) => q2.test(a), nz = /* @__PURE__ */ new Set(["length", "size", "percentage"]), rz = (a) => Pd(a, nz, f_), oz = (a) => Pd(a, "position", f_), az = /* @__PURE__ */ new Set(["image", "url"]), iz = (a) => Pd(a, az, cz), lz = (a) => Pd(a, "", sz), nh = () => !0, Pd = (a, u, s) => {
  const f = c_.exec(a);
  return f ? f[1] ? typeof u == "string" ? f[1] === u : u.has(f[1]) : s(f[2]) : !1;
}, uz = (a) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  X2.test(a) && !Z2.test(a)
), f_ = () => !1, sz = (a) => J2.test(a), cz = (a) => ez.test(a), fz = () => {
  const a = mn("colors"), u = mn("spacing"), s = mn("blur"), f = mn("brightness"), p = mn("borderColor"), h = mn("borderRadius"), m = mn("borderSpacing"), x = mn("borderWidth"), C = mn("contrast"), E = mn("grayscale"), R = mn("hueRotate"), T = mn("invert"), O = mn("gap"), N = mn("gradientColorStops"), j = mn("gradientColorStopPositions"), k = mn("inset"), A = mn("margin"), z = mn("opacity"), F = mn("padding"), I = mn("saturate"), V = mn("scale"), B = mn("sepia"), ae = mn("skew"), Z = mn("space"), pe = mn("translate"), de = () => ["auto", "contain", "none"], me = () => ["auto", "hidden", "clip", "visible", "scroll"], Te = () => ["auto", wt, u], ve = () => [wt, u], ce = () => ["", Wl, Yu], Ee = () => ["auto", Rd, wt], Ue = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Re = () => ["solid", "dashed", "dotted", "double", "none"], Ke = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], oe = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], le = () => ["", "0", wt], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ie = () => [Rd, wt];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [nh],
      spacing: [Wl, Yu],
      blur: ["none", "", Gu, wt],
      brightness: ie(),
      borderColor: [a],
      borderRadius: ["none", "", "full", Gu, wt],
      borderSpacing: ve(),
      borderWidth: ce(),
      contrast: ie(),
      grayscale: le(),
      hueRotate: ie(),
      invert: le(),
      gap: ve(),
      gradientColorStops: [a],
      gradientColorStopPositions: [tz, Yu],
      inset: Te(),
      margin: Te(),
      opacity: ie(),
      padding: ve(),
      saturate: ie(),
      scale: ie(),
      sepia: le(),
      skew: ie(),
      space: ve(),
      translate: ve()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", wt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Gu]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Ue(), wt]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: me()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": me()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": me()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: de()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": de()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": de()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [k]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [k]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [k]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [k]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [k]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [k]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [k]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [k]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [k]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", th, wt]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Te()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", wt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: le()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: le()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", th, wt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [nh]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", th, wt]
        }, wt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Ee()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Ee()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [nh]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [th, wt]
        }, wt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Ee()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Ee()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", wt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", wt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [O]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [O]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [O]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...oe()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...oe(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...oe(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [F]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [F]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [F]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [F]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [F]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [F]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [F]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [F]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [F]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [A]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [A]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [A]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [A]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [A]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [A]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [A]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [A]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [A]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", wt, u]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [wt, u, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [wt, u, "none", "full", "min", "max", "fit", "prose", {
          screen: [Gu]
        }, Gu]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [wt, u, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [wt, u, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [wt, u, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [wt, u, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Gu, Yu]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", H0]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [nh]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", wt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Rd, H0]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Wl, wt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", wt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", wt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [a]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [z]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [a]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [z]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Wl, Yu]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Wl, wt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [a]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: ve()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", wt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", wt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [z]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Ue(), oz]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", rz]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, iz]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [a]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [j]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [j]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [j]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [N]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [N]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [N]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [h]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [h]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [h]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [h]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [h]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [h]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [h]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [h]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [h]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [h]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [h]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [h]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [h]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [h]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [h]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [x]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [x]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [x]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [x]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [x]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [x]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [x]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [x]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [x]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [z]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Re(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [x]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [x]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [z]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Re()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [p]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [p]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [p]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [p]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [p]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [p]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [p]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [p]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [p]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [p]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Re()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Wl, wt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Wl, Yu]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [a]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ce()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [a]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [z]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Wl, Yu]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [a]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Gu, lz]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [nh]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [z]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Ke(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ke()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [s]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [f]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [C]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Gu, wt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [E]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [R]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [T]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [I]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [B]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [s]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [f]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [C]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [E]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [R]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [T]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [z]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [I]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [B]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [m]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [m]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [m]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", wt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ie()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", wt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ie()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", wt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [V]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [V]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [V]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [th, wt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [pe]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [pe]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [ae]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [ae]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", wt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", a]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", wt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [a]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": ve()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": ve()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": ve()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": ve()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": ve()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": ve()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": ve()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": ve()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": ve()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": ve()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": ve()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": ve()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": ve()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": ve()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": ve()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": ve()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": ve()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": ve()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", wt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [a, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Wl, Yu, H0]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [a, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, mC = /* @__PURE__ */ G2(fz), dz = {
  sm: "ui-w-4 ui-h-4",
  md: "ui-w-5 ui-h-5",
  lg: "ui-w-6 ui-h-6"
}, pz = {
  sm: "ui-mt-[2px] ui-ml-[1px]",
  md: "ui-mt-[3px] ui-ml-[2px]",
  lg: "ui-mt-[4px] ui-ml-[3px]"
}, vz = {
  sm: "0 0 28 28",
  md: "0 0 24 24",
  lg: "0 0 22 22"
}, hz = {
  primary: "checkbox-primary",
  secondary: "checkbox-secondary"
}, mz = ut.forwardRef(
  ({
    checked: a,
    onChange: u,
    size: s = "md",
    disabled: f,
    defaultChecked: p = !1,
    variant: h = "primary",
    ...m
  }, x) => {
    const [C, E] = ut.useState(p ?? !1), R = a !== void 0, T = R ? a : C, O = (N) => {
      f || (R || E(N.target.checked), u == null || u(N.target.checked));
    };
    return /* @__PURE__ */ D.jsxs("div", { className: "ui-size-fit ui-relative ui-flex ui-gap-2", children: [
      /* @__PURE__ */ D.jsx(
        "input",
        {
          ref: x,
          checked: T,
          onChange: O,
          className: mC(
            // Base styles
            "ui-relative ui-shrink-0 ui-appearance-none ui-rounded-sm peer cursor-pointer",
            // Default state
            "ui-border-2",
            // Checked state
            "checked:ui-border-0",
            // Disabled state
            "disabled:ui-border-gray-dark",
            // Disabled + Checked state
            "disabled:checked:ui-bg-gray-dark",
            // Dynamic size classes
            dz[s],
            // Disabled opacity
            f && "ui-opacity-40",
            hz[h]
          ),
          type: "checkbox",
          disabled: f,
          ...m
        }
      ),
      /* @__PURE__ */ D.jsx(
        "svg",
        {
          className: mC(
            "ui-pointer-events-none ui-absolute ui-hidden ui-h-4 ui-w-4 ui-stroke-white ui-outline-none peer-checked:block",
            pz[s],
            f && "ui-opacity-80"
          ),
          viewBox: vz[s],
          fill: "none",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: /* @__PURE__ */ D.jsx("polyline", { points: "20 6 9 17 4 12" })
        }
      )
    ] });
  }
);
mz.displayName = "Checkbox";
function mt(a, u, { checkForDefaultPrevented: s = !0 } = {}) {
  return function(p) {
    if (a == null || a(p), s === !1 || !p.defaultPrevented)
      return u == null ? void 0 : u(p);
  };
}
function y1(a, u) {
  if (typeof a == "function")
    return a(u);
  a != null && (a.current = u);
}
function Wy(...a) {
  return (u) => {
    let s = !1;
    const f = a.map((p) => {
      const h = y1(p, u);
      return !s && typeof h == "function" && (s = !0), h;
    });
    if (s)
      return () => {
        for (let p = 0; p < f.length; p++) {
          const h = f[p];
          typeof h == "function" ? h() : y1(a[p], null);
        }
      };
  };
}
function Yn(...a) {
  return L.useCallback(Wy(...a), a);
}
function gz(a, u) {
  const s = L.createContext(u), f = (h) => {
    const { children: m, ...x } = h, C = L.useMemo(() => x, Object.values(x));
    return /* @__PURE__ */ D.jsx(s.Provider, { value: C, children: m });
  };
  f.displayName = a + "Provider";
  function p(h) {
    const m = L.useContext(s);
    if (m) return m;
    if (u !== void 0) return u;
    throw new Error(`\`${h}\` must be used within \`${a}\``);
  }
  return [f, p];
}
function Zl(a, u = []) {
  let s = [];
  function f(h, m) {
    const x = L.createContext(m), C = s.length;
    s = [...s, m];
    const E = (T) => {
      var z;
      const { scope: O, children: N, ...j } = T, k = ((z = O == null ? void 0 : O[a]) == null ? void 0 : z[C]) || x, A = L.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ D.jsx(k.Provider, { value: A, children: N });
    };
    E.displayName = h + "Provider";
    function R(T, O) {
      var k;
      const N = ((k = O == null ? void 0 : O[a]) == null ? void 0 : k[C]) || x, j = L.useContext(N);
      if (j) return j;
      if (m !== void 0) return m;
      throw new Error(`\`${T}\` must be used within \`${h}\``);
    }
    return [E, R];
  }
  const p = () => {
    const h = s.map((m) => L.createContext(m));
    return function(x) {
      const C = (x == null ? void 0 : x[a]) || h;
      return L.useMemo(
        () => ({ [`__scope${a}`]: { ...x, [a]: C } }),
        [x, C]
      );
    };
  };
  return p.scopeName = a, [f, yz(p, ...u)];
}
function yz(...a) {
  const u = a[0];
  if (a.length === 1) return u;
  const s = () => {
    const f = a.map((p) => ({
      useScope: p(),
      scopeName: p.scopeName
    }));
    return function(h) {
      const m = f.reduce((x, { useScope: C, scopeName: E }) => {
        const T = C(h)[`__scope${E}`];
        return { ...x, ...T };
      }, {});
      return L.useMemo(() => ({ [`__scope${u.scopeName}`]: m }), [m]);
    };
  };
  return s.scopeName = u.scopeName, s;
}
var Ql = globalThis != null && globalThis.document ? L.useLayoutEffect : () => {
}, xz = L[" useInsertionEffect ".trim().toString()] || Ql;
function Tc({
  prop: a,
  defaultProp: u,
  onChange: s = () => {
  },
  caller: f
}) {
  const [p, h, m] = Sz({
    defaultProp: u,
    onChange: s
  }), x = a !== void 0, C = x ? a : p;
  {
    const R = L.useRef(a !== void 0);
    L.useEffect(() => {
      const T = R.current;
      T !== x && console.warn(
        `${f} is changing from ${T ? "controlled" : "uncontrolled"} to ${x ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), R.current = x;
    }, [x, f]);
  }
  const E = L.useCallback(
    (R) => {
      var T;
      if (x) {
        const O = bz(R) ? R(a) : R;
        O !== a && ((T = m.current) == null || T.call(m, O));
      } else
        h(R);
    },
    [x, a, h, m]
  );
  return [C, E];
}
function Sz({
  defaultProp: a,
  onChange: u
}) {
  const [s, f] = L.useState(a), p = L.useRef(s), h = L.useRef(u);
  return xz(() => {
    h.current = u;
  }, [u]), L.useEffect(() => {
    var m;
    p.current !== s && ((m = h.current) == null || m.call(h, s), p.current = s);
  }, [s, p]), [s, f, h];
}
function bz(a) {
  return typeof a == "function";
}
var gC = { exports: {} }, Lo = {}, xy = { exports: {} }, $0 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x1;
function Cz() {
  return x1 || (x1 = 1, function(a) {
    function u(oe, le) {
      var W = oe.length;
      oe.push(le);
      e: for (; 0 < W; ) {
        var ie = W - 1 >>> 1, we = oe[ie];
        if (0 < p(we, le)) oe[ie] = le, oe[W] = we, W = ie;
        else break e;
      }
    }
    function s(oe) {
      return oe.length === 0 ? null : oe[0];
    }
    function f(oe) {
      if (oe.length === 0) return null;
      var le = oe[0], W = oe.pop();
      if (W !== le) {
        oe[0] = W;
        e: for (var ie = 0, we = oe.length, je = we >>> 1; ie < je; ) {
          var ke = 2 * (ie + 1) - 1, et = oe[ke], Pe = ke + 1, Oe = oe[Pe];
          if (0 > p(et, W)) Pe < we && 0 > p(Oe, et) ? (oe[ie] = Oe, oe[Pe] = W, ie = Pe) : (oe[ie] = et, oe[ke] = W, ie = ke);
          else if (Pe < we && 0 > p(Oe, W)) oe[ie] = Oe, oe[Pe] = W, ie = Pe;
          else break e;
        }
      }
      return le;
    }
    function p(oe, le) {
      var W = oe.sortIndex - le.sortIndex;
      return W !== 0 ? W : oe.id - le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var h = performance;
      a.unstable_now = function() {
        return h.now();
      };
    } else {
      var m = Date, x = m.now();
      a.unstable_now = function() {
        return m.now() - x;
      };
    }
    var C = [], E = [], R = 1, T = null, O = 3, N = !1, j = !1, k = !1, A = typeof setTimeout == "function" ? setTimeout : null, z = typeof clearTimeout == "function" ? clearTimeout : null, F = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function I(oe) {
      for (var le = s(E); le !== null; ) {
        if (le.callback === null) f(E);
        else if (le.startTime <= oe) f(E), le.sortIndex = le.expirationTime, u(C, le);
        else break;
        le = s(E);
      }
    }
    function V(oe) {
      if (k = !1, I(oe), !j) if (s(C) !== null) j = !0, Re(B);
      else {
        var le = s(E);
        le !== null && Ke(V, le.startTime - oe);
      }
    }
    function B(oe, le) {
      j = !1, k && (k = !1, z(pe), pe = -1), N = !0;
      var W = O;
      try {
        for (I(le), T = s(C); T !== null && (!(T.expirationTime > le) || oe && !Te()); ) {
          var ie = T.callback;
          if (typeof ie == "function") {
            T.callback = null, O = T.priorityLevel;
            var we = ie(T.expirationTime <= le);
            le = a.unstable_now(), typeof we == "function" ? T.callback = we : T === s(C) && f(C), I(le);
          } else f(C);
          T = s(C);
        }
        if (T !== null) var je = !0;
        else {
          var ke = s(E);
          ke !== null && Ke(V, ke.startTime - le), je = !1;
        }
        return je;
      } finally {
        T = null, O = W, N = !1;
      }
    }
    var ae = !1, Z = null, pe = -1, de = 5, me = -1;
    function Te() {
      return !(a.unstable_now() - me < de);
    }
    function ve() {
      if (Z !== null) {
        var oe = a.unstable_now();
        me = oe;
        var le = !0;
        try {
          le = Z(!0, oe);
        } finally {
          le ? ce() : (ae = !1, Z = null);
        }
      } else ae = !1;
    }
    var ce;
    if (typeof F == "function") ce = function() {
      F(ve);
    };
    else if (typeof MessageChannel < "u") {
      var Ee = new MessageChannel(), Ue = Ee.port2;
      Ee.port1.onmessage = ve, ce = function() {
        Ue.postMessage(null);
      };
    } else ce = function() {
      A(ve, 0);
    };
    function Re(oe) {
      Z = oe, ae || (ae = !0, ce());
    }
    function Ke(oe, le) {
      pe = A(function() {
        oe(a.unstable_now());
      }, le);
    }
    a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(oe) {
      oe.callback = null;
    }, a.unstable_continueExecution = function() {
      j || N || (j = !0, Re(B));
    }, a.unstable_forceFrameRate = function(oe) {
      0 > oe || 125 < oe ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : de = 0 < oe ? Math.floor(1e3 / oe) : 5;
    }, a.unstable_getCurrentPriorityLevel = function() {
      return O;
    }, a.unstable_getFirstCallbackNode = function() {
      return s(C);
    }, a.unstable_next = function(oe) {
      switch (O) {
        case 1:
        case 2:
        case 3:
          var le = 3;
          break;
        default:
          le = O;
      }
      var W = O;
      O = le;
      try {
        return oe();
      } finally {
        O = W;
      }
    }, a.unstable_pauseExecution = function() {
    }, a.unstable_requestPaint = function() {
    }, a.unstable_runWithPriority = function(oe, le) {
      switch (oe) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          oe = 3;
      }
      var W = O;
      O = oe;
      try {
        return le();
      } finally {
        O = W;
      }
    }, a.unstable_scheduleCallback = function(oe, le, W) {
      var ie = a.unstable_now();
      switch (typeof W == "object" && W !== null ? (W = W.delay, W = typeof W == "number" && 0 < W ? ie + W : ie) : W = ie, oe) {
        case 1:
          var we = -1;
          break;
        case 2:
          we = 250;
          break;
        case 5:
          we = 1073741823;
          break;
        case 4:
          we = 1e4;
          break;
        default:
          we = 5e3;
      }
      return we = W + we, oe = { id: R++, callback: le, priorityLevel: oe, startTime: W, expirationTime: we, sortIndex: -1 }, W > ie ? (oe.sortIndex = W, u(E, oe), s(C) === null && oe === s(E) && (k ? (z(pe), pe = -1) : k = !0, Ke(V, W - ie))) : (oe.sortIndex = we, u(C, oe), j || N || (j = !0, Re(B))), oe;
    }, a.unstable_shouldYield = Te, a.unstable_wrapCallback = function(oe) {
      var le = O;
      return function() {
        var W = O;
        O = le;
        try {
          return oe.apply(this, arguments);
        } finally {
          O = W;
        }
      };
    };
  }($0)), $0;
}
var V0 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S1;
function Ez() {
  return S1 || (S1 = 1, function(a) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var u = !1, s = 5;
      function f(_e, Ze) {
        var gt = _e.length;
        _e.push(Ze), m(_e, Ze, gt);
      }
      function p(_e) {
        return _e.length === 0 ? null : _e[0];
      }
      function h(_e) {
        if (_e.length === 0)
          return null;
        var Ze = _e[0], gt = _e.pop();
        return gt !== Ze && (_e[0] = gt, x(_e, gt, 0)), Ze;
      }
      function m(_e, Ze, gt) {
        for (var At = gt; At > 0; ) {
          var en = At - 1 >>> 1, Qn = _e[en];
          if (C(Qn, Ze) > 0)
            _e[en] = Ze, _e[At] = Qn, At = en;
          else
            return;
        }
      }
      function x(_e, Ze, gt) {
        for (var At = gt, en = _e.length, Qn = en >>> 1; At < Qn; ) {
          var un = (At + 1) * 2 - 1, Kn = _e[un], tn = un + 1, Yt = _e[tn];
          if (C(Kn, Ze) < 0)
            tn < en && C(Yt, Kn) < 0 ? (_e[At] = Yt, _e[tn] = Ze, At = tn) : (_e[At] = Kn, _e[un] = Ze, At = un);
          else if (tn < en && C(Yt, Ze) < 0)
            _e[At] = Yt, _e[tn] = Ze, At = tn;
          else
            return;
        }
      }
      function C(_e, Ze) {
        var gt = _e.sortIndex - Ze.sortIndex;
        return gt !== 0 ? gt : _e.id - Ze.id;
      }
      var E = 1, R = 2, T = 3, O = 4, N = 5;
      function j(_e, Ze) {
      }
      var k = typeof performance == "object" && typeof performance.now == "function";
      if (k) {
        var A = performance;
        a.unstable_now = function() {
          return A.now();
        };
      } else {
        var z = Date, F = z.now();
        a.unstable_now = function() {
          return z.now() - F;
        };
      }
      var I = 1073741823, V = -1, B = 250, ae = 5e3, Z = 1e4, pe = I, de = [], me = [], Te = 1, ve = null, ce = T, Ee = !1, Ue = !1, Re = !1, Ke = typeof setTimeout == "function" ? setTimeout : null, oe = typeof clearTimeout == "function" ? clearTimeout : null, le = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function W(_e) {
        for (var Ze = p(me); Ze !== null; ) {
          if (Ze.callback === null)
            h(me);
          else if (Ze.startTime <= _e)
            h(me), Ze.sortIndex = Ze.expirationTime, f(de, Ze);
          else
            return;
          Ze = p(me);
        }
      }
      function ie(_e) {
        if (Re = !1, W(_e), !Ue)
          if (p(de) !== null)
            Ue = !0, Fn(we);
          else {
            var Ze = p(me);
            Ze !== null && xr(ie, Ze.startTime - _e);
          }
      }
      function we(_e, Ze) {
        Ue = !1, Re && (Re = !1, eo()), Ee = !0;
        var gt = ce;
        try {
          var At;
          if (!u) return je(_e, Ze);
        } finally {
          ve = null, ce = gt, Ee = !1;
        }
      }
      function je(_e, Ze) {
        var gt = Ze;
        for (W(gt), ve = p(de); ve !== null && !(ve.expirationTime > gt && (!_e || Gn())); ) {
          var At = ve.callback;
          if (typeof At == "function") {
            ve.callback = null, ce = ve.priorityLevel;
            var en = ve.expirationTime <= gt, Qn = At(en);
            gt = a.unstable_now(), typeof Qn == "function" ? ve.callback = Qn : ve === p(de) && h(de), W(gt);
          } else
            h(de);
          ve = p(de);
        }
        if (ve !== null)
          return !0;
        var un = p(me);
        return un !== null && xr(ie, un.startTime - gt), !1;
      }
      function ke(_e, Ze) {
        switch (_e) {
          case E:
          case R:
          case T:
          case O:
          case N:
            break;
          default:
            _e = T;
        }
        var gt = ce;
        ce = _e;
        try {
          return Ze();
        } finally {
          ce = gt;
        }
      }
      function et(_e) {
        var Ze;
        switch (ce) {
          case E:
          case R:
          case T:
            Ze = T;
            break;
          default:
            Ze = ce;
            break;
        }
        var gt = ce;
        ce = Ze;
        try {
          return _e();
        } finally {
          ce = gt;
        }
      }
      function Pe(_e) {
        var Ze = ce;
        return function() {
          var gt = ce;
          ce = Ze;
          try {
            return _e.apply(this, arguments);
          } finally {
            ce = gt;
          }
        };
      }
      function Oe(_e, Ze, gt) {
        var At = a.unstable_now(), en;
        if (typeof gt == "object" && gt !== null) {
          var Qn = gt.delay;
          typeof Qn == "number" && Qn > 0 ? en = At + Qn : en = At;
        } else
          en = At;
        var un;
        switch (_e) {
          case E:
            un = V;
            break;
          case R:
            un = B;
            break;
          case N:
            un = pe;
            break;
          case O:
            un = Z;
            break;
          case T:
          default:
            un = ae;
            break;
        }
        var Kn = en + un, tn = {
          id: Te++,
          callback: Ze,
          priorityLevel: _e,
          startTime: en,
          expirationTime: Kn,
          sortIndex: -1
        };
        return en > At ? (tn.sortIndex = en, f(me, tn), p(de) === null && tn === p(me) && (Re ? eo() : Re = !0, xr(ie, en - At))) : (tn.sortIndex = Kn, f(de, tn), !Ue && !Ee && (Ue = !0, Fn(we))), tn;
      }
      function Me() {
      }
      function Ie() {
        !Ue && !Ee && (Ue = !0, Fn(we));
      }
      function $e() {
        return p(de);
      }
      function Qe(_e) {
        _e.callback = null;
      }
      function re() {
        return ce;
      }
      var qe = !1, vt = null, Tt = -1, $t = s, xn = -1;
      function Gn() {
        var _e = a.unstable_now() - xn;
        return !(_e < $t);
      }
      function ln() {
      }
      function er(_e) {
        if (_e < 0 || _e > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        _e > 0 ? $t = Math.floor(1e3 / _e) : $t = s;
      }
      var Sn = function() {
        if (vt !== null) {
          var _e = a.unstable_now();
          xn = _e;
          var Ze = !0, gt = !0;
          try {
            gt = vt(Ze, _e);
          } finally {
            gt ? Dn() : (qe = !1, vt = null);
          }
        } else
          qe = !1;
      }, Dn;
      if (typeof le == "function")
        Dn = function() {
          le(Sn);
        };
      else if (typeof MessageChannel < "u") {
        var tr = new MessageChannel(), Io = tr.port2;
        tr.port1.onmessage = Sn, Dn = function() {
          Io.postMessage(null);
        };
      } else
        Dn = function() {
          Ke(Sn, 0);
        };
      function Fn(_e) {
        vt = _e, qe || (qe = !0, Dn());
      }
      function xr(_e, Ze) {
        Tt = Ke(function() {
          _e(a.unstable_now());
        }, Ze);
      }
      function eo() {
        oe(Tt), Tt = -1;
      }
      var Uo = ln, mo = null;
      a.unstable_IdlePriority = N, a.unstable_ImmediatePriority = E, a.unstable_LowPriority = O, a.unstable_NormalPriority = T, a.unstable_Profiling = mo, a.unstable_UserBlockingPriority = R, a.unstable_cancelCallback = Qe, a.unstable_continueExecution = Ie, a.unstable_forceFrameRate = er, a.unstable_getCurrentPriorityLevel = re, a.unstable_getFirstCallbackNode = $e, a.unstable_next = et, a.unstable_pauseExecution = Me, a.unstable_requestPaint = Uo, a.unstable_runWithPriority = ke, a.unstable_scheduleCallback = Oe, a.unstable_shouldYield = Gn, a.unstable_wrapCallback = Pe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(V0)), V0;
}
var b1;
function d_() {
  return b1 || (b1 = 1, process.env.NODE_ENV === "production" ? xy.exports = Cz() : xy.exports = Ez()), xy.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C1;
function wz() {
  if (C1) return Lo;
  C1 = 1;
  var a = ut, u = d_();
  function s(n) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, l = 1; l < arguments.length; l++) r += "&args[]=" + encodeURIComponent(arguments[l]);
    return "Minified React error #" + n + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var f = /* @__PURE__ */ new Set(), p = {};
  function h(n, r) {
    m(n, r), m(n + "Capture", r);
  }
  function m(n, r) {
    for (p[n] = r, n = 0; n < r.length; n++) f.add(r[n]);
  }
  var x = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), C = Object.prototype.hasOwnProperty, E = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = {}, T = {};
  function O(n) {
    return C.call(T, n) ? !0 : C.call(R, n) ? !1 : E.test(n) ? T[n] = !0 : (R[n] = !0, !1);
  }
  function N(n, r, l, d) {
    if (l !== null && l.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return d ? !1 : l !== null ? !l.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function j(n, r, l, d) {
    if (r === null || typeof r > "u" || N(n, r, l, d)) return !0;
    if (d) return !1;
    if (l !== null) switch (l.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function k(n, r, l, d, g, S, _) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = d, this.attributeNamespace = g, this.mustUseProperty = l, this.propertyName = n, this.type = r, this.sanitizeURL = S, this.removeEmptyString = _;
  }
  var A = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    A[n] = new k(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var r = n[0];
    A[r] = new k(r, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    A[n] = new k(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    A[n] = new k(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    A[n] = new k(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    A[n] = new k(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    A[n] = new k(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    A[n] = new k(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    A[n] = new k(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var z = /[\-:]([a-z])/g;
  function F(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var r = n.replace(
      z,
      F
    );
    A[r] = new k(r, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var r = n.replace(z, F);
    A[r] = new k(r, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var r = n.replace(z, F);
    A[r] = new k(r, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    A[n] = new k(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), A.xlinkHref = new k("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    A[n] = new k(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function I(n, r, l, d) {
    var g = A.hasOwnProperty(r) ? A[r] : null;
    (g !== null ? g.type !== 0 : d || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (j(r, l, g, d) && (l = null), d || g === null ? O(r) && (l === null ? n.removeAttribute(r) : n.setAttribute(r, "" + l)) : g.mustUseProperty ? n[g.propertyName] = l === null ? g.type === 3 ? !1 : "" : l : (r = g.attributeName, d = g.attributeNamespace, l === null ? n.removeAttribute(r) : (g = g.type, l = g === 3 || g === 4 && l === !0 ? "" : "" + l, d ? n.setAttributeNS(d, r, l) : n.setAttribute(r, l))));
  }
  var V = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, B = Symbol.for("react.element"), ae = Symbol.for("react.portal"), Z = Symbol.for("react.fragment"), pe = Symbol.for("react.strict_mode"), de = Symbol.for("react.profiler"), me = Symbol.for("react.provider"), Te = Symbol.for("react.context"), ve = Symbol.for("react.forward_ref"), ce = Symbol.for("react.suspense"), Ee = Symbol.for("react.suspense_list"), Ue = Symbol.for("react.memo"), Re = Symbol.for("react.lazy"), Ke = Symbol.for("react.offscreen"), oe = Symbol.iterator;
  function le(n) {
    return n === null || typeof n != "object" ? null : (n = oe && n[oe] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var W = Object.assign, ie;
  function we(n) {
    if (ie === void 0) try {
      throw Error();
    } catch (l) {
      var r = l.stack.trim().match(/\n( *(at )?)/);
      ie = r && r[1] || "";
    }
    return `
` + ie + n;
  }
  var je = !1;
  function ke(n, r) {
    if (!n || je) return "";
    je = !0;
    var l = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (te) {
          var d = te;
        }
        Reflect.construct(n, [], r);
      } else {
        try {
          r.call();
        } catch (te) {
          d = te;
        }
        n.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (te) {
          d = te;
        }
        n();
      }
    } catch (te) {
      if (te && d && typeof te.stack == "string") {
        for (var g = te.stack.split(`
`), S = d.stack.split(`
`), _ = g.length - 1, U = S.length - 1; 1 <= _ && 0 <= U && g[_] !== S[U]; ) U--;
        for (; 1 <= _ && 0 <= U; _--, U--) if (g[_] !== S[U]) {
          if (_ !== 1 || U !== 1)
            do
              if (_--, U--, 0 > U || g[_] !== S[U]) {
                var $ = `
` + g[_].replace(" at new ", " at ");
                return n.displayName && $.includes("<anonymous>") && ($ = $.replace("<anonymous>", n.displayName)), $;
              }
            while (1 <= _ && 0 <= U);
          break;
        }
      }
    } finally {
      je = !1, Error.prepareStackTrace = l;
    }
    return (n = n ? n.displayName || n.name : "") ? we(n) : "";
  }
  function et(n) {
    switch (n.tag) {
      case 5:
        return we(n.type);
      case 16:
        return we("Lazy");
      case 13:
        return we("Suspense");
      case 19:
        return we("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = ke(n.type, !1), n;
      case 11:
        return n = ke(n.type.render, !1), n;
      case 1:
        return n = ke(n.type, !0), n;
      default:
        return "";
    }
  }
  function Pe(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case Z:
        return "Fragment";
      case ae:
        return "Portal";
      case de:
        return "Profiler";
      case pe:
        return "StrictMode";
      case ce:
        return "Suspense";
      case Ee:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case Te:
        return (n.displayName || "Context") + ".Consumer";
      case me:
        return (n._context.displayName || "Context") + ".Provider";
      case ve:
        var r = n.render;
        return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case Ue:
        return r = n.displayName || null, r !== null ? r : Pe(n.type) || "Memo";
      case Re:
        r = n._payload, n = n._init;
        try {
          return Pe(n(r));
        } catch {
        }
    }
    return null;
  }
  function Oe(n) {
    var r = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = r.render, n = n.displayName || n.name || "", r.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Pe(r);
      case 8:
        return r === pe ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function Me(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function Ie(n) {
    var r = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function $e(n) {
    var r = Ie(n) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(n.constructor.prototype, r), d = "" + n[r];
    if (!n.hasOwnProperty(r) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var g = l.get, S = l.set;
      return Object.defineProperty(n, r, { configurable: !0, get: function() {
        return g.call(this);
      }, set: function(_) {
        d = "" + _, S.call(this, _);
      } }), Object.defineProperty(n, r, { enumerable: l.enumerable }), { getValue: function() {
        return d;
      }, setValue: function(_) {
        d = "" + _;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[r];
      } };
    }
  }
  function Qe(n) {
    n._valueTracker || (n._valueTracker = $e(n));
  }
  function re(n) {
    if (!n) return !1;
    var r = n._valueTracker;
    if (!r) return !0;
    var l = r.getValue(), d = "";
    return n && (d = Ie(n) ? n.checked ? "true" : "false" : n.value), n = d, n !== l ? (r.setValue(n), !0) : !1;
  }
  function qe(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  function vt(n, r) {
    var l = r.checked;
    return W({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: l ?? n._wrapperState.initialChecked });
  }
  function Tt(n, r) {
    var l = r.defaultValue == null ? "" : r.defaultValue, d = r.checked != null ? r.checked : r.defaultChecked;
    l = Me(r.value != null ? r.value : l), n._wrapperState = { initialChecked: d, initialValue: l, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function $t(n, r) {
    r = r.checked, r != null && I(n, "checked", r, !1);
  }
  function xn(n, r) {
    $t(n, r);
    var l = Me(r.value), d = r.type;
    if (l != null) d === "number" ? (l === 0 && n.value === "" || n.value != l) && (n.value = "" + l) : n.value !== "" + l && (n.value = "" + l);
    else if (d === "submit" || d === "reset") {
      n.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? ln(n, r.type, l) : r.hasOwnProperty("defaultValue") && ln(n, r.type, Me(r.defaultValue)), r.checked == null && r.defaultChecked != null && (n.defaultChecked = !!r.defaultChecked);
  }
  function Gn(n, r, l) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var d = r.type;
      if (!(d !== "submit" && d !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + n._wrapperState.initialValue, l || r === n.value || (n.value = r), n.defaultValue = r;
    }
    l = n.name, l !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, l !== "" && (n.name = l);
  }
  function ln(n, r, l) {
    (r !== "number" || qe(n.ownerDocument) !== n) && (l == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + l && (n.defaultValue = "" + l));
  }
  var er = Array.isArray;
  function Sn(n, r, l, d) {
    if (n = n.options, r) {
      r = {};
      for (var g = 0; g < l.length; g++) r["$" + l[g]] = !0;
      for (l = 0; l < n.length; l++) g = r.hasOwnProperty("$" + n[l].value), n[l].selected !== g && (n[l].selected = g), g && d && (n[l].defaultSelected = !0);
    } else {
      for (l = "" + Me(l), r = null, g = 0; g < n.length; g++) {
        if (n[g].value === l) {
          n[g].selected = !0, d && (n[g].defaultSelected = !0);
          return;
        }
        r !== null || n[g].disabled || (r = n[g]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function Dn(n, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(s(91));
    return W({}, r, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function tr(n, r) {
    var l = r.value;
    if (l == null) {
      if (l = r.children, r = r.defaultValue, l != null) {
        if (r != null) throw Error(s(92));
        if (er(l)) {
          if (1 < l.length) throw Error(s(93));
          l = l[0];
        }
        r = l;
      }
      r == null && (r = ""), l = r;
    }
    n._wrapperState = { initialValue: Me(l) };
  }
  function Io(n, r) {
    var l = Me(r.value), d = Me(r.defaultValue);
    l != null && (l = "" + l, l !== n.value && (n.value = l), r.defaultValue == null && n.defaultValue !== l && (n.defaultValue = l)), d != null && (n.defaultValue = "" + d);
  }
  function Fn(n) {
    var r = n.textContent;
    r === n._wrapperState.initialValue && r !== "" && r !== null && (n.value = r);
  }
  function xr(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function eo(n, r) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? xr(r) : n === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var Uo, mo = function(n) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, l, d, g) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(r, l, d, g);
      });
    } : n;
  }(function(n, r) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = r;
    else {
      for (Uo = Uo || document.createElement("div"), Uo.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Uo.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; r.firstChild; ) n.appendChild(r.firstChild);
    }
  });
  function _e(n, r) {
    if (r) {
      var l = n.firstChild;
      if (l && l === n.lastChild && l.nodeType === 3) {
        l.nodeValue = r;
        return;
      }
    }
    n.textContent = r;
  }
  var Ze = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, gt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ze).forEach(function(n) {
    gt.forEach(function(r) {
      r = r + n.charAt(0).toUpperCase() + n.substring(1), Ze[r] = Ze[n];
    });
  });
  function At(n, r, l) {
    return r == null || typeof r == "boolean" || r === "" ? "" : l || typeof r != "number" || r === 0 || Ze.hasOwnProperty(n) && Ze[n] ? ("" + r).trim() : r + "px";
  }
  function en(n, r) {
    n = n.style;
    for (var l in r) if (r.hasOwnProperty(l)) {
      var d = l.indexOf("--") === 0, g = At(l, r[l], d);
      l === "float" && (l = "cssFloat"), d ? n.setProperty(l, g) : n[l] = g;
    }
  }
  var Qn = W({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function un(n, r) {
    if (r) {
      if (Qn[n] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(s(137, n));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(s(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(s(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(s(62));
    }
  }
  function Kn(n, r) {
    if (n.indexOf("-") === -1) return typeof r.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var tn = null;
  function Yt(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var Gt = null, to = null, Sr = null;
  function ta(n) {
    if (n = nt(n)) {
      if (typeof Gt != "function") throw Error(s(280));
      var r = n.stateNode;
      r && (r = bn(r), Gt(n.stateNode, n.type, r));
    }
  }
  function Jl(n) {
    to ? Sr ? Sr.push(n) : Sr = [n] : to = n;
  }
  function li() {
    if (to) {
      var n = to, r = Sr;
      if (Sr = to = null, ta(n), r) for (n = 0; n < r.length; n++) ta(r[n]);
    }
  }
  function Ji(n, r) {
    return n(r);
  }
  function eu() {
  }
  var tu = !1;
  function ts(n, r, l) {
    if (tu) return n(r, l);
    tu = !0;
    try {
      return Ji(n, r, l);
    } finally {
      tu = !1, (to !== null || Sr !== null) && (eu(), li());
    }
  }
  function wa(n, r) {
    var l = n.stateNode;
    if (l === null) return null;
    var d = bn(l);
    if (d === null) return null;
    l = d[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (n = n.type, d = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !d;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (l && typeof l != "function") throw Error(s(231, r, typeof l));
    return l;
  }
  var Fo = !1;
  if (x) try {
    var jr = {};
    Object.defineProperty(jr, "passive", { get: function() {
      Fo = !0;
    } }), window.addEventListener("test", jr, jr), window.removeEventListener("test", jr, jr);
  } catch {
    Fo = !1;
  }
  function ui(n, r, l, d, g, S, _, U, $) {
    var te = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(l, te);
    } catch (xe) {
      this.onError(xe);
    }
  }
  var Ta = !1, si = null, ci = !1, H = null, ye = { onError: function(n) {
    Ta = !0, si = n;
  } };
  function Le(n, r, l, d, g, S, _, U, $) {
    Ta = !1, si = null, ui.apply(ye, arguments);
  }
  function lt(n, r, l, d, g, S, _, U, $) {
    if (Le.apply(this, arguments), Ta) {
      if (Ta) {
        var te = si;
        Ta = !1, si = null;
      } else throw Error(s(198));
      ci || (ci = !0, H = te);
    }
  }
  function St(n) {
    var r = n, l = n;
    if (n.alternate) for (; r.return; ) r = r.return;
    else {
      n = r;
      do
        r = n, r.flags & 4098 && (l = r.return), n = r.return;
      while (n);
    }
    return r.tag === 3 ? l : null;
  }
  function ht(n) {
    if (n.tag === 13) {
      var r = n.memoizedState;
      if (r === null && (n = n.alternate, n !== null && (r = n.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function _t(n) {
    if (St(n) !== n) throw Error(s(188));
  }
  function Rt(n) {
    var r = n.alternate;
    if (!r) {
      if (r = St(n), r === null) throw Error(s(188));
      return r !== n ? null : n;
    }
    for (var l = n, d = r; ; ) {
      var g = l.return;
      if (g === null) break;
      var S = g.alternate;
      if (S === null) {
        if (d = g.return, d !== null) {
          l = d;
          continue;
        }
        break;
      }
      if (g.child === S.child) {
        for (S = g.child; S; ) {
          if (S === l) return _t(g), n;
          if (S === d) return _t(g), r;
          S = S.sibling;
        }
        throw Error(s(188));
      }
      if (l.return !== d.return) l = g, d = S;
      else {
        for (var _ = !1, U = g.child; U; ) {
          if (U === l) {
            _ = !0, l = g, d = S;
            break;
          }
          if (U === d) {
            _ = !0, d = g, l = S;
            break;
          }
          U = U.sibling;
        }
        if (!_) {
          for (U = S.child; U; ) {
            if (U === l) {
              _ = !0, l = S, d = g;
              break;
            }
            if (U === d) {
              _ = !0, d = S, l = g;
              break;
            }
            U = U.sibling;
          }
          if (!_) throw Error(s(189));
        }
      }
      if (l.alternate !== d) throw Error(s(190));
    }
    if (l.tag !== 3) throw Error(s(188));
    return l.stateNode.current === l ? n : r;
  }
  function Bn(n) {
    return n = Rt(n), n !== null ? sn(n) : null;
  }
  function sn(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var r = sn(n);
      if (r !== null) return r;
      n = n.sibling;
    }
    return null;
  }
  var dn = u.unstable_scheduleCallback, br = u.unstable_cancelCallback, Ra = u.unstable_shouldYield, _a = u.unstable_requestPaint, bt = u.unstable_now, Ct = u.unstable_getCurrentPriorityLevel, Oa = u.unstable_ImmediatePriority, ns = u.unstable_UserBlockingPriority, rs = u.unstable_NormalPriority, bh = u.unstable_LowPriority, zd = u.unstable_IdlePriority, os = null, Bo = null;
  function Ch(n) {
    if (Bo && typeof Bo.onCommitFiberRoot == "function") try {
      Bo.onCommitFiberRoot(os, n, void 0, (n.current.flags & 128) === 128);
    } catch {
    }
  }
  var go = Math.clz32 ? Math.clz32 : Id, cx = Math.log, fx = Math.LN2;
  function Id(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (cx(n) / fx | 0) | 0;
  }
  var nu = 64, Ho = 4194304;
  function el(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function tl(n, r) {
    var l = n.pendingLanes;
    if (l === 0) return 0;
    var d = 0, g = n.suspendedLanes, S = n.pingedLanes, _ = l & 268435455;
    if (_ !== 0) {
      var U = _ & ~g;
      U !== 0 ? d = el(U) : (S &= _, S !== 0 && (d = el(S)));
    } else _ = l & ~g, _ !== 0 ? d = el(_) : S !== 0 && (d = el(S));
    if (d === 0) return 0;
    if (r !== 0 && r !== d && !(r & g) && (g = d & -d, S = r & -r, g >= S || g === 16 && (S & 4194240) !== 0)) return r;
    if (d & 4 && (d |= l & 16), r = n.entangledLanes, r !== 0) for (n = n.entanglements, r &= d; 0 < r; ) l = 31 - go(r), g = 1 << l, d |= n[l], r &= ~g;
    return d;
  }
  function dx(n, r) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Ud(n, r) {
    for (var l = n.suspendedLanes, d = n.pingedLanes, g = n.expirationTimes, S = n.pendingLanes; 0 < S; ) {
      var _ = 31 - go(S), U = 1 << _, $ = g[_];
      $ === -1 ? (!(U & l) || U & d) && (g[_] = dx(U, r)) : $ <= r && (n.expiredLanes |= U), S &= ~U;
    }
  }
  function Fd(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function Oc() {
    var n = nu;
    return nu <<= 1, !(nu & 4194240) && (nu = 64), n;
  }
  function Bd(n) {
    for (var r = [], l = 0; 31 > l; l++) r.push(n);
    return r;
  }
  function nl(n, r, l) {
    n.pendingLanes |= r, r !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, r = 31 - go(r), n[r] = l;
  }
  function px(n, r) {
    var l = n.pendingLanes & ~r;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r, r = n.entanglements;
    var d = n.eventTimes;
    for (n = n.expirationTimes; 0 < l; ) {
      var g = 31 - go(l), S = 1 << g;
      r[g] = 0, d[g] = -1, n[g] = -1, l &= ~S;
    }
  }
  function Dc(n, r) {
    var l = n.entangledLanes |= r;
    for (n = n.entanglements; l; ) {
      var d = 31 - go(l), g = 1 << d;
      g & r | n[d] & r && (n[d] |= r), l &= ~g;
    }
  }
  var Vt = 0;
  function Hd(n) {
    return n &= -n, 1 < n ? 4 < n ? n & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Wt, $d, Vd, yt, Wd, Cr = !1, fi = [], yo = null, di = null, gn = null, rn = /* @__PURE__ */ new Map(), as = /* @__PURE__ */ new Map(), nr = [], xo = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Da(n, r) {
    switch (n) {
      case "focusin":
      case "focusout":
        yo = null;
        break;
      case "dragenter":
      case "dragleave":
        di = null;
        break;
      case "mouseover":
      case "mouseout":
        gn = null;
        break;
      case "pointerover":
      case "pointerout":
        rn.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        as.delete(r.pointerId);
    }
  }
  function is(n, r, l, d, g, S) {
    return n === null || n.nativeEvent !== S ? (n = { blockedOn: r, domEventName: l, eventSystemFlags: d, nativeEvent: S, targetContainers: [g] }, r !== null && (r = nt(r), r !== null && $d(r)), n) : (n.eventSystemFlags |= d, r = n.targetContainers, g !== null && r.indexOf(g) === -1 && r.push(g), n);
  }
  function Yd(n, r, l, d, g) {
    switch (r) {
      case "focusin":
        return yo = is(yo, n, r, l, d, g), !0;
      case "dragenter":
        return di = is(di, n, r, l, d, g), !0;
      case "mouseover":
        return gn = is(gn, n, r, l, d, g), !0;
      case "pointerover":
        var S = g.pointerId;
        return rn.set(S, is(rn.get(S) || null, n, r, l, d, g)), !0;
      case "gotpointercapture":
        return S = g.pointerId, as.set(S, is(as.get(S) || null, n, r, l, d, g)), !0;
    }
    return !1;
  }
  function Gd(n) {
    var r = dl(n.target);
    if (r !== null) {
      var l = St(r);
      if (l !== null) {
        if (r = l.tag, r === 13) {
          if (r = ht(l), r !== null) {
            n.blockedOn = r, Wd(n.priority, function() {
              Vd(l);
            });
            return;
          }
        } else if (r === 3 && l.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = l.tag === 3 ? l.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function ls(n) {
    if (n.blockedOn !== null) return !1;
    for (var r = n.targetContainers; 0 < r.length; ) {
      var l = Mc(n.domEventName, n.eventSystemFlags, r[0], n.nativeEvent);
      if (l === null) {
        l = n.nativeEvent;
        var d = new l.constructor(l.type, l);
        tn = d, l.target.dispatchEvent(d), tn = null;
      } else return r = nt(l), r !== null && $d(r), n.blockedOn = l, !1;
      r.shift();
    }
    return !0;
  }
  function Eh(n, r, l) {
    ls(n) && l.delete(r);
  }
  function vx() {
    Cr = !1, yo !== null && ls(yo) && (yo = null), di !== null && ls(di) && (di = null), gn !== null && ls(gn) && (gn = null), rn.forEach(Eh), as.forEach(Eh);
  }
  function us(n, r) {
    n.blockedOn === r && (n.blockedOn = null, Cr || (Cr = !0, u.unstable_scheduleCallback(u.unstable_NormalPriority, vx)));
  }
  function pi(n) {
    function r(g) {
      return us(g, n);
    }
    if (0 < fi.length) {
      us(fi[0], n);
      for (var l = 1; l < fi.length; l++) {
        var d = fi[l];
        d.blockedOn === n && (d.blockedOn = null);
      }
    }
    for (yo !== null && us(yo, n), di !== null && us(di, n), gn !== null && us(gn, n), rn.forEach(r), as.forEach(r), l = 0; l < nr.length; l++) d = nr[l], d.blockedOn === n && (d.blockedOn = null);
    for (; 0 < nr.length && (l = nr[0], l.blockedOn === null); ) Gd(l), l.blockedOn === null && nr.shift();
  }
  var rl = V.ReactCurrentBatchConfig, ol = !0;
  function wh(n, r, l, d) {
    var g = Vt, S = rl.transition;
    rl.transition = null;
    try {
      Vt = 1, kc(n, r, l, d);
    } finally {
      Vt = g, rl.transition = S;
    }
  }
  function Th(n, r, l, d) {
    var g = Vt, S = rl.transition;
    rl.transition = null;
    try {
      Vt = 4, kc(n, r, l, d);
    } finally {
      Vt = g, rl.transition = S;
    }
  }
  function kc(n, r, l, d) {
    if (ol) {
      var g = Mc(n, r, l, d);
      if (g === null) Kc(n, r, d, ss, l), Da(n, d);
      else if (Yd(g, n, r, l, d)) d.stopPropagation();
      else if (Da(n, d), r & 4 && -1 < xo.indexOf(n)) {
        for (; g !== null; ) {
          var S = nt(g);
          if (S !== null && Wt(S), S = Mc(n, r, l, d), S === null && Kc(n, r, d, ss, l), S === g) break;
          g = S;
        }
        g !== null && d.stopPropagation();
      } else Kc(n, r, d, null, l);
    }
  }
  var ss = null;
  function Mc(n, r, l, d) {
    if (ss = null, n = Yt(d), n = dl(n), n !== null) if (r = St(n), r === null) n = null;
    else if (l = r.tag, l === 13) {
      if (n = ht(r), n !== null) return n;
      n = null;
    } else if (l === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      n = null;
    } else r !== n && (n = null);
    return ss = n, null;
  }
  function Nc(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Ct()) {
          case Oa:
            return 1;
          case ns:
            return 4;
          case rs:
          case bh:
            return 16;
          case zd:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var ka = null, Ac = null, ru = null;
  function Qd() {
    if (ru) return ru;
    var n, r = Ac, l = r.length, d, g = "value" in ka ? ka.value : ka.textContent, S = g.length;
    for (n = 0; n < l && r[n] === g[n]; n++) ;
    var _ = l - n;
    for (d = 1; d <= _ && r[l - d] === g[S - d]; d++) ;
    return ru = g.slice(n, 1 < d ? 1 - d : void 0);
  }
  function Pc(n) {
    var r = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && r === 13 && (n = 13)) : n = r, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function Lc() {
    return !0;
  }
  function jc() {
    return !1;
  }
  function zr(n) {
    function r(l, d, g, S, _) {
      this._reactName = l, this._targetInst = g, this.type = d, this.nativeEvent = S, this.target = _, this.currentTarget = null;
      for (var U in n) n.hasOwnProperty(U) && (l = n[U], this[U] = l ? l(S) : S[U]);
      return this.isDefaultPrevented = (S.defaultPrevented != null ? S.defaultPrevented : S.returnValue === !1) ? Lc : jc, this.isPropagationStopped = jc, this;
    }
    return W(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var l = this.nativeEvent;
      l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = Lc);
    }, stopPropagation: function() {
      var l = this.nativeEvent;
      l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = Lc);
    }, persist: function() {
    }, isPersistent: Lc }), r;
  }
  var al = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, zc = zr(al), ou = W({}, al, { view: 0, detail: 0 }), hx = zr(ou), Kd, rr, il, cs = W({}, ou, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: ep, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== il && (il && n.type === "mousemove" ? (Kd = n.screenX - il.screenX, rr = n.screenY - il.screenY) : rr = Kd = 0, il = n), Kd);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : rr;
  } }), qd = zr(cs), mx = W({}, cs, { dataTransfer: 0 }), au = zr(mx), Xd = W({}, ou, { relatedTarget: 0 }), Ic = zr(Xd), gx = W({}, al, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), yx = zr(gx), xx = W({}, al, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), Rh = zr(xx), Zd = W({}, al, { data: 0 }), Jd = zr(Zd), _h = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Oh = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Sx = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Ma(n) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(n) : (n = Sx[n]) ? !!r[n] : !1;
  }
  function ep() {
    return Ma;
  }
  var tp = W({}, ou, { key: function(n) {
    if (n.key) {
      var r = _h[n.key] || n.key;
      if (r !== "Unidentified") return r;
    }
    return n.type === "keypress" ? (n = Pc(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Oh[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: ep, charCode: function(n) {
    return n.type === "keypress" ? Pc(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? Pc(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), np = zr(tp), rp = W({}, cs, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Dh = zr(rp), Uc = W({}, ou, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: ep }), kh = zr(Uc), Ir = W({}, al, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Na = zr(Ir), kn = W({}, cs, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Aa = zr(kn), op = [9, 13, 27, 32], iu = x && "CompositionEvent" in window, fs = null;
  x && "documentMode" in document && (fs = document.documentMode);
  var ds = x && "TextEvent" in window && !fs, Mh = x && (!iu || fs && 8 < fs && 11 >= fs), Nh = " ", Fc = !1;
  function Ah(n, r) {
    switch (n) {
      case "keyup":
        return op.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Ph(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var lu = !1;
  function Lh(n, r) {
    switch (n) {
      case "compositionend":
        return Ph(r);
      case "keypress":
        return r.which !== 32 ? null : (Fc = !0, Nh);
      case "textInput":
        return n = r.data, n === Nh && Fc ? null : n;
      default:
        return null;
    }
  }
  function bx(n, r) {
    if (lu) return n === "compositionend" || !iu && Ah(n, r) ? (n = Qd(), ru = Ac = ka = null, lu = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return Mh && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var Cx = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function jh(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r === "input" ? !!Cx[n.type] : r === "textarea";
  }
  function ap(n, r, l, d) {
    Jl(d), r = ys(r, "onChange"), 0 < r.length && (l = new zc("onChange", "change", null, l, d), n.push({ event: l, listeners: r }));
  }
  var na = null, ll = null;
  function zh(n) {
    cl(n, 0);
  }
  function ps(n) {
    var r = Vo(n);
    if (re(r)) return n;
  }
  function Ex(n, r) {
    if (n === "change") return r;
  }
  var Ih = !1;
  if (x) {
    var ip;
    if (x) {
      var lp = "oninput" in document;
      if (!lp) {
        var Uh = document.createElement("div");
        Uh.setAttribute("oninput", "return;"), lp = typeof Uh.oninput == "function";
      }
      ip = lp;
    } else ip = !1;
    Ih = ip && (!document.documentMode || 9 < document.documentMode);
  }
  function Fh() {
    na && (na.detachEvent("onpropertychange", Bh), ll = na = null);
  }
  function Bh(n) {
    if (n.propertyName === "value" && ps(ll)) {
      var r = [];
      ap(r, ll, n, Yt(n)), ts(zh, r);
    }
  }
  function wx(n, r, l) {
    n === "focusin" ? (Fh(), na = r, ll = l, na.attachEvent("onpropertychange", Bh)) : n === "focusout" && Fh();
  }
  function Hh(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return ps(ll);
  }
  function Tx(n, r) {
    if (n === "click") return ps(r);
  }
  function $h(n, r) {
    if (n === "input" || n === "change") return ps(r);
  }
  function Rx(n, r) {
    return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
  }
  var $o = typeof Object.is == "function" ? Object.is : Rx;
  function vs(n, r) {
    if ($o(n, r)) return !0;
    if (typeof n != "object" || n === null || typeof r != "object" || r === null) return !1;
    var l = Object.keys(n), d = Object.keys(r);
    if (l.length !== d.length) return !1;
    for (d = 0; d < l.length; d++) {
      var g = l[d];
      if (!C.call(r, g) || !$o(n[g], r[g])) return !1;
    }
    return !0;
  }
  function Vh(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function Bc(n, r) {
    var l = Vh(n);
    n = 0;
    for (var d; l; ) {
      if (l.nodeType === 3) {
        if (d = n + l.textContent.length, n <= r && d >= r) return { node: l, offset: r - n };
        n = d;
      }
      e: {
        for (; l; ) {
          if (l.nextSibling) {
            l = l.nextSibling;
            break e;
          }
          l = l.parentNode;
        }
        l = void 0;
      }
      l = Vh(l);
    }
  }
  function vi(n, r) {
    return n && r ? n === r ? !0 : n && n.nodeType === 3 ? !1 : r && r.nodeType === 3 ? vi(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function hs() {
    for (var n = window, r = qe(); r instanceof n.HTMLIFrameElement; ) {
      try {
        var l = typeof r.contentWindow.location.href == "string";
      } catch {
        l = !1;
      }
      if (l) n = r.contentWindow;
      else break;
      r = qe(n.document);
    }
    return r;
  }
  function Hc(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
  }
  function uu(n) {
    var r = hs(), l = n.focusedElem, d = n.selectionRange;
    if (r !== l && l && l.ownerDocument && vi(l.ownerDocument.documentElement, l)) {
      if (d !== null && Hc(l)) {
        if (r = d.start, n = d.end, n === void 0 && (n = r), "selectionStart" in l) l.selectionStart = r, l.selectionEnd = Math.min(n, l.value.length);
        else if (n = (r = l.ownerDocument || document) && r.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var g = l.textContent.length, S = Math.min(d.start, g);
          d = d.end === void 0 ? S : Math.min(d.end, g), !n.extend && S > d && (g = d, d = S, S = g), g = Bc(l, S);
          var _ = Bc(
            l,
            d
          );
          g && _ && (n.rangeCount !== 1 || n.anchorNode !== g.node || n.anchorOffset !== g.offset || n.focusNode !== _.node || n.focusOffset !== _.offset) && (r = r.createRange(), r.setStart(g.node, g.offset), n.removeAllRanges(), S > d ? (n.addRange(r), n.extend(_.node, _.offset)) : (r.setEnd(_.node, _.offset), n.addRange(r)));
        }
      }
      for (r = [], n = l; n = n.parentNode; ) n.nodeType === 1 && r.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof l.focus == "function" && l.focus(), l = 0; l < r.length; l++) n = r[l], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var _x = x && "documentMode" in document && 11 >= document.documentMode, su = null, up = null, ms = null, sp = !1;
  function cp(n, r, l) {
    var d = l.window === l ? l.document : l.nodeType === 9 ? l : l.ownerDocument;
    sp || su == null || su !== qe(d) || (d = su, "selectionStart" in d && Hc(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), ms && vs(ms, d) || (ms = d, d = ys(up, "onSelect"), 0 < d.length && (r = new zc("onSelect", "select", null, r, l), n.push({ event: r, listeners: d }), r.target = su)));
  }
  function $c(n, r) {
    var l = {};
    return l[n.toLowerCase()] = r.toLowerCase(), l["Webkit" + n] = "webkit" + r, l["Moz" + n] = "moz" + r, l;
  }
  var ul = { animationend: $c("Animation", "AnimationEnd"), animationiteration: $c("Animation", "AnimationIteration"), animationstart: $c("Animation", "AnimationStart"), transitionend: $c("Transition", "TransitionEnd") }, or = {}, fp = {};
  x && (fp = document.createElement("div").style, "AnimationEvent" in window || (delete ul.animationend.animation, delete ul.animationiteration.animation, delete ul.animationstart.animation), "TransitionEvent" in window || delete ul.transitionend.transition);
  function Vc(n) {
    if (or[n]) return or[n];
    if (!ul[n]) return n;
    var r = ul[n], l;
    for (l in r) if (r.hasOwnProperty(l) && l in fp) return or[n] = r[l];
    return n;
  }
  var Wh = Vc("animationend"), Yh = Vc("animationiteration"), Gh = Vc("animationstart"), Qh = Vc("transitionend"), dp = /* @__PURE__ */ new Map(), Wc = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function So(n, r) {
    dp.set(n, r), h(r, [n]);
  }
  for (var pp = 0; pp < Wc.length; pp++) {
    var sl = Wc[pp], Ox = sl.toLowerCase(), Dx = sl[0].toUpperCase() + sl.slice(1);
    So(Ox, "on" + Dx);
  }
  So(Wh, "onAnimationEnd"), So(Yh, "onAnimationIteration"), So(Gh, "onAnimationStart"), So("dblclick", "onDoubleClick"), So("focusin", "onFocus"), So("focusout", "onBlur"), So(Qh, "onTransitionEnd"), m("onMouseEnter", ["mouseout", "mouseover"]), m("onMouseLeave", ["mouseout", "mouseover"]), m("onPointerEnter", ["pointerout", "pointerover"]), m("onPointerLeave", ["pointerout", "pointerover"]), h("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), h("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), h("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), h("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), h("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), h("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var gs = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), vp = new Set("cancel close invalid load scroll toggle".split(" ").concat(gs));
  function Yc(n, r, l) {
    var d = n.type || "unknown-event";
    n.currentTarget = l, lt(d, r, void 0, n), n.currentTarget = null;
  }
  function cl(n, r) {
    r = (r & 4) !== 0;
    for (var l = 0; l < n.length; l++) {
      var d = n[l], g = d.event;
      d = d.listeners;
      e: {
        var S = void 0;
        if (r) for (var _ = d.length - 1; 0 <= _; _--) {
          var U = d[_], $ = U.instance, te = U.currentTarget;
          if (U = U.listener, $ !== S && g.isPropagationStopped()) break e;
          Yc(g, U, te), S = $;
        }
        else for (_ = 0; _ < d.length; _++) {
          if (U = d[_], $ = U.instance, te = U.currentTarget, U = U.listener, $ !== S && g.isPropagationStopped()) break e;
          Yc(g, U, te), S = $;
        }
      }
    }
    if (ci) throw n = H, ci = !1, H = null, n;
  }
  function Ft(n, r) {
    var l = r[bs];
    l === void 0 && (l = r[bs] = /* @__PURE__ */ new Set());
    var d = n + "__bubble";
    l.has(d) || (Kh(r, n, 2, !1), l.add(d));
  }
  function Gc(n, r, l) {
    var d = 0;
    r && (d |= 4), Kh(l, n, d, r);
  }
  var Qc = "_reactListening" + Math.random().toString(36).slice(2);
  function cu(n) {
    if (!n[Qc]) {
      n[Qc] = !0, f.forEach(function(l) {
        l !== "selectionchange" && (vp.has(l) || Gc(l, !1, n), Gc(l, !0, n));
      });
      var r = n.nodeType === 9 ? n : n.ownerDocument;
      r === null || r[Qc] || (r[Qc] = !0, Gc("selectionchange", !1, r));
    }
  }
  function Kh(n, r, l, d) {
    switch (Nc(r)) {
      case 1:
        var g = wh;
        break;
      case 4:
        g = Th;
        break;
      default:
        g = kc;
    }
    l = g.bind(null, r, l, n), g = void 0, !Fo || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (g = !0), d ? g !== void 0 ? n.addEventListener(r, l, { capture: !0, passive: g }) : n.addEventListener(r, l, !0) : g !== void 0 ? n.addEventListener(r, l, { passive: g }) : n.addEventListener(r, l, !1);
  }
  function Kc(n, r, l, d, g) {
    var S = d;
    if (!(r & 1) && !(r & 2) && d !== null) e: for (; ; ) {
      if (d === null) return;
      var _ = d.tag;
      if (_ === 3 || _ === 4) {
        var U = d.stateNode.containerInfo;
        if (U === g || U.nodeType === 8 && U.parentNode === g) break;
        if (_ === 4) for (_ = d.return; _ !== null; ) {
          var $ = _.tag;
          if (($ === 3 || $ === 4) && ($ = _.stateNode.containerInfo, $ === g || $.nodeType === 8 && $.parentNode === g)) return;
          _ = _.return;
        }
        for (; U !== null; ) {
          if (_ = dl(U), _ === null) return;
          if ($ = _.tag, $ === 5 || $ === 6) {
            d = S = _;
            continue e;
          }
          U = U.parentNode;
        }
      }
      d = d.return;
    }
    ts(function() {
      var te = S, xe = Yt(l), be = [];
      e: {
        var ge = dp.get(n);
        if (ge !== void 0) {
          var Fe = zc, We = n;
          switch (n) {
            case "keypress":
              if (Pc(l) === 0) break e;
            case "keydown":
            case "keyup":
              Fe = np;
              break;
            case "focusin":
              We = "focus", Fe = Ic;
              break;
            case "focusout":
              We = "blur", Fe = Ic;
              break;
            case "beforeblur":
            case "afterblur":
              Fe = Ic;
              break;
            case "click":
              if (l.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Fe = qd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Fe = au;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Fe = kh;
              break;
            case Wh:
            case Yh:
            case Gh:
              Fe = yx;
              break;
            case Qh:
              Fe = Na;
              break;
            case "scroll":
              Fe = hx;
              break;
            case "wheel":
              Fe = Aa;
              break;
            case "copy":
            case "cut":
            case "paste":
              Fe = Rh;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Fe = Dh;
          }
          var Xe = (r & 4) !== 0, Rn = !Xe && n === "scroll", K = Xe ? ge !== null ? ge + "Capture" : null : ge;
          Xe = [];
          for (var G = te, J; G !== null; ) {
            J = G;
            var Se = J.stateNode;
            if (J.tag === 5 && Se !== null && (J = Se, K !== null && (Se = wa(G, K), Se != null && Xe.push(fu(G, Se, J)))), Rn) break;
            G = G.return;
          }
          0 < Xe.length && (ge = new Fe(ge, We, null, l, xe), be.push({ event: ge, listeners: Xe }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (ge = n === "mouseover" || n === "pointerover", Fe = n === "mouseout" || n === "pointerout", ge && l !== tn && (We = l.relatedTarget || l.fromElement) && (dl(We) || We[Pa])) break e;
          if ((Fe || ge) && (ge = xe.window === xe ? xe : (ge = xe.ownerDocument) ? ge.defaultView || ge.parentWindow : window, Fe ? (We = l.relatedTarget || l.toElement, Fe = te, We = We ? dl(We) : null, We !== null && (Rn = St(We), We !== Rn || We.tag !== 5 && We.tag !== 6) && (We = null)) : (Fe = null, We = te), Fe !== We)) {
            if (Xe = qd, Se = "onMouseLeave", K = "onMouseEnter", G = "mouse", (n === "pointerout" || n === "pointerover") && (Xe = Dh, Se = "onPointerLeave", K = "onPointerEnter", G = "pointer"), Rn = Fe == null ? ge : Vo(Fe), J = We == null ? ge : Vo(We), ge = new Xe(Se, G + "leave", Fe, l, xe), ge.target = Rn, ge.relatedTarget = J, Se = null, dl(xe) === te && (Xe = new Xe(K, G + "enter", We, l, xe), Xe.target = J, Xe.relatedTarget = Rn, Se = Xe), Rn = Se, Fe && We) t: {
              for (Xe = Fe, K = We, G = 0, J = Xe; J; J = hi(J)) G++;
              for (J = 0, Se = K; Se; Se = hi(Se)) J++;
              for (; 0 < G - J; ) Xe = hi(Xe), G--;
              for (; 0 < J - G; ) K = hi(K), J--;
              for (; G--; ) {
                if (Xe === K || K !== null && Xe === K.alternate) break t;
                Xe = hi(Xe), K = hi(K);
              }
              Xe = null;
            }
            else Xe = null;
            Fe !== null && qh(be, ge, Fe, Xe, !1), We !== null && Rn !== null && qh(be, Rn, We, Xe, !0);
          }
        }
        e: {
          if (ge = te ? Vo(te) : window, Fe = ge.nodeName && ge.nodeName.toLowerCase(), Fe === "select" || Fe === "input" && ge.type === "file") var Ye = Ex;
          else if (jh(ge)) if (Ih) Ye = $h;
          else {
            Ye = Hh;
            var at = wx;
          }
          else (Fe = ge.nodeName) && Fe.toLowerCase() === "input" && (ge.type === "checkbox" || ge.type === "radio") && (Ye = Tx);
          if (Ye && (Ye = Ye(n, te))) {
            ap(be, Ye, l, xe);
            break e;
          }
          at && at(n, ge, te), n === "focusout" && (at = ge._wrapperState) && at.controlled && ge.type === "number" && ln(ge, "number", ge.value);
        }
        switch (at = te ? Vo(te) : window, n) {
          case "focusin":
            (jh(at) || at.contentEditable === "true") && (su = at, up = te, ms = null);
            break;
          case "focusout":
            ms = up = su = null;
            break;
          case "mousedown":
            sp = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            sp = !1, cp(be, l, xe);
            break;
          case "selectionchange":
            if (_x) break;
          case "keydown":
          case "keyup":
            cp(be, l, xe);
        }
        var it;
        if (iu) e: {
          switch (n) {
            case "compositionstart":
              var ft = "onCompositionStart";
              break e;
            case "compositionend":
              ft = "onCompositionEnd";
              break e;
            case "compositionupdate":
              ft = "onCompositionUpdate";
              break e;
          }
          ft = void 0;
        }
        else lu ? Ah(n, l) && (ft = "onCompositionEnd") : n === "keydown" && l.keyCode === 229 && (ft = "onCompositionStart");
        ft && (Mh && l.locale !== "ko" && (lu || ft !== "onCompositionStart" ? ft === "onCompositionEnd" && lu && (it = Qd()) : (ka = xe, Ac = "value" in ka ? ka.value : ka.textContent, lu = !0)), at = ys(te, ft), 0 < at.length && (ft = new Jd(ft, n, null, l, xe), be.push({ event: ft, listeners: at }), it ? ft.data = it : (it = Ph(l), it !== null && (ft.data = it)))), (it = ds ? Lh(n, l) : bx(n, l)) && (te = ys(te, "onBeforeInput"), 0 < te.length && (xe = new Jd("onBeforeInput", "beforeinput", null, l, xe), be.push({ event: xe, listeners: te }), xe.data = it));
      }
      cl(be, r);
    });
  }
  function fu(n, r, l) {
    return { instance: n, listener: r, currentTarget: l };
  }
  function ys(n, r) {
    for (var l = r + "Capture", d = []; n !== null; ) {
      var g = n, S = g.stateNode;
      g.tag === 5 && S !== null && (g = S, S = wa(n, l), S != null && d.unshift(fu(n, S, g)), S = wa(n, r), S != null && d.push(fu(n, S, g))), n = n.return;
    }
    return d;
  }
  function hi(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function qh(n, r, l, d, g) {
    for (var S = r._reactName, _ = []; l !== null && l !== d; ) {
      var U = l, $ = U.alternate, te = U.stateNode;
      if ($ !== null && $ === d) break;
      U.tag === 5 && te !== null && (U = te, g ? ($ = wa(l, S), $ != null && _.unshift(fu(l, $, U))) : g || ($ = wa(l, S), $ != null && _.push(fu(l, $, U)))), l = l.return;
    }
    _.length !== 0 && n.push({ event: r, listeners: _ });
  }
  var Xh = /\r\n?/g, kx = /\u0000|\uFFFD/g;
  function Zh(n) {
    return (typeof n == "string" ? n : "" + n).replace(Xh, `
`).replace(kx, "");
  }
  function qc(n, r, l) {
    if (r = Zh(r), Zh(n) !== r && l) throw Error(s(425));
  }
  function mi() {
  }
  var xs = null, fl = null;
  function Xc(n, r) {
    return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var Zc = typeof setTimeout == "function" ? setTimeout : void 0, hp = typeof clearTimeout == "function" ? clearTimeout : void 0, Jh = typeof Promise == "function" ? Promise : void 0, du = typeof queueMicrotask == "function" ? queueMicrotask : typeof Jh < "u" ? function(n) {
    return Jh.resolve(null).then(n).catch(Jc);
  } : Zc;
  function Jc(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function pu(n, r) {
    var l = r, d = 0;
    do {
      var g = l.nextSibling;
      if (n.removeChild(l), g && g.nodeType === 8) if (l = g.data, l === "/$") {
        if (d === 0) {
          n.removeChild(g), pi(r);
          return;
        }
        d--;
      } else l !== "$" && l !== "$?" && l !== "$!" || d++;
      l = g;
    } while (l);
    pi(r);
  }
  function ra(n) {
    for (; n != null; n = n.nextSibling) {
      var r = n.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = n.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return n;
  }
  function em(n) {
    n = n.previousSibling;
    for (var r = 0; n; ) {
      if (n.nodeType === 8) {
        var l = n.data;
        if (l === "$" || l === "$!" || l === "$?") {
          if (r === 0) return n;
          r--;
        } else l === "/$" && r++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var gi = Math.random().toString(36).slice(2), oa = "__reactFiber$" + gi, Ss = "__reactProps$" + gi, Pa = "__reactContainer$" + gi, bs = "__reactEvents$" + gi, vu = "__reactListeners$" + gi, Mx = "__reactHandles$" + gi;
  function dl(n) {
    var r = n[oa];
    if (r) return r;
    for (var l = n.parentNode; l; ) {
      if (r = l[Pa] || l[oa]) {
        if (l = r.alternate, r.child !== null || l !== null && l.child !== null) for (n = em(n); n !== null; ) {
          if (l = n[oa]) return l;
          n = em(n);
        }
        return r;
      }
      n = l, l = n.parentNode;
    }
    return null;
  }
  function nt(n) {
    return n = n[oa] || n[Pa], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function Vo(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(s(33));
  }
  function bn(n) {
    return n[Ss] || null;
  }
  var Dt = [], bo = -1;
  function Wo(n) {
    return { current: n };
  }
  function nn(n) {
    0 > bo || (n.current = Dt[bo], Dt[bo] = null, bo--);
  }
  function tt(n, r) {
    bo++, Dt[bo] = n.current, n.current = r;
  }
  var Ur = {}, yn = Wo(Ur), Hn = Wo(!1), Fr = Ur;
  function Co(n, r) {
    var l = n.type.contextTypes;
    if (!l) return Ur;
    var d = n.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === r) return d.__reactInternalMemoizedMaskedChildContext;
    var g = {}, S;
    for (S in l) g[S] = r[S];
    return d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = r, n.__reactInternalMemoizedMaskedChildContext = g), g;
  }
  function Mn(n) {
    return n = n.childContextTypes, n != null;
  }
  function hu() {
    nn(Hn), nn(yn);
  }
  function tm(n, r, l) {
    if (yn.current !== Ur) throw Error(s(168));
    tt(yn, r), tt(Hn, l);
  }
  function Cs(n, r, l) {
    var d = n.stateNode;
    if (r = r.childContextTypes, typeof d.getChildContext != "function") return l;
    d = d.getChildContext();
    for (var g in d) if (!(g in r)) throw Error(s(108, Oe(n) || "Unknown", g));
    return W({}, l, d);
  }
  function Br(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || Ur, Fr = yn.current, tt(yn, n), tt(Hn, Hn.current), !0;
  }
  function ef(n, r, l) {
    var d = n.stateNode;
    if (!d) throw Error(s(169));
    l ? (n = Cs(n, r, Fr), d.__reactInternalMemoizedMergedChildContext = n, nn(Hn), nn(yn), tt(yn, n)) : nn(Hn), tt(Hn, l);
  }
  var aa = null, mu = !1, La = !1;
  function tf(n) {
    aa === null ? aa = [n] : aa.push(n);
  }
  function yi(n) {
    mu = !0, tf(n);
  }
  function ia() {
    if (!La && aa !== null) {
      La = !0;
      var n = 0, r = Vt;
      try {
        var l = aa;
        for (Vt = 1; n < l.length; n++) {
          var d = l[n];
          do
            d = d(!0);
          while (d !== null);
        }
        aa = null, mu = !1;
      } catch (g) {
        throw aa !== null && (aa = aa.slice(n + 1)), dn(Oa, ia), g;
      } finally {
        Vt = r, La = !1;
      }
    }
    return null;
  }
  var xi = [], Si = 0, bi = null, ja = 0, Nn = [], Eo = 0, no = null, la = 1, ua = "";
  function pl(n, r) {
    xi[Si++] = ja, xi[Si++] = bi, bi = n, ja = r;
  }
  function nm(n, r, l) {
    Nn[Eo++] = la, Nn[Eo++] = ua, Nn[Eo++] = no, no = n;
    var d = la;
    n = ua;
    var g = 32 - go(d) - 1;
    d &= ~(1 << g), l += 1;
    var S = 32 - go(r) + g;
    if (30 < S) {
      var _ = g - g % 5;
      S = (d & (1 << _) - 1).toString(32), d >>= _, g -= _, la = 1 << 32 - go(r) + g | l << g | d, ua = S + n;
    } else la = 1 << S | l << g | d, ua = n;
  }
  function nf(n) {
    n.return !== null && (pl(n, 1), nm(n, 1, 0));
  }
  function rf(n) {
    for (; n === bi; ) bi = xi[--Si], xi[Si] = null, ja = xi[--Si], xi[Si] = null;
    for (; n === no; ) no = Nn[--Eo], Nn[Eo] = null, ua = Nn[--Eo], Nn[Eo] = null, la = Nn[--Eo], Nn[Eo] = null;
  }
  var Hr = null, $r = null, cn = !1, wo = null;
  function mp(n, r) {
    var l = Do(5, null, null, 0);
    l.elementType = "DELETED", l.stateNode = r, l.return = n, r = n.deletions, r === null ? (n.deletions = [l], n.flags |= 16) : r.push(l);
  }
  function rm(n, r) {
    switch (n.tag) {
      case 5:
        var l = n.type;
        return r = r.nodeType !== 1 || l.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (n.stateNode = r, Hr = n, $r = ra(r.firstChild), !0) : !1;
      case 6:
        return r = n.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (n.stateNode = r, Hr = n, $r = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (l = no !== null ? { id: la, overflow: ua } : null, n.memoizedState = { dehydrated: r, treeContext: l, retryLane: 1073741824 }, l = Do(18, null, null, 0), l.stateNode = r, l.return = n, n.child = l, Hr = n, $r = null, !0) : !1;
      default:
        return !1;
    }
  }
  function gp(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function yp(n) {
    if (cn) {
      var r = $r;
      if (r) {
        var l = r;
        if (!rm(n, r)) {
          if (gp(n)) throw Error(s(418));
          r = ra(l.nextSibling);
          var d = Hr;
          r && rm(n, r) ? mp(d, l) : (n.flags = n.flags & -4097 | 2, cn = !1, Hr = n);
        }
      } else {
        if (gp(n)) throw Error(s(418));
        n.flags = n.flags & -4097 | 2, cn = !1, Hr = n;
      }
    }
  }
  function $n(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    Hr = n;
  }
  function of(n) {
    if (n !== Hr) return !1;
    if (!cn) return $n(n), cn = !0, !1;
    var r;
    if ((r = n.tag !== 3) && !(r = n.tag !== 5) && (r = n.type, r = r !== "head" && r !== "body" && !Xc(n.type, n.memoizedProps)), r && (r = $r)) {
      if (gp(n)) throw Es(), Error(s(418));
      for (; r; ) mp(n, r), r = ra(r.nextSibling);
    }
    if ($n(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(s(317));
      e: {
        for (n = n.nextSibling, r = 0; n; ) {
          if (n.nodeType === 8) {
            var l = n.data;
            if (l === "/$") {
              if (r === 0) {
                $r = ra(n.nextSibling);
                break e;
              }
              r--;
            } else l !== "$" && l !== "$!" && l !== "$?" || r++;
          }
          n = n.nextSibling;
        }
        $r = null;
      }
    } else $r = Hr ? ra(n.stateNode.nextSibling) : null;
    return !0;
  }
  function Es() {
    for (var n = $r; n; ) n = ra(n.nextSibling);
  }
  function Ci() {
    $r = Hr = null, cn = !1;
  }
  function za(n) {
    wo === null ? wo = [n] : wo.push(n);
  }
  var Nx = V.ReactCurrentBatchConfig;
  function vl(n, r, l) {
    if (n = l.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (l._owner) {
        if (l = l._owner, l) {
          if (l.tag !== 1) throw Error(s(309));
          var d = l.stateNode;
        }
        if (!d) throw Error(s(147, n));
        var g = d, S = "" + n;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === S ? r.ref : (r = function(_) {
          var U = g.refs;
          _ === null ? delete U[S] : U[S] = _;
        }, r._stringRef = S, r);
      }
      if (typeof n != "string") throw Error(s(284));
      if (!l._owner) throw Error(s(290, n));
    }
    return n;
  }
  function af(n, r) {
    throw n = Object.prototype.toString.call(r), Error(s(31, n === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : n));
  }
  function om(n) {
    var r = n._init;
    return r(n._payload);
  }
  function hl(n) {
    function r(K, G) {
      if (n) {
        var J = K.deletions;
        J === null ? (K.deletions = [G], K.flags |= 16) : J.push(G);
      }
    }
    function l(K, G) {
      if (!n) return null;
      for (; G !== null; ) r(K, G), G = G.sibling;
      return null;
    }
    function d(K, G) {
      for (K = /* @__PURE__ */ new Map(); G !== null; ) G.key !== null ? K.set(G.key, G) : K.set(G.index, G), G = G.sibling;
      return K;
    }
    function g(K, G) {
      return K = ki(K, G), K.index = 0, K.sibling = null, K;
    }
    function S(K, G, J) {
      return K.index = J, n ? (J = K.alternate, J !== null ? (J = J.index, J < G ? (K.flags |= 2, G) : J) : (K.flags |= 2, G)) : (K.flags |= 1048576, G);
    }
    function _(K) {
      return n && K.alternate === null && (K.flags |= 2), K;
    }
    function U(K, G, J, Se) {
      return G === null || G.tag !== 6 ? (G = Kp(J, K.mode, Se), G.return = K, G) : (G = g(G, J), G.return = K, G);
    }
    function $(K, G, J, Se) {
      var Ye = J.type;
      return Ye === Z ? xe(K, G, J.props.children, Se, J.key) : G !== null && (G.elementType === Ye || typeof Ye == "object" && Ye !== null && Ye.$$typeof === Re && om(Ye) === G.type) ? (Se = g(G, J.props), Se.ref = vl(K, G, J), Se.return = K, Se) : (Se = Js(J.type, J.key, J.props, null, K.mode, Se), Se.ref = vl(K, G, J), Se.return = K, Se);
    }
    function te(K, G, J, Se) {
      return G === null || G.tag !== 4 || G.stateNode.containerInfo !== J.containerInfo || G.stateNode.implementation !== J.implementation ? (G = Uf(J, K.mode, Se), G.return = K, G) : (G = g(G, J.children || []), G.return = K, G);
    }
    function xe(K, G, J, Se, Ye) {
      return G === null || G.tag !== 7 ? (G = $a(J, K.mode, Se, Ye), G.return = K, G) : (G = g(G, J), G.return = K, G);
    }
    function be(K, G, J) {
      if (typeof G == "string" && G !== "" || typeof G == "number") return G = Kp("" + G, K.mode, J), G.return = K, G;
      if (typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case B:
            return J = Js(G.type, G.key, G.props, null, K.mode, J), J.ref = vl(K, null, G), J.return = K, J;
          case ae:
            return G = Uf(G, K.mode, J), G.return = K, G;
          case Re:
            var Se = G._init;
            return be(K, Se(G._payload), J);
        }
        if (er(G) || le(G)) return G = $a(G, K.mode, J, null), G.return = K, G;
        af(K, G);
      }
      return null;
    }
    function ge(K, G, J, Se) {
      var Ye = G !== null ? G.key : null;
      if (typeof J == "string" && J !== "" || typeof J == "number") return Ye !== null ? null : U(K, G, "" + J, Se);
      if (typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case B:
            return J.key === Ye ? $(K, G, J, Se) : null;
          case ae:
            return J.key === Ye ? te(K, G, J, Se) : null;
          case Re:
            return Ye = J._init, ge(
              K,
              G,
              Ye(J._payload),
              Se
            );
        }
        if (er(J) || le(J)) return Ye !== null ? null : xe(K, G, J, Se, null);
        af(K, J);
      }
      return null;
    }
    function Fe(K, G, J, Se, Ye) {
      if (typeof Se == "string" && Se !== "" || typeof Se == "number") return K = K.get(J) || null, U(G, K, "" + Se, Ye);
      if (typeof Se == "object" && Se !== null) {
        switch (Se.$$typeof) {
          case B:
            return K = K.get(Se.key === null ? J : Se.key) || null, $(G, K, Se, Ye);
          case ae:
            return K = K.get(Se.key === null ? J : Se.key) || null, te(G, K, Se, Ye);
          case Re:
            var at = Se._init;
            return Fe(K, G, J, at(Se._payload), Ye);
        }
        if (er(Se) || le(Se)) return K = K.get(J) || null, xe(G, K, Se, Ye, null);
        af(G, Se);
      }
      return null;
    }
    function We(K, G, J, Se) {
      for (var Ye = null, at = null, it = G, ft = G = 0, Zn = null; it !== null && ft < J.length; ft++) {
        it.index > ft ? (Zn = it, it = null) : Zn = it.sibling;
        var zt = ge(K, it, J[ft], Se);
        if (zt === null) {
          it === null && (it = Zn);
          break;
        }
        n && it && zt.alternate === null && r(K, it), G = S(zt, G, ft), at === null ? Ye = zt : at.sibling = zt, at = zt, it = Zn;
      }
      if (ft === J.length) return l(K, it), cn && pl(K, ft), Ye;
      if (it === null) {
        for (; ft < J.length; ft++) it = be(K, J[ft], Se), it !== null && (G = S(it, G, ft), at === null ? Ye = it : at.sibling = it, at = it);
        return cn && pl(K, ft), Ye;
      }
      for (it = d(K, it); ft < J.length; ft++) Zn = Fe(it, K, ft, J[ft], Se), Zn !== null && (n && Zn.alternate !== null && it.delete(Zn.key === null ? ft : Zn.key), G = S(Zn, G, ft), at === null ? Ye = Zn : at.sibling = Zn, at = Zn);
      return n && it.forEach(function(Ai) {
        return r(K, Ai);
      }), cn && pl(K, ft), Ye;
    }
    function Xe(K, G, J, Se) {
      var Ye = le(J);
      if (typeof Ye != "function") throw Error(s(150));
      if (J = Ye.call(J), J == null) throw Error(s(151));
      for (var at = Ye = null, it = G, ft = G = 0, Zn = null, zt = J.next(); it !== null && !zt.done; ft++, zt = J.next()) {
        it.index > ft ? (Zn = it, it = null) : Zn = it.sibling;
        var Ai = ge(K, it, zt.value, Se);
        if (Ai === null) {
          it === null && (it = Zn);
          break;
        }
        n && it && Ai.alternate === null && r(K, it), G = S(Ai, G, ft), at === null ? Ye = Ai : at.sibling = Ai, at = Ai, it = Zn;
      }
      if (zt.done) return l(
        K,
        it
      ), cn && pl(K, ft), Ye;
      if (it === null) {
        for (; !zt.done; ft++, zt = J.next()) zt = be(K, zt.value, Se), zt !== null && (G = S(zt, G, ft), at === null ? Ye = zt : at.sibling = zt, at = zt);
        return cn && pl(K, ft), Ye;
      }
      for (it = d(K, it); !zt.done; ft++, zt = J.next()) zt = Fe(it, K, ft, zt.value, Se), zt !== null && (n && zt.alternate !== null && it.delete(zt.key === null ? ft : zt.key), G = S(zt, G, ft), at === null ? Ye = zt : at.sibling = zt, at = zt);
      return n && it.forEach(function(Fm) {
        return r(K, Fm);
      }), cn && pl(K, ft), Ye;
    }
    function Rn(K, G, J, Se) {
      if (typeof J == "object" && J !== null && J.type === Z && J.key === null && (J = J.props.children), typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case B:
            e: {
              for (var Ye = J.key, at = G; at !== null; ) {
                if (at.key === Ye) {
                  if (Ye = J.type, Ye === Z) {
                    if (at.tag === 7) {
                      l(K, at.sibling), G = g(at, J.props.children), G.return = K, K = G;
                      break e;
                    }
                  } else if (at.elementType === Ye || typeof Ye == "object" && Ye !== null && Ye.$$typeof === Re && om(Ye) === at.type) {
                    l(K, at.sibling), G = g(at, J.props), G.ref = vl(K, at, J), G.return = K, K = G;
                    break e;
                  }
                  l(K, at);
                  break;
                } else r(K, at);
                at = at.sibling;
              }
              J.type === Z ? (G = $a(J.props.children, K.mode, Se, J.key), G.return = K, K = G) : (Se = Js(J.type, J.key, J.props, null, K.mode, Se), Se.ref = vl(K, G, J), Se.return = K, K = Se);
            }
            return _(K);
          case ae:
            e: {
              for (at = J.key; G !== null; ) {
                if (G.key === at) if (G.tag === 4 && G.stateNode.containerInfo === J.containerInfo && G.stateNode.implementation === J.implementation) {
                  l(K, G.sibling), G = g(G, J.children || []), G.return = K, K = G;
                  break e;
                } else {
                  l(K, G);
                  break;
                }
                else r(K, G);
                G = G.sibling;
              }
              G = Uf(J, K.mode, Se), G.return = K, K = G;
            }
            return _(K);
          case Re:
            return at = J._init, Rn(K, G, at(J._payload), Se);
        }
        if (er(J)) return We(K, G, J, Se);
        if (le(J)) return Xe(K, G, J, Se);
        af(K, J);
      }
      return typeof J == "string" && J !== "" || typeof J == "number" ? (J = "" + J, G !== null && G.tag === 6 ? (l(K, G.sibling), G = g(G, J), G.return = K, K = G) : (l(K, G), G = Kp(J, K.mode, Se), G.return = K, K = G), _(K)) : l(K, G);
    }
    return Rn;
  }
  var Cn = hl(!0), Ne = hl(!1), ro = Wo(null), Vr = null, gu = null, xp = null;
  function Sp() {
    xp = gu = Vr = null;
  }
  function bp(n) {
    var r = ro.current;
    nn(ro), n._currentValue = r;
  }
  function Cp(n, r, l) {
    for (; n !== null; ) {
      var d = n.alternate;
      if ((n.childLanes & r) !== r ? (n.childLanes |= r, d !== null && (d.childLanes |= r)) : d !== null && (d.childLanes & r) !== r && (d.childLanes |= r), n === l) break;
      n = n.return;
    }
  }
  function pn(n, r) {
    Vr = n, xp = gu = null, n = n.dependencies, n !== null && n.firstContext !== null && (n.lanes & r && (Pn = !0), n.firstContext = null);
  }
  function To(n) {
    var r = n._currentValue;
    if (xp !== n) if (n = { context: n, memoizedValue: r, next: null }, gu === null) {
      if (Vr === null) throw Error(s(308));
      gu = n, Vr.dependencies = { lanes: 0, firstContext: n };
    } else gu = gu.next = n;
    return r;
  }
  var ml = null;
  function Ep(n) {
    ml === null ? ml = [n] : ml.push(n);
  }
  function wp(n, r, l, d) {
    var g = r.interleaved;
    return g === null ? (l.next = l, Ep(r)) : (l.next = g.next, g.next = l), r.interleaved = l, oo(n, d);
  }
  function oo(n, r) {
    n.lanes |= r;
    var l = n.alternate;
    for (l !== null && (l.lanes |= r), l = n, n = n.return; n !== null; ) n.childLanes |= r, l = n.alternate, l !== null && (l.childLanes |= r), l = n, n = n.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var ao = !1;
  function Tp(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function am(n, r) {
    n = n.updateQueue, r.updateQueue === n && (r.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function Ia(n, r) {
    return { eventTime: n, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function Ei(n, r, l) {
    var d = n.updateQueue;
    if (d === null) return null;
    if (d = d.shared, kt & 2) {
      var g = d.pending;
      return g === null ? r.next = r : (r.next = g.next, g.next = r), d.pending = r, oo(n, l);
    }
    return g = d.interleaved, g === null ? (r.next = r, Ep(d)) : (r.next = g.next, g.next = r), d.interleaved = r, oo(n, l);
  }
  function lf(n, r, l) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (l & 4194240) !== 0)) {
      var d = r.lanes;
      d &= n.pendingLanes, l |= d, r.lanes = l, Dc(n, l);
    }
  }
  function im(n, r) {
    var l = n.updateQueue, d = n.alternate;
    if (d !== null && (d = d.updateQueue, l === d)) {
      var g = null, S = null;
      if (l = l.firstBaseUpdate, l !== null) {
        do {
          var _ = { eventTime: l.eventTime, lane: l.lane, tag: l.tag, payload: l.payload, callback: l.callback, next: null };
          S === null ? g = S = _ : S = S.next = _, l = l.next;
        } while (l !== null);
        S === null ? g = S = r : S = S.next = r;
      } else g = S = r;
      l = { baseState: d.baseState, firstBaseUpdate: g, lastBaseUpdate: S, shared: d.shared, effects: d.effects }, n.updateQueue = l;
      return;
    }
    n = l.lastBaseUpdate, n === null ? l.firstBaseUpdate = r : n.next = r, l.lastBaseUpdate = r;
  }
  function ws(n, r, l, d) {
    var g = n.updateQueue;
    ao = !1;
    var S = g.firstBaseUpdate, _ = g.lastBaseUpdate, U = g.shared.pending;
    if (U !== null) {
      g.shared.pending = null;
      var $ = U, te = $.next;
      $.next = null, _ === null ? S = te : _.next = te, _ = $;
      var xe = n.alternate;
      xe !== null && (xe = xe.updateQueue, U = xe.lastBaseUpdate, U !== _ && (U === null ? xe.firstBaseUpdate = te : U.next = te, xe.lastBaseUpdate = $));
    }
    if (S !== null) {
      var be = g.baseState;
      _ = 0, xe = te = $ = null, U = S;
      do {
        var ge = U.lane, Fe = U.eventTime;
        if ((d & ge) === ge) {
          xe !== null && (xe = xe.next = {
            eventTime: Fe,
            lane: 0,
            tag: U.tag,
            payload: U.payload,
            callback: U.callback,
            next: null
          });
          e: {
            var We = n, Xe = U;
            switch (ge = r, Fe = l, Xe.tag) {
              case 1:
                if (We = Xe.payload, typeof We == "function") {
                  be = We.call(Fe, be, ge);
                  break e;
                }
                be = We;
                break e;
              case 3:
                We.flags = We.flags & -65537 | 128;
              case 0:
                if (We = Xe.payload, ge = typeof We == "function" ? We.call(Fe, be, ge) : We, ge == null) break e;
                be = W({}, be, ge);
                break e;
              case 2:
                ao = !0;
            }
          }
          U.callback !== null && U.lane !== 0 && (n.flags |= 64, ge = g.effects, ge === null ? g.effects = [U] : ge.push(U));
        } else Fe = { eventTime: Fe, lane: ge, tag: U.tag, payload: U.payload, callback: U.callback, next: null }, xe === null ? (te = xe = Fe, $ = be) : xe = xe.next = Fe, _ |= ge;
        if (U = U.next, U === null) {
          if (U = g.shared.pending, U === null) break;
          ge = U, U = ge.next, ge.next = null, g.lastBaseUpdate = ge, g.shared.pending = null;
        }
      } while (!0);
      if (xe === null && ($ = be), g.baseState = $, g.firstBaseUpdate = te, g.lastBaseUpdate = xe, r = g.shared.interleaved, r !== null) {
        g = r;
        do
          _ |= g.lane, g = g.next;
        while (g !== r);
      } else S === null && (g.shared.lanes = 0);
      pa |= _, n.lanes = _, n.memoizedState = be;
    }
  }
  function Rp(n, r, l) {
    if (n = r.effects, r.effects = null, n !== null) for (r = 0; r < n.length; r++) {
      var d = n[r], g = d.callback;
      if (g !== null) {
        if (d.callback = null, d = l, typeof g != "function") throw Error(s(191, g));
        g.call(d);
      }
    }
  }
  var Ts = {}, sa = Wo(Ts), Rs = Wo(Ts), _s = Wo(Ts);
  function gl(n) {
    if (n === Ts) throw Error(s(174));
    return n;
  }
  function _p(n, r) {
    switch (tt(_s, r), tt(Rs, n), tt(sa, Ts), n = r.nodeType, n) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : eo(null, "");
        break;
      default:
        n = n === 8 ? r.parentNode : r, r = n.namespaceURI || null, n = n.tagName, r = eo(r, n);
    }
    nn(sa), tt(sa, r);
  }
  function yl() {
    nn(sa), nn(Rs), nn(_s);
  }
  function lm(n) {
    gl(_s.current);
    var r = gl(sa.current), l = eo(r, n.type);
    r !== l && (tt(Rs, n), tt(sa, l));
  }
  function uf(n) {
    Rs.current === n && (nn(sa), nn(Rs));
  }
  var vn = Wo(0);
  function sf(n) {
    for (var r = n; r !== null; ) {
      if (r.tag === 13) {
        var l = r.memoizedState;
        if (l !== null && (l = l.dehydrated, l === null || l.data === "$?" || l.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === n) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === n) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var Os = [];
  function rt() {
    for (var n = 0; n < Os.length; n++) Os[n]._workInProgressVersionPrimary = null;
    Os.length = 0;
  }
  var Et = V.ReactCurrentDispatcher, Lt = V.ReactCurrentBatchConfig, Qt = 0, jt = null, An = null, qn = null, cf = !1, Ds = !1, xl = 0, he = 0;
  function Pt() {
    throw Error(s(321));
  }
  function st(n, r) {
    if (r === null) return !1;
    for (var l = 0; l < r.length && l < n.length; l++) if (!$o(n[l], r[l])) return !1;
    return !0;
  }
  function wi(n, r, l, d, g, S) {
    if (Qt = S, jt = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, Et.current = n === null || n.memoizedState === null ? Tf : Ls, n = l(d, g), Ds) {
      S = 0;
      do {
        if (Ds = !1, xl = 0, 25 <= S) throw Error(s(301));
        S += 1, qn = An = null, r.updateQueue = null, Et.current = Rf, n = l(d, g);
      } while (Ds);
    }
    if (Et.current = wl, r = An !== null && An.next !== null, Qt = 0, qn = An = jt = null, cf = !1, r) throw Error(s(300));
    return n;
  }
  function Yo() {
    var n = xl !== 0;
    return xl = 0, n;
  }
  function mr() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return qn === null ? jt.memoizedState = qn = n : qn = qn.next = n, qn;
  }
  function En() {
    if (An === null) {
      var n = jt.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = An.next;
    var r = qn === null ? jt.memoizedState : qn.next;
    if (r !== null) qn = r, An = n;
    else {
      if (n === null) throw Error(s(310));
      An = n, n = { memoizedState: An.memoizedState, baseState: An.baseState, baseQueue: An.baseQueue, queue: An.queue, next: null }, qn === null ? jt.memoizedState = qn = n : qn = qn.next = n;
    }
    return qn;
  }
  function Ua(n, r) {
    return typeof r == "function" ? r(n) : r;
  }
  function Ti(n) {
    var r = En(), l = r.queue;
    if (l === null) throw Error(s(311));
    l.lastRenderedReducer = n;
    var d = An, g = d.baseQueue, S = l.pending;
    if (S !== null) {
      if (g !== null) {
        var _ = g.next;
        g.next = S.next, S.next = _;
      }
      d.baseQueue = g = S, l.pending = null;
    }
    if (g !== null) {
      S = g.next, d = d.baseState;
      var U = _ = null, $ = null, te = S;
      do {
        var xe = te.lane;
        if ((Qt & xe) === xe) $ !== null && ($ = $.next = { lane: 0, action: te.action, hasEagerState: te.hasEagerState, eagerState: te.eagerState, next: null }), d = te.hasEagerState ? te.eagerState : n(d, te.action);
        else {
          var be = {
            lane: xe,
            action: te.action,
            hasEagerState: te.hasEagerState,
            eagerState: te.eagerState,
            next: null
          };
          $ === null ? (U = $ = be, _ = d) : $ = $.next = be, jt.lanes |= xe, pa |= xe;
        }
        te = te.next;
      } while (te !== null && te !== S);
      $ === null ? _ = d : $.next = U, $o(d, r.memoizedState) || (Pn = !0), r.memoizedState = d, r.baseState = _, r.baseQueue = $, l.lastRenderedState = d;
    }
    if (n = l.interleaved, n !== null) {
      g = n;
      do
        S = g.lane, jt.lanes |= S, pa |= S, g = g.next;
      while (g !== n);
    } else g === null && (l.lanes = 0);
    return [r.memoizedState, l.dispatch];
  }
  function Sl(n) {
    var r = En(), l = r.queue;
    if (l === null) throw Error(s(311));
    l.lastRenderedReducer = n;
    var d = l.dispatch, g = l.pending, S = r.memoizedState;
    if (g !== null) {
      l.pending = null;
      var _ = g = g.next;
      do
        S = n(S, _.action), _ = _.next;
      while (_ !== g);
      $o(S, r.memoizedState) || (Pn = !0), r.memoizedState = S, r.baseQueue === null && (r.baseState = S), l.lastRenderedState = S;
    }
    return [S, d];
  }
  function ff() {
  }
  function df(n, r) {
    var l = jt, d = En(), g = r(), S = !$o(d.memoizedState, g);
    if (S && (d.memoizedState = g, Pn = !0), d = d.queue, ks(hf.bind(null, l, d, n), [n]), d.getSnapshot !== r || S || qn !== null && qn.memoizedState.tag & 1) {
      if (l.flags |= 2048, bl(9, vf.bind(null, l, d, g, r), void 0, null), Vn === null) throw Error(s(349));
      Qt & 30 || pf(l, r, g);
    }
    return g;
  }
  function pf(n, r, l) {
    n.flags |= 16384, n = { getSnapshot: r, value: l }, r = jt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, jt.updateQueue = r, r.stores = [n]) : (l = r.stores, l === null ? r.stores = [n] : l.push(n));
  }
  function vf(n, r, l, d) {
    r.value = l, r.getSnapshot = d, mf(r) && gf(n);
  }
  function hf(n, r, l) {
    return l(function() {
      mf(r) && gf(n);
    });
  }
  function mf(n) {
    var r = n.getSnapshot;
    n = n.value;
    try {
      var l = r();
      return !$o(n, l);
    } catch {
      return !0;
    }
  }
  function gf(n) {
    var r = oo(n, 1);
    r !== null && Rr(r, n, 1, -1);
  }
  function yf(n) {
    var r = mr();
    return typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ua, lastRenderedState: n }, r.queue = n, n = n.dispatch = El.bind(null, jt, n), [r.memoizedState, n];
  }
  function bl(n, r, l, d) {
    return n = { tag: n, create: r, destroy: l, deps: d, next: null }, r = jt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, jt.updateQueue = r, r.lastEffect = n.next = n) : (l = r.lastEffect, l === null ? r.lastEffect = n.next = n : (d = l.next, l.next = n, n.next = d, r.lastEffect = n)), n;
  }
  function xf() {
    return En().memoizedState;
  }
  function yu(n, r, l, d) {
    var g = mr();
    jt.flags |= n, g.memoizedState = bl(1 | r, l, void 0, d === void 0 ? null : d);
  }
  function xu(n, r, l, d) {
    var g = En();
    d = d === void 0 ? null : d;
    var S = void 0;
    if (An !== null) {
      var _ = An.memoizedState;
      if (S = _.destroy, d !== null && st(d, _.deps)) {
        g.memoizedState = bl(r, l, S, d);
        return;
      }
    }
    jt.flags |= n, g.memoizedState = bl(1 | r, l, S, d);
  }
  function Sf(n, r) {
    return yu(8390656, 8, n, r);
  }
  function ks(n, r) {
    return xu(2048, 8, n, r);
  }
  function bf(n, r) {
    return xu(4, 2, n, r);
  }
  function Ms(n, r) {
    return xu(4, 4, n, r);
  }
  function Cl(n, r) {
    if (typeof r == "function") return n = n(), r(n), function() {
      r(null);
    };
    if (r != null) return n = n(), r.current = n, function() {
      r.current = null;
    };
  }
  function Cf(n, r, l) {
    return l = l != null ? l.concat([n]) : null, xu(4, 4, Cl.bind(null, r, n), l);
  }
  function Ns() {
  }
  function Ef(n, r) {
    var l = En();
    r = r === void 0 ? null : r;
    var d = l.memoizedState;
    return d !== null && r !== null && st(r, d[1]) ? d[0] : (l.memoizedState = [n, r], n);
  }
  function wf(n, r) {
    var l = En();
    r = r === void 0 ? null : r;
    var d = l.memoizedState;
    return d !== null && r !== null && st(r, d[1]) ? d[0] : (n = n(), l.memoizedState = [n, r], n);
  }
  function Op(n, r, l) {
    return Qt & 21 ? ($o(l, r) || (l = Oc(), jt.lanes |= l, pa |= l, n.baseState = !0), r) : (n.baseState && (n.baseState = !1, Pn = !0), n.memoizedState = l);
  }
  function As(n, r) {
    var l = Vt;
    Vt = l !== 0 && 4 > l ? l : 4, n(!0);
    var d = Lt.transition;
    Lt.transition = {};
    try {
      n(!1), r();
    } finally {
      Vt = l, Lt.transition = d;
    }
  }
  function Dp() {
    return En().memoizedState;
  }
  function Ps(n, r, l) {
    var d = va(n);
    if (l = { lane: d, action: l, hasEagerState: !1, eagerState: null, next: null }, io(n)) um(r, l);
    else if (l = wp(n, r, l, d), l !== null) {
      var g = zn();
      Rr(l, n, d, g), Jt(l, r, d);
    }
  }
  function El(n, r, l) {
    var d = va(n), g = { lane: d, action: l, hasEagerState: !1, eagerState: null, next: null };
    if (io(n)) um(r, g);
    else {
      var S = n.alternate;
      if (n.lanes === 0 && (S === null || S.lanes === 0) && (S = r.lastRenderedReducer, S !== null)) try {
        var _ = r.lastRenderedState, U = S(_, l);
        if (g.hasEagerState = !0, g.eagerState = U, $o(U, _)) {
          var $ = r.interleaved;
          $ === null ? (g.next = g, Ep(r)) : (g.next = $.next, $.next = g), r.interleaved = g;
          return;
        }
      } catch {
      } finally {
      }
      l = wp(n, r, g, d), l !== null && (g = zn(), Rr(l, n, d, g), Jt(l, r, d));
    }
  }
  function io(n) {
    var r = n.alternate;
    return n === jt || r !== null && r === jt;
  }
  function um(n, r) {
    Ds = cf = !0;
    var l = n.pending;
    l === null ? r.next = r : (r.next = l.next, l.next = r), n.pending = r;
  }
  function Jt(n, r, l) {
    if (l & 4194240) {
      var d = r.lanes;
      d &= n.pendingLanes, l |= d, r.lanes = l, Dc(n, l);
    }
  }
  var wl = { readContext: To, useCallback: Pt, useContext: Pt, useEffect: Pt, useImperativeHandle: Pt, useInsertionEffect: Pt, useLayoutEffect: Pt, useMemo: Pt, useReducer: Pt, useRef: Pt, useState: Pt, useDebugValue: Pt, useDeferredValue: Pt, useTransition: Pt, useMutableSource: Pt, useSyncExternalStore: Pt, useId: Pt, unstable_isNewReconciler: !1 }, Tf = { readContext: To, useCallback: function(n, r) {
    return mr().memoizedState = [n, r === void 0 ? null : r], n;
  }, useContext: To, useEffect: Sf, useImperativeHandle: function(n, r, l) {
    return l = l != null ? l.concat([n]) : null, yu(
      4194308,
      4,
      Cl.bind(null, r, n),
      l
    );
  }, useLayoutEffect: function(n, r) {
    return yu(4194308, 4, n, r);
  }, useInsertionEffect: function(n, r) {
    return yu(4, 2, n, r);
  }, useMemo: function(n, r) {
    var l = mr();
    return r = r === void 0 ? null : r, n = n(), l.memoizedState = [n, r], n;
  }, useReducer: function(n, r, l) {
    var d = mr();
    return r = l !== void 0 ? l(r) : r, d.memoizedState = d.baseState = r, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: r }, d.queue = n, n = n.dispatch = Ps.bind(null, jt, n), [d.memoizedState, n];
  }, useRef: function(n) {
    var r = mr();
    return n = { current: n }, r.memoizedState = n;
  }, useState: yf, useDebugValue: Ns, useDeferredValue: function(n) {
    return mr().memoizedState = n;
  }, useTransition: function() {
    var n = yf(!1), r = n[0];
    return n = As.bind(null, n[1]), mr().memoizedState = n, [r, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, r, l) {
    var d = jt, g = mr();
    if (cn) {
      if (l === void 0) throw Error(s(407));
      l = l();
    } else {
      if (l = r(), Vn === null) throw Error(s(349));
      Qt & 30 || pf(d, r, l);
    }
    g.memoizedState = l;
    var S = { value: l, getSnapshot: r };
    return g.queue = S, Sf(hf.bind(
      null,
      d,
      S,
      n
    ), [n]), d.flags |= 2048, bl(9, vf.bind(null, d, S, l, r), void 0, null), l;
  }, useId: function() {
    var n = mr(), r = Vn.identifierPrefix;
    if (cn) {
      var l = ua, d = la;
      l = (d & ~(1 << 32 - go(d) - 1)).toString(32) + l, r = ":" + r + "R" + l, l = xl++, 0 < l && (r += "H" + l.toString(32)), r += ":";
    } else l = he++, r = ":" + r + "r" + l.toString(32) + ":";
    return n.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, Ls = {
    readContext: To,
    useCallback: Ef,
    useContext: To,
    useEffect: ks,
    useImperativeHandle: Cf,
    useInsertionEffect: bf,
    useLayoutEffect: Ms,
    useMemo: wf,
    useReducer: Ti,
    useRef: xf,
    useState: function() {
      return Ti(Ua);
    },
    useDebugValue: Ns,
    useDeferredValue: function(n) {
      var r = En();
      return Op(r, An.memoizedState, n);
    },
    useTransition: function() {
      var n = Ti(Ua)[0], r = En().memoizedState;
      return [n, r];
    },
    useMutableSource: ff,
    useSyncExternalStore: df,
    useId: Dp,
    unstable_isNewReconciler: !1
  }, Rf = { readContext: To, useCallback: Ef, useContext: To, useEffect: ks, useImperativeHandle: Cf, useInsertionEffect: bf, useLayoutEffect: Ms, useMemo: wf, useReducer: Sl, useRef: xf, useState: function() {
    return Sl(Ua);
  }, useDebugValue: Ns, useDeferredValue: function(n) {
    var r = En();
    return An === null ? r.memoizedState = n : Op(r, An.memoizedState, n);
  }, useTransition: function() {
    var n = Sl(Ua)[0], r = En().memoizedState;
    return [n, r];
  }, useMutableSource: ff, useSyncExternalStore: df, useId: Dp, unstable_isNewReconciler: !1 };
  function Go(n, r) {
    if (n && n.defaultProps) {
      r = W({}, r), n = n.defaultProps;
      for (var l in n) r[l] === void 0 && (r[l] = n[l]);
      return r;
    }
    return r;
  }
  function kp(n, r, l, d) {
    r = n.memoizedState, l = l(d, r), l = l == null ? r : W({}, r, l), n.memoizedState = l, n.lanes === 0 && (n.updateQueue.baseState = l);
  }
  var _f = { isMounted: function(n) {
    return (n = n._reactInternals) ? St(n) === n : !1;
  }, enqueueSetState: function(n, r, l) {
    n = n._reactInternals;
    var d = zn(), g = va(n), S = Ia(d, g);
    S.payload = r, l != null && (S.callback = l), r = Ei(n, S, g), r !== null && (Rr(r, n, g, d), lf(r, n, g));
  }, enqueueReplaceState: function(n, r, l) {
    n = n._reactInternals;
    var d = zn(), g = va(n), S = Ia(d, g);
    S.tag = 1, S.payload = r, l != null && (S.callback = l), r = Ei(n, S, g), r !== null && (Rr(r, n, g, d), lf(r, n, g));
  }, enqueueForceUpdate: function(n, r) {
    n = n._reactInternals;
    var l = zn(), d = va(n), g = Ia(l, d);
    g.tag = 2, r != null && (g.callback = r), r = Ei(n, g, d), r !== null && (Rr(r, n, d, l), lf(r, n, d));
  } };
  function sm(n, r, l, d, g, S, _) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(d, S, _) : r.prototype && r.prototype.isPureReactComponent ? !vs(l, d) || !vs(g, S) : !0;
  }
  function Of(n, r, l) {
    var d = !1, g = Ur, S = r.contextType;
    return typeof S == "object" && S !== null ? S = To(S) : (g = Mn(r) ? Fr : yn.current, d = r.contextTypes, S = (d = d != null) ? Co(n, g) : Ur), r = new r(l, S), n.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = _f, n.stateNode = r, r._reactInternals = n, d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = g, n.__reactInternalMemoizedMaskedChildContext = S), r;
  }
  function cm(n, r, l, d) {
    n = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(l, d), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(l, d), r.state !== n && _f.enqueueReplaceState(r, r.state, null);
  }
  function js(n, r, l, d) {
    var g = n.stateNode;
    g.props = l, g.state = n.memoizedState, g.refs = {}, Tp(n);
    var S = r.contextType;
    typeof S == "object" && S !== null ? g.context = To(S) : (S = Mn(r) ? Fr : yn.current, g.context = Co(n, S)), g.state = n.memoizedState, S = r.getDerivedStateFromProps, typeof S == "function" && (kp(n, r, S, l), g.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof g.getSnapshotBeforeUpdate == "function" || typeof g.UNSAFE_componentWillMount != "function" && typeof g.componentWillMount != "function" || (r = g.state, typeof g.componentWillMount == "function" && g.componentWillMount(), typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), r !== g.state && _f.enqueueReplaceState(g, g.state, null), ws(n, l, g, d), g.state = n.memoizedState), typeof g.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function Tl(n, r) {
    try {
      var l = "", d = r;
      do
        l += et(d), d = d.return;
      while (d);
      var g = l;
    } catch (S) {
      g = `
Error generating stack: ` + S.message + `
` + S.stack;
    }
    return { value: n, source: r, stack: g, digest: null };
  }
  function Mp(n, r, l) {
    return { value: n, source: null, stack: l ?? null, digest: r ?? null };
  }
  function Np(n, r) {
    try {
      console.error(r.value);
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  var Df = typeof WeakMap == "function" ? WeakMap : Map;
  function fm(n, r, l) {
    l = Ia(-1, l), l.tag = 3, l.payload = { element: null };
    var d = r.value;
    return l.callback = function() {
      Tu || (Tu = !0, Ol = d), Np(n, r);
    }, l;
  }
  function Ap(n, r, l) {
    l = Ia(-1, l), l.tag = 3;
    var d = n.type.getDerivedStateFromError;
    if (typeof d == "function") {
      var g = r.value;
      l.payload = function() {
        return d(g);
      }, l.callback = function() {
        Np(n, r);
      };
    }
    var S = n.stateNode;
    return S !== null && typeof S.componentDidCatch == "function" && (l.callback = function() {
      Np(n, r), typeof d != "function" && (Oi === null ? Oi = /* @__PURE__ */ new Set([this]) : Oi.add(this));
      var _ = r.stack;
      this.componentDidCatch(r.value, { componentStack: _ !== null ? _ : "" });
    }), l;
  }
  function Pp(n, r, l) {
    var d = n.pingCache;
    if (d === null) {
      d = n.pingCache = new Df();
      var g = /* @__PURE__ */ new Set();
      d.set(r, g);
    } else g = d.get(r), g === void 0 && (g = /* @__PURE__ */ new Set(), d.set(r, g));
    g.has(l) || (g.add(l), n = Ux.bind(null, n, r, l), r.then(n, n));
  }
  function dm(n) {
    do {
      var r;
      if ((r = n.tag === 13) && (r = n.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function Ri(n, r, l, d, g) {
    return n.mode & 1 ? (n.flags |= 65536, n.lanes = g, n) : (n === r ? n.flags |= 65536 : (n.flags |= 128, l.flags |= 131072, l.flags &= -52805, l.tag === 1 && (l.alternate === null ? l.tag = 17 : (r = Ia(-1, 1), r.tag = 2, Ei(l, r, 1))), l.lanes |= 1), n);
  }
  var zs = V.ReactCurrentOwner, Pn = !1;
  function ar(n, r, l, d) {
    r.child = n === null ? Ne(r, null, l, d) : Cn(r, n.child, l, d);
  }
  function Wr(n, r, l, d, g) {
    l = l.render;
    var S = r.ref;
    return pn(r, g), d = wi(n, r, l, d, S, g), l = Yo(), n !== null && !Pn ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~g, _o(n, r, g)) : (cn && l && nf(r), r.flags |= 1, ar(n, r, d, g), r.child);
  }
  function Rl(n, r, l, d, g) {
    if (n === null) {
      var S = l.type;
      return typeof S == "function" && !Qp(S) && S.defaultProps === void 0 && l.compare === null && l.defaultProps === void 0 ? (r.tag = 15, r.type = S, xt(n, r, S, d, g)) : (n = Js(l.type, null, d, r, r.mode, g), n.ref = r.ref, n.return = r, r.child = n);
    }
    if (S = n.child, !(n.lanes & g)) {
      var _ = S.memoizedProps;
      if (l = l.compare, l = l !== null ? l : vs, l(_, d) && n.ref === r.ref) return _o(n, r, g);
    }
    return r.flags |= 1, n = ki(S, d), n.ref = r.ref, n.return = r, r.child = n;
  }
  function xt(n, r, l, d, g) {
    if (n !== null) {
      var S = n.memoizedProps;
      if (vs(S, d) && n.ref === r.ref) if (Pn = !1, r.pendingProps = d = S, (n.lanes & g) !== 0) n.flags & 131072 && (Pn = !0);
      else return r.lanes = n.lanes, _o(n, r, g);
    }
    return pm(n, r, l, d, g);
  }
  function Is(n, r, l) {
    var d = r.pendingProps, g = d.children, S = n !== null ? n.memoizedState : null;
    if (d.mode === "hidden") if (!(r.mode & 1)) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, tt(Cu, lo), lo |= l;
    else {
      if (!(l & 1073741824)) return n = S !== null ? S.baseLanes | l : l, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, r.updateQueue = null, tt(Cu, lo), lo |= n, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, d = S !== null ? S.baseLanes : l, tt(Cu, lo), lo |= d;
    }
    else S !== null ? (d = S.baseLanes | l, r.memoizedState = null) : d = l, tt(Cu, lo), lo |= d;
    return ar(n, r, g, l), r.child;
  }
  function Lp(n, r) {
    var l = r.ref;
    (n === null && l !== null || n !== null && n.ref !== l) && (r.flags |= 512, r.flags |= 2097152);
  }
  function pm(n, r, l, d, g) {
    var S = Mn(l) ? Fr : yn.current;
    return S = Co(r, S), pn(r, g), l = wi(n, r, l, d, S, g), d = Yo(), n !== null && !Pn ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~g, _o(n, r, g)) : (cn && d && nf(r), r.flags |= 1, ar(n, r, l, g), r.child);
  }
  function vm(n, r, l, d, g) {
    if (Mn(l)) {
      var S = !0;
      Br(r);
    } else S = !1;
    if (pn(r, g), r.stateNode === null) Ro(n, r), Of(r, l, d), js(r, l, d, g), d = !0;
    else if (n === null) {
      var _ = r.stateNode, U = r.memoizedProps;
      _.props = U;
      var $ = _.context, te = l.contextType;
      typeof te == "object" && te !== null ? te = To(te) : (te = Mn(l) ? Fr : yn.current, te = Co(r, te));
      var xe = l.getDerivedStateFromProps, be = typeof xe == "function" || typeof _.getSnapshotBeforeUpdate == "function";
      be || typeof _.UNSAFE_componentWillReceiveProps != "function" && typeof _.componentWillReceiveProps != "function" || (U !== d || $ !== te) && cm(r, _, d, te), ao = !1;
      var ge = r.memoizedState;
      _.state = ge, ws(r, d, _, g), $ = r.memoizedState, U !== d || ge !== $ || Hn.current || ao ? (typeof xe == "function" && (kp(r, l, xe, d), $ = r.memoizedState), (U = ao || sm(r, l, U, d, ge, $, te)) ? (be || typeof _.UNSAFE_componentWillMount != "function" && typeof _.componentWillMount != "function" || (typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount()), typeof _.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof _.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = d, r.memoizedState = $), _.props = d, _.state = $, _.context = te, d = U) : (typeof _.componentDidMount == "function" && (r.flags |= 4194308), d = !1);
    } else {
      _ = r.stateNode, am(n, r), U = r.memoizedProps, te = r.type === r.elementType ? U : Go(r.type, U), _.props = te, be = r.pendingProps, ge = _.context, $ = l.contextType, typeof $ == "object" && $ !== null ? $ = To($) : ($ = Mn(l) ? Fr : yn.current, $ = Co(r, $));
      var Fe = l.getDerivedStateFromProps;
      (xe = typeof Fe == "function" || typeof _.getSnapshotBeforeUpdate == "function") || typeof _.UNSAFE_componentWillReceiveProps != "function" && typeof _.componentWillReceiveProps != "function" || (U !== be || ge !== $) && cm(r, _, d, $), ao = !1, ge = r.memoizedState, _.state = ge, ws(r, d, _, g);
      var We = r.memoizedState;
      U !== be || ge !== We || Hn.current || ao ? (typeof Fe == "function" && (kp(r, l, Fe, d), We = r.memoizedState), (te = ao || sm(r, l, te, d, ge, We, $) || !1) ? (xe || typeof _.UNSAFE_componentWillUpdate != "function" && typeof _.componentWillUpdate != "function" || (typeof _.componentWillUpdate == "function" && _.componentWillUpdate(d, We, $), typeof _.UNSAFE_componentWillUpdate == "function" && _.UNSAFE_componentWillUpdate(d, We, $)), typeof _.componentDidUpdate == "function" && (r.flags |= 4), typeof _.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof _.componentDidUpdate != "function" || U === n.memoizedProps && ge === n.memoizedState || (r.flags |= 4), typeof _.getSnapshotBeforeUpdate != "function" || U === n.memoizedProps && ge === n.memoizedState || (r.flags |= 1024), r.memoizedProps = d, r.memoizedState = We), _.props = d, _.state = We, _.context = $, d = te) : (typeof _.componentDidUpdate != "function" || U === n.memoizedProps && ge === n.memoizedState || (r.flags |= 4), typeof _.getSnapshotBeforeUpdate != "function" || U === n.memoizedProps && ge === n.memoizedState || (r.flags |= 1024), d = !1);
    }
    return Us(n, r, l, d, S, g);
  }
  function Us(n, r, l, d, g, S) {
    Lp(n, r);
    var _ = (r.flags & 128) !== 0;
    if (!d && !_) return g && ef(r, l, !1), _o(n, r, S);
    d = r.stateNode, zs.current = r;
    var U = _ && typeof l.getDerivedStateFromError != "function" ? null : d.render();
    return r.flags |= 1, n !== null && _ ? (r.child = Cn(r, n.child, null, S), r.child = Cn(r, null, U, S)) : ar(n, r, U, S), r.memoizedState = d.state, g && ef(r, l, !0), r.child;
  }
  function Su(n) {
    var r = n.stateNode;
    r.pendingContext ? tm(n, r.pendingContext, r.pendingContext !== r.context) : r.context && tm(n, r.context, !1), _p(n, r.containerInfo);
  }
  function hm(n, r, l, d, g) {
    return Ci(), za(g), r.flags |= 256, ar(n, r, l, d), r.child;
  }
  var kf = { dehydrated: null, treeContext: null, retryLane: 0 };
  function jp(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function Mf(n, r, l) {
    var d = r.pendingProps, g = vn.current, S = !1, _ = (r.flags & 128) !== 0, U;
    if ((U = _) || (U = n !== null && n.memoizedState === null ? !1 : (g & 2) !== 0), U ? (S = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (g |= 1), tt(vn, g & 1), n === null)
      return yp(r), n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? (r.mode & 1 ? n.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (_ = d.children, n = d.fallback, S ? (d = r.mode, S = r.child, _ = { mode: "hidden", children: _ }, !(d & 1) && S !== null ? (S.childLanes = 0, S.pendingProps = _) : S = Mi(_, d, 0, null), n = $a(n, d, l, null), S.return = r, n.return = r, S.sibling = n, r.child = S, r.child.memoizedState = jp(l), r.memoizedState = kf, n) : zp(r, _));
    if (g = n.memoizedState, g !== null && (U = g.dehydrated, U !== null)) return mm(n, r, _, d, U, g, l);
    if (S) {
      S = d.fallback, _ = r.mode, g = n.child, U = g.sibling;
      var $ = { mode: "hidden", children: d.children };
      return !(_ & 1) && r.child !== g ? (d = r.child, d.childLanes = 0, d.pendingProps = $, r.deletions = null) : (d = ki(g, $), d.subtreeFlags = g.subtreeFlags & 14680064), U !== null ? S = ki(U, S) : (S = $a(S, _, l, null), S.flags |= 2), S.return = r, d.return = r, d.sibling = S, r.child = d, d = S, S = r.child, _ = n.child.memoizedState, _ = _ === null ? jp(l) : { baseLanes: _.baseLanes | l, cachePool: null, transitions: _.transitions }, S.memoizedState = _, S.childLanes = n.childLanes & ~l, r.memoizedState = kf, d;
    }
    return S = n.child, n = S.sibling, d = ki(S, { mode: "visible", children: d.children }), !(r.mode & 1) && (d.lanes = l), d.return = r, d.sibling = null, n !== null && (l = r.deletions, l === null ? (r.deletions = [n], r.flags |= 16) : l.push(n)), r.child = d, r.memoizedState = null, d;
  }
  function zp(n, r) {
    return r = Mi({ mode: "visible", children: r }, n.mode, 0, null), r.return = n, n.child = r;
  }
  function Fs(n, r, l, d) {
    return d !== null && za(d), Cn(r, n.child, null, l), n = zp(r, r.pendingProps.children), n.flags |= 2, r.memoizedState = null, n;
  }
  function mm(n, r, l, d, g, S, _) {
    if (l)
      return r.flags & 256 ? (r.flags &= -257, d = Mp(Error(s(422))), Fs(n, r, _, d)) : r.memoizedState !== null ? (r.child = n.child, r.flags |= 128, null) : (S = d.fallback, g = r.mode, d = Mi({ mode: "visible", children: d.children }, g, 0, null), S = $a(S, g, _, null), S.flags |= 2, d.return = r, S.return = r, d.sibling = S, r.child = d, r.mode & 1 && Cn(r, n.child, null, _), r.child.memoizedState = jp(_), r.memoizedState = kf, S);
    if (!(r.mode & 1)) return Fs(n, r, _, null);
    if (g.data === "$!") {
      if (d = g.nextSibling && g.nextSibling.dataset, d) var U = d.dgst;
      return d = U, S = Error(s(419)), d = Mp(S, d, void 0), Fs(n, r, _, d);
    }
    if (U = (_ & n.childLanes) !== 0, Pn || U) {
      if (d = Vn, d !== null) {
        switch (_ & -_) {
          case 4:
            g = 2;
            break;
          case 16:
            g = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            g = 32;
            break;
          case 536870912:
            g = 268435456;
            break;
          default:
            g = 0;
        }
        g = g & (d.suspendedLanes | _) ? 0 : g, g !== 0 && g !== S.retryLane && (S.retryLane = g, oo(n, g), Rr(d, n, g, -1));
      }
      return Gp(), d = Mp(Error(s(421))), Fs(n, r, _, d);
    }
    return g.data === "$?" ? (r.flags |= 128, r.child = n.child, r = Fx.bind(null, n), g._reactRetry = r, null) : (n = S.treeContext, $r = ra(g.nextSibling), Hr = r, cn = !0, wo = null, n !== null && (Nn[Eo++] = la, Nn[Eo++] = ua, Nn[Eo++] = no, la = n.id, ua = n.overflow, no = r), r = zp(r, d.children), r.flags |= 4096, r);
  }
  function Ip(n, r, l) {
    n.lanes |= r;
    var d = n.alternate;
    d !== null && (d.lanes |= r), Cp(n.return, r, l);
  }
  function Er(n, r, l, d, g) {
    var S = n.memoizedState;
    S === null ? n.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: d, tail: l, tailMode: g } : (S.isBackwards = r, S.rendering = null, S.renderingStartTime = 0, S.last = d, S.tail = l, S.tailMode = g);
  }
  function ca(n, r, l) {
    var d = r.pendingProps, g = d.revealOrder, S = d.tail;
    if (ar(n, r, d.children, l), d = vn.current, d & 2) d = d & 1 | 2, r.flags |= 128;
    else {
      if (n !== null && n.flags & 128) e: for (n = r.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && Ip(n, l, r);
        else if (n.tag === 19) Ip(n, l, r);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === r) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === r) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      d &= 1;
    }
    if (tt(vn, d), !(r.mode & 1)) r.memoizedState = null;
    else switch (g) {
      case "forwards":
        for (l = r.child, g = null; l !== null; ) n = l.alternate, n !== null && sf(n) === null && (g = l), l = l.sibling;
        l = g, l === null ? (g = r.child, r.child = null) : (g = l.sibling, l.sibling = null), Er(r, !1, g, l, S);
        break;
      case "backwards":
        for (l = null, g = r.child, r.child = null; g !== null; ) {
          if (n = g.alternate, n !== null && sf(n) === null) {
            r.child = g;
            break;
          }
          n = g.sibling, g.sibling = l, l = g, g = n;
        }
        Er(r, !0, l, null, S);
        break;
      case "together":
        Er(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Ro(n, r) {
    !(r.mode & 1) && n !== null && (n.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function _o(n, r, l) {
    if (n !== null && (r.dependencies = n.dependencies), pa |= r.lanes, !(l & r.childLanes)) return null;
    if (n !== null && r.child !== n.child) throw Error(s(153));
    if (r.child !== null) {
      for (n = r.child, l = ki(n, n.pendingProps), r.child = l, l.return = r; n.sibling !== null; ) n = n.sibling, l = l.sibling = ki(n, n.pendingProps), l.return = r;
      l.sibling = null;
    }
    return r.child;
  }
  function Bs(n, r, l) {
    switch (r.tag) {
      case 3:
        Su(r), Ci();
        break;
      case 5:
        lm(r);
        break;
      case 1:
        Mn(r.type) && Br(r);
        break;
      case 4:
        _p(r, r.stateNode.containerInfo);
        break;
      case 10:
        var d = r.type._context, g = r.memoizedProps.value;
        tt(ro, d._currentValue), d._currentValue = g;
        break;
      case 13:
        if (d = r.memoizedState, d !== null)
          return d.dehydrated !== null ? (tt(vn, vn.current & 1), r.flags |= 128, null) : l & r.child.childLanes ? Mf(n, r, l) : (tt(vn, vn.current & 1), n = _o(n, r, l), n !== null ? n.sibling : null);
        tt(vn, vn.current & 1);
        break;
      case 19:
        if (d = (l & r.childLanes) !== 0, n.flags & 128) {
          if (d) return ca(n, r, l);
          r.flags |= 128;
        }
        if (g = r.memoizedState, g !== null && (g.rendering = null, g.tail = null, g.lastEffect = null), tt(vn, vn.current), d) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, Is(n, r, l);
    }
    return _o(n, r, l);
  }
  var Oo, Ln, gm, ym;
  Oo = function(n, r) {
    for (var l = r.child; l !== null; ) {
      if (l.tag === 5 || l.tag === 6) n.appendChild(l.stateNode);
      else if (l.tag !== 4 && l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === r) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === r) return;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
  }, Ln = function() {
  }, gm = function(n, r, l, d) {
    var g = n.memoizedProps;
    if (g !== d) {
      n = r.stateNode, gl(sa.current);
      var S = null;
      switch (l) {
        case "input":
          g = vt(n, g), d = vt(n, d), S = [];
          break;
        case "select":
          g = W({}, g, { value: void 0 }), d = W({}, d, { value: void 0 }), S = [];
          break;
        case "textarea":
          g = Dn(n, g), d = Dn(n, d), S = [];
          break;
        default:
          typeof g.onClick != "function" && typeof d.onClick == "function" && (n.onclick = mi);
      }
      un(l, d);
      var _;
      l = null;
      for (te in g) if (!d.hasOwnProperty(te) && g.hasOwnProperty(te) && g[te] != null) if (te === "style") {
        var U = g[te];
        for (_ in U) U.hasOwnProperty(_) && (l || (l = {}), l[_] = "");
      } else te !== "dangerouslySetInnerHTML" && te !== "children" && te !== "suppressContentEditableWarning" && te !== "suppressHydrationWarning" && te !== "autoFocus" && (p.hasOwnProperty(te) ? S || (S = []) : (S = S || []).push(te, null));
      for (te in d) {
        var $ = d[te];
        if (U = g != null ? g[te] : void 0, d.hasOwnProperty(te) && $ !== U && ($ != null || U != null)) if (te === "style") if (U) {
          for (_ in U) !U.hasOwnProperty(_) || $ && $.hasOwnProperty(_) || (l || (l = {}), l[_] = "");
          for (_ in $) $.hasOwnProperty(_) && U[_] !== $[_] && (l || (l = {}), l[_] = $[_]);
        } else l || (S || (S = []), S.push(
          te,
          l
        )), l = $;
        else te === "dangerouslySetInnerHTML" ? ($ = $ ? $.__html : void 0, U = U ? U.__html : void 0, $ != null && U !== $ && (S = S || []).push(te, $)) : te === "children" ? typeof $ != "string" && typeof $ != "number" || (S = S || []).push(te, "" + $) : te !== "suppressContentEditableWarning" && te !== "suppressHydrationWarning" && (p.hasOwnProperty(te) ? ($ != null && te === "onScroll" && Ft("scroll", n), S || U === $ || (S = [])) : (S = S || []).push(te, $));
      }
      l && (S = S || []).push("style", l);
      var te = S;
      (r.updateQueue = te) && (r.flags |= 4);
    }
  }, ym = function(n, r, l, d) {
    l !== d && (r.flags |= 4);
  };
  function Hs(n, r) {
    if (!cn) switch (n.tailMode) {
      case "hidden":
        r = n.tail;
        for (var l = null; r !== null; ) r.alternate !== null && (l = r), r = r.sibling;
        l === null ? n.tail = null : l.sibling = null;
        break;
      case "collapsed":
        l = n.tail;
        for (var d = null; l !== null; ) l.alternate !== null && (d = l), l = l.sibling;
        d === null ? r || n.tail === null ? n.tail = null : n.tail.sibling = null : d.sibling = null;
    }
  }
  function Xn(n) {
    var r = n.alternate !== null && n.alternate.child === n.child, l = 0, d = 0;
    if (r) for (var g = n.child; g !== null; ) l |= g.lanes | g.childLanes, d |= g.subtreeFlags & 14680064, d |= g.flags & 14680064, g.return = n, g = g.sibling;
    else for (g = n.child; g !== null; ) l |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, g.return = n, g = g.sibling;
    return n.subtreeFlags |= d, n.childLanes = l, r;
  }
  function xm(n, r, l) {
    var d = r.pendingProps;
    switch (rf(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Xn(r), null;
      case 1:
        return Mn(r.type) && hu(), Xn(r), null;
      case 3:
        return d = r.stateNode, yl(), nn(Hn), nn(yn), rt(), d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null), (n === null || n.child === null) && (of(r) ? r.flags |= 4 : n === null || n.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, wo !== null && (Dl(wo), wo = null))), Ln(n, r), Xn(r), null;
      case 5:
        uf(r);
        var g = gl(_s.current);
        if (l = r.type, n !== null && r.stateNode != null) gm(n, r, l, d, g), n.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!d) {
            if (r.stateNode === null) throw Error(s(166));
            return Xn(r), null;
          }
          if (n = gl(sa.current), of(r)) {
            d = r.stateNode, l = r.type;
            var S = r.memoizedProps;
            switch (d[oa] = r, d[Ss] = S, n = (r.mode & 1) !== 0, l) {
              case "dialog":
                Ft("cancel", d), Ft("close", d);
                break;
              case "iframe":
              case "object":
              case "embed":
                Ft("load", d);
                break;
              case "video":
              case "audio":
                for (g = 0; g < gs.length; g++) Ft(gs[g], d);
                break;
              case "source":
                Ft("error", d);
                break;
              case "img":
              case "image":
              case "link":
                Ft(
                  "error",
                  d
                ), Ft("load", d);
                break;
              case "details":
                Ft("toggle", d);
                break;
              case "input":
                Tt(d, S), Ft("invalid", d);
                break;
              case "select":
                d._wrapperState = { wasMultiple: !!S.multiple }, Ft("invalid", d);
                break;
              case "textarea":
                tr(d, S), Ft("invalid", d);
            }
            un(l, S), g = null;
            for (var _ in S) if (S.hasOwnProperty(_)) {
              var U = S[_];
              _ === "children" ? typeof U == "string" ? d.textContent !== U && (S.suppressHydrationWarning !== !0 && qc(d.textContent, U, n), g = ["children", U]) : typeof U == "number" && d.textContent !== "" + U && (S.suppressHydrationWarning !== !0 && qc(
                d.textContent,
                U,
                n
              ), g = ["children", "" + U]) : p.hasOwnProperty(_) && U != null && _ === "onScroll" && Ft("scroll", d);
            }
            switch (l) {
              case "input":
                Qe(d), Gn(d, S, !0);
                break;
              case "textarea":
                Qe(d), Fn(d);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof S.onClick == "function" && (d.onclick = mi);
            }
            d = g, r.updateQueue = d, d !== null && (r.flags |= 4);
          } else {
            _ = g.nodeType === 9 ? g : g.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = xr(l)), n === "http://www.w3.org/1999/xhtml" ? l === "script" ? (n = _.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof d.is == "string" ? n = _.createElement(l, { is: d.is }) : (n = _.createElement(l), l === "select" && (_ = n, d.multiple ? _.multiple = !0 : d.size && (_.size = d.size))) : n = _.createElementNS(n, l), n[oa] = r, n[Ss] = d, Oo(n, r, !1, !1), r.stateNode = n;
            e: {
              switch (_ = Kn(l, d), l) {
                case "dialog":
                  Ft("cancel", n), Ft("close", n), g = d;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Ft("load", n), g = d;
                  break;
                case "video":
                case "audio":
                  for (g = 0; g < gs.length; g++) Ft(gs[g], n);
                  g = d;
                  break;
                case "source":
                  Ft("error", n), g = d;
                  break;
                case "img":
                case "image":
                case "link":
                  Ft(
                    "error",
                    n
                  ), Ft("load", n), g = d;
                  break;
                case "details":
                  Ft("toggle", n), g = d;
                  break;
                case "input":
                  Tt(n, d), g = vt(n, d), Ft("invalid", n);
                  break;
                case "option":
                  g = d;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!d.multiple }, g = W({}, d, { value: void 0 }), Ft("invalid", n);
                  break;
                case "textarea":
                  tr(n, d), g = Dn(n, d), Ft("invalid", n);
                  break;
                default:
                  g = d;
              }
              un(l, g), U = g;
              for (S in U) if (U.hasOwnProperty(S)) {
                var $ = U[S];
                S === "style" ? en(n, $) : S === "dangerouslySetInnerHTML" ? ($ = $ ? $.__html : void 0, $ != null && mo(n, $)) : S === "children" ? typeof $ == "string" ? (l !== "textarea" || $ !== "") && _e(n, $) : typeof $ == "number" && _e(n, "" + $) : S !== "suppressContentEditableWarning" && S !== "suppressHydrationWarning" && S !== "autoFocus" && (p.hasOwnProperty(S) ? $ != null && S === "onScroll" && Ft("scroll", n) : $ != null && I(n, S, $, _));
              }
              switch (l) {
                case "input":
                  Qe(n), Gn(n, d, !1);
                  break;
                case "textarea":
                  Qe(n), Fn(n);
                  break;
                case "option":
                  d.value != null && n.setAttribute("value", "" + Me(d.value));
                  break;
                case "select":
                  n.multiple = !!d.multiple, S = d.value, S != null ? Sn(n, !!d.multiple, S, !1) : d.defaultValue != null && Sn(
                    n,
                    !!d.multiple,
                    d.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof g.onClick == "function" && (n.onclick = mi);
              }
              switch (l) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d = !!d.autoFocus;
                  break e;
                case "img":
                  d = !0;
                  break e;
                default:
                  d = !1;
              }
            }
            d && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return Xn(r), null;
      case 6:
        if (n && r.stateNode != null) ym(n, r, n.memoizedProps, d);
        else {
          if (typeof d != "string" && r.stateNode === null) throw Error(s(166));
          if (l = gl(_s.current), gl(sa.current), of(r)) {
            if (d = r.stateNode, l = r.memoizedProps, d[oa] = r, (S = d.nodeValue !== l) && (n = Hr, n !== null)) switch (n.tag) {
              case 3:
                qc(d.nodeValue, l, (n.mode & 1) !== 0);
                break;
              case 5:
                n.memoizedProps.suppressHydrationWarning !== !0 && qc(d.nodeValue, l, (n.mode & 1) !== 0);
            }
            S && (r.flags |= 4);
          } else d = (l.nodeType === 9 ? l : l.ownerDocument).createTextNode(d), d[oa] = r, r.stateNode = d;
        }
        return Xn(r), null;
      case 13:
        if (nn(vn), d = r.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (cn && $r !== null && r.mode & 1 && !(r.flags & 128)) Es(), Ci(), r.flags |= 98560, S = !1;
          else if (S = of(r), d !== null && d.dehydrated !== null) {
            if (n === null) {
              if (!S) throw Error(s(318));
              if (S = r.memoizedState, S = S !== null ? S.dehydrated : null, !S) throw Error(s(317));
              S[oa] = r;
            } else Ci(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            Xn(r), S = !1;
          } else wo !== null && (Dl(wo), wo = null), S = !0;
          if (!S) return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = l, r) : (d = d !== null, d !== (n !== null && n.memoizedState !== null) && d && (r.child.flags |= 8192, r.mode & 1 && (n === null || vn.current & 1 ? Tn === 0 && (Tn = 3) : Gp())), r.updateQueue !== null && (r.flags |= 4), Xn(r), null);
      case 4:
        return yl(), Ln(n, r), n === null && cu(r.stateNode.containerInfo), Xn(r), null;
      case 10:
        return bp(r.type._context), Xn(r), null;
      case 17:
        return Mn(r.type) && hu(), Xn(r), null;
      case 19:
        if (nn(vn), S = r.memoizedState, S === null) return Xn(r), null;
        if (d = (r.flags & 128) !== 0, _ = S.rendering, _ === null) if (d) Hs(S, !1);
        else {
          if (Tn !== 0 || n !== null && n.flags & 128) for (n = r.child; n !== null; ) {
            if (_ = sf(n), _ !== null) {
              for (r.flags |= 128, Hs(S, !1), d = _.updateQueue, d !== null && (r.updateQueue = d, r.flags |= 4), r.subtreeFlags = 0, d = l, l = r.child; l !== null; ) S = l, n = d, S.flags &= 14680066, _ = S.alternate, _ === null ? (S.childLanes = 0, S.lanes = n, S.child = null, S.subtreeFlags = 0, S.memoizedProps = null, S.memoizedState = null, S.updateQueue = null, S.dependencies = null, S.stateNode = null) : (S.childLanes = _.childLanes, S.lanes = _.lanes, S.child = _.child, S.subtreeFlags = 0, S.deletions = null, S.memoizedProps = _.memoizedProps, S.memoizedState = _.memoizedState, S.updateQueue = _.updateQueue, S.type = _.type, n = _.dependencies, S.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), l = l.sibling;
              return tt(vn, vn.current & 1 | 2), r.child;
            }
            n = n.sibling;
          }
          S.tail !== null && bt() > wu && (r.flags |= 128, d = !0, Hs(S, !1), r.lanes = 4194304);
        }
        else {
          if (!d) if (n = sf(_), n !== null) {
            if (r.flags |= 128, d = !0, l = n.updateQueue, l !== null && (r.updateQueue = l, r.flags |= 4), Hs(S, !0), S.tail === null && S.tailMode === "hidden" && !_.alternate && !cn) return Xn(r), null;
          } else 2 * bt() - S.renderingStartTime > wu && l !== 1073741824 && (r.flags |= 128, d = !0, Hs(S, !1), r.lanes = 4194304);
          S.isBackwards ? (_.sibling = r.child, r.child = _) : (l = S.last, l !== null ? l.sibling = _ : r.child = _, S.last = _);
        }
        return S.tail !== null ? (r = S.tail, S.rendering = r, S.tail = r.sibling, S.renderingStartTime = bt(), r.sibling = null, l = vn.current, tt(vn, d ? l & 1 | 2 : l & 1), r) : (Xn(r), null);
      case 22:
      case 23:
        return Yp(), d = r.memoizedState !== null, n !== null && n.memoizedState !== null !== d && (r.flags |= 8192), d && r.mode & 1 ? lo & 1073741824 && (Xn(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : Xn(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(s(156, r.tag));
  }
  function Nf(n, r) {
    switch (rf(r), r.tag) {
      case 1:
        return Mn(r.type) && hu(), n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 3:
        return yl(), nn(Hn), nn(yn), rt(), n = r.flags, n & 65536 && !(n & 128) ? (r.flags = n & -65537 | 128, r) : null;
      case 5:
        return uf(r), null;
      case 13:
        if (nn(vn), n = r.memoizedState, n !== null && n.dehydrated !== null) {
          if (r.alternate === null) throw Error(s(340));
          Ci();
        }
        return n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 19:
        return nn(vn), null;
      case 4:
        return yl(), null;
      case 10:
        return bp(r.type._context), null;
      case 22:
      case 23:
        return Yp(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var $s = !1, gr = !1, Ax = typeof WeakSet == "function" ? WeakSet : Set, Ve = null;
  function bu(n, r) {
    var l = n.ref;
    if (l !== null) if (typeof l == "function") try {
      l(null);
    } catch (d) {
      fn(n, r, d);
    }
    else l.current = null;
  }
  function Af(n, r, l) {
    try {
      l();
    } catch (d) {
      fn(n, r, d);
    }
  }
  var Sm = !1;
  function bm(n, r) {
    if (xs = ol, n = hs(), Hc(n)) {
      if ("selectionStart" in n) var l = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        l = (l = n.ownerDocument) && l.defaultView || window;
        var d = l.getSelection && l.getSelection();
        if (d && d.rangeCount !== 0) {
          l = d.anchorNode;
          var g = d.anchorOffset, S = d.focusNode;
          d = d.focusOffset;
          try {
            l.nodeType, S.nodeType;
          } catch {
            l = null;
            break e;
          }
          var _ = 0, U = -1, $ = -1, te = 0, xe = 0, be = n, ge = null;
          t: for (; ; ) {
            for (var Fe; be !== l || g !== 0 && be.nodeType !== 3 || (U = _ + g), be !== S || d !== 0 && be.nodeType !== 3 || ($ = _ + d), be.nodeType === 3 && (_ += be.nodeValue.length), (Fe = be.firstChild) !== null; )
              ge = be, be = Fe;
            for (; ; ) {
              if (be === n) break t;
              if (ge === l && ++te === g && (U = _), ge === S && ++xe === d && ($ = _), (Fe = be.nextSibling) !== null) break;
              be = ge, ge = be.parentNode;
            }
            be = Fe;
          }
          l = U === -1 || $ === -1 ? null : { start: U, end: $ };
        } else l = null;
      }
      l = l || { start: 0, end: 0 };
    } else l = null;
    for (fl = { focusedElem: n, selectionRange: l }, ol = !1, Ve = r; Ve !== null; ) if (r = Ve, n = r.child, (r.subtreeFlags & 1028) !== 0 && n !== null) n.return = r, Ve = n;
    else for (; Ve !== null; ) {
      r = Ve;
      try {
        var We = r.alternate;
        if (r.flags & 1024) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (We !== null) {
              var Xe = We.memoizedProps, Rn = We.memoizedState, K = r.stateNode, G = K.getSnapshotBeforeUpdate(r.elementType === r.type ? Xe : Go(r.type, Xe), Rn);
              K.__reactInternalSnapshotBeforeUpdate = G;
            }
            break;
          case 3:
            var J = r.stateNode.containerInfo;
            J.nodeType === 1 ? J.textContent = "" : J.nodeType === 9 && J.documentElement && J.removeChild(J.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(s(163));
        }
      } catch (Se) {
        fn(r, r.return, Se);
      }
      if (n = r.sibling, n !== null) {
        n.return = r.return, Ve = n;
        break;
      }
      Ve = r.return;
    }
    return We = Sm, Sm = !1, We;
  }
  function Vs(n, r, l) {
    var d = r.updateQueue;
    if (d = d !== null ? d.lastEffect : null, d !== null) {
      var g = d = d.next;
      do {
        if ((g.tag & n) === n) {
          var S = g.destroy;
          g.destroy = void 0, S !== void 0 && Af(r, l, S);
        }
        g = g.next;
      } while (g !== d);
    }
  }
  function Ws(n, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var l = r = r.next;
      do {
        if ((l.tag & n) === n) {
          var d = l.create;
          l.destroy = d();
        }
        l = l.next;
      } while (l !== r);
    }
  }
  function Up(n) {
    var r = n.ref;
    if (r !== null) {
      var l = n.stateNode;
      switch (n.tag) {
        case 5:
          n = l;
          break;
        default:
          n = l;
      }
      typeof r == "function" ? r(n) : r.current = n;
    }
  }
  function Pf(n) {
    var r = n.alternate;
    r !== null && (n.alternate = null, Pf(r)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (r = n.stateNode, r !== null && (delete r[oa], delete r[Ss], delete r[bs], delete r[vu], delete r[Mx])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Ys(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function Fa(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Ys(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function fa(n, r, l) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, r ? l.nodeType === 8 ? l.parentNode.insertBefore(n, r) : l.insertBefore(n, r) : (l.nodeType === 8 ? (r = l.parentNode, r.insertBefore(n, l)) : (r = l, r.appendChild(n)), l = l._reactRootContainer, l != null || r.onclick !== null || (r.onclick = mi));
    else if (d !== 4 && (n = n.child, n !== null)) for (fa(n, r, l), n = n.sibling; n !== null; ) fa(n, r, l), n = n.sibling;
  }
  function da(n, r, l) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, r ? l.insertBefore(n, r) : l.appendChild(n);
    else if (d !== 4 && (n = n.child, n !== null)) for (da(n, r, l), n = n.sibling; n !== null; ) da(n, r, l), n = n.sibling;
  }
  var wn = null, wr = !1;
  function Tr(n, r, l) {
    for (l = l.child; l !== null; ) Cm(n, r, l), l = l.sibling;
  }
  function Cm(n, r, l) {
    if (Bo && typeof Bo.onCommitFiberUnmount == "function") try {
      Bo.onCommitFiberUnmount(os, l);
    } catch {
    }
    switch (l.tag) {
      case 5:
        gr || bu(l, r);
      case 6:
        var d = wn, g = wr;
        wn = null, Tr(n, r, l), wn = d, wr = g, wn !== null && (wr ? (n = wn, l = l.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(l) : n.removeChild(l)) : wn.removeChild(l.stateNode));
        break;
      case 18:
        wn !== null && (wr ? (n = wn, l = l.stateNode, n.nodeType === 8 ? pu(n.parentNode, l) : n.nodeType === 1 && pu(n, l), pi(n)) : pu(wn, l.stateNode));
        break;
      case 4:
        d = wn, g = wr, wn = l.stateNode.containerInfo, wr = !0, Tr(n, r, l), wn = d, wr = g;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!gr && (d = l.updateQueue, d !== null && (d = d.lastEffect, d !== null))) {
          g = d = d.next;
          do {
            var S = g, _ = S.destroy;
            S = S.tag, _ !== void 0 && (S & 2 || S & 4) && Af(l, r, _), g = g.next;
          } while (g !== d);
        }
        Tr(n, r, l);
        break;
      case 1:
        if (!gr && (bu(l, r), d = l.stateNode, typeof d.componentWillUnmount == "function")) try {
          d.props = l.memoizedProps, d.state = l.memoizedState, d.componentWillUnmount();
        } catch (U) {
          fn(l, r, U);
        }
        Tr(n, r, l);
        break;
      case 21:
        Tr(n, r, l);
        break;
      case 22:
        l.mode & 1 ? (gr = (d = gr) || l.memoizedState !== null, Tr(n, r, l), gr = d) : Tr(n, r, l);
        break;
      default:
        Tr(n, r, l);
    }
  }
  function Em(n) {
    var r = n.updateQueue;
    if (r !== null) {
      n.updateQueue = null;
      var l = n.stateNode;
      l === null && (l = n.stateNode = new Ax()), r.forEach(function(d) {
        var g = Nm.bind(null, n, d);
        l.has(d) || (l.add(d), d.then(g, g));
      });
    }
  }
  function Qo(n, r) {
    var l = r.deletions;
    if (l !== null) for (var d = 0; d < l.length; d++) {
      var g = l[d];
      try {
        var S = n, _ = r, U = _;
        e: for (; U !== null; ) {
          switch (U.tag) {
            case 5:
              wn = U.stateNode, wr = !1;
              break e;
            case 3:
              wn = U.stateNode.containerInfo, wr = !0;
              break e;
            case 4:
              wn = U.stateNode.containerInfo, wr = !0;
              break e;
          }
          U = U.return;
        }
        if (wn === null) throw Error(s(160));
        Cm(S, _, g), wn = null, wr = !1;
        var $ = g.alternate;
        $ !== null && ($.return = null), g.return = null;
      } catch (te) {
        fn(g, r, te);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) Fp(r, n), r = r.sibling;
  }
  function Fp(n, r) {
    var l = n.alternate, d = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Qo(r, n), Yr(n), d & 4) {
          try {
            Vs(3, n, n.return), Ws(3, n);
          } catch (Xe) {
            fn(n, n.return, Xe);
          }
          try {
            Vs(5, n, n.return);
          } catch (Xe) {
            fn(n, n.return, Xe);
          }
        }
        break;
      case 1:
        Qo(r, n), Yr(n), d & 512 && l !== null && bu(l, l.return);
        break;
      case 5:
        if (Qo(r, n), Yr(n), d & 512 && l !== null && bu(l, l.return), n.flags & 32) {
          var g = n.stateNode;
          try {
            _e(g, "");
          } catch (Xe) {
            fn(n, n.return, Xe);
          }
        }
        if (d & 4 && (g = n.stateNode, g != null)) {
          var S = n.memoizedProps, _ = l !== null ? l.memoizedProps : S, U = n.type, $ = n.updateQueue;
          if (n.updateQueue = null, $ !== null) try {
            U === "input" && S.type === "radio" && S.name != null && $t(g, S), Kn(U, _);
            var te = Kn(U, S);
            for (_ = 0; _ < $.length; _ += 2) {
              var xe = $[_], be = $[_ + 1];
              xe === "style" ? en(g, be) : xe === "dangerouslySetInnerHTML" ? mo(g, be) : xe === "children" ? _e(g, be) : I(g, xe, be, te);
            }
            switch (U) {
              case "input":
                xn(g, S);
                break;
              case "textarea":
                Io(g, S);
                break;
              case "select":
                var ge = g._wrapperState.wasMultiple;
                g._wrapperState.wasMultiple = !!S.multiple;
                var Fe = S.value;
                Fe != null ? Sn(g, !!S.multiple, Fe, !1) : ge !== !!S.multiple && (S.defaultValue != null ? Sn(
                  g,
                  !!S.multiple,
                  S.defaultValue,
                  !0
                ) : Sn(g, !!S.multiple, S.multiple ? [] : "", !1));
            }
            g[Ss] = S;
          } catch (Xe) {
            fn(n, n.return, Xe);
          }
        }
        break;
      case 6:
        if (Qo(r, n), Yr(n), d & 4) {
          if (n.stateNode === null) throw Error(s(162));
          g = n.stateNode, S = n.memoizedProps;
          try {
            g.nodeValue = S;
          } catch (Xe) {
            fn(n, n.return, Xe);
          }
        }
        break;
      case 3:
        if (Qo(r, n), Yr(n), d & 4 && l !== null && l.memoizedState.isDehydrated) try {
          pi(r.containerInfo);
        } catch (Xe) {
          fn(n, n.return, Xe);
        }
        break;
      case 4:
        Qo(r, n), Yr(n);
        break;
      case 13:
        Qo(r, n), Yr(n), g = n.child, g.flags & 8192 && (S = g.memoizedState !== null, g.stateNode.isHidden = S, !S || g.alternate !== null && g.alternate.memoizedState !== null || ($p = bt())), d & 4 && Em(n);
        break;
      case 22:
        if (xe = l !== null && l.memoizedState !== null, n.mode & 1 ? (gr = (te = gr) || xe, Qo(r, n), gr = te) : Qo(r, n), Yr(n), d & 8192) {
          if (te = n.memoizedState !== null, (n.stateNode.isHidden = te) && !xe && n.mode & 1) for (Ve = n, xe = n.child; xe !== null; ) {
            for (be = Ve = xe; Ve !== null; ) {
              switch (ge = Ve, Fe = ge.child, ge.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Vs(4, ge, ge.return);
                  break;
                case 1:
                  bu(ge, ge.return);
                  var We = ge.stateNode;
                  if (typeof We.componentWillUnmount == "function") {
                    d = ge, l = ge.return;
                    try {
                      r = d, We.props = r.memoizedProps, We.state = r.memoizedState, We.componentWillUnmount();
                    } catch (Xe) {
                      fn(d, l, Xe);
                    }
                  }
                  break;
                case 5:
                  bu(ge, ge.return);
                  break;
                case 22:
                  if (ge.memoizedState !== null) {
                    Gs(be);
                    continue;
                  }
              }
              Fe !== null ? (Fe.return = ge, Ve = Fe) : Gs(be);
            }
            xe = xe.sibling;
          }
          e: for (xe = null, be = n; ; ) {
            if (be.tag === 5) {
              if (xe === null) {
                xe = be;
                try {
                  g = be.stateNode, te ? (S = g.style, typeof S.setProperty == "function" ? S.setProperty("display", "none", "important") : S.display = "none") : (U = be.stateNode, $ = be.memoizedProps.style, _ = $ != null && $.hasOwnProperty("display") ? $.display : null, U.style.display = At("display", _));
                } catch (Xe) {
                  fn(n, n.return, Xe);
                }
              }
            } else if (be.tag === 6) {
              if (xe === null) try {
                be.stateNode.nodeValue = te ? "" : be.memoizedProps;
              } catch (Xe) {
                fn(n, n.return, Xe);
              }
            } else if ((be.tag !== 22 && be.tag !== 23 || be.memoizedState === null || be === n) && be.child !== null) {
              be.child.return = be, be = be.child;
              continue;
            }
            if (be === n) break e;
            for (; be.sibling === null; ) {
              if (be.return === null || be.return === n) break e;
              xe === be && (xe = null), be = be.return;
            }
            xe === be && (xe = null), be.sibling.return = be.return, be = be.sibling;
          }
        }
        break;
      case 19:
        Qo(r, n), Yr(n), d & 4 && Em(n);
        break;
      case 21:
        break;
      default:
        Qo(
          r,
          n
        ), Yr(n);
    }
  }
  function Yr(n) {
    var r = n.flags;
    if (r & 2) {
      try {
        e: {
          for (var l = n.return; l !== null; ) {
            if (Ys(l)) {
              var d = l;
              break e;
            }
            l = l.return;
          }
          throw Error(s(160));
        }
        switch (d.tag) {
          case 5:
            var g = d.stateNode;
            d.flags & 32 && (_e(g, ""), d.flags &= -33);
            var S = Fa(n);
            da(n, S, g);
            break;
          case 3:
          case 4:
            var _ = d.stateNode.containerInfo, U = Fa(n);
            fa(n, U, _);
            break;
          default:
            throw Error(s(161));
        }
      } catch ($) {
        fn(n, n.return, $);
      }
      n.flags &= -3;
    }
    r & 4096 && (n.flags &= -4097);
  }
  function Px(n, r, l) {
    Ve = n, Bp(n);
  }
  function Bp(n, r, l) {
    for (var d = (n.mode & 1) !== 0; Ve !== null; ) {
      var g = Ve, S = g.child;
      if (g.tag === 22 && d) {
        var _ = g.memoizedState !== null || $s;
        if (!_) {
          var U = g.alternate, $ = U !== null && U.memoizedState !== null || gr;
          U = $s;
          var te = gr;
          if ($s = _, (gr = $) && !te) for (Ve = g; Ve !== null; ) _ = Ve, $ = _.child, _.tag === 22 && _.memoizedState !== null ? Hp(g) : $ !== null ? ($.return = _, Ve = $) : Hp(g);
          for (; S !== null; ) Ve = S, Bp(S), S = S.sibling;
          Ve = g, $s = U, gr = te;
        }
        wm(n);
      } else g.subtreeFlags & 8772 && S !== null ? (S.return = g, Ve = S) : wm(n);
    }
  }
  function wm(n) {
    for (; Ve !== null; ) {
      var r = Ve;
      if (r.flags & 8772) {
        var l = r.alternate;
        try {
          if (r.flags & 8772) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              gr || Ws(5, r);
              break;
            case 1:
              var d = r.stateNode;
              if (r.flags & 4 && !gr) if (l === null) d.componentDidMount();
              else {
                var g = r.elementType === r.type ? l.memoizedProps : Go(r.type, l.memoizedProps);
                d.componentDidUpdate(g, l.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
              }
              var S = r.updateQueue;
              S !== null && Rp(r, S, d);
              break;
            case 3:
              var _ = r.updateQueue;
              if (_ !== null) {
                if (l = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    l = r.child.stateNode;
                    break;
                  case 1:
                    l = r.child.stateNode;
                }
                Rp(r, _, l);
              }
              break;
            case 5:
              var U = r.stateNode;
              if (l === null && r.flags & 4) {
                l = U;
                var $ = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    $.autoFocus && l.focus();
                    break;
                  case "img":
                    $.src && (l.src = $.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var te = r.alternate;
                if (te !== null) {
                  var xe = te.memoizedState;
                  if (xe !== null) {
                    var be = xe.dehydrated;
                    be !== null && pi(be);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(s(163));
          }
          gr || r.flags & 512 && Up(r);
        } catch (ge) {
          fn(r, r.return, ge);
        }
      }
      if (r === n) {
        Ve = null;
        break;
      }
      if (l = r.sibling, l !== null) {
        l.return = r.return, Ve = l;
        break;
      }
      Ve = r.return;
    }
  }
  function Gs(n) {
    for (; Ve !== null; ) {
      var r = Ve;
      if (r === n) {
        Ve = null;
        break;
      }
      var l = r.sibling;
      if (l !== null) {
        l.return = r.return, Ve = l;
        break;
      }
      Ve = r.return;
    }
  }
  function Hp(n) {
    for (; Ve !== null; ) {
      var r = Ve;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var l = r.return;
            try {
              Ws(4, r);
            } catch ($) {
              fn(r, l, $);
            }
            break;
          case 1:
            var d = r.stateNode;
            if (typeof d.componentDidMount == "function") {
              var g = r.return;
              try {
                d.componentDidMount();
              } catch ($) {
                fn(r, g, $);
              }
            }
            var S = r.return;
            try {
              Up(r);
            } catch ($) {
              fn(r, S, $);
            }
            break;
          case 5:
            var _ = r.return;
            try {
              Up(r);
            } catch ($) {
              fn(r, _, $);
            }
        }
      } catch ($) {
        fn(r, r.return, $);
      }
      if (r === n) {
        Ve = null;
        break;
      }
      var U = r.sibling;
      if (U !== null) {
        U.return = r.return, Ve = U;
        break;
      }
      Ve = r.return;
    }
  }
  var Lx = Math.ceil, _i = V.ReactCurrentDispatcher, _l = V.ReactCurrentOwner, ir = V.ReactCurrentBatchConfig, kt = 0, Vn = null, jn = null, lr = 0, lo = 0, Cu = Wo(0), Tn = 0, Qs = null, pa = 0, Eu = 0, Lf = 0, Ks = null, Gr = null, $p = 0, wu = 1 / 0, uo = null, Tu = !1, Ol = null, Oi = null, jf = !1, Ba = null, qs = 0, Di = 0, Ru = null, Xs = -1, yr = 0;
  function zn() {
    return kt & 6 ? bt() : Xs !== -1 ? Xs : Xs = bt();
  }
  function va(n) {
    return n.mode & 1 ? kt & 2 && lr !== 0 ? lr & -lr : Nx.transition !== null ? (yr === 0 && (yr = Oc()), yr) : (n = Vt, n !== 0 || (n = window.event, n = n === void 0 ? 16 : Nc(n.type)), n) : 1;
  }
  function Rr(n, r, l, d) {
    if (50 < Di) throw Di = 0, Ru = null, Error(s(185));
    nl(n, l, d), (!(kt & 2) || n !== Vn) && (n === Vn && (!(kt & 2) && (Eu |= l), Tn === 4 && Ko(n, lr)), Qr(n, d), l === 1 && kt === 0 && !(r.mode & 1) && (wu = bt() + 500, mu && ia()));
  }
  function Qr(n, r) {
    var l = n.callbackNode;
    Ud(n, r);
    var d = tl(n, n === Vn ? lr : 0);
    if (d === 0) l !== null && br(l), n.callbackNode = null, n.callbackPriority = 0;
    else if (r = d & -d, n.callbackPriority !== r) {
      if (l != null && br(l), r === 1) n.tag === 0 ? yi(Vp.bind(null, n)) : tf(Vp.bind(null, n)), du(function() {
        !(kt & 6) && ia();
      }), l = null;
      else {
        switch (Hd(d)) {
          case 1:
            l = Oa;
            break;
          case 4:
            l = ns;
            break;
          case 16:
            l = rs;
            break;
          case 536870912:
            l = zd;
            break;
          default:
            l = rs;
        }
        l = Pm(l, zf.bind(null, n));
      }
      n.callbackPriority = r, n.callbackNode = l;
    }
  }
  function zf(n, r) {
    if (Xs = -1, yr = 0, kt & 6) throw Error(s(327));
    var l = n.callbackNode;
    if (_u() && n.callbackNode !== l) return null;
    var d = tl(n, n === Vn ? lr : 0);
    if (d === 0) return null;
    if (d & 30 || d & n.expiredLanes || r) r = If(n, d);
    else {
      r = d;
      var g = kt;
      kt |= 2;
      var S = Rm();
      (Vn !== n || lr !== r) && (uo = null, wu = bt() + 500, Ha(n, r));
      do
        try {
          _m();
          break;
        } catch (U) {
          Tm(n, U);
        }
      while (!0);
      Sp(), _i.current = S, kt = g, jn !== null ? r = 0 : (Vn = null, lr = 0, r = Tn);
    }
    if (r !== 0) {
      if (r === 2 && (g = Fd(n), g !== 0 && (d = g, r = Zs(n, g))), r === 1) throw l = Qs, Ha(n, 0), Ko(n, d), Qr(n, bt()), l;
      if (r === 6) Ko(n, d);
      else {
        if (g = n.current.alternate, !(d & 30) && !jx(g) && (r = If(n, d), r === 2 && (S = Fd(n), S !== 0 && (d = S, r = Zs(n, S))), r === 1)) throw l = Qs, Ha(n, 0), Ko(n, d), Qr(n, bt()), l;
        switch (n.finishedWork = g, n.finishedLanes = d, r) {
          case 0:
          case 1:
            throw Error(s(345));
          case 2:
            Ml(n, Gr, uo);
            break;
          case 3:
            if (Ko(n, d), (d & 130023424) === d && (r = $p + 500 - bt(), 10 < r)) {
              if (tl(n, 0) !== 0) break;
              if (g = n.suspendedLanes, (g & d) !== d) {
                zn(), n.pingedLanes |= n.suspendedLanes & g;
                break;
              }
              n.timeoutHandle = Zc(Ml.bind(null, n, Gr, uo), r);
              break;
            }
            Ml(n, Gr, uo);
            break;
          case 4:
            if (Ko(n, d), (d & 4194240) === d) break;
            for (r = n.eventTimes, g = -1; 0 < d; ) {
              var _ = 31 - go(d);
              S = 1 << _, _ = r[_], _ > g && (g = _), d &= ~S;
            }
            if (d = g, d = bt() - d, d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * Lx(d / 1960)) - d, 10 < d) {
              n.timeoutHandle = Zc(Ml.bind(null, n, Gr, uo), d);
              break;
            }
            Ml(n, Gr, uo);
            break;
          case 5:
            Ml(n, Gr, uo);
            break;
          default:
            throw Error(s(329));
        }
      }
    }
    return Qr(n, bt()), n.callbackNode === l ? zf.bind(null, n) : null;
  }
  function Zs(n, r) {
    var l = Ks;
    return n.current.memoizedState.isDehydrated && (Ha(n, r).flags |= 256), n = If(n, r), n !== 2 && (r = Gr, Gr = l, r !== null && Dl(r)), n;
  }
  function Dl(n) {
    Gr === null ? Gr = n : Gr.push.apply(Gr, n);
  }
  function jx(n) {
    for (var r = n; ; ) {
      if (r.flags & 16384) {
        var l = r.updateQueue;
        if (l !== null && (l = l.stores, l !== null)) for (var d = 0; d < l.length; d++) {
          var g = l[d], S = g.getSnapshot;
          g = g.value;
          try {
            if (!$o(S(), g)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (l = r.child, r.subtreeFlags & 16384 && l !== null) l.return = r, r = l;
      else {
        if (r === n) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function Ko(n, r) {
    for (r &= ~Lf, r &= ~Eu, n.suspendedLanes |= r, n.pingedLanes &= ~r, n = n.expirationTimes; 0 < r; ) {
      var l = 31 - go(r), d = 1 << l;
      n[l] = -1, r &= ~d;
    }
  }
  function Vp(n) {
    if (kt & 6) throw Error(s(327));
    _u();
    var r = tl(n, 0);
    if (!(r & 1)) return Qr(n, bt()), null;
    var l = If(n, r);
    if (n.tag !== 0 && l === 2) {
      var d = Fd(n);
      d !== 0 && (r = d, l = Zs(n, d));
    }
    if (l === 1) throw l = Qs, Ha(n, 0), Ko(n, r), Qr(n, bt()), l;
    if (l === 6) throw Error(s(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = r, Ml(n, Gr, uo), Qr(n, bt()), null;
  }
  function Wp(n, r) {
    var l = kt;
    kt |= 1;
    try {
      return n(r);
    } finally {
      kt = l, kt === 0 && (wu = bt() + 500, mu && ia());
    }
  }
  function kl(n) {
    Ba !== null && Ba.tag === 0 && !(kt & 6) && _u();
    var r = kt;
    kt |= 1;
    var l = ir.transition, d = Vt;
    try {
      if (ir.transition = null, Vt = 1, n) return n();
    } finally {
      Vt = d, ir.transition = l, kt = r, !(kt & 6) && ia();
    }
  }
  function Yp() {
    lo = Cu.current, nn(Cu);
  }
  function Ha(n, r) {
    n.finishedWork = null, n.finishedLanes = 0;
    var l = n.timeoutHandle;
    if (l !== -1 && (n.timeoutHandle = -1, hp(l)), jn !== null) for (l = jn.return; l !== null; ) {
      var d = l;
      switch (rf(d), d.tag) {
        case 1:
          d = d.type.childContextTypes, d != null && hu();
          break;
        case 3:
          yl(), nn(Hn), nn(yn), rt();
          break;
        case 5:
          uf(d);
          break;
        case 4:
          yl();
          break;
        case 13:
          nn(vn);
          break;
        case 19:
          nn(vn);
          break;
        case 10:
          bp(d.type._context);
          break;
        case 22:
        case 23:
          Yp();
      }
      l = l.return;
    }
    if (Vn = n, jn = n = ki(n.current, null), lr = lo = r, Tn = 0, Qs = null, Lf = Eu = pa = 0, Gr = Ks = null, ml !== null) {
      for (r = 0; r < ml.length; r++) if (l = ml[r], d = l.interleaved, d !== null) {
        l.interleaved = null;
        var g = d.next, S = l.pending;
        if (S !== null) {
          var _ = S.next;
          S.next = g, d.next = _;
        }
        l.pending = d;
      }
      ml = null;
    }
    return n;
  }
  function Tm(n, r) {
    do {
      var l = jn;
      try {
        if (Sp(), Et.current = wl, cf) {
          for (var d = jt.memoizedState; d !== null; ) {
            var g = d.queue;
            g !== null && (g.pending = null), d = d.next;
          }
          cf = !1;
        }
        if (Qt = 0, qn = An = jt = null, Ds = !1, xl = 0, _l.current = null, l === null || l.return === null) {
          Tn = 1, Qs = r, jn = null;
          break;
        }
        e: {
          var S = n, _ = l.return, U = l, $ = r;
          if (r = lr, U.flags |= 32768, $ !== null && typeof $ == "object" && typeof $.then == "function") {
            var te = $, xe = U, be = xe.tag;
            if (!(xe.mode & 1) && (be === 0 || be === 11 || be === 15)) {
              var ge = xe.alternate;
              ge ? (xe.updateQueue = ge.updateQueue, xe.memoizedState = ge.memoizedState, xe.lanes = ge.lanes) : (xe.updateQueue = null, xe.memoizedState = null);
            }
            var Fe = dm(_);
            if (Fe !== null) {
              Fe.flags &= -257, Ri(Fe, _, U, S, r), Fe.mode & 1 && Pp(S, te, r), r = Fe, $ = te;
              var We = r.updateQueue;
              if (We === null) {
                var Xe = /* @__PURE__ */ new Set();
                Xe.add($), r.updateQueue = Xe;
              } else We.add($);
              break e;
            } else {
              if (!(r & 1)) {
                Pp(S, te, r), Gp();
                break e;
              }
              $ = Error(s(426));
            }
          } else if (cn && U.mode & 1) {
            var Rn = dm(_);
            if (Rn !== null) {
              !(Rn.flags & 65536) && (Rn.flags |= 256), Ri(Rn, _, U, S, r), za(Tl($, U));
              break e;
            }
          }
          S = $ = Tl($, U), Tn !== 4 && (Tn = 2), Ks === null ? Ks = [S] : Ks.push(S), S = _;
          do {
            switch (S.tag) {
              case 3:
                S.flags |= 65536, r &= -r, S.lanes |= r;
                var K = fm(S, $, r);
                im(S, K);
                break e;
              case 1:
                U = $;
                var G = S.type, J = S.stateNode;
                if (!(S.flags & 128) && (typeof G.getDerivedStateFromError == "function" || J !== null && typeof J.componentDidCatch == "function" && (Oi === null || !Oi.has(J)))) {
                  S.flags |= 65536, r &= -r, S.lanes |= r;
                  var Se = Ap(S, U, r);
                  im(S, Se);
                  break e;
                }
            }
            S = S.return;
          } while (S !== null);
        }
        Dm(l);
      } catch (Ye) {
        r = Ye, jn === l && l !== null && (jn = l = l.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Rm() {
    var n = _i.current;
    return _i.current = wl, n === null ? wl : n;
  }
  function Gp() {
    (Tn === 0 || Tn === 3 || Tn === 2) && (Tn = 4), Vn === null || !(pa & 268435455) && !(Eu & 268435455) || Ko(Vn, lr);
  }
  function If(n, r) {
    var l = kt;
    kt |= 2;
    var d = Rm();
    (Vn !== n || lr !== r) && (uo = null, Ha(n, r));
    do
      try {
        zx();
        break;
      } catch (g) {
        Tm(n, g);
      }
    while (!0);
    if (Sp(), kt = l, _i.current = d, jn !== null) throw Error(s(261));
    return Vn = null, lr = 0, Tn;
  }
  function zx() {
    for (; jn !== null; ) Om(jn);
  }
  function _m() {
    for (; jn !== null && !Ra(); ) Om(jn);
  }
  function Om(n) {
    var r = Am(n.alternate, n, lo);
    n.memoizedProps = n.pendingProps, r === null ? Dm(n) : jn = r, _l.current = null;
  }
  function Dm(n) {
    var r = n;
    do {
      var l = r.alternate;
      if (n = r.return, r.flags & 32768) {
        if (l = Nf(l, r), l !== null) {
          l.flags &= 32767, jn = l;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          Tn = 6, jn = null;
          return;
        }
      } else if (l = xm(l, r, lo), l !== null) {
        jn = l;
        return;
      }
      if (r = r.sibling, r !== null) {
        jn = r;
        return;
      }
      jn = r = n;
    } while (r !== null);
    Tn === 0 && (Tn = 5);
  }
  function Ml(n, r, l) {
    var d = Vt, g = ir.transition;
    try {
      ir.transition = null, Vt = 1, Ix(n, r, l, d);
    } finally {
      ir.transition = g, Vt = d;
    }
    return null;
  }
  function Ix(n, r, l, d) {
    do
      _u();
    while (Ba !== null);
    if (kt & 6) throw Error(s(327));
    l = n.finishedWork;
    var g = n.finishedLanes;
    if (l === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, l === n.current) throw Error(s(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var S = l.lanes | l.childLanes;
    if (px(n, S), n === Vn && (jn = Vn = null, lr = 0), !(l.subtreeFlags & 2064) && !(l.flags & 2064) || jf || (jf = !0, Pm(rs, function() {
      return _u(), null;
    })), S = (l.flags & 15990) !== 0, l.subtreeFlags & 15990 || S) {
      S = ir.transition, ir.transition = null;
      var _ = Vt;
      Vt = 1;
      var U = kt;
      kt |= 4, _l.current = null, bm(n, l), Fp(l, n), uu(fl), ol = !!xs, fl = xs = null, n.current = l, Px(l), _a(), kt = U, Vt = _, ir.transition = S;
    } else n.current = l;
    if (jf && (jf = !1, Ba = n, qs = g), S = n.pendingLanes, S === 0 && (Oi = null), Ch(l.stateNode), Qr(n, bt()), r !== null) for (d = n.onRecoverableError, l = 0; l < r.length; l++) g = r[l], d(g.value, { componentStack: g.stack, digest: g.digest });
    if (Tu) throw Tu = !1, n = Ol, Ol = null, n;
    return qs & 1 && n.tag !== 0 && _u(), S = n.pendingLanes, S & 1 ? n === Ru ? Di++ : (Di = 0, Ru = n) : Di = 0, ia(), null;
  }
  function _u() {
    if (Ba !== null) {
      var n = Hd(qs), r = ir.transition, l = Vt;
      try {
        if (ir.transition = null, Vt = 16 > n ? 16 : n, Ba === null) var d = !1;
        else {
          if (n = Ba, Ba = null, qs = 0, kt & 6) throw Error(s(331));
          var g = kt;
          for (kt |= 4, Ve = n.current; Ve !== null; ) {
            var S = Ve, _ = S.child;
            if (Ve.flags & 16) {
              var U = S.deletions;
              if (U !== null) {
                for (var $ = 0; $ < U.length; $++) {
                  var te = U[$];
                  for (Ve = te; Ve !== null; ) {
                    var xe = Ve;
                    switch (xe.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Vs(8, xe, S);
                    }
                    var be = xe.child;
                    if (be !== null) be.return = xe, Ve = be;
                    else for (; Ve !== null; ) {
                      xe = Ve;
                      var ge = xe.sibling, Fe = xe.return;
                      if (Pf(xe), xe === te) {
                        Ve = null;
                        break;
                      }
                      if (ge !== null) {
                        ge.return = Fe, Ve = ge;
                        break;
                      }
                      Ve = Fe;
                    }
                  }
                }
                var We = S.alternate;
                if (We !== null) {
                  var Xe = We.child;
                  if (Xe !== null) {
                    We.child = null;
                    do {
                      var Rn = Xe.sibling;
                      Xe.sibling = null, Xe = Rn;
                    } while (Xe !== null);
                  }
                }
                Ve = S;
              }
            }
            if (S.subtreeFlags & 2064 && _ !== null) _.return = S, Ve = _;
            else e: for (; Ve !== null; ) {
              if (S = Ve, S.flags & 2048) switch (S.tag) {
                case 0:
                case 11:
                case 15:
                  Vs(9, S, S.return);
              }
              var K = S.sibling;
              if (K !== null) {
                K.return = S.return, Ve = K;
                break e;
              }
              Ve = S.return;
            }
          }
          var G = n.current;
          for (Ve = G; Ve !== null; ) {
            _ = Ve;
            var J = _.child;
            if (_.subtreeFlags & 2064 && J !== null) J.return = _, Ve = J;
            else e: for (_ = G; Ve !== null; ) {
              if (U = Ve, U.flags & 2048) try {
                switch (U.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Ws(9, U);
                }
              } catch (Ye) {
                fn(U, U.return, Ye);
              }
              if (U === _) {
                Ve = null;
                break e;
              }
              var Se = U.sibling;
              if (Se !== null) {
                Se.return = U.return, Ve = Se;
                break e;
              }
              Ve = U.return;
            }
          }
          if (kt = g, ia(), Bo && typeof Bo.onPostCommitFiberRoot == "function") try {
            Bo.onPostCommitFiberRoot(os, n);
          } catch {
          }
          d = !0;
        }
        return d;
      } finally {
        Vt = l, ir.transition = r;
      }
    }
    return !1;
  }
  function km(n, r, l) {
    r = Tl(l, r), r = fm(n, r, 1), n = Ei(n, r, 1), r = zn(), n !== null && (nl(n, 1, r), Qr(n, r));
  }
  function fn(n, r, l) {
    if (n.tag === 3) km(n, n, l);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        km(r, n, l);
        break;
      } else if (r.tag === 1) {
        var d = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof d.componentDidCatch == "function" && (Oi === null || !Oi.has(d))) {
          n = Tl(l, n), n = Ap(r, n, 1), r = Ei(r, n, 1), n = zn(), r !== null && (nl(r, 1, n), Qr(r, n));
          break;
        }
      }
      r = r.return;
    }
  }
  function Ux(n, r, l) {
    var d = n.pingCache;
    d !== null && d.delete(r), r = zn(), n.pingedLanes |= n.suspendedLanes & l, Vn === n && (lr & l) === l && (Tn === 4 || Tn === 3 && (lr & 130023424) === lr && 500 > bt() - $p ? Ha(n, 0) : Lf |= l), Qr(n, r);
  }
  function Mm(n, r) {
    r === 0 && (n.mode & 1 ? (r = Ho, Ho <<= 1, !(Ho & 130023424) && (Ho = 4194304)) : r = 1);
    var l = zn();
    n = oo(n, r), n !== null && (nl(n, r, l), Qr(n, l));
  }
  function Fx(n) {
    var r = n.memoizedState, l = 0;
    r !== null && (l = r.retryLane), Mm(n, l);
  }
  function Nm(n, r) {
    var l = 0;
    switch (n.tag) {
      case 13:
        var d = n.stateNode, g = n.memoizedState;
        g !== null && (l = g.retryLane);
        break;
      case 19:
        d = n.stateNode;
        break;
      default:
        throw Error(s(314));
    }
    d !== null && d.delete(r), Mm(n, l);
  }
  var Am;
  Am = function(n, r, l) {
    if (n !== null) if (n.memoizedProps !== r.pendingProps || Hn.current) Pn = !0;
    else {
      if (!(n.lanes & l) && !(r.flags & 128)) return Pn = !1, Bs(n, r, l);
      Pn = !!(n.flags & 131072);
    }
    else Pn = !1, cn && r.flags & 1048576 && nm(r, ja, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var d = r.type;
        Ro(n, r), n = r.pendingProps;
        var g = Co(r, yn.current);
        pn(r, l), g = wi(null, r, d, n, g, l);
        var S = Yo();
        return r.flags |= 1, typeof g == "object" && g !== null && typeof g.render == "function" && g.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Mn(d) ? (S = !0, Br(r)) : S = !1, r.memoizedState = g.state !== null && g.state !== void 0 ? g.state : null, Tp(r), g.updater = _f, r.stateNode = g, g._reactInternals = r, js(r, d, n, l), r = Us(null, r, d, !0, S, l)) : (r.tag = 0, cn && S && nf(r), ar(null, r, g, l), r = r.child), r;
      case 16:
        d = r.elementType;
        e: {
          switch (Ro(n, r), n = r.pendingProps, g = d._init, d = g(d._payload), r.type = d, g = r.tag = Hx(d), n = Go(d, n), g) {
            case 0:
              r = pm(null, r, d, n, l);
              break e;
            case 1:
              r = vm(null, r, d, n, l);
              break e;
            case 11:
              r = Wr(null, r, d, n, l);
              break e;
            case 14:
              r = Rl(null, r, d, Go(d.type, n), l);
              break e;
          }
          throw Error(s(
            306,
            d,
            ""
          ));
        }
        return r;
      case 0:
        return d = r.type, g = r.pendingProps, g = r.elementType === d ? g : Go(d, g), pm(n, r, d, g, l);
      case 1:
        return d = r.type, g = r.pendingProps, g = r.elementType === d ? g : Go(d, g), vm(n, r, d, g, l);
      case 3:
        e: {
          if (Su(r), n === null) throw Error(s(387));
          d = r.pendingProps, S = r.memoizedState, g = S.element, am(n, r), ws(r, d, null, l);
          var _ = r.memoizedState;
          if (d = _.element, S.isDehydrated) if (S = { element: d, isDehydrated: !1, cache: _.cache, pendingSuspenseBoundaries: _.pendingSuspenseBoundaries, transitions: _.transitions }, r.updateQueue.baseState = S, r.memoizedState = S, r.flags & 256) {
            g = Tl(Error(s(423)), r), r = hm(n, r, d, l, g);
            break e;
          } else if (d !== g) {
            g = Tl(Error(s(424)), r), r = hm(n, r, d, l, g);
            break e;
          } else for ($r = ra(r.stateNode.containerInfo.firstChild), Hr = r, cn = !0, wo = null, l = Ne(r, null, d, l), r.child = l; l; ) l.flags = l.flags & -3 | 4096, l = l.sibling;
          else {
            if (Ci(), d === g) {
              r = _o(n, r, l);
              break e;
            }
            ar(n, r, d, l);
          }
          r = r.child;
        }
        return r;
      case 5:
        return lm(r), n === null && yp(r), d = r.type, g = r.pendingProps, S = n !== null ? n.memoizedProps : null, _ = g.children, Xc(d, g) ? _ = null : S !== null && Xc(d, S) && (r.flags |= 32), Lp(n, r), ar(n, r, _, l), r.child;
      case 6:
        return n === null && yp(r), null;
      case 13:
        return Mf(n, r, l);
      case 4:
        return _p(r, r.stateNode.containerInfo), d = r.pendingProps, n === null ? r.child = Cn(r, null, d, l) : ar(n, r, d, l), r.child;
      case 11:
        return d = r.type, g = r.pendingProps, g = r.elementType === d ? g : Go(d, g), Wr(n, r, d, g, l);
      case 7:
        return ar(n, r, r.pendingProps, l), r.child;
      case 8:
        return ar(n, r, r.pendingProps.children, l), r.child;
      case 12:
        return ar(n, r, r.pendingProps.children, l), r.child;
      case 10:
        e: {
          if (d = r.type._context, g = r.pendingProps, S = r.memoizedProps, _ = g.value, tt(ro, d._currentValue), d._currentValue = _, S !== null) if ($o(S.value, _)) {
            if (S.children === g.children && !Hn.current) {
              r = _o(n, r, l);
              break e;
            }
          } else for (S = r.child, S !== null && (S.return = r); S !== null; ) {
            var U = S.dependencies;
            if (U !== null) {
              _ = S.child;
              for (var $ = U.firstContext; $ !== null; ) {
                if ($.context === d) {
                  if (S.tag === 1) {
                    $ = Ia(-1, l & -l), $.tag = 2;
                    var te = S.updateQueue;
                    if (te !== null) {
                      te = te.shared;
                      var xe = te.pending;
                      xe === null ? $.next = $ : ($.next = xe.next, xe.next = $), te.pending = $;
                    }
                  }
                  S.lanes |= l, $ = S.alternate, $ !== null && ($.lanes |= l), Cp(
                    S.return,
                    l,
                    r
                  ), U.lanes |= l;
                  break;
                }
                $ = $.next;
              }
            } else if (S.tag === 10) _ = S.type === r.type ? null : S.child;
            else if (S.tag === 18) {
              if (_ = S.return, _ === null) throw Error(s(341));
              _.lanes |= l, U = _.alternate, U !== null && (U.lanes |= l), Cp(_, l, r), _ = S.sibling;
            } else _ = S.child;
            if (_ !== null) _.return = S;
            else for (_ = S; _ !== null; ) {
              if (_ === r) {
                _ = null;
                break;
              }
              if (S = _.sibling, S !== null) {
                S.return = _.return, _ = S;
                break;
              }
              _ = _.return;
            }
            S = _;
          }
          ar(n, r, g.children, l), r = r.child;
        }
        return r;
      case 9:
        return g = r.type, d = r.pendingProps.children, pn(r, l), g = To(g), d = d(g), r.flags |= 1, ar(n, r, d, l), r.child;
      case 14:
        return d = r.type, g = Go(d, r.pendingProps), g = Go(d.type, g), Rl(n, r, d, g, l);
      case 15:
        return xt(n, r, r.type, r.pendingProps, l);
      case 17:
        return d = r.type, g = r.pendingProps, g = r.elementType === d ? g : Go(d, g), Ro(n, r), r.tag = 1, Mn(d) ? (n = !0, Br(r)) : n = !1, pn(r, l), Of(r, d, g), js(r, d, g, l), Us(null, r, d, !0, n, l);
      case 19:
        return ca(n, r, l);
      case 22:
        return Is(n, r, l);
    }
    throw Error(s(156, r.tag));
  };
  function Pm(n, r) {
    return dn(n, r);
  }
  function Bx(n, r, l, d) {
    this.tag = n, this.key = l, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = d, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Do(n, r, l, d) {
    return new Bx(n, r, l, d);
  }
  function Qp(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function Hx(n) {
    if (typeof n == "function") return Qp(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === ve) return 11;
      if (n === Ue) return 14;
    }
    return 2;
  }
  function ki(n, r) {
    var l = n.alternate;
    return l === null ? (l = Do(n.tag, r, n.key, n.mode), l.elementType = n.elementType, l.type = n.type, l.stateNode = n.stateNode, l.alternate = n, n.alternate = l) : (l.pendingProps = r, l.type = n.type, l.flags = 0, l.subtreeFlags = 0, l.deletions = null), l.flags = n.flags & 14680064, l.childLanes = n.childLanes, l.lanes = n.lanes, l.child = n.child, l.memoizedProps = n.memoizedProps, l.memoizedState = n.memoizedState, l.updateQueue = n.updateQueue, r = n.dependencies, l.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, l.sibling = n.sibling, l.index = n.index, l.ref = n.ref, l;
  }
  function Js(n, r, l, d, g, S) {
    var _ = 2;
    if (d = n, typeof n == "function") Qp(n) && (_ = 1);
    else if (typeof n == "string") _ = 5;
    else e: switch (n) {
      case Z:
        return $a(l.children, g, S, r);
      case pe:
        _ = 8, g |= 8;
        break;
      case de:
        return n = Do(12, l, r, g | 2), n.elementType = de, n.lanes = S, n;
      case ce:
        return n = Do(13, l, r, g), n.elementType = ce, n.lanes = S, n;
      case Ee:
        return n = Do(19, l, r, g), n.elementType = Ee, n.lanes = S, n;
      case Ke:
        return Mi(l, g, S, r);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case me:
            _ = 10;
            break e;
          case Te:
            _ = 9;
            break e;
          case ve:
            _ = 11;
            break e;
          case Ue:
            _ = 14;
            break e;
          case Re:
            _ = 16, d = null;
            break e;
        }
        throw Error(s(130, n == null ? n : typeof n, ""));
    }
    return r = Do(_, l, r, g), r.elementType = n, r.type = d, r.lanes = S, r;
  }
  function $a(n, r, l, d) {
    return n = Do(7, n, d, r), n.lanes = l, n;
  }
  function Mi(n, r, l, d) {
    return n = Do(22, n, d, r), n.elementType = Ke, n.lanes = l, n.stateNode = { isHidden: !1 }, n;
  }
  function Kp(n, r, l) {
    return n = Do(6, n, null, r), n.lanes = l, n;
  }
  function Uf(n, r, l) {
    return r = Do(4, n.children !== null ? n.children : [], n.key, r), r.lanes = l, r.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, r;
  }
  function Lm(n, r, l, d, g) {
    this.tag = r, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Bd(0), this.expirationTimes = Bd(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Bd(0), this.identifierPrefix = d, this.onRecoverableError = g, this.mutableSourceEagerHydrationData = null;
  }
  function Ff(n, r, l, d, g, S, _, U, $) {
    return n = new Lm(n, r, l, U, $), r === 1 ? (r = 1, S === !0 && (r |= 8)) : r = 0, S = Do(3, null, null, r), n.current = S, S.stateNode = n, S.memoizedState = { element: d, isDehydrated: l, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Tp(S), n;
  }
  function $x(n, r, l) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ae, key: d == null ? null : "" + d, children: n, containerInfo: r, implementation: l };
  }
  function qp(n) {
    if (!n) return Ur;
    n = n._reactInternals;
    e: {
      if (St(n) !== n || n.tag !== 1) throw Error(s(170));
      var r = n;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Mn(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(s(171));
    }
    if (n.tag === 1) {
      var l = n.type;
      if (Mn(l)) return Cs(n, l, r);
    }
    return r;
  }
  function jm(n, r, l, d, g, S, _, U, $) {
    return n = Ff(l, d, !0, n, g, S, _, U, $), n.context = qp(null), l = n.current, d = zn(), g = va(l), S = Ia(d, g), S.callback = r ?? null, Ei(l, S, g), n.current.lanes = g, nl(n, g, d), Qr(n, d), n;
  }
  function Bf(n, r, l, d) {
    var g = r.current, S = zn(), _ = va(g);
    return l = qp(l), r.context === null ? r.context = l : r.pendingContext = l, r = Ia(S, _), r.payload = { element: n }, d = d === void 0 ? null : d, d !== null && (r.callback = d), n = Ei(g, r, _), n !== null && (Rr(n, g, _, S), lf(n, g, _)), _;
  }
  function Hf(n) {
    if (n = n.current, !n.child) return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function Xp(n, r) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var l = n.retryLane;
      n.retryLane = l !== 0 && l < r ? l : r;
    }
  }
  function $f(n, r) {
    Xp(n, r), (n = n.alternate) && Xp(n, r);
  }
  function zm() {
    return null;
  }
  var Nl = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function Zp(n) {
    this._internalRoot = n;
  }
  Vf.prototype.render = Zp.prototype.render = function(n) {
    var r = this._internalRoot;
    if (r === null) throw Error(s(409));
    Bf(n, r, null, null);
  }, Vf.prototype.unmount = Zp.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var r = n.containerInfo;
      kl(function() {
        Bf(null, n, null, null);
      }), r[Pa] = null;
    }
  };
  function Vf(n) {
    this._internalRoot = n;
  }
  Vf.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var r = yt();
      n = { blockedOn: null, target: n, priority: r };
      for (var l = 0; l < nr.length && r !== 0 && r < nr[l].priority; l++) ;
      nr.splice(l, 0, n), l === 0 && Gd(n);
    }
  };
  function Jp(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function Wf(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function Im() {
  }
  function Vx(n, r, l, d, g) {
    if (g) {
      if (typeof d == "function") {
        var S = d;
        d = function() {
          var te = Hf(_);
          S.call(te);
        };
      }
      var _ = jm(r, d, n, 0, null, !1, !1, "", Im);
      return n._reactRootContainer = _, n[Pa] = _.current, cu(n.nodeType === 8 ? n.parentNode : n), kl(), _;
    }
    for (; g = n.lastChild; ) n.removeChild(g);
    if (typeof d == "function") {
      var U = d;
      d = function() {
        var te = Hf($);
        U.call(te);
      };
    }
    var $ = Ff(n, 0, !1, null, null, !1, !1, "", Im);
    return n._reactRootContainer = $, n[Pa] = $.current, cu(n.nodeType === 8 ? n.parentNode : n), kl(function() {
      Bf(r, $, l, d);
    }), $;
  }
  function ec(n, r, l, d, g) {
    var S = l._reactRootContainer;
    if (S) {
      var _ = S;
      if (typeof g == "function") {
        var U = g;
        g = function() {
          var $ = Hf(_);
          U.call($);
        };
      }
      Bf(r, _, n, g);
    } else _ = Vx(l, r, n, g, d);
    return Hf(_);
  }
  Wt = function(n) {
    switch (n.tag) {
      case 3:
        var r = n.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var l = el(r.pendingLanes);
          l !== 0 && (Dc(r, l | 1), Qr(r, bt()), !(kt & 6) && (wu = bt() + 500, ia()));
        }
        break;
      case 13:
        kl(function() {
          var d = oo(n, 1);
          if (d !== null) {
            var g = zn();
            Rr(d, n, 1, g);
          }
        }), $f(n, 1);
    }
  }, $d = function(n) {
    if (n.tag === 13) {
      var r = oo(n, 134217728);
      if (r !== null) {
        var l = zn();
        Rr(r, n, 134217728, l);
      }
      $f(n, 134217728);
    }
  }, Vd = function(n) {
    if (n.tag === 13) {
      var r = va(n), l = oo(n, r);
      if (l !== null) {
        var d = zn();
        Rr(l, n, r, d);
      }
      $f(n, r);
    }
  }, yt = function() {
    return Vt;
  }, Wd = function(n, r) {
    var l = Vt;
    try {
      return Vt = n, r();
    } finally {
      Vt = l;
    }
  }, Gt = function(n, r, l) {
    switch (r) {
      case "input":
        if (xn(n, l), r = l.name, l.type === "radio" && r != null) {
          for (l = n; l.parentNode; ) l = l.parentNode;
          for (l = l.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < l.length; r++) {
            var d = l[r];
            if (d !== n && d.form === n.form) {
              var g = bn(d);
              if (!g) throw Error(s(90));
              re(d), xn(d, g);
            }
          }
        }
        break;
      case "textarea":
        Io(n, l);
        break;
      case "select":
        r = l.value, r != null && Sn(n, !!l.multiple, r, !1);
    }
  }, Ji = Wp, eu = kl;
  var Wx = { usingClientEntryPoint: !1, Events: [nt, Vo, bn, Jl, li, Wp] }, tc = { findFiberByHostInstance: dl, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Um = { bundleType: tc.bundleType, version: tc.version, rendererPackageName: tc.rendererPackageName, rendererConfig: tc.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: V.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = Bn(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: tc.findFiberByHostInstance || zm, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Ni = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Ni.isDisabled && Ni.supportsFiber) try {
      os = Ni.inject(Um), Bo = Ni;
    } catch {
    }
  }
  return Lo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Wx, Lo.createPortal = function(n, r) {
    var l = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Jp(r)) throw Error(s(200));
    return $x(n, r, null, l);
  }, Lo.createRoot = function(n, r) {
    if (!Jp(n)) throw Error(s(299));
    var l = !1, d = "", g = Nl;
    return r != null && (r.unstable_strictMode === !0 && (l = !0), r.identifierPrefix !== void 0 && (d = r.identifierPrefix), r.onRecoverableError !== void 0 && (g = r.onRecoverableError)), r = Ff(n, 1, !1, null, null, l, !1, d, g), n[Pa] = r.current, cu(n.nodeType === 8 ? n.parentNode : n), new Zp(r);
  }, Lo.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var r = n._reactInternals;
    if (r === void 0)
      throw typeof n.render == "function" ? Error(s(188)) : (n = Object.keys(n).join(","), Error(s(268, n)));
    return n = Bn(r), n = n === null ? null : n.stateNode, n;
  }, Lo.flushSync = function(n) {
    return kl(n);
  }, Lo.hydrate = function(n, r, l) {
    if (!Wf(r)) throw Error(s(200));
    return ec(null, n, r, !0, l);
  }, Lo.hydrateRoot = function(n, r, l) {
    if (!Jp(n)) throw Error(s(405));
    var d = l != null && l.hydratedSources || null, g = !1, S = "", _ = Nl;
    if (l != null && (l.unstable_strictMode === !0 && (g = !0), l.identifierPrefix !== void 0 && (S = l.identifierPrefix), l.onRecoverableError !== void 0 && (_ = l.onRecoverableError)), r = jm(r, null, n, 1, l ?? null, g, !1, S, _), n[Pa] = r.current, cu(n), d) for (n = 0; n < d.length; n++) l = d[n], g = l._getVersion, g = g(l._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [l, g] : r.mutableSourceEagerHydrationData.push(
      l,
      g
    );
    return new Vf(r);
  }, Lo.render = function(n, r, l) {
    if (!Wf(r)) throw Error(s(200));
    return ec(null, n, r, !1, l);
  }, Lo.unmountComponentAtNode = function(n) {
    if (!Wf(n)) throw Error(s(40));
    return n._reactRootContainer ? (kl(function() {
      ec(null, null, n, !1, function() {
        n._reactRootContainer = null, n[Pa] = null;
      });
    }), !0) : !1;
  }, Lo.unstable_batchedUpdates = Wp, Lo.unstable_renderSubtreeIntoContainer = function(n, r, l, d) {
    if (!Wf(l)) throw Error(s(200));
    if (n == null || n._reactInternals === void 0) throw Error(s(38));
    return ec(n, r, l, !1, d);
  }, Lo.version = "18.3.1-next-f1338f8080-20240426", Lo;
}
var jo = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E1;
function Tz() {
  return E1 || (E1 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var a = ut, u = d_(), s = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, f = !1;
    function p(e) {
      f = e;
    }
    function h(e) {
      if (!f) {
        for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          o[i - 1] = arguments[i];
        x("warn", e, o);
      }
    }
    function m(e) {
      if (!f) {
        for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          o[i - 1] = arguments[i];
        x("error", e, o);
      }
    }
    function x(e, t, o) {
      {
        var i = s.ReactDebugCurrentFrame, c = i.getStackAddendum();
        c !== "" && (t += "%s", o = o.concat([c]));
        var v = o.map(function(y) {
          return String(y);
        });
        v.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, v);
      }
    }
    var C = 0, E = 1, R = 2, T = 3, O = 4, N = 5, j = 6, k = 7, A = 8, z = 9, F = 10, I = 11, V = 12, B = 13, ae = 14, Z = 15, pe = 16, de = 17, me = 18, Te = 19, ve = 21, ce = 22, Ee = 23, Ue = 24, Re = 25, Ke = !0, oe = !1, le = !1, W = !1, ie = !1, we = !0, je = !0, ke = !0, et = !0, Pe = /* @__PURE__ */ new Set(), Oe = {}, Me = {};
    function Ie(e, t) {
      $e(e, t), $e(e + "Capture", t);
    }
    function $e(e, t) {
      Oe[e] && m("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), Oe[e] = t;
      {
        var o = e.toLowerCase();
        Me[o] = e, e === "onDoubleClick" && (Me.ondblclick = e);
      }
      for (var i = 0; i < t.length; i++)
        Pe.add(t[i]);
    }
    var Qe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", re = Object.prototype.hasOwnProperty;
    function qe(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, o = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function vt(e) {
      try {
        return Tt(e), !1;
      } catch {
        return !0;
      }
    }
    function Tt(e) {
      return "" + e;
    }
    function $t(e, t) {
      if (vt(e))
        return m("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, qe(e)), Tt(e);
    }
    function xn(e) {
      if (vt(e))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(e)), Tt(e);
    }
    function Gn(e, t) {
      if (vt(e))
        return m("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, qe(e)), Tt(e);
    }
    function ln(e, t) {
      if (vt(e))
        return m("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, qe(e)), Tt(e);
    }
    function er(e) {
      if (vt(e))
        return m("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", qe(e)), Tt(e);
    }
    function Sn(e) {
      if (vt(e))
        return m("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", qe(e)), Tt(e);
    }
    var Dn = 0, tr = 1, Io = 2, Fn = 3, xr = 4, eo = 5, Uo = 6, mo = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", _e = mo + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ze = new RegExp("^[" + mo + "][" + _e + "]*$"), gt = {}, At = {};
    function en(e) {
      return re.call(At, e) ? !0 : re.call(gt, e) ? !1 : Ze.test(e) ? (At[e] = !0, !0) : (gt[e] = !0, m("Invalid attribute name: `%s`", e), !1);
    }
    function Qn(e, t, o) {
      return t !== null ? t.type === Dn : o ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function un(e, t, o, i) {
      if (o !== null && o.type === Dn)
        return !1;
      switch (typeof t) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (i)
            return !1;
          if (o !== null)
            return !o.acceptsBooleans;
          var c = e.toLowerCase().slice(0, 5);
          return c !== "data-" && c !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Kn(e, t, o, i) {
      if (t === null || typeof t > "u" || un(e, t, o, i))
        return !0;
      if (i)
        return !1;
      if (o !== null)
        switch (o.type) {
          case Fn:
            return !t;
          case xr:
            return t === !1;
          case eo:
            return isNaN(t);
          case Uo:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function tn(e) {
      return Gt.hasOwnProperty(e) ? Gt[e] : null;
    }
    function Yt(e, t, o, i, c, v, y) {
      this.acceptsBooleans = t === Io || t === Fn || t === xr, this.attributeName = i, this.attributeNamespace = c, this.mustUseProperty = o, this.propertyName = e, this.type = t, this.sanitizeURL = v, this.removeEmptyString = y;
    }
    var Gt = {}, to = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    to.forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Dn,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], o = e[1];
      Gt[t] = new Yt(
        t,
        tr,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Io,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Io,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Fn,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Fn,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        xr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        Uo,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        eo,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Sr = /[\-\:]([a-z])/g, ta = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, ta);
      Gt[t] = new Yt(
        t,
        tr,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, ta);
      Gt[t] = new Yt(
        t,
        tr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, ta);
      Gt[t] = new Yt(
        t,
        tr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        tr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Jl = "xlinkHref";
    Gt[Jl] = new Yt(
      "xlinkHref",
      tr,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      Gt[e] = new Yt(
        e,
        tr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var li = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Ji = !1;
    function eu(e) {
      !Ji && li.test(e) && (Ji = !0, m("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function tu(e, t, o, i) {
      if (i.mustUseProperty) {
        var c = i.propertyName;
        return e[c];
      } else {
        $t(o, t), i.sanitizeURL && eu("" + o);
        var v = i.attributeName, y = null;
        if (i.type === xr) {
          if (e.hasAttribute(v)) {
            var b = e.getAttribute(v);
            return b === "" ? !0 : Kn(t, o, i, !1) ? b : b === "" + o ? o : b;
          }
        } else if (e.hasAttribute(v)) {
          if (Kn(t, o, i, !1))
            return e.getAttribute(v);
          if (i.type === Fn)
            return o;
          y = e.getAttribute(v);
        }
        return Kn(t, o, i, !1) ? y === null ? o : y : y === "" + o ? o : y;
      }
    }
    function ts(e, t, o, i) {
      {
        if (!en(t))
          return;
        if (!e.hasAttribute(t))
          return o === void 0 ? void 0 : null;
        var c = e.getAttribute(t);
        return $t(o, t), c === "" + o ? o : c;
      }
    }
    function wa(e, t, o, i) {
      var c = tn(t);
      if (!Qn(t, c, i)) {
        if (Kn(t, o, c, i) && (o = null), i || c === null) {
          if (en(t)) {
            var v = t;
            o === null ? e.removeAttribute(v) : ($t(o, t), e.setAttribute(v, "" + o));
          }
          return;
        }
        var y = c.mustUseProperty;
        if (y) {
          var b = c.propertyName;
          if (o === null) {
            var w = c.type;
            e[b] = w === Fn ? !1 : "";
          } else
            e[b] = o;
          return;
        }
        var M = c.attributeName, P = c.attributeNamespace;
        if (o === null)
          e.removeAttribute(M);
        else {
          var Q = c.type, Y;
          Q === Fn || Q === xr && o === !0 ? Y = "" : ($t(o, M), Y = "" + o, c.sanitizeURL && eu(Y.toString())), P ? e.setAttributeNS(P, M, Y) : e.setAttribute(M, Y);
        }
      }
    }
    var Fo = Symbol.for("react.element"), jr = Symbol.for("react.portal"), ui = Symbol.for("react.fragment"), Ta = Symbol.for("react.strict_mode"), si = Symbol.for("react.profiler"), ci = Symbol.for("react.provider"), H = Symbol.for("react.context"), ye = Symbol.for("react.forward_ref"), Le = Symbol.for("react.suspense"), lt = Symbol.for("react.suspense_list"), St = Symbol.for("react.memo"), ht = Symbol.for("react.lazy"), _t = Symbol.for("react.scope"), Rt = Symbol.for("react.debug_trace_mode"), Bn = Symbol.for("react.offscreen"), sn = Symbol.for("react.legacy_hidden"), dn = Symbol.for("react.cache"), br = Symbol.for("react.tracing_marker"), Ra = Symbol.iterator, _a = "@@iterator";
    function bt(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Ra && e[Ra] || e[_a];
      return typeof t == "function" ? t : null;
    }
    var Ct = Object.assign, Oa = 0, ns, rs, bh, zd, os, Bo, Ch;
    function go() {
    }
    go.__reactDisabledLog = !0;
    function cx() {
      {
        if (Oa === 0) {
          ns = console.log, rs = console.info, bh = console.warn, zd = console.error, os = console.group, Bo = console.groupCollapsed, Ch = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: go,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Oa++;
      }
    }
    function fx() {
      {
        if (Oa--, Oa === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ct({}, e, {
              value: ns
            }),
            info: Ct({}, e, {
              value: rs
            }),
            warn: Ct({}, e, {
              value: bh
            }),
            error: Ct({}, e, {
              value: zd
            }),
            group: Ct({}, e, {
              value: os
            }),
            groupCollapsed: Ct({}, e, {
              value: Bo
            }),
            groupEnd: Ct({}, e, {
              value: Ch
            })
          });
        }
        Oa < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Id = s.ReactCurrentDispatcher, nu;
    function Ho(e, t, o) {
      {
        if (nu === void 0)
          try {
            throw Error();
          } catch (c) {
            var i = c.stack.trim().match(/\n( *(at )?)/);
            nu = i && i[1] || "";
          }
        return `
` + nu + e;
      }
    }
    var el = !1, tl;
    {
      var dx = typeof WeakMap == "function" ? WeakMap : Map;
      tl = new dx();
    }
    function Ud(e, t) {
      if (!e || el)
        return "";
      {
        var o = tl.get(e);
        if (o !== void 0)
          return o;
      }
      var i;
      el = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v;
      v = Id.current, Id.current = null, cx();
      try {
        if (t) {
          var y = function() {
            throw Error();
          };
          if (Object.defineProperty(y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(y, []);
            } catch (ne) {
              i = ne;
            }
            Reflect.construct(e, [], y);
          } else {
            try {
              y.call();
            } catch (ne) {
              i = ne;
            }
            e.call(y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            i = ne;
          }
          e();
        }
      } catch (ne) {
        if (ne && i && typeof ne.stack == "string") {
          for (var b = ne.stack.split(`
`), w = i.stack.split(`
`), M = b.length - 1, P = w.length - 1; M >= 1 && P >= 0 && b[M] !== w[P]; )
            P--;
          for (; M >= 1 && P >= 0; M--, P--)
            if (b[M] !== w[P]) {
              if (M !== 1 || P !== 1)
                do
                  if (M--, P--, P < 0 || b[M] !== w[P]) {
                    var Q = `
` + b[M].replace(" at new ", " at ");
                    return e.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", e.displayName)), typeof e == "function" && tl.set(e, Q), Q;
                  }
                while (M >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        el = !1, Id.current = v, fx(), Error.prepareStackTrace = c;
      }
      var Y = e ? e.displayName || e.name : "", ee = Y ? Ho(Y) : "";
      return typeof e == "function" && tl.set(e, ee), ee;
    }
    function Fd(e, t, o) {
      return Ud(e, !0);
    }
    function Oc(e, t, o) {
      return Ud(e, !1);
    }
    function Bd(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function nl(e, t, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Ud(e, Bd(e));
      if (typeof e == "string")
        return Ho(e);
      switch (e) {
        case Le:
          return Ho("Suspense");
        case lt:
          return Ho("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case ye:
            return Oc(e.render);
          case St:
            return nl(e.type, t, o);
          case ht: {
            var i = e, c = i._payload, v = i._init;
            try {
              return nl(v(c), t, o);
            } catch {
            }
          }
        }
      return "";
    }
    function px(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case N:
          return Ho(e.type);
        case pe:
          return Ho("Lazy");
        case B:
          return Ho("Suspense");
        case Te:
          return Ho("SuspenseList");
        case C:
        case R:
        case Z:
          return Oc(e.type);
        case I:
          return Oc(e.type.render);
        case E:
          return Fd(e.type);
        default:
          return "";
      }
    }
    function Dc(e) {
      try {
        var t = "", o = e;
        do
          t += px(o), o = o.return;
        while (o);
        return t;
      } catch (i) {
        return `
Error generating stack: ` + i.message + `
` + i.stack;
      }
    }
    function Vt(e, t, o) {
      var i = e.displayName;
      if (i)
        return i;
      var c = t.displayName || t.name || "";
      return c !== "" ? o + "(" + c + ")" : o;
    }
    function Hd(e) {
      return e.displayName || "Context";
    }
    function Wt(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case ui:
          return "Fragment";
        case jr:
          return "Portal";
        case si:
          return "Profiler";
        case Ta:
          return "StrictMode";
        case Le:
          return "Suspense";
        case lt:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case H:
            var t = e;
            return Hd(t) + ".Consumer";
          case ci:
            var o = e;
            return Hd(o._context) + ".Provider";
          case ye:
            return Vt(e, e.render, "ForwardRef");
          case St:
            var i = e.displayName || null;
            return i !== null ? i : Wt(e.type) || "Memo";
          case ht: {
            var c = e, v = c._payload, y = c._init;
            try {
              return Wt(y(v));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function $d(e, t, o) {
      var i = t.displayName || t.name || "";
      return e.displayName || (i !== "" ? o + "(" + i + ")" : o);
    }
    function Vd(e) {
      return e.displayName || "Context";
    }
    function yt(e) {
      var t = e.tag, o = e.type;
      switch (t) {
        case Ue:
          return "Cache";
        case z:
          var i = o;
          return Vd(i) + ".Consumer";
        case F:
          var c = o;
          return Vd(c._context) + ".Provider";
        case me:
          return "DehydratedFragment";
        case I:
          return $d(o, o.render, "ForwardRef");
        case k:
          return "Fragment";
        case N:
          return o;
        case O:
          return "Portal";
        case T:
          return "Root";
        case j:
          return "Text";
        case pe:
          return Wt(o);
        case A:
          return o === Ta ? "StrictMode" : "Mode";
        case ce:
          return "Offscreen";
        case V:
          return "Profiler";
        case ve:
          return "Scope";
        case B:
          return "Suspense";
        case Te:
          return "SuspenseList";
        case Re:
          return "TracingMarker";
        case E:
        case C:
        case de:
        case R:
        case ae:
        case Z:
          if (typeof o == "function")
            return o.displayName || o.name || null;
          if (typeof o == "string")
            return o;
          break;
      }
      return null;
    }
    var Wd = s.ReactDebugCurrentFrame, Cr = null, fi = !1;
    function yo() {
      {
        if (Cr === null)
          return null;
        var e = Cr._debugOwner;
        if (e !== null && typeof e < "u")
          return yt(e);
      }
      return null;
    }
    function di() {
      return Cr === null ? "" : Dc(Cr);
    }
    function gn() {
      Wd.getCurrentStack = null, Cr = null, fi = !1;
    }
    function rn(e) {
      Wd.getCurrentStack = e === null ? null : di, Cr = e, fi = !1;
    }
    function as() {
      return Cr;
    }
    function nr(e) {
      fi = e;
    }
    function xo(e) {
      return "" + e;
    }
    function Da(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return Sn(e), e;
        default:
          return "";
      }
    }
    var is = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Yd(e, t) {
      is[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || m("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || m("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Gd(e) {
      var t = e.type, o = e.nodeName;
      return o && o.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function ls(e) {
      return e._valueTracker;
    }
    function Eh(e) {
      e._valueTracker = null;
    }
    function vx(e) {
      var t = "";
      return e && (Gd(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function us(e) {
      var t = Gd(e) ? "checked" : "value", o = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      Sn(e[t]);
      var i = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof o > "u" || typeof o.get != "function" || typeof o.set != "function")) {
        var c = o.get, v = o.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(b) {
            Sn(b), i = "" + b, v.call(this, b);
          }
        }), Object.defineProperty(e, t, {
          enumerable: o.enumerable
        });
        var y = {
          getValue: function() {
            return i;
          },
          setValue: function(b) {
            Sn(b), i = "" + b;
          },
          stopTracking: function() {
            Eh(e), delete e[t];
          }
        };
        return y;
      }
    }
    function pi(e) {
      ls(e) || (e._valueTracker = us(e));
    }
    function rl(e) {
      if (!e)
        return !1;
      var t = ls(e);
      if (!t)
        return !0;
      var o = t.getValue(), i = vx(e);
      return i !== o ? (t.setValue(i), !0) : !1;
    }
    function ol(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var wh = !1, Th = !1, kc = !1, ss = !1;
    function Mc(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function Nc(e, t) {
      var o = e, i = t.checked, c = Ct({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: i ?? o._wrapperState.initialChecked
      });
      return c;
    }
    function ka(e, t) {
      Yd("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !Th && (m("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yo() || "A component", t.type), Th = !0), t.value !== void 0 && t.defaultValue !== void 0 && !wh && (m("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yo() || "A component", t.type), wh = !0);
      var o = e, i = t.defaultValue == null ? "" : t.defaultValue;
      o._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: Da(t.value != null ? t.value : i),
        controlled: Mc(t)
      };
    }
    function Ac(e, t) {
      var o = e, i = t.checked;
      i != null && wa(o, "checked", i, !1);
    }
    function ru(e, t) {
      var o = e;
      {
        var i = Mc(t);
        !o._wrapperState.controlled && i && !ss && (m("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), ss = !0), o._wrapperState.controlled && !i && !kc && (m("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), kc = !0);
      }
      Ac(e, t);
      var c = Da(t.value), v = t.type;
      if (c != null)
        v === "number" ? (c === 0 && o.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        o.value != c) && (o.value = xo(c)) : o.value !== xo(c) && (o.value = xo(c));
      else if (v === "submit" || v === "reset") {
        o.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? jc(o, t.type, c) : t.hasOwnProperty("defaultValue") && jc(o, t.type, Da(t.defaultValue)), t.checked == null && t.defaultChecked != null && (o.defaultChecked = !!t.defaultChecked);
    }
    function Qd(e, t, o) {
      var i = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var c = t.type, v = c === "submit" || c === "reset";
        if (v && (t.value === void 0 || t.value === null))
          return;
        var y = xo(i._wrapperState.initialValue);
        o || y !== i.value && (i.value = y), i.defaultValue = y;
      }
      var b = i.name;
      b !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, b !== "" && (i.name = b);
    }
    function Pc(e, t) {
      var o = e;
      ru(o, t), Lc(o, t);
    }
    function Lc(e, t) {
      var o = t.name;
      if (t.type === "radio" && o != null) {
        for (var i = e; i.parentNode; )
          i = i.parentNode;
        $t(o, "name");
        for (var c = i.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), v = 0; v < c.length; v++) {
          var y = c[v];
          if (!(y === e || y.form !== e.form)) {
            var b = rg(y);
            if (!b)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            rl(y), ru(y, b);
          }
        }
      }
    }
    function jc(e, t, o) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || ol(e.ownerDocument) !== e) && (o == null ? e.defaultValue = xo(e._wrapperState.initialValue) : e.defaultValue !== xo(o) && (e.defaultValue = xo(o)));
    }
    var zr = !1, al = !1, zc = !1;
    function ou(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? a.Children.forEach(t.children, function(o) {
        o != null && (typeof o == "string" || typeof o == "number" || al || (al = !0, m("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (zc || (zc = !0, m("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !zr && (m("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), zr = !0);
    }
    function hx(e, t) {
      t.value != null && e.setAttribute("value", xo(Da(t.value)));
    }
    var Kd = Array.isArray;
    function rr(e) {
      return Kd(e);
    }
    var il;
    il = !1;
    function cs() {
      var e = yo();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var qd = ["value", "defaultValue"];
    function mx(e) {
      {
        Yd("select", e);
        for (var t = 0; t < qd.length; t++) {
          var o = qd[t];
          if (e[o] != null) {
            var i = rr(e[o]);
            e.multiple && !i ? m("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", o, cs()) : !e.multiple && i && m("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", o, cs());
          }
        }
      }
    }
    function au(e, t, o, i) {
      var c = e.options;
      if (t) {
        for (var v = o, y = {}, b = 0; b < v.length; b++)
          y["$" + v[b]] = !0;
        for (var w = 0; w < c.length; w++) {
          var M = y.hasOwnProperty("$" + c[w].value);
          c[w].selected !== M && (c[w].selected = M), M && i && (c[w].defaultSelected = !0);
        }
      } else {
        for (var P = xo(Da(o)), Q = null, Y = 0; Y < c.length; Y++) {
          if (c[Y].value === P) {
            c[Y].selected = !0, i && (c[Y].defaultSelected = !0);
            return;
          }
          Q === null && !c[Y].disabled && (Q = c[Y]);
        }
        Q !== null && (Q.selected = !0);
      }
    }
    function Xd(e, t) {
      return Ct({}, t, {
        value: void 0
      });
    }
    function Ic(e, t) {
      var o = e;
      mx(t), o._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !il && (m("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), il = !0);
    }
    function gx(e, t) {
      var o = e;
      o.multiple = !!t.multiple;
      var i = t.value;
      i != null ? au(o, !!t.multiple, i, !1) : t.defaultValue != null && au(o, !!t.multiple, t.defaultValue, !0);
    }
    function yx(e, t) {
      var o = e, i = o._wrapperState.wasMultiple;
      o._wrapperState.wasMultiple = !!t.multiple;
      var c = t.value;
      c != null ? au(o, !!t.multiple, c, !1) : i !== !!t.multiple && (t.defaultValue != null ? au(o, !!t.multiple, t.defaultValue, !0) : au(o, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function xx(e, t) {
      var o = e, i = t.value;
      i != null && au(o, !!t.multiple, i, !1);
    }
    var Rh = !1;
    function Zd(e, t) {
      var o = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var i = Ct({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: xo(o._wrapperState.initialValue)
      });
      return i;
    }
    function Jd(e, t) {
      var o = e;
      Yd("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !Rh && (m("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", yo() || "A component"), Rh = !0);
      var i = t.value;
      if (i == null) {
        var c = t.children, v = t.defaultValue;
        if (c != null) {
          m("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (v != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (rr(c)) {
              if (c.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              c = c[0];
            }
            v = c;
          }
        }
        v == null && (v = ""), i = v;
      }
      o._wrapperState = {
        initialValue: Da(i)
      };
    }
    function _h(e, t) {
      var o = e, i = Da(t.value), c = Da(t.defaultValue);
      if (i != null) {
        var v = xo(i);
        v !== o.value && (o.value = v), t.defaultValue == null && o.defaultValue !== v && (o.defaultValue = v);
      }
      c != null && (o.defaultValue = xo(c));
    }
    function Oh(e, t) {
      var o = e, i = o.textContent;
      i === o._wrapperState.initialValue && i !== "" && i !== null && (o.value = i);
    }
    function Sx(e, t) {
      _h(e, t);
    }
    var Ma = "http://www.w3.org/1999/xhtml", ep = "http://www.w3.org/1998/Math/MathML", tp = "http://www.w3.org/2000/svg";
    function np(e) {
      switch (e) {
        case "svg":
          return tp;
        case "math":
          return ep;
        default:
          return Ma;
      }
    }
    function rp(e, t) {
      return e == null || e === Ma ? np(t) : e === tp && t === "foreignObject" ? Ma : e;
    }
    var Dh = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, o, i, c) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, o, i, c);
        });
      } : e;
    }, Uc, kh = Dh(function(e, t) {
      if (e.namespaceURI === tp && !("innerHTML" in e)) {
        Uc = Uc || document.createElement("div"), Uc.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var o = Uc.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; o.firstChild; )
          e.appendChild(o.firstChild);
        return;
      }
      e.innerHTML = t;
    }), Ir = 1, Na = 3, kn = 8, Aa = 9, op = 11, iu = function(e, t) {
      if (t) {
        var o = e.firstChild;
        if (o && o === e.lastChild && o.nodeType === Na) {
          o.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, fs = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, ds = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Mh(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var Nh = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ds).forEach(function(e) {
      Nh.forEach(function(t) {
        ds[Mh(t, e)] = ds[e];
      });
    });
    function Fc(e, t, o) {
      var i = t == null || typeof t == "boolean" || t === "";
      return i ? "" : !o && typeof t == "number" && t !== 0 && !(ds.hasOwnProperty(e) && ds[e]) ? t + "px" : (ln(t, e), ("" + t).trim());
    }
    var Ah = /([A-Z])/g, Ph = /^ms-/;
    function lu(e) {
      return e.replace(Ah, "-$1").toLowerCase().replace(Ph, "-ms-");
    }
    var Lh = function() {
    };
    {
      var bx = /^(?:webkit|moz|o)[A-Z]/, Cx = /^-ms-/, jh = /-(.)/g, ap = /;\s*$/, na = {}, ll = {}, zh = !1, ps = !1, Ex = function(e) {
        return e.replace(jh, function(t, o) {
          return o.toUpperCase();
        });
      }, Ih = function(e) {
        na.hasOwnProperty(e) && na[e] || (na[e] = !0, m(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Ex(e.replace(Cx, "ms-"))
        ));
      }, ip = function(e) {
        na.hasOwnProperty(e) && na[e] || (na[e] = !0, m("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, lp = function(e, t) {
        ll.hasOwnProperty(t) && ll[t] || (ll[t] = !0, m(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(ap, "")));
      }, Uh = function(e, t) {
        zh || (zh = !0, m("`NaN` is an invalid value for the `%s` css style property.", e));
      }, Fh = function(e, t) {
        ps || (ps = !0, m("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      Lh = function(e, t) {
        e.indexOf("-") > -1 ? Ih(e) : bx.test(e) ? ip(e) : ap.test(t) && lp(e, t), typeof t == "number" && (isNaN(t) ? Uh(e, t) : isFinite(t) || Fh(e, t));
      };
    }
    var Bh = Lh;
    function wx(e) {
      {
        var t = "", o = "";
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var c = e[i];
            if (c != null) {
              var v = i.indexOf("--") === 0;
              t += o + (v ? i : lu(i)) + ":", t += Fc(i, c, v), o = ";";
            }
          }
        return t || null;
      }
    }
    function Hh(e, t) {
      var o = e.style;
      for (var i in t)
        if (t.hasOwnProperty(i)) {
          var c = i.indexOf("--") === 0;
          c || Bh(i, t[i]);
          var v = Fc(i, t[i], c);
          i === "float" && (i = "cssFloat"), c ? o.setProperty(i, v) : o[i] = v;
        }
    }
    function Tx(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function $h(e) {
      var t = {};
      for (var o in e)
        for (var i = fs[o] || [o], c = 0; c < i.length; c++)
          t[i[c]] = o;
      return t;
    }
    function Rx(e, t) {
      {
        if (!t)
          return;
        var o = $h(e), i = $h(t), c = {};
        for (var v in o) {
          var y = o[v], b = i[v];
          if (b && y !== b) {
            var w = y + "," + b;
            if (c[w])
              continue;
            c[w] = !0, m("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Tx(e[y]) ? "Removing" : "Updating", y, b);
          }
        }
      }
    }
    var $o = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, vs = Ct({
      menuitem: !0
    }, $o), Vh = "__html";
    function Bc(e, t) {
      if (t) {
        if (vs[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(Vh in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && m("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function vi(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var hs = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Hc = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, uu = {}, _x = new RegExp("^(aria)-[" + _e + "]*$"), su = new RegExp("^(aria)[A-Z][" + _e + "]*$");
    function up(e, t) {
      {
        if (re.call(uu, t) && uu[t])
          return !0;
        if (su.test(t)) {
          var o = "aria-" + t.slice(4).toLowerCase(), i = Hc.hasOwnProperty(o) ? o : null;
          if (i == null)
            return m("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), uu[t] = !0, !0;
          if (t !== i)
            return m("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), uu[t] = !0, !0;
        }
        if (_x.test(t)) {
          var c = t.toLowerCase(), v = Hc.hasOwnProperty(c) ? c : null;
          if (v == null)
            return uu[t] = !0, !1;
          if (t !== v)
            return m("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, v), uu[t] = !0, !0;
        }
      }
      return !0;
    }
    function ms(e, t) {
      {
        var o = [];
        for (var i in t) {
          var c = up(e, i);
          c || o.push(i);
        }
        var v = o.map(function(y) {
          return "`" + y + "`";
        }).join(", ");
        o.length === 1 ? m("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", v, e) : o.length > 1 && m("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", v, e);
      }
    }
    function sp(e, t) {
      vi(e, t) || ms(e, t);
    }
    var cp = !1;
    function $c(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !cp && (cp = !0, e === "select" && t.multiple ? m("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : m("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var ul = function() {
    };
    {
      var or = {}, fp = /^on./, Vc = /^on[^A-Z]/, Wh = new RegExp("^(aria)-[" + _e + "]*$"), Yh = new RegExp("^(aria)[A-Z][" + _e + "]*$");
      ul = function(e, t, o, i) {
        if (re.call(or, t) && or[t])
          return !0;
        var c = t.toLowerCase();
        if (c === "onfocusin" || c === "onfocusout")
          return m("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), or[t] = !0, !0;
        if (i != null) {
          var v = i.registrationNameDependencies, y = i.possibleRegistrationNames;
          if (v.hasOwnProperty(t))
            return !0;
          var b = y.hasOwnProperty(c) ? y[c] : null;
          if (b != null)
            return m("Invalid event handler property `%s`. Did you mean `%s`?", t, b), or[t] = !0, !0;
          if (fp.test(t))
            return m("Unknown event handler property `%s`. It will be ignored.", t), or[t] = !0, !0;
        } else if (fp.test(t))
          return Vc.test(t) && m("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), or[t] = !0, !0;
        if (Wh.test(t) || Yh.test(t))
          return !0;
        if (c === "innerhtml")
          return m("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), or[t] = !0, !0;
        if (c === "aria")
          return m("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), or[t] = !0, !0;
        if (c === "is" && o !== null && o !== void 0 && typeof o != "string")
          return m("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof o), or[t] = !0, !0;
        if (typeof o == "number" && isNaN(o))
          return m("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), or[t] = !0, !0;
        var w = tn(t), M = w !== null && w.type === Dn;
        if (hs.hasOwnProperty(c)) {
          var P = hs[c];
          if (P !== t)
            return m("Invalid DOM property `%s`. Did you mean `%s`?", t, P), or[t] = !0, !0;
        } else if (!M && t !== c)
          return m("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, c), or[t] = !0, !0;
        return typeof o == "boolean" && un(t, o, w, !1) ? (o ? m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', o, t, t, o, t) : m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', o, t, t, o, t, t, t), or[t] = !0, !0) : M ? !0 : un(t, o, w, !1) ? (or[t] = !0, !1) : ((o === "false" || o === "true") && w !== null && w.type === Fn && (m("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", o, t, o === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, o), or[t] = !0), !0);
      };
    }
    var Gh = function(e, t, o) {
      {
        var i = [];
        for (var c in t) {
          var v = ul(e, c, t[c], o);
          v || i.push(c);
        }
        var y = i.map(function(b) {
          return "`" + b + "`";
        }).join(", ");
        i.length === 1 ? m("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", y, e) : i.length > 1 && m("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", y, e);
      }
    };
    function Qh(e, t, o) {
      vi(e, t) || Gh(e, t, o);
    }
    var dp = 1, Wc = 2, So = 4, pp = dp | Wc | So, sl = null;
    function Ox(e) {
      sl !== null && m("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), sl = e;
    }
    function Dx() {
      sl === null && m("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), sl = null;
    }
    function gs(e) {
      return e === sl;
    }
    function vp(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Na ? t.parentNode : t;
    }
    var Yc = null, cl = null, Ft = null;
    function Gc(e) {
      var t = ku(e);
      if (t) {
        if (typeof Yc != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var o = t.stateNode;
        if (o) {
          var i = rg(o);
          Yc(t.stateNode, t.type, i);
        }
      }
    }
    function Qc(e) {
      Yc = e;
    }
    function cu(e) {
      cl ? Ft ? Ft.push(e) : Ft = [e] : cl = e;
    }
    function Kh() {
      return cl !== null || Ft !== null;
    }
    function Kc() {
      if (cl) {
        var e = cl, t = Ft;
        if (cl = null, Ft = null, Gc(e), t)
          for (var o = 0; o < t.length; o++)
            Gc(t[o]);
      }
    }
    var fu = function(e, t) {
      return e(t);
    }, ys = function() {
    }, hi = !1;
    function qh() {
      var e = Kh();
      e && (ys(), Kc());
    }
    function Xh(e, t, o) {
      if (hi)
        return e(t, o);
      hi = !0;
      try {
        return fu(e, t, o);
      } finally {
        hi = !1, qh();
      }
    }
    function kx(e, t, o) {
      fu = e, ys = o;
    }
    function Zh(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function qc(e, t, o) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(o.disabled && Zh(t));
        default:
          return !1;
      }
    }
    function mi(e, t) {
      var o = e.stateNode;
      if (o === null)
        return null;
      var i = rg(o);
      if (i === null)
        return null;
      var c = i[t];
      if (qc(t, e.type, i))
        return null;
      if (c && typeof c != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof c + "` type.");
      return c;
    }
    var xs = !1;
    if (Qe)
      try {
        var fl = {};
        Object.defineProperty(fl, "passive", {
          get: function() {
            xs = !0;
          }
        }), window.addEventListener("test", fl, fl), window.removeEventListener("test", fl, fl);
      } catch {
        xs = !1;
      }
    function Xc(e, t, o, i, c, v, y, b, w) {
      var M = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(o, M);
      } catch (P) {
        this.onError(P);
      }
    }
    var Zc = Xc;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var hp = document.createElement("react");
      Zc = function(t, o, i, c, v, y, b, w, M) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var P = document.createEvent("Event"), Q = !1, Y = !0, ee = window.event, ne = Object.getOwnPropertyDescriptor(window, "event");
        function ue() {
          hp.removeEventListener(se, ot, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = ee);
        }
        var Ae = Array.prototype.slice.call(arguments, 3);
        function ot() {
          Q = !0, ue(), o.apply(i, Ae), Y = !1;
        }
        var Je, Nt = !1, Ot = !1;
        function q(X) {
          if (Je = X.error, Nt = !0, Je === null && X.colno === 0 && X.lineno === 0 && (Ot = !0), X.defaultPrevented && Je != null && typeof Je == "object")
            try {
              Je._suppressLogging = !0;
            } catch {
            }
        }
        var se = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", q), hp.addEventListener(se, ot, !1), P.initEvent(se, !1, !1), hp.dispatchEvent(P), ne && Object.defineProperty(window, "event", ne), Q && Y && (Nt ? Ot && (Je = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Je = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Je)), window.removeEventListener("error", q), !Q)
          return ue(), Xc.apply(this, arguments);
      };
    }
    var Jh = Zc, du = !1, Jc = null, pu = !1, ra = null, em = {
      onError: function(e) {
        du = !0, Jc = e;
      }
    };
    function gi(e, t, o, i, c, v, y, b, w) {
      du = !1, Jc = null, Jh.apply(em, arguments);
    }
    function oa(e, t, o, i, c, v, y, b, w) {
      if (gi.apply(this, arguments), du) {
        var M = bs();
        pu || (pu = !0, ra = M);
      }
    }
    function Ss() {
      if (pu) {
        var e = ra;
        throw pu = !1, ra = null, e;
      }
    }
    function Pa() {
      return du;
    }
    function bs() {
      if (du) {
        var e = Jc;
        return du = !1, Jc = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function vu(e) {
      return e._reactInternals;
    }
    function Mx(e) {
      return e._reactInternals !== void 0;
    }
    function dl(e, t) {
      e._reactInternals = t;
    }
    var nt = (
      /*                      */
      0
    ), Vo = (
      /*                */
      1
    ), bn = (
      /*                    */
      2
    ), Dt = (
      /*                       */
      4
    ), bo = (
      /*                */
      16
    ), Wo = (
      /*                 */
      32
    ), nn = (
      /*                     */
      64
    ), tt = (
      /*                   */
      128
    ), Ur = (
      /*            */
      256
    ), yn = (
      /*                          */
      512
    ), Hn = (
      /*                     */
      1024
    ), Fr = (
      /*                      */
      2048
    ), Co = (
      /*                    */
      4096
    ), Mn = (
      /*                   */
      8192
    ), hu = (
      /*             */
      16384
    ), tm = (
      /*               */
      32767
    ), Cs = (
      /*                   */
      32768
    ), Br = (
      /*                */
      65536
    ), ef = (
      /* */
      131072
    ), aa = (
      /*                       */
      1048576
    ), mu = (
      /*                    */
      2097152
    ), La = (
      /*                 */
      4194304
    ), tf = (
      /*                */
      8388608
    ), yi = (
      /*               */
      16777216
    ), ia = (
      /*              */
      33554432
    ), xi = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Dt | Hn | 0
    ), Si = bn | Dt | bo | Wo | yn | Co | Mn, bi = Dt | nn | yn | Mn, ja = Fr | bo, Nn = La | tf | mu, Eo = s.ReactCurrentOwner;
    function no(e) {
      var t = e, o = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var i = t;
        do
          t = i, (t.flags & (bn | Co)) !== nt && (o = t.return), i = t.return;
        while (i);
      }
      return t.tag === T ? o : null;
    }
    function la(e) {
      if (e.tag === B) {
        var t = e.memoizedState;
        if (t === null) {
          var o = e.alternate;
          o !== null && (t = o.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function ua(e) {
      return e.tag === T ? e.stateNode.containerInfo : null;
    }
    function pl(e) {
      return no(e) === e;
    }
    function nm(e) {
      {
        var t = Eo.current;
        if (t !== null && t.tag === E) {
          var o = t, i = o.stateNode;
          i._warnedAboutRefsInRender || m("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", yt(o) || "A component"), i._warnedAboutRefsInRender = !0;
        }
      }
      var c = vu(e);
      return c ? no(c) === c : !1;
    }
    function nf(e) {
      if (no(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function rf(e) {
      var t = e.alternate;
      if (!t) {
        var o = no(e);
        if (o === null)
          throw new Error("Unable to find node on an unmounted component.");
        return o !== e ? null : e;
      }
      for (var i = e, c = t; ; ) {
        var v = i.return;
        if (v === null)
          break;
        var y = v.alternate;
        if (y === null) {
          var b = v.return;
          if (b !== null) {
            i = c = b;
            continue;
          }
          break;
        }
        if (v.child === y.child) {
          for (var w = v.child; w; ) {
            if (w === i)
              return nf(v), e;
            if (w === c)
              return nf(v), t;
            w = w.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== c.return)
          i = v, c = y;
        else {
          for (var M = !1, P = v.child; P; ) {
            if (P === i) {
              M = !0, i = v, c = y;
              break;
            }
            if (P === c) {
              M = !0, c = v, i = y;
              break;
            }
            P = P.sibling;
          }
          if (!M) {
            for (P = y.child; P; ) {
              if (P === i) {
                M = !0, i = y, c = v;
                break;
              }
              if (P === c) {
                M = !0, c = y, i = v;
                break;
              }
              P = P.sibling;
            }
            if (!M)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (i.alternate !== c)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (i.tag !== T)
        throw new Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function Hr(e) {
      var t = rf(e);
      return t !== null ? $r(t) : null;
    }
    function $r(e) {
      if (e.tag === N || e.tag === j)
        return e;
      for (var t = e.child; t !== null; ) {
        var o = $r(t);
        if (o !== null)
          return o;
        t = t.sibling;
      }
      return null;
    }
    function cn(e) {
      var t = rf(e);
      return t !== null ? wo(t) : null;
    }
    function wo(e) {
      if (e.tag === N || e.tag === j)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== O) {
          var o = wo(t);
          if (o !== null)
            return o;
        }
        t = t.sibling;
      }
      return null;
    }
    var mp = u.unstable_scheduleCallback, rm = u.unstable_cancelCallback, gp = u.unstable_shouldYield, yp = u.unstable_requestPaint, $n = u.unstable_now, of = u.unstable_getCurrentPriorityLevel, Es = u.unstable_ImmediatePriority, Ci = u.unstable_UserBlockingPriority, za = u.unstable_NormalPriority, Nx = u.unstable_LowPriority, vl = u.unstable_IdlePriority, af = u.unstable_yieldValue, om = u.unstable_setDisableYieldValue, hl = null, Cn = null, Ne = null, ro = !1, Vr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function gu(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return m("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        je && (e = Ct({}, e, {
          getLaneLabelMap: ml,
          injectProfilingHooks: To
        })), hl = t.inject(e), Cn = t;
      } catch (o) {
        m("React instrumentation encountered an error: %s.", o);
      }
      return !!t.checkDCE;
    }
    function xp(e, t) {
      if (Cn && typeof Cn.onScheduleFiberRoot == "function")
        try {
          Cn.onScheduleFiberRoot(hl, e, t);
        } catch (o) {
          ro || (ro = !0, m("React instrumentation encountered an error: %s", o));
        }
    }
    function Sp(e, t) {
      if (Cn && typeof Cn.onCommitFiberRoot == "function")
        try {
          var o = (e.current.flags & tt) === tt;
          if (ke) {
            var i;
            switch (t) {
              case Er:
                i = Es;
                break;
              case ca:
                i = Ci;
                break;
              case Ro:
                i = za;
                break;
              case _o:
                i = vl;
                break;
              default:
                i = za;
                break;
            }
            Cn.onCommitFiberRoot(hl, e, i, o);
          }
        } catch (c) {
          ro || (ro = !0, m("React instrumentation encountered an error: %s", c));
        }
    }
    function bp(e) {
      if (Cn && typeof Cn.onPostCommitFiberRoot == "function")
        try {
          Cn.onPostCommitFiberRoot(hl, e);
        } catch (t) {
          ro || (ro = !0, m("React instrumentation encountered an error: %s", t));
        }
    }
    function Cp(e) {
      if (Cn && typeof Cn.onCommitFiberUnmount == "function")
        try {
          Cn.onCommitFiberUnmount(hl, e);
        } catch (t) {
          ro || (ro = !0, m("React instrumentation encountered an error: %s", t));
        }
    }
    function pn(e) {
      if (typeof af == "function" && (om(e), p(e)), Cn && typeof Cn.setStrictMode == "function")
        try {
          Cn.setStrictMode(hl, e);
        } catch (t) {
          ro || (ro = !0, m("React instrumentation encountered an error: %s", t));
        }
    }
    function To(e) {
      Ne = e;
    }
    function ml() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, o = 0; o < xl; o++) {
          var i = um(t);
          e.set(t, i), t *= 2;
        }
        return e;
      }
    }
    function Ep(e) {
      Ne !== null && typeof Ne.markCommitStarted == "function" && Ne.markCommitStarted(e);
    }
    function wp() {
      Ne !== null && typeof Ne.markCommitStopped == "function" && Ne.markCommitStopped();
    }
    function oo(e) {
      Ne !== null && typeof Ne.markComponentRenderStarted == "function" && Ne.markComponentRenderStarted(e);
    }
    function ao() {
      Ne !== null && typeof Ne.markComponentRenderStopped == "function" && Ne.markComponentRenderStopped();
    }
    function Tp(e) {
      Ne !== null && typeof Ne.markComponentPassiveEffectMountStarted == "function" && Ne.markComponentPassiveEffectMountStarted(e);
    }
    function am() {
      Ne !== null && typeof Ne.markComponentPassiveEffectMountStopped == "function" && Ne.markComponentPassiveEffectMountStopped();
    }
    function Ia(e) {
      Ne !== null && typeof Ne.markComponentPassiveEffectUnmountStarted == "function" && Ne.markComponentPassiveEffectUnmountStarted(e);
    }
    function Ei() {
      Ne !== null && typeof Ne.markComponentPassiveEffectUnmountStopped == "function" && Ne.markComponentPassiveEffectUnmountStopped();
    }
    function lf(e) {
      Ne !== null && typeof Ne.markComponentLayoutEffectMountStarted == "function" && Ne.markComponentLayoutEffectMountStarted(e);
    }
    function im() {
      Ne !== null && typeof Ne.markComponentLayoutEffectMountStopped == "function" && Ne.markComponentLayoutEffectMountStopped();
    }
    function ws(e) {
      Ne !== null && typeof Ne.markComponentLayoutEffectUnmountStarted == "function" && Ne.markComponentLayoutEffectUnmountStarted(e);
    }
    function Rp() {
      Ne !== null && typeof Ne.markComponentLayoutEffectUnmountStopped == "function" && Ne.markComponentLayoutEffectUnmountStopped();
    }
    function Ts(e, t, o) {
      Ne !== null && typeof Ne.markComponentErrored == "function" && Ne.markComponentErrored(e, t, o);
    }
    function sa(e, t, o) {
      Ne !== null && typeof Ne.markComponentSuspended == "function" && Ne.markComponentSuspended(e, t, o);
    }
    function Rs(e) {
      Ne !== null && typeof Ne.markLayoutEffectsStarted == "function" && Ne.markLayoutEffectsStarted(e);
    }
    function _s() {
      Ne !== null && typeof Ne.markLayoutEffectsStopped == "function" && Ne.markLayoutEffectsStopped();
    }
    function gl(e) {
      Ne !== null && typeof Ne.markPassiveEffectsStarted == "function" && Ne.markPassiveEffectsStarted(e);
    }
    function _p() {
      Ne !== null && typeof Ne.markPassiveEffectsStopped == "function" && Ne.markPassiveEffectsStopped();
    }
    function yl(e) {
      Ne !== null && typeof Ne.markRenderStarted == "function" && Ne.markRenderStarted(e);
    }
    function lm() {
      Ne !== null && typeof Ne.markRenderYielded == "function" && Ne.markRenderYielded();
    }
    function uf() {
      Ne !== null && typeof Ne.markRenderStopped == "function" && Ne.markRenderStopped();
    }
    function vn(e) {
      Ne !== null && typeof Ne.markRenderScheduled == "function" && Ne.markRenderScheduled(e);
    }
    function sf(e, t) {
      Ne !== null && typeof Ne.markForceUpdateScheduled == "function" && Ne.markForceUpdateScheduled(e, t);
    }
    function Os(e, t) {
      Ne !== null && typeof Ne.markStateUpdateScheduled == "function" && Ne.markStateUpdateScheduled(e, t);
    }
    var rt = (
      /*                         */
      0
    ), Et = (
      /*                 */
      1
    ), Lt = (
      /*                    */
      2
    ), Qt = (
      /*               */
      8
    ), jt = (
      /*              */
      16
    ), An = Math.clz32 ? Math.clz32 : Ds, qn = Math.log, cf = Math.LN2;
    function Ds(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (qn(t) / cf | 0) | 0;
    }
    var xl = 31, he = (
      /*                        */
      0
    ), Pt = (
      /*                          */
      0
    ), st = (
      /*                        */
      1
    ), wi = (
      /*    */
      2
    ), Yo = (
      /*             */
      4
    ), mr = (
      /*            */
      8
    ), En = (
      /*                     */
      16
    ), Ua = (
      /*                */
      32
    ), Ti = (
      /*                       */
      4194240
    ), Sl = (
      /*                        */
      64
    ), ff = (
      /*                        */
      128
    ), df = (
      /*                        */
      256
    ), pf = (
      /*                        */
      512
    ), vf = (
      /*                        */
      1024
    ), hf = (
      /*                        */
      2048
    ), mf = (
      /*                        */
      4096
    ), gf = (
      /*                        */
      8192
    ), yf = (
      /*                        */
      16384
    ), bl = (
      /*                       */
      32768
    ), xf = (
      /*                       */
      65536
    ), yu = (
      /*                       */
      131072
    ), xu = (
      /*                       */
      262144
    ), Sf = (
      /*                       */
      524288
    ), ks = (
      /*                       */
      1048576
    ), bf = (
      /*                       */
      2097152
    ), Ms = (
      /*                            */
      130023424
    ), Cl = (
      /*                             */
      4194304
    ), Cf = (
      /*                             */
      8388608
    ), Ns = (
      /*                             */
      16777216
    ), Ef = (
      /*                             */
      33554432
    ), wf = (
      /*                             */
      67108864
    ), Op = Cl, As = (
      /*          */
      134217728
    ), Dp = (
      /*                          */
      268435455
    ), Ps = (
      /*               */
      268435456
    ), El = (
      /*                        */
      536870912
    ), io = (
      /*                   */
      1073741824
    );
    function um(e) {
      {
        if (e & st)
          return "Sync";
        if (e & wi)
          return "InputContinuousHydration";
        if (e & Yo)
          return "InputContinuous";
        if (e & mr)
          return "DefaultHydration";
        if (e & En)
          return "Default";
        if (e & Ua)
          return "TransitionHydration";
        if (e & Ti)
          return "Transition";
        if (e & Ms)
          return "Retry";
        if (e & As)
          return "SelectiveHydration";
        if (e & Ps)
          return "IdleHydration";
        if (e & El)
          return "Idle";
        if (e & io)
          return "Offscreen";
      }
    }
    var Jt = -1, wl = Sl, Tf = Cl;
    function Ls(e) {
      switch (Ri(e)) {
        case st:
          return st;
        case wi:
          return wi;
        case Yo:
          return Yo;
        case mr:
          return mr;
        case En:
          return En;
        case Ua:
          return Ua;
        case Sl:
        case ff:
        case df:
        case pf:
        case vf:
        case hf:
        case mf:
        case gf:
        case yf:
        case bl:
        case xf:
        case yu:
        case xu:
        case Sf:
        case ks:
        case bf:
          return e & Ti;
        case Cl:
        case Cf:
        case Ns:
        case Ef:
        case wf:
          return e & Ms;
        case As:
          return As;
        case Ps:
          return Ps;
        case El:
          return El;
        case io:
          return io;
        default:
          return m("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function Rf(e, t) {
      var o = e.pendingLanes;
      if (o === he)
        return he;
      var i = he, c = e.suspendedLanes, v = e.pingedLanes, y = o & Dp;
      if (y !== he) {
        var b = y & ~c;
        if (b !== he)
          i = Ls(b);
        else {
          var w = y & v;
          w !== he && (i = Ls(w));
        }
      } else {
        var M = o & ~c;
        M !== he ? i = Ls(M) : v !== he && (i = Ls(v));
      }
      if (i === he)
        return he;
      if (t !== he && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & c) === he) {
        var P = Ri(i), Q = Ri(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          P >= Q || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          P === En && (Q & Ti) !== he
        )
          return t;
      }
      (i & Yo) !== he && (i |= o & En);
      var Y = e.entangledLanes;
      if (Y !== he)
        for (var ee = e.entanglements, ne = i & Y; ne > 0; ) {
          var ue = Pn(ne), Ae = 1 << ue;
          i |= ee[ue], ne &= ~Ae;
        }
      return i;
    }
    function Go(e, t) {
      for (var o = e.eventTimes, i = Jt; t > 0; ) {
        var c = Pn(t), v = 1 << c, y = o[c];
        y > i && (i = y), t &= ~v;
      }
      return i;
    }
    function kp(e, t) {
      switch (e) {
        case st:
        case wi:
        case Yo:
          return t + 250;
        case mr:
        case En:
        case Ua:
        case Sl:
        case ff:
        case df:
        case pf:
        case vf:
        case hf:
        case mf:
        case gf:
        case yf:
        case bl:
        case xf:
        case yu:
        case xu:
        case Sf:
        case ks:
        case bf:
          return t + 5e3;
        case Cl:
        case Cf:
        case Ns:
        case Ef:
        case wf:
          return Jt;
        case As:
        case Ps:
        case El:
        case io:
          return Jt;
        default:
          return m("Should have found matching lanes. This is a bug in React."), Jt;
      }
    }
    function _f(e, t) {
      for (var o = e.pendingLanes, i = e.suspendedLanes, c = e.pingedLanes, v = e.expirationTimes, y = o; y > 0; ) {
        var b = Pn(y), w = 1 << b, M = v[b];
        M === Jt ? ((w & i) === he || (w & c) !== he) && (v[b] = kp(w, t)) : M <= t && (e.expiredLanes |= w), y &= ~w;
      }
    }
    function sm(e) {
      return Ls(e.pendingLanes);
    }
    function Of(e) {
      var t = e.pendingLanes & -1073741825;
      return t !== he ? t : t & io ? io : he;
    }
    function cm(e) {
      return (e & st) !== he;
    }
    function js(e) {
      return (e & Dp) !== he;
    }
    function Tl(e) {
      return (e & Ms) === e;
    }
    function Mp(e) {
      var t = st | Yo | En;
      return (e & t) === he;
    }
    function Np(e) {
      return (e & Ti) === e;
    }
    function Df(e, t) {
      var o = wi | Yo | mr | En;
      return (t & o) !== he;
    }
    function fm(e, t) {
      return (t & e.expiredLanes) !== he;
    }
    function Ap(e) {
      return (e & Ti) !== he;
    }
    function Pp() {
      var e = wl;
      return wl <<= 1, (wl & Ti) === he && (wl = Sl), e;
    }
    function dm() {
      var e = Tf;
      return Tf <<= 1, (Tf & Ms) === he && (Tf = Cl), e;
    }
    function Ri(e) {
      return e & -e;
    }
    function zs(e) {
      return Ri(e);
    }
    function Pn(e) {
      return 31 - An(e);
    }
    function ar(e) {
      return Pn(e);
    }
    function Wr(e, t) {
      return (e & t) !== he;
    }
    function Rl(e, t) {
      return (e & t) === t;
    }
    function xt(e, t) {
      return e | t;
    }
    function Is(e, t) {
      return e & ~t;
    }
    function Lp(e, t) {
      return e & t;
    }
    function pm(e) {
      return e;
    }
    function vm(e, t) {
      return e !== Pt && e < t ? e : t;
    }
    function Us(e) {
      for (var t = [], o = 0; o < xl; o++)
        t.push(e);
      return t;
    }
    function Su(e, t, o) {
      e.pendingLanes |= t, t !== El && (e.suspendedLanes = he, e.pingedLanes = he);
      var i = e.eventTimes, c = ar(t);
      i[c] = o;
    }
    function hm(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var o = e.expirationTimes, i = t; i > 0; ) {
        var c = Pn(i), v = 1 << c;
        o[c] = Jt, i &= ~v;
      }
    }
    function kf(e, t, o) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function jp(e, t) {
      var o = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = he, e.pingedLanes = he, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var i = e.entanglements, c = e.eventTimes, v = e.expirationTimes, y = o; y > 0; ) {
        var b = Pn(y), w = 1 << b;
        i[b] = he, c[b] = Jt, v[b] = Jt, y &= ~w;
      }
    }
    function Mf(e, t) {
      for (var o = e.entangledLanes |= t, i = e.entanglements, c = o; c; ) {
        var v = Pn(c), y = 1 << v;
        // Is this one of the newly entangled lanes?
        y & t | // Is this lane transitively entangled with the newly entangled lanes?
        i[v] & t && (i[v] |= t), c &= ~y;
      }
    }
    function zp(e, t) {
      var o = Ri(t), i;
      switch (o) {
        case Yo:
          i = wi;
          break;
        case En:
          i = mr;
          break;
        case Sl:
        case ff:
        case df:
        case pf:
        case vf:
        case hf:
        case mf:
        case gf:
        case yf:
        case bl:
        case xf:
        case yu:
        case xu:
        case Sf:
        case ks:
        case bf:
        case Cl:
        case Cf:
        case Ns:
        case Ef:
        case wf:
          i = Ua;
          break;
        case El:
          i = Ps;
          break;
        default:
          i = Pt;
          break;
      }
      return (i & (e.suspendedLanes | t)) !== Pt ? Pt : i;
    }
    function Fs(e, t, o) {
      if (Vr)
        for (var i = e.pendingUpdatersLaneMap; o > 0; ) {
          var c = ar(o), v = 1 << c, y = i[c];
          y.add(t), o &= ~v;
        }
    }
    function mm(e, t) {
      if (Vr)
        for (var o = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
          var c = ar(t), v = 1 << c, y = o[c];
          y.size > 0 && (y.forEach(function(b) {
            var w = b.alternate;
            (w === null || !i.has(w)) && i.add(b);
          }), y.clear()), t &= ~v;
        }
    }
    function Ip(e, t) {
      return null;
    }
    var Er = st, ca = Yo, Ro = En, _o = El, Bs = Pt;
    function Oo() {
      return Bs;
    }
    function Ln(e) {
      Bs = e;
    }
    function gm(e, t) {
      var o = Bs;
      try {
        return Bs = e, t();
      } finally {
        Bs = o;
      }
    }
    function ym(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function Hs(e, t) {
      return e > t ? e : t;
    }
    function Xn(e, t) {
      return e !== 0 && e < t;
    }
    function xm(e) {
      var t = Ri(e);
      return Xn(Er, t) ? Xn(ca, t) ? js(t) ? Ro : _o : ca : Er;
    }
    function Nf(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var $s;
    function gr(e) {
      $s = e;
    }
    function Ax(e) {
      $s(e);
    }
    var Ve;
    function bu(e) {
      Ve = e;
    }
    var Af;
    function Sm(e) {
      Af = e;
    }
    var bm;
    function Vs(e) {
      bm = e;
    }
    var Ws;
    function Up(e) {
      Ws = e;
    }
    var Pf = !1, Ys = [], Fa = null, fa = null, da = null, wn = /* @__PURE__ */ new Map(), wr = /* @__PURE__ */ new Map(), Tr = [], Cm = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Em(e) {
      return Cm.indexOf(e) > -1;
    }
    function Qo(e, t, o, i, c) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: o,
        nativeEvent: c,
        targetContainers: [i]
      };
    }
    function Fp(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Fa = null;
          break;
        case "dragenter":
        case "dragleave":
          fa = null;
          break;
        case "mouseover":
        case "mouseout":
          da = null;
          break;
        case "pointerover":
        case "pointerout": {
          var o = t.pointerId;
          wn.delete(o);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var i = t.pointerId;
          wr.delete(i);
          break;
        }
      }
    }
    function Yr(e, t, o, i, c, v) {
      if (e === null || e.nativeEvent !== v) {
        var y = Qo(t, o, i, c, v);
        if (t !== null) {
          var b = ku(t);
          b !== null && Ve(b);
        }
        return y;
      }
      e.eventSystemFlags |= i;
      var w = e.targetContainers;
      return c !== null && w.indexOf(c) === -1 && w.push(c), e;
    }
    function Px(e, t, o, i, c) {
      switch (t) {
        case "focusin": {
          var v = c;
          return Fa = Yr(Fa, e, t, o, i, v), !0;
        }
        case "dragenter": {
          var y = c;
          return fa = Yr(fa, e, t, o, i, y), !0;
        }
        case "mouseover": {
          var b = c;
          return da = Yr(da, e, t, o, i, b), !0;
        }
        case "pointerover": {
          var w = c, M = w.pointerId;
          return wn.set(M, Yr(wn.get(M) || null, e, t, o, i, w)), !0;
        }
        case "gotpointercapture": {
          var P = c, Q = P.pointerId;
          return wr.set(Q, Yr(wr.get(Q) || null, e, t, o, i, P)), !0;
        }
      }
      return !1;
    }
    function Bp(e) {
      var t = oc(e.target);
      if (t !== null) {
        var o = no(t);
        if (o !== null) {
          var i = o.tag;
          if (i === B) {
            var c = la(o);
            if (c !== null) {
              e.blockedOn = c, Ws(e.priority, function() {
                Af(o);
              });
              return;
            }
          } else if (i === T) {
            var v = o.stateNode;
            if (Nf(v)) {
              e.blockedOn = ua(o);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function wm(e) {
      for (var t = bm(), o = {
        blockedOn: null,
        target: e,
        priority: t
      }, i = 0; i < Tr.length && Xn(t, Tr[i].priority); i++)
        ;
      Tr.splice(i, 0, o), i === 0 && Bp(o);
    }
    function Gs(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var o = t[0], i = Eu(e.domEventName, e.eventSystemFlags, o, e.nativeEvent);
        if (i === null) {
          var c = e.nativeEvent, v = new c.constructor(c.type, c);
          Ox(v), c.target.dispatchEvent(v), Dx();
        } else {
          var y = ku(i);
          return y !== null && Ve(y), e.blockedOn = i, !1;
        }
        t.shift();
      }
      return !0;
    }
    function Hp(e, t, o) {
      Gs(e) && o.delete(t);
    }
    function Lx() {
      Pf = !1, Fa !== null && Gs(Fa) && (Fa = null), fa !== null && Gs(fa) && (fa = null), da !== null && Gs(da) && (da = null), wn.forEach(Hp), wr.forEach(Hp);
    }
    function _i(e, t) {
      e.blockedOn === t && (e.blockedOn = null, Pf || (Pf = !0, u.unstable_scheduleCallback(u.unstable_NormalPriority, Lx)));
    }
    function _l(e) {
      if (Ys.length > 0) {
        _i(Ys[0], e);
        for (var t = 1; t < Ys.length; t++) {
          var o = Ys[t];
          o.blockedOn === e && (o.blockedOn = null);
        }
      }
      Fa !== null && _i(Fa, e), fa !== null && _i(fa, e), da !== null && _i(da, e);
      var i = function(b) {
        return _i(b, e);
      };
      wn.forEach(i), wr.forEach(i);
      for (var c = 0; c < Tr.length; c++) {
        var v = Tr[c];
        v.blockedOn === e && (v.blockedOn = null);
      }
      for (; Tr.length > 0; ) {
        var y = Tr[0];
        if (y.blockedOn !== null)
          break;
        Bp(y), y.blockedOn === null && Tr.shift();
      }
    }
    var ir = s.ReactCurrentBatchConfig, kt = !0;
    function Vn(e) {
      kt = !!e;
    }
    function jn() {
      return kt;
    }
    function lr(e, t, o) {
      var i = Lf(t), c;
      switch (i) {
        case Er:
          c = lo;
          break;
        case ca:
          c = Cu;
          break;
        case Ro:
        default:
          c = Tn;
          break;
      }
      return c.bind(null, t, o, e);
    }
    function lo(e, t, o, i) {
      var c = Oo(), v = ir.transition;
      ir.transition = null;
      try {
        Ln(Er), Tn(e, t, o, i);
      } finally {
        Ln(c), ir.transition = v;
      }
    }
    function Cu(e, t, o, i) {
      var c = Oo(), v = ir.transition;
      ir.transition = null;
      try {
        Ln(ca), Tn(e, t, o, i);
      } finally {
        Ln(c), ir.transition = v;
      }
    }
    function Tn(e, t, o, i) {
      kt && Qs(e, t, o, i);
    }
    function Qs(e, t, o, i) {
      var c = Eu(e, t, o, i);
      if (c === null) {
        Zx(e, t, i, pa, o), Fp(e, i);
        return;
      }
      if (Px(c, e, t, o, i)) {
        i.stopPropagation();
        return;
      }
      if (Fp(e, i), t & So && Em(e)) {
        for (; c !== null; ) {
          var v = ku(c);
          v !== null && Ax(v);
          var y = Eu(e, t, o, i);
          if (y === null && Zx(e, t, i, pa, o), y === c)
            break;
          c = y;
        }
        c !== null && i.stopPropagation();
        return;
      }
      Zx(e, t, i, null, o);
    }
    var pa = null;
    function Eu(e, t, o, i) {
      pa = null;
      var c = vp(i), v = oc(c);
      if (v !== null) {
        var y = no(v);
        if (y === null)
          v = null;
        else {
          var b = y.tag;
          if (b === B) {
            var w = la(y);
            if (w !== null)
              return w;
            v = null;
          } else if (b === T) {
            var M = y.stateNode;
            if (Nf(M))
              return ua(y);
            v = null;
          } else y !== v && (v = null);
        }
      }
      return pa = v, null;
    }
    function Lf(e) {
      switch (e) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Er;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ca;
        case "message": {
          var t = of();
          switch (t) {
            case Es:
              return Er;
            case Ci:
              return ca;
            case za:
            case Nx:
              return Ro;
            case vl:
              return _o;
            default:
              return Ro;
          }
        }
        default:
          return Ro;
      }
    }
    function Ks(e, t, o) {
      return e.addEventListener(t, o, !1), o;
    }
    function Gr(e, t, o) {
      return e.addEventListener(t, o, !0), o;
    }
    function $p(e, t, o, i) {
      return e.addEventListener(t, o, {
        capture: !0,
        passive: i
      }), o;
    }
    function wu(e, t, o, i) {
      return e.addEventListener(t, o, {
        passive: i
      }), o;
    }
    var uo = null, Tu = null, Ol = null;
    function Oi(e) {
      return uo = e, Tu = qs(), !0;
    }
    function jf() {
      uo = null, Tu = null, Ol = null;
    }
    function Ba() {
      if (Ol)
        return Ol;
      var e, t = Tu, o = t.length, i, c = qs(), v = c.length;
      for (e = 0; e < o && t[e] === c[e]; e++)
        ;
      var y = o - e;
      for (i = 1; i <= y && t[o - i] === c[v - i]; i++)
        ;
      var b = i > 1 ? 1 - i : void 0;
      return Ol = c.slice(e, b), Ol;
    }
    function qs() {
      return "value" in uo ? uo.value : uo.textContent;
    }
    function Di(e) {
      var t, o = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && o === 13 && (t = 13)) : t = o, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function Ru() {
      return !0;
    }
    function Xs() {
      return !1;
    }
    function yr(e) {
      function t(o, i, c, v, y) {
        this._reactName = o, this._targetInst = c, this.type = i, this.nativeEvent = v, this.target = y, this.currentTarget = null;
        for (var b in e)
          if (e.hasOwnProperty(b)) {
            var w = e[b];
            w ? this[b] = w(v) : this[b] = v[b];
          }
        var M = v.defaultPrevented != null ? v.defaultPrevented : v.returnValue === !1;
        return M ? this.isDefaultPrevented = Ru : this.isDefaultPrevented = Xs, this.isPropagationStopped = Xs, this;
      }
      return Ct(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var o = this.nativeEvent;
          o && (o.preventDefault ? o.preventDefault() : typeof o.returnValue != "unknown" && (o.returnValue = !1), this.isDefaultPrevented = Ru);
        },
        stopPropagation: function() {
          var o = this.nativeEvent;
          o && (o.stopPropagation ? o.stopPropagation() : typeof o.cancelBubble != "unknown" && (o.cancelBubble = !0), this.isPropagationStopped = Ru);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Ru
      }), t;
    }
    var zn = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, va = yr(zn), Rr = Ct({}, zn, {
      view: 0,
      detail: 0
    }), Qr = yr(Rr), zf, Zs, Dl;
    function jx(e) {
      e !== Dl && (Dl && e.type === "mousemove" ? (zf = e.screenX - Dl.screenX, Zs = e.screenY - Dl.screenY) : (zf = 0, Zs = 0), Dl = e);
    }
    var Ko = Ct({}, Rr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: fn,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (jx(e), zf);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Zs;
      }
    }), Vp = yr(Ko), Wp = Ct({}, Ko, {
      dataTransfer: 0
    }), kl = yr(Wp), Yp = Ct({}, Rr, {
      relatedTarget: 0
    }), Ha = yr(Yp), Tm = Ct({}, zn, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Rm = yr(Tm), Gp = Ct({}, zn, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), If = yr(Gp), zx = Ct({}, zn, {
      data: 0
    }), _m = yr(zx), Om = _m, Dm = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Ml = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Ix(e) {
      if (e.key) {
        var t = Dm[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var o = Di(e);
        return o === 13 ? "Enter" : String.fromCharCode(o);
      }
      return e.type === "keydown" || e.type === "keyup" ? Ml[e.keyCode] || "Unidentified" : "";
    }
    var _u = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function km(e) {
      var t = this, o = t.nativeEvent;
      if (o.getModifierState)
        return o.getModifierState(e);
      var i = _u[e];
      return i ? !!o[i] : !1;
    }
    function fn(e) {
      return km;
    }
    var Ux = Ct({}, Rr, {
      key: Ix,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: fn,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Di(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Di(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), Mm = yr(Ux), Fx = Ct({}, Ko, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Nm = yr(Fx), Am = Ct({}, Rr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: fn
    }), Pm = yr(Am), Bx = Ct({}, zn, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Do = yr(Bx), Qp = Ct({}, Ko, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Hx = yr(Qp), ki = [9, 13, 27, 32], Js = 229, $a = Qe && "CompositionEvent" in window, Mi = null;
    Qe && "documentMode" in document && (Mi = document.documentMode);
    var Kp = Qe && "TextEvent" in window && !Mi, Uf = Qe && (!$a || Mi && Mi > 8 && Mi <= 11), Lm = 32, Ff = String.fromCharCode(Lm);
    function $x() {
      Ie("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Ie("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Ie("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Ie("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var qp = !1;
    function jm(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function Bf(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Hf(e, t) {
      return e === "keydown" && t.keyCode === Js;
    }
    function Xp(e, t) {
      switch (e) {
        case "keyup":
          return ki.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== Js;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function $f(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function zm(e) {
      return e.locale === "ko";
    }
    var Nl = !1;
    function Zp(e, t, o, i, c) {
      var v, y;
      if ($a ? v = Bf(t) : Nl ? Xp(t, i) && (v = "onCompositionEnd") : Hf(t, i) && (v = "onCompositionStart"), !v)
        return null;
      Uf && !zm(i) && (!Nl && v === "onCompositionStart" ? Nl = Oi(c) : v === "onCompositionEnd" && Nl && (y = Ba()));
      var b = Vm(o, v);
      if (b.length > 0) {
        var w = new _m(v, t, null, i, c);
        if (e.push({
          event: w,
          listeners: b
        }), y)
          w.data = y;
        else {
          var M = $f(i);
          M !== null && (w.data = M);
        }
      }
    }
    function Vf(e, t) {
      switch (e) {
        case "compositionend":
          return $f(t);
        case "keypress":
          var o = t.which;
          return o !== Lm ? null : (qp = !0, Ff);
        case "textInput":
          var i = t.data;
          return i === Ff && qp ? null : i;
        default:
          return null;
      }
    }
    function Jp(e, t) {
      if (Nl) {
        if (e === "compositionend" || !$a && Xp(e, t)) {
          var o = Ba();
          return jf(), Nl = !1, o;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!jm(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return Uf && !zm(t) ? null : t.data;
        default:
          return null;
      }
    }
    function Wf(e, t, o, i, c) {
      var v;
      if (Kp ? v = Vf(t, i) : v = Jp(t, i), !v)
        return null;
      var y = Vm(o, "onBeforeInput");
      if (y.length > 0) {
        var b = new Om("onBeforeInput", "beforeinput", null, i, c);
        e.push({
          event: b,
          listeners: y
        }), b.data = v;
      }
    }
    function Im(e, t, o, i, c, v, y) {
      Zp(e, t, o, i, c), Wf(e, t, o, i, c);
    }
    var Vx = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function ec(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Vx[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Wx(e) {
      if (!Qe)
        return !1;
      var t = "on" + e, o = t in document;
      if (!o) {
        var i = document.createElement("div");
        i.setAttribute(t, "return;"), o = typeof i[t] == "function";
      }
      return o;
    }
    function tc() {
      Ie("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Um(e, t, o, i) {
      cu(i);
      var c = Vm(t, "onChange");
      if (c.length > 0) {
        var v = new va("onChange", "change", null, o, i);
        e.push({
          event: v,
          listeners: c
        });
      }
    }
    var Ni = null, n = null;
    function r(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function l(e) {
      var t = [];
      Um(t, n, e, vp(e)), Xh(d, t);
    }
    function d(e) {
      DE(e, 0);
    }
    function g(e) {
      var t = Xf(e);
      if (rl(t))
        return e;
    }
    function S(e, t) {
      if (e === "change")
        return t;
    }
    var _ = !1;
    Qe && (_ = Wx("input") && (!document.documentMode || document.documentMode > 9));
    function U(e, t) {
      Ni = e, n = t, Ni.attachEvent("onpropertychange", te);
    }
    function $() {
      Ni && (Ni.detachEvent("onpropertychange", te), Ni = null, n = null);
    }
    function te(e) {
      e.propertyName === "value" && g(n) && l(e);
    }
    function xe(e, t, o) {
      e === "focusin" ? ($(), U(t, o)) : e === "focusout" && $();
    }
    function be(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return g(n);
    }
    function ge(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function Fe(e, t) {
      if (e === "click")
        return g(t);
    }
    function We(e, t) {
      if (e === "input" || e === "change")
        return g(t);
    }
    function Xe(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || jc(e, "number", e.value);
    }
    function Rn(e, t, o, i, c, v, y) {
      var b = o ? Xf(o) : window, w, M;
      if (r(b) ? w = S : ec(b) ? _ ? w = We : (w = be, M = xe) : ge(b) && (w = Fe), w) {
        var P = w(t, o);
        if (P) {
          Um(e, P, i, c);
          return;
        }
      }
      M && M(t, b, o), t === "focusout" && Xe(b);
    }
    function K() {
      $e("onMouseEnter", ["mouseout", "mouseover"]), $e("onMouseLeave", ["mouseout", "mouseover"]), $e("onPointerEnter", ["pointerout", "pointerover"]), $e("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function G(e, t, o, i, c, v, y) {
      var b = t === "mouseover" || t === "pointerover", w = t === "mouseout" || t === "pointerout";
      if (b && !gs(i)) {
        var M = i.relatedTarget || i.fromElement;
        if (M && (oc(M) || pv(M)))
          return;
      }
      if (!(!w && !b)) {
        var P;
        if (c.window === c)
          P = c;
        else {
          var Q = c.ownerDocument;
          Q ? P = Q.defaultView || Q.parentWindow : P = window;
        }
        var Y, ee;
        if (w) {
          var ne = i.relatedTarget || i.toElement;
          if (Y = o, ee = ne ? oc(ne) : null, ee !== null) {
            var ue = no(ee);
            (ee !== ue || ee.tag !== N && ee.tag !== j) && (ee = null);
          }
        } else
          Y = null, ee = o;
        if (Y !== ee) {
          var Ae = Vp, ot = "onMouseLeave", Je = "onMouseEnter", Nt = "mouse";
          (t === "pointerout" || t === "pointerover") && (Ae = Nm, ot = "onPointerLeave", Je = "onPointerEnter", Nt = "pointer");
          var Ot = Y == null ? P : Xf(Y), q = ee == null ? P : Xf(ee), se = new Ae(ot, Nt + "leave", Y, i, c);
          se.target = Ot, se.relatedTarget = q;
          var X = null, Ce = oc(c);
          if (Ce === o) {
            var He = new Ae(Je, Nt + "enter", ee, i, c);
            He.target = q, He.relatedTarget = Ot, X = He;
          }
          vk(e, se, X, Y, ee);
        }
      }
    }
    function J(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var Se = typeof Object.is == "function" ? Object.is : J;
    function Ye(e, t) {
      if (Se(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var o = Object.keys(e), i = Object.keys(t);
      if (o.length !== i.length)
        return !1;
      for (var c = 0; c < o.length; c++) {
        var v = o[c];
        if (!re.call(t, v) || !Se(e[v], t[v]))
          return !1;
      }
      return !0;
    }
    function at(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function it(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function ft(e, t) {
      for (var o = at(e), i = 0, c = 0; o; ) {
        if (o.nodeType === Na) {
          if (c = i + o.textContent.length, i <= t && c >= t)
            return {
              node: o,
              offset: t - i
            };
          i = c;
        }
        o = at(it(o));
      }
    }
    function Zn(e) {
      var t = e.ownerDocument, o = t && t.defaultView || window, i = o.getSelection && o.getSelection();
      if (!i || i.rangeCount === 0)
        return null;
      var c = i.anchorNode, v = i.anchorOffset, y = i.focusNode, b = i.focusOffset;
      try {
        c.nodeType, y.nodeType;
      } catch {
        return null;
      }
      return zt(e, c, v, y, b);
    }
    function zt(e, t, o, i, c) {
      var v = 0, y = -1, b = -1, w = 0, M = 0, P = e, Q = null;
      e: for (; ; ) {
        for (var Y = null; P === t && (o === 0 || P.nodeType === Na) && (y = v + o), P === i && (c === 0 || P.nodeType === Na) && (b = v + c), P.nodeType === Na && (v += P.nodeValue.length), (Y = P.firstChild) !== null; )
          Q = P, P = Y;
        for (; ; ) {
          if (P === e)
            break e;
          if (Q === t && ++w === o && (y = v), Q === i && ++M === c && (b = v), (Y = P.nextSibling) !== null)
            break;
          P = Q, Q = P.parentNode;
        }
        P = Y;
      }
      return y === -1 || b === -1 ? null : {
        start: y,
        end: b
      };
    }
    function Ai(e, t) {
      var o = e.ownerDocument || document, i = o && o.defaultView || window;
      if (i.getSelection) {
        var c = i.getSelection(), v = e.textContent.length, y = Math.min(t.start, v), b = t.end === void 0 ? y : Math.min(t.end, v);
        if (!c.extend && y > b) {
          var w = b;
          b = y, y = w;
        }
        var M = ft(e, y), P = ft(e, b);
        if (M && P) {
          if (c.rangeCount === 1 && c.anchorNode === M.node && c.anchorOffset === M.offset && c.focusNode === P.node && c.focusOffset === P.offset)
            return;
          var Q = o.createRange();
          Q.setStart(M.node, M.offset), c.removeAllRanges(), y > b ? (c.addRange(Q), c.extend(P.node, P.offset)) : (Q.setEnd(P.node, P.offset), c.addRange(Q));
        }
      }
    }
    function Fm(e) {
      return e && e.nodeType === Na;
    }
    function yE(e, t) {
      return !e || !t ? !1 : e === t ? !0 : Fm(e) ? !1 : Fm(t) ? yE(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function qD(e) {
      return e && e.ownerDocument && yE(e.ownerDocument.documentElement, e);
    }
    function XD(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function xE() {
      for (var e = window, t = ol(); t instanceof e.HTMLIFrameElement; ) {
        if (XD(t))
          e = t.contentWindow;
        else
          return t;
        t = ol(e.document);
      }
      return t;
    }
    function Yx(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function ZD() {
      var e = xE();
      return {
        focusedElem: e,
        selectionRange: Yx(e) ? ek(e) : null
      };
    }
    function JD(e) {
      var t = xE(), o = e.focusedElem, i = e.selectionRange;
      if (t !== o && qD(o)) {
        i !== null && Yx(o) && tk(o, i);
        for (var c = [], v = o; v = v.parentNode; )
          v.nodeType === Ir && c.push({
            element: v,
            left: v.scrollLeft,
            top: v.scrollTop
          });
        typeof o.focus == "function" && o.focus();
        for (var y = 0; y < c.length; y++) {
          var b = c[y];
          b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
        }
      }
    }
    function ek(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = Zn(e), t || {
        start: 0,
        end: 0
      };
    }
    function tk(e, t) {
      var o = t.start, i = t.end;
      i === void 0 && (i = o), "selectionStart" in e ? (e.selectionStart = o, e.selectionEnd = Math.min(i, e.value.length)) : Ai(e, t);
    }
    var nk = Qe && "documentMode" in document && document.documentMode <= 11;
    function rk() {
      Ie("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Yf = null, Gx = null, ev = null, Qx = !1;
    function ok(e) {
      if ("selectionStart" in e && Yx(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, o = t.getSelection();
      return {
        anchorNode: o.anchorNode,
        anchorOffset: o.anchorOffset,
        focusNode: o.focusNode,
        focusOffset: o.focusOffset
      };
    }
    function ak(e) {
      return e.window === e ? e.document : e.nodeType === Aa ? e : e.ownerDocument;
    }
    function SE(e, t, o) {
      var i = ak(o);
      if (!(Qx || Yf == null || Yf !== ol(i))) {
        var c = ok(Yf);
        if (!ev || !Ye(ev, c)) {
          ev = c;
          var v = Vm(Gx, "onSelect");
          if (v.length > 0) {
            var y = new va("onSelect", "select", null, t, o);
            e.push({
              event: y,
              listeners: v
            }), y.target = Yf;
          }
        }
      }
    }
    function ik(e, t, o, i, c, v, y) {
      var b = o ? Xf(o) : window;
      switch (t) {
        case "focusin":
          (ec(b) || b.contentEditable === "true") && (Yf = b, Gx = o, ev = null);
          break;
        case "focusout":
          Yf = null, Gx = null, ev = null;
          break;
        case "mousedown":
          Qx = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Qx = !1, SE(e, i, c);
          break;
        case "selectionchange":
          if (nk)
            break;
        case "keydown":
        case "keyup":
          SE(e, i, c);
      }
    }
    function Bm(e, t) {
      var o = {};
      return o[e.toLowerCase()] = t.toLowerCase(), o["Webkit" + e] = "webkit" + t, o["Moz" + e] = "moz" + t, o;
    }
    var Gf = {
      animationend: Bm("Animation", "AnimationEnd"),
      animationiteration: Bm("Animation", "AnimationIteration"),
      animationstart: Bm("Animation", "AnimationStart"),
      transitionend: Bm("Transition", "TransitionEnd")
    }, Kx = {}, bE = {};
    Qe && (bE = document.createElement("div").style, "AnimationEvent" in window || (delete Gf.animationend.animation, delete Gf.animationiteration.animation, delete Gf.animationstart.animation), "TransitionEvent" in window || delete Gf.transitionend.transition);
    function Hm(e) {
      if (Kx[e])
        return Kx[e];
      if (!Gf[e])
        return e;
      var t = Gf[e];
      for (var o in t)
        if (t.hasOwnProperty(o) && o in bE)
          return Kx[e] = t[o];
      return e;
    }
    var CE = Hm("animationend"), EE = Hm("animationiteration"), wE = Hm("animationstart"), TE = Hm("transitionend"), RE = /* @__PURE__ */ new Map(), _E = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Ou(e, t) {
      RE.set(e, t), Ie(t, [e]);
    }
    function lk() {
      for (var e = 0; e < _E.length; e++) {
        var t = _E[e], o = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
        Ou(o, "on" + i);
      }
      Ou(CE, "onAnimationEnd"), Ou(EE, "onAnimationIteration"), Ou(wE, "onAnimationStart"), Ou("dblclick", "onDoubleClick"), Ou("focusin", "onFocus"), Ou("focusout", "onBlur"), Ou(TE, "onTransitionEnd");
    }
    function uk(e, t, o, i, c, v, y) {
      var b = RE.get(t);
      if (b !== void 0) {
        var w = va, M = t;
        switch (t) {
          case "keypress":
            if (Di(i) === 0)
              return;
          case "keydown":
          case "keyup":
            w = Mm;
            break;
          case "focusin":
            M = "focus", w = Ha;
            break;
          case "focusout":
            M = "blur", w = Ha;
            break;
          case "beforeblur":
          case "afterblur":
            w = Ha;
            break;
          case "click":
            if (i.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            w = Vp;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            w = kl;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            w = Pm;
            break;
          case CE:
          case EE:
          case wE:
            w = Rm;
            break;
          case TE:
            w = Do;
            break;
          case "scroll":
            w = Qr;
            break;
          case "wheel":
            w = Hx;
            break;
          case "copy":
          case "cut":
          case "paste":
            w = If;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            w = Nm;
            break;
        }
        var P = (v & So) !== 0;
        {
          var Q = !P && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", Y = dk(o, b, i.type, P, Q);
          if (Y.length > 0) {
            var ee = new w(b, M, null, i, c);
            e.push({
              event: ee,
              listeners: Y
            });
          }
        }
      }
    }
    lk(), K(), tc(), rk(), $x();
    function sk(e, t, o, i, c, v, y) {
      uk(e, t, o, i, c, v);
      var b = (v & pp) === 0;
      b && (G(e, t, o, i, c), Rn(e, t, o, i, c), ik(e, t, o, i, c), Im(e, t, o, i, c));
    }
    var tv = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], qx = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(tv));
    function OE(e, t, o) {
      var i = e.type || "unknown-event";
      e.currentTarget = o, oa(i, t, void 0, e), e.currentTarget = null;
    }
    function ck(e, t, o) {
      var i;
      if (o)
        for (var c = t.length - 1; c >= 0; c--) {
          var v = t[c], y = v.instance, b = v.currentTarget, w = v.listener;
          if (y !== i && e.isPropagationStopped())
            return;
          OE(e, w, b), i = y;
        }
      else
        for (var M = 0; M < t.length; M++) {
          var P = t[M], Q = P.instance, Y = P.currentTarget, ee = P.listener;
          if (Q !== i && e.isPropagationStopped())
            return;
          OE(e, ee, Y), i = Q;
        }
    }
    function DE(e, t) {
      for (var o = (t & So) !== 0, i = 0; i < e.length; i++) {
        var c = e[i], v = c.event, y = c.listeners;
        ck(v, y, o);
      }
      Ss();
    }
    function fk(e, t, o, i, c) {
      var v = vp(o), y = [];
      sk(y, e, i, o, v, t), DE(y, t);
    }
    function hn(e, t) {
      qx.has(e) || m('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var o = !1, i = BM(t), c = hk(e);
      i.has(c) || (kE(t, e, Wc, o), i.add(c));
    }
    function Xx(e, t, o) {
      qx.has(e) && !t && m('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var i = 0;
      t && (i |= So), kE(o, e, i, t);
    }
    var $m = "_reactListening" + Math.random().toString(36).slice(2);
    function nv(e) {
      if (!e[$m]) {
        e[$m] = !0, Pe.forEach(function(o) {
          o !== "selectionchange" && (qx.has(o) || Xx(o, !1, e), Xx(o, !0, e));
        });
        var t = e.nodeType === Aa ? e : e.ownerDocument;
        t !== null && (t[$m] || (t[$m] = !0, Xx("selectionchange", !1, t)));
      }
    }
    function kE(e, t, o, i, c) {
      var v = lr(e, t, o), y = void 0;
      xs && (t === "touchstart" || t === "touchmove" || t === "wheel") && (y = !0), e = e, i ? y !== void 0 ? $p(e, t, v, y) : Gr(e, t, v) : y !== void 0 ? wu(e, t, v, y) : Ks(e, t, v);
    }
    function ME(e, t) {
      return e === t || e.nodeType === kn && e.parentNode === t;
    }
    function Zx(e, t, o, i, c) {
      var v = i;
      if (!(t & dp) && !(t & Wc)) {
        var y = c;
        if (i !== null) {
          var b = i;
          e: for (; ; ) {
            if (b === null)
              return;
            var w = b.tag;
            if (w === T || w === O) {
              var M = b.stateNode.containerInfo;
              if (ME(M, y))
                break;
              if (w === O)
                for (var P = b.return; P !== null; ) {
                  var Q = P.tag;
                  if (Q === T || Q === O) {
                    var Y = P.stateNode.containerInfo;
                    if (ME(Y, y))
                      return;
                  }
                  P = P.return;
                }
              for (; M !== null; ) {
                var ee = oc(M);
                if (ee === null)
                  return;
                var ne = ee.tag;
                if (ne === N || ne === j) {
                  b = v = ee;
                  continue e;
                }
                M = M.parentNode;
              }
            }
            b = b.return;
          }
        }
      }
      Xh(function() {
        return fk(e, t, o, v);
      });
    }
    function rv(e, t, o) {
      return {
        instance: e,
        listener: t,
        currentTarget: o
      };
    }
    function dk(e, t, o, i, c, v) {
      for (var y = t !== null ? t + "Capture" : null, b = i ? y : t, w = [], M = e, P = null; M !== null; ) {
        var Q = M, Y = Q.stateNode, ee = Q.tag;
        if (ee === N && Y !== null && (P = Y, b !== null)) {
          var ne = mi(M, b);
          ne != null && w.push(rv(M, ne, P));
        }
        if (c)
          break;
        M = M.return;
      }
      return w;
    }
    function Vm(e, t) {
      for (var o = t + "Capture", i = [], c = e; c !== null; ) {
        var v = c, y = v.stateNode, b = v.tag;
        if (b === N && y !== null) {
          var w = y, M = mi(c, o);
          M != null && i.unshift(rv(c, M, w));
          var P = mi(c, t);
          P != null && i.push(rv(c, P, w));
        }
        c = c.return;
      }
      return i;
    }
    function Qf(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== N);
      return e || null;
    }
    function pk(e, t) {
      for (var o = e, i = t, c = 0, v = o; v; v = Qf(v))
        c++;
      for (var y = 0, b = i; b; b = Qf(b))
        y++;
      for (; c - y > 0; )
        o = Qf(o), c--;
      for (; y - c > 0; )
        i = Qf(i), y--;
      for (var w = c; w--; ) {
        if (o === i || i !== null && o === i.alternate)
          return o;
        o = Qf(o), i = Qf(i);
      }
      return null;
    }
    function NE(e, t, o, i, c) {
      for (var v = t._reactName, y = [], b = o; b !== null && b !== i; ) {
        var w = b, M = w.alternate, P = w.stateNode, Q = w.tag;
        if (M !== null && M === i)
          break;
        if (Q === N && P !== null) {
          var Y = P;
          if (c) {
            var ee = mi(b, v);
            ee != null && y.unshift(rv(b, ee, Y));
          } else if (!c) {
            var ne = mi(b, v);
            ne != null && y.push(rv(b, ne, Y));
          }
        }
        b = b.return;
      }
      y.length !== 0 && e.push({
        event: t,
        listeners: y
      });
    }
    function vk(e, t, o, i, c) {
      var v = i && c ? pk(i, c) : null;
      i !== null && NE(e, t, i, v, !1), c !== null && o !== null && NE(e, o, c, v, !0);
    }
    function hk(e, t) {
      return e + "__bubble";
    }
    var ko = !1, ov = "dangerouslySetInnerHTML", Wm = "suppressContentEditableWarning", Du = "suppressHydrationWarning", AE = "autoFocus", nc = "children", rc = "style", Ym = "__html", Jx, Gm, av, PE, Qm, LE, jE;
    Jx = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Gm = function(e, t) {
      sp(e, t), $c(e, t), Qh(e, t, {
        registrationNameDependencies: Oe,
        possibleRegistrationNames: Me
      });
    }, LE = Qe && !document.documentMode, av = function(e, t, o) {
      if (!ko) {
        var i = Km(o), c = Km(t);
        c !== i && (ko = !0, m("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(c), JSON.stringify(i)));
      }
    }, PE = function(e) {
      if (!ko) {
        ko = !0;
        var t = [];
        e.forEach(function(o) {
          t.push(o);
        }), m("Extra attributes from the server: %s", t);
      }
    }, Qm = function(e, t) {
      t === !1 ? m("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : m("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, jE = function(e, t) {
      var o = e.namespaceURI === Ma ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return o.innerHTML = t, o.innerHTML;
    };
    var mk = /\r\n?/g, gk = /\u0000|\uFFFD/g;
    function Km(e) {
      er(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(mk, `
`).replace(gk, "");
    }
    function qm(e, t, o, i) {
      var c = Km(t), v = Km(e);
      if (v !== c && (i && (ko || (ko = !0, m('Text content did not match. Server: "%s" Client: "%s"', v, c))), o && Ke))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function zE(e) {
      return e.nodeType === Aa ? e : e.ownerDocument;
    }
    function yk() {
    }
    function Xm(e) {
      e.onclick = yk;
    }
    function xk(e, t, o, i, c) {
      for (var v in i)
        if (i.hasOwnProperty(v)) {
          var y = i[v];
          if (v === rc)
            y && Object.freeze(y), Hh(t, y);
          else if (v === ov) {
            var b = y ? y[Ym] : void 0;
            b != null && kh(t, b);
          } else if (v === nc)
            if (typeof y == "string") {
              var w = e !== "textarea" || y !== "";
              w && iu(t, y);
            } else typeof y == "number" && iu(t, "" + y);
          else v === Wm || v === Du || v === AE || (Oe.hasOwnProperty(v) ? y != null && (typeof y != "function" && Qm(v, y), v === "onScroll" && hn("scroll", t)) : y != null && wa(t, v, y, c));
        }
    }
    function Sk(e, t, o, i) {
      for (var c = 0; c < t.length; c += 2) {
        var v = t[c], y = t[c + 1];
        v === rc ? Hh(e, y) : v === ov ? kh(e, y) : v === nc ? iu(e, y) : wa(e, v, y, i);
      }
    }
    function bk(e, t, o, i) {
      var c, v = zE(o), y, b = i;
      if (b === Ma && (b = np(e)), b === Ma) {
        if (c = vi(e, t), !c && e !== e.toLowerCase() && m("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var w = v.createElement("div");
          w.innerHTML = "<script><\/script>";
          var M = w.firstChild;
          y = w.removeChild(M);
        } else if (typeof t.is == "string")
          y = v.createElement(e, {
            is: t.is
          });
        else if (y = v.createElement(e), e === "select") {
          var P = y;
          t.multiple ? P.multiple = !0 : t.size && (P.size = t.size);
        }
      } else
        y = v.createElementNS(b, e);
      return b === Ma && !c && Object.prototype.toString.call(y) === "[object HTMLUnknownElement]" && !re.call(Jx, e) && (Jx[e] = !0, m("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), y;
    }
    function Ck(e, t) {
      return zE(t).createTextNode(e);
    }
    function Ek(e, t, o, i) {
      var c = vi(t, o);
      Gm(t, o);
      var v;
      switch (t) {
        case "dialog":
          hn("cancel", e), hn("close", e), v = o;
          break;
        case "iframe":
        case "object":
        case "embed":
          hn("load", e), v = o;
          break;
        case "video":
        case "audio":
          for (var y = 0; y < tv.length; y++)
            hn(tv[y], e);
          v = o;
          break;
        case "source":
          hn("error", e), v = o;
          break;
        case "img":
        case "image":
        case "link":
          hn("error", e), hn("load", e), v = o;
          break;
        case "details":
          hn("toggle", e), v = o;
          break;
        case "input":
          ka(e, o), v = Nc(e, o), hn("invalid", e);
          break;
        case "option":
          ou(e, o), v = o;
          break;
        case "select":
          Ic(e, o), v = Xd(e, o), hn("invalid", e);
          break;
        case "textarea":
          Jd(e, o), v = Zd(e, o), hn("invalid", e);
          break;
        default:
          v = o;
      }
      switch (Bc(t, v), xk(t, e, i, v, c), t) {
        case "input":
          pi(e), Qd(e, o, !1);
          break;
        case "textarea":
          pi(e), Oh(e);
          break;
        case "option":
          hx(e, o);
          break;
        case "select":
          gx(e, o);
          break;
        default:
          typeof v.onClick == "function" && Xm(e);
          break;
      }
    }
    function wk(e, t, o, i, c) {
      Gm(t, i);
      var v = null, y, b;
      switch (t) {
        case "input":
          y = Nc(e, o), b = Nc(e, i), v = [];
          break;
        case "select":
          y = Xd(e, o), b = Xd(e, i), v = [];
          break;
        case "textarea":
          y = Zd(e, o), b = Zd(e, i), v = [];
          break;
        default:
          y = o, b = i, typeof y.onClick != "function" && typeof b.onClick == "function" && Xm(e);
          break;
      }
      Bc(t, b);
      var w, M, P = null;
      for (w in y)
        if (!(b.hasOwnProperty(w) || !y.hasOwnProperty(w) || y[w] == null))
          if (w === rc) {
            var Q = y[w];
            for (M in Q)
              Q.hasOwnProperty(M) && (P || (P = {}), P[M] = "");
          } else w === ov || w === nc || w === Wm || w === Du || w === AE || (Oe.hasOwnProperty(w) ? v || (v = []) : (v = v || []).push(w, null));
      for (w in b) {
        var Y = b[w], ee = y != null ? y[w] : void 0;
        if (!(!b.hasOwnProperty(w) || Y === ee || Y == null && ee == null))
          if (w === rc)
            if (Y && Object.freeze(Y), ee) {
              for (M in ee)
                ee.hasOwnProperty(M) && (!Y || !Y.hasOwnProperty(M)) && (P || (P = {}), P[M] = "");
              for (M in Y)
                Y.hasOwnProperty(M) && ee[M] !== Y[M] && (P || (P = {}), P[M] = Y[M]);
            } else
              P || (v || (v = []), v.push(w, P)), P = Y;
          else if (w === ov) {
            var ne = Y ? Y[Ym] : void 0, ue = ee ? ee[Ym] : void 0;
            ne != null && ue !== ne && (v = v || []).push(w, ne);
          } else w === nc ? (typeof Y == "string" || typeof Y == "number") && (v = v || []).push(w, "" + Y) : w === Wm || w === Du || (Oe.hasOwnProperty(w) ? (Y != null && (typeof Y != "function" && Qm(w, Y), w === "onScroll" && hn("scroll", e)), !v && ee !== Y && (v = [])) : (v = v || []).push(w, Y));
      }
      return P && (Rx(P, b[rc]), (v = v || []).push(rc, P)), v;
    }
    function Tk(e, t, o, i, c) {
      o === "input" && c.type === "radio" && c.name != null && Ac(e, c);
      var v = vi(o, i), y = vi(o, c);
      switch (Sk(e, t, v, y), o) {
        case "input":
          ru(e, c);
          break;
        case "textarea":
          _h(e, c);
          break;
        case "select":
          yx(e, c);
          break;
      }
    }
    function Rk(e) {
      {
        var t = e.toLowerCase();
        return hs.hasOwnProperty(t) && hs[t] || null;
      }
    }
    function _k(e, t, o, i, c, v, y) {
      var b, w;
      switch (b = vi(t, o), Gm(t, o), t) {
        case "dialog":
          hn("cancel", e), hn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          hn("load", e);
          break;
        case "video":
        case "audio":
          for (var M = 0; M < tv.length; M++)
            hn(tv[M], e);
          break;
        case "source":
          hn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          hn("error", e), hn("load", e);
          break;
        case "details":
          hn("toggle", e);
          break;
        case "input":
          ka(e, o), hn("invalid", e);
          break;
        case "option":
          ou(e, o);
          break;
        case "select":
          Ic(e, o), hn("invalid", e);
          break;
        case "textarea":
          Jd(e, o), hn("invalid", e);
          break;
      }
      Bc(t, o);
      {
        w = /* @__PURE__ */ new Set();
        for (var P = e.attributes, Q = 0; Q < P.length; Q++) {
          var Y = P[Q].name.toLowerCase();
          switch (Y) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              w.add(P[Q].name);
          }
        }
      }
      var ee = null;
      for (var ne in o)
        if (o.hasOwnProperty(ne)) {
          var ue = o[ne];
          if (ne === nc)
            typeof ue == "string" ? e.textContent !== ue && (o[Du] !== !0 && qm(e.textContent, ue, v, y), ee = [nc, ue]) : typeof ue == "number" && e.textContent !== "" + ue && (o[Du] !== !0 && qm(e.textContent, ue, v, y), ee = [nc, "" + ue]);
          else if (Oe.hasOwnProperty(ne))
            ue != null && (typeof ue != "function" && Qm(ne, ue), ne === "onScroll" && hn("scroll", e));
          else if (y && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof b == "boolean") {
            var Ae = void 0, ot = tn(ne);
            if (o[Du] !== !0) {
              if (!(ne === Wm || ne === Du || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              ne === "value" || ne === "checked" || ne === "selected")) {
                if (ne === ov) {
                  var Je = e.innerHTML, Nt = ue ? ue[Ym] : void 0;
                  if (Nt != null) {
                    var Ot = jE(e, Nt);
                    Ot !== Je && av(ne, Je, Ot);
                  }
                } else if (ne === rc) {
                  if (w.delete(ne), LE) {
                    var q = wx(ue);
                    Ae = e.getAttribute("style"), q !== Ae && av(ne, Ae, q);
                  }
                } else if (b)
                  w.delete(ne.toLowerCase()), Ae = ts(e, ne, ue), ue !== Ae && av(ne, Ae, ue);
                else if (!Qn(ne, ot, b) && !Kn(ne, ue, ot, b)) {
                  var se = !1;
                  if (ot !== null)
                    w.delete(ot.attributeName), Ae = tu(e, ne, ue, ot);
                  else {
                    var X = i;
                    if (X === Ma && (X = np(t)), X === Ma)
                      w.delete(ne.toLowerCase());
                    else {
                      var Ce = Rk(ne);
                      Ce !== null && Ce !== ne && (se = !0, w.delete(Ce)), w.delete(ne);
                    }
                    Ae = ts(e, ne, ue);
                  }
                  var He = ie;
                  !He && ue !== Ae && !se && av(ne, Ae, ue);
                }
              }
            }
          }
        }
      switch (y && // $FlowFixMe - Should be inferred as not undefined.
      w.size > 0 && o[Du] !== !0 && PE(w), t) {
        case "input":
          pi(e), Qd(e, o, !0);
          break;
        case "textarea":
          pi(e), Oh(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof o.onClick == "function" && Xm(e);
          break;
      }
      return ee;
    }
    function Ok(e, t, o) {
      var i = e.nodeValue !== t;
      return i;
    }
    function eS(e, t) {
      {
        if (ko)
          return;
        ko = !0, m("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function tS(e, t) {
      {
        if (ko)
          return;
        ko = !0, m('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function nS(e, t, o) {
      {
        if (ko)
          return;
        ko = !0, m("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function rS(e, t) {
      {
        if (t === "" || ko)
          return;
        ko = !0, m('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function Dk(e, t, o) {
      switch (t) {
        case "input":
          Pc(e, o);
          return;
        case "textarea":
          Sx(e, o);
          return;
        case "select":
          xx(e, o);
          return;
      }
    }
    var iv = function() {
    }, lv = function() {
    };
    {
      var kk = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], IE = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], Mk = IE.concat(["button"]), Nk = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], UE = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      lv = function(e, t) {
        var o = Ct({}, e || UE), i = {
          tag: t
        };
        return IE.indexOf(t) !== -1 && (o.aTagInScope = null, o.buttonTagInScope = null, o.nobrTagInScope = null), Mk.indexOf(t) !== -1 && (o.pTagInButtonScope = null), kk.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (o.listItemTagAutoclosing = null, o.dlItemTagAutoclosing = null), o.current = i, t === "form" && (o.formTag = i), t === "a" && (o.aTagInScope = i), t === "button" && (o.buttonTagInScope = i), t === "nobr" && (o.nobrTagInScope = i), t === "p" && (o.pTagInButtonScope = i), t === "li" && (o.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (o.dlItemTagAutoclosing = i), o;
      };
      var Ak = function(e, t) {
        switch (t) {
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          case "option":
            return e === "#text";
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          case "colgroup":
            return e === "col" || e === "template";
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return Nk.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, Pk = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, FE = {};
      iv = function(e, t, o) {
        o = o || UE;
        var i = o.current, c = i && i.tag;
        t != null && (e != null && m("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var v = Ak(e, c) ? null : i, y = v ? null : Pk(e, o), b = v || y;
        if (b) {
          var w = b.tag, M = !!v + "|" + e + "|" + w;
          if (!FE[M]) {
            FE[M] = !0;
            var P = e, Q = "";
            if (e === "#text" ? /\S/.test(t) ? P = "Text nodes" : (P = "Whitespace text nodes", Q = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : P = "<" + e + ">", v) {
              var Y = "";
              w === "table" && e === "tr" && (Y += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), m("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", P, w, Q, Y);
            } else
              m("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", P, w);
          }
        }
      };
    }
    var Zm = "suppressHydrationWarning", Jm = "$", eg = "/$", uv = "$?", sv = "$!", Lk = "style", oS = null, aS = null;
    function jk(e) {
      var t, o, i = e.nodeType;
      switch (i) {
        case Aa:
        case op: {
          t = i === Aa ? "#document" : "#fragment";
          var c = e.documentElement;
          o = c ? c.namespaceURI : rp(null, "");
          break;
        }
        default: {
          var v = i === kn ? e.parentNode : e, y = v.namespaceURI || null;
          t = v.tagName, o = rp(y, t);
          break;
        }
      }
      {
        var b = t.toLowerCase(), w = lv(null, b);
        return {
          namespace: o,
          ancestorInfo: w
        };
      }
    }
    function zk(e, t, o) {
      {
        var i = e, c = rp(i.namespace, t), v = lv(i.ancestorInfo, t);
        return {
          namespace: c,
          ancestorInfo: v
        };
      }
    }
    function A3(e) {
      return e;
    }
    function Ik(e) {
      oS = jn(), aS = ZD();
      var t = null;
      return Vn(!1), t;
    }
    function Uk(e) {
      JD(aS), Vn(oS), oS = null, aS = null;
    }
    function Fk(e, t, o, i, c) {
      var v;
      {
        var y = i;
        if (iv(e, null, y.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var b = "" + t.children, w = lv(y.ancestorInfo, e);
          iv(null, b, w);
        }
        v = y.namespace;
      }
      var M = bk(e, t, o, v);
      return dv(c, M), pS(M, t), M;
    }
    function Bk(e, t) {
      e.appendChild(t);
    }
    function Hk(e, t, o, i, c) {
      switch (Ek(e, t, o, i), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!o.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function $k(e, t, o, i, c, v) {
      {
        var y = v;
        if (typeof i.children != typeof o.children && (typeof i.children == "string" || typeof i.children == "number")) {
          var b = "" + i.children, w = lv(y.ancestorInfo, t);
          iv(null, b, w);
        }
      }
      return wk(e, t, o, i);
    }
    function iS(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function Vk(e, t, o, i) {
      {
        var c = o;
        iv(null, e, c.ancestorInfo);
      }
      var v = Ck(e, t);
      return dv(i, v), v;
    }
    function Wk() {
      var e = window.event;
      return e === void 0 ? Ro : Lf(e.type);
    }
    var lS = typeof setTimeout == "function" ? setTimeout : void 0, Yk = typeof clearTimeout == "function" ? clearTimeout : void 0, uS = -1, BE = typeof Promise == "function" ? Promise : void 0, Gk = typeof queueMicrotask == "function" ? queueMicrotask : typeof BE < "u" ? function(e) {
      return BE.resolve(null).then(e).catch(Qk);
    } : lS;
    function Qk(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function Kk(e, t, o, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          o.autoFocus && e.focus();
          return;
        case "img": {
          o.src && (e.src = o.src);
          return;
        }
      }
    }
    function qk(e, t, o, i, c, v) {
      Tk(e, t, o, i, c), pS(e, c);
    }
    function HE(e) {
      iu(e, "");
    }
    function Xk(e, t, o) {
      e.nodeValue = o;
    }
    function Zk(e, t) {
      e.appendChild(t);
    }
    function Jk(e, t) {
      var o;
      e.nodeType === kn ? (o = e.parentNode, o.insertBefore(t, e)) : (o = e, o.appendChild(t));
      var i = e._reactRootContainer;
      i == null && o.onclick === null && Xm(o);
    }
    function eM(e, t, o) {
      e.insertBefore(t, o);
    }
    function tM(e, t, o) {
      e.nodeType === kn ? e.parentNode.insertBefore(t, o) : e.insertBefore(t, o);
    }
    function nM(e, t) {
      e.removeChild(t);
    }
    function rM(e, t) {
      e.nodeType === kn ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function sS(e, t) {
      var o = t, i = 0;
      do {
        var c = o.nextSibling;
        if (e.removeChild(o), c && c.nodeType === kn) {
          var v = c.data;
          if (v === eg)
            if (i === 0) {
              e.removeChild(c), _l(t);
              return;
            } else
              i--;
          else (v === Jm || v === uv || v === sv) && i++;
        }
        o = c;
      } while (o);
      _l(t);
    }
    function oM(e, t) {
      e.nodeType === kn ? sS(e.parentNode, t) : e.nodeType === Ir && sS(e, t), _l(e);
    }
    function aM(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function iM(e) {
      e.nodeValue = "";
    }
    function lM(e, t) {
      e = e;
      var o = t[Lk], i = o != null && o.hasOwnProperty("display") ? o.display : null;
      e.style.display = Fc("display", i);
    }
    function uM(e, t) {
      e.nodeValue = t;
    }
    function sM(e) {
      e.nodeType === Ir ? e.textContent = "" : e.nodeType === Aa && e.documentElement && e.removeChild(e.documentElement);
    }
    function cM(e, t, o) {
      return e.nodeType !== Ir || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function fM(e, t) {
      return t === "" || e.nodeType !== Na ? null : e;
    }
    function dM(e) {
      return e.nodeType !== kn ? null : e;
    }
    function $E(e) {
      return e.data === uv;
    }
    function cS(e) {
      return e.data === sv;
    }
    function pM(e) {
      var t = e.nextSibling && e.nextSibling.dataset, o, i, c;
      return t && (o = t.dgst, i = t.msg, c = t.stck), {
        message: i,
        digest: o,
        stack: c
      };
    }
    function vM(e, t) {
      e._reactRetry = t;
    }
    function tg(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === Ir || t === Na)
          break;
        if (t === kn) {
          var o = e.data;
          if (o === Jm || o === sv || o === uv)
            break;
          if (o === eg)
            return null;
        }
      }
      return e;
    }
    function cv(e) {
      return tg(e.nextSibling);
    }
    function hM(e) {
      return tg(e.firstChild);
    }
    function mM(e) {
      return tg(e.firstChild);
    }
    function gM(e) {
      return tg(e.nextSibling);
    }
    function yM(e, t, o, i, c, v, y) {
      dv(v, e), pS(e, o);
      var b;
      {
        var w = c;
        b = w.namespace;
      }
      var M = (v.mode & Et) !== rt;
      return _k(e, t, o, b, i, M, y);
    }
    function xM(e, t, o, i) {
      return dv(o, e), o.mode & Et, Ok(e, t);
    }
    function SM(e, t) {
      dv(t, e);
    }
    function bM(e) {
      for (var t = e.nextSibling, o = 0; t; ) {
        if (t.nodeType === kn) {
          var i = t.data;
          if (i === eg) {
            if (o === 0)
              return cv(t);
            o--;
          } else (i === Jm || i === sv || i === uv) && o++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function VE(e) {
      for (var t = e.previousSibling, o = 0; t; ) {
        if (t.nodeType === kn) {
          var i = t.data;
          if (i === Jm || i === sv || i === uv) {
            if (o === 0)
              return t;
            o--;
          } else i === eg && o++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function CM(e) {
      _l(e);
    }
    function EM(e) {
      _l(e);
    }
    function wM(e) {
      return e !== "head" && e !== "body";
    }
    function TM(e, t, o, i) {
      var c = !0;
      qm(t.nodeValue, o, i, c);
    }
    function RM(e, t, o, i, c, v) {
      if (t[Zm] !== !0) {
        var y = !0;
        qm(i.nodeValue, c, v, y);
      }
    }
    function _M(e, t) {
      t.nodeType === Ir ? eS(e, t) : t.nodeType === kn || tS(e, t);
    }
    function OM(e, t) {
      {
        var o = e.parentNode;
        o !== null && (t.nodeType === Ir ? eS(o, t) : t.nodeType === kn || tS(o, t));
      }
    }
    function DM(e, t, o, i, c) {
      (c || t[Zm] !== !0) && (i.nodeType === Ir ? eS(o, i) : i.nodeType === kn || tS(o, i));
    }
    function kM(e, t, o) {
      nS(e, t);
    }
    function MM(e, t) {
      rS(e, t);
    }
    function NM(e, t, o) {
      {
        var i = e.parentNode;
        i !== null && nS(i, t);
      }
    }
    function AM(e, t) {
      {
        var o = e.parentNode;
        o !== null && rS(o, t);
      }
    }
    function PM(e, t, o, i, c, v) {
      (v || t[Zm] !== !0) && nS(o, i);
    }
    function LM(e, t, o, i, c) {
      (c || t[Zm] !== !0) && rS(o, i);
    }
    function jM(e) {
      m("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function zM(e) {
      nv(e);
    }
    var Kf = Math.random().toString(36).slice(2), qf = "__reactFiber$" + Kf, fS = "__reactProps$" + Kf, fv = "__reactContainer$" + Kf, dS = "__reactEvents$" + Kf, IM = "__reactListeners$" + Kf, UM = "__reactHandles$" + Kf;
    function FM(e) {
      delete e[qf], delete e[fS], delete e[dS], delete e[IM], delete e[UM];
    }
    function dv(e, t) {
      t[qf] = e;
    }
    function ng(e, t) {
      t[fv] = e;
    }
    function WE(e) {
      e[fv] = null;
    }
    function pv(e) {
      return !!e[fv];
    }
    function oc(e) {
      var t = e[qf];
      if (t)
        return t;
      for (var o = e.parentNode; o; ) {
        if (t = o[fv] || o[qf], t) {
          var i = t.alternate;
          if (t.child !== null || i !== null && i.child !== null)
            for (var c = VE(e); c !== null; ) {
              var v = c[qf];
              if (v)
                return v;
              c = VE(c);
            }
          return t;
        }
        e = o, o = e.parentNode;
      }
      return null;
    }
    function ku(e) {
      var t = e[qf] || e[fv];
      return t && (t.tag === N || t.tag === j || t.tag === B || t.tag === T) ? t : null;
    }
    function Xf(e) {
      if (e.tag === N || e.tag === j)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function rg(e) {
      return e[fS] || null;
    }
    function pS(e, t) {
      e[fS] = t;
    }
    function BM(e) {
      var t = e[dS];
      return t === void 0 && (t = e[dS] = /* @__PURE__ */ new Set()), t;
    }
    var YE = {}, GE = s.ReactDebugCurrentFrame;
    function og(e) {
      if (e) {
        var t = e._owner, o = nl(e.type, e._source, t ? t.type : null);
        GE.setExtraStackFrame(o);
      } else
        GE.setExtraStackFrame(null);
    }
    function Va(e, t, o, i, c) {
      {
        var v = Function.call.bind(re);
        for (var y in e)
          if (v(e, y)) {
            var b = void 0;
            try {
              if (typeof e[y] != "function") {
                var w = Error((i || "React class") + ": " + o + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw w.name = "Invariant Violation", w;
              }
              b = e[y](t, y, i, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              b = M;
            }
            b && !(b instanceof Error) && (og(c), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", o, y, typeof b), og(null)), b instanceof Error && !(b.message in YE) && (YE[b.message] = !0, og(c), m("Failed %s type: %s", o, b.message), og(null));
          }
      }
    }
    var vS = [], ag;
    ag = [];
    var Al = -1;
    function Mu(e) {
      return {
        current: e
      };
    }
    function Kr(e, t) {
      if (Al < 0) {
        m("Unexpected pop.");
        return;
      }
      t !== ag[Al] && m("Unexpected Fiber popped."), e.current = vS[Al], vS[Al] = null, ag[Al] = null, Al--;
    }
    function qr(e, t, o) {
      Al++, vS[Al] = e.current, ag[Al] = o, e.current = t;
    }
    var hS;
    hS = {};
    var qo = {};
    Object.freeze(qo);
    var Pl = Mu(qo), Pi = Mu(!1), mS = qo;
    function Zf(e, t, o) {
      return o && Li(t) ? mS : Pl.current;
    }
    function QE(e, t, o) {
      {
        var i = e.stateNode;
        i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = o;
      }
    }
    function Jf(e, t) {
      {
        var o = e.type, i = o.contextTypes;
        if (!i)
          return qo;
        var c = e.stateNode;
        if (c && c.__reactInternalMemoizedUnmaskedChildContext === t)
          return c.__reactInternalMemoizedMaskedChildContext;
        var v = {};
        for (var y in i)
          v[y] = t[y];
        {
          var b = yt(e) || "Unknown";
          Va(i, v, "context", b);
        }
        return c && QE(e, t, v), v;
      }
    }
    function ig() {
      return Pi.current;
    }
    function Li(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function lg(e) {
      Kr(Pi, e), Kr(Pl, e);
    }
    function gS(e) {
      Kr(Pi, e), Kr(Pl, e);
    }
    function KE(e, t, o) {
      {
        if (Pl.current !== qo)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        qr(Pl, t, e), qr(Pi, o, e);
      }
    }
    function qE(e, t, o) {
      {
        var i = e.stateNode, c = t.childContextTypes;
        if (typeof i.getChildContext != "function") {
          {
            var v = yt(e) || "Unknown";
            hS[v] || (hS[v] = !0, m("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", v, v));
          }
          return o;
        }
        var y = i.getChildContext();
        for (var b in y)
          if (!(b in c))
            throw new Error((yt(e) || "Unknown") + '.getChildContext(): key "' + b + '" is not defined in childContextTypes.');
        {
          var w = yt(e) || "Unknown";
          Va(c, y, "child context", w);
        }
        return Ct({}, o, y);
      }
    }
    function ug(e) {
      {
        var t = e.stateNode, o = t && t.__reactInternalMemoizedMergedChildContext || qo;
        return mS = Pl.current, qr(Pl, o, e), qr(Pi, Pi.current, e), !0;
      }
    }
    function XE(e, t, o) {
      {
        var i = e.stateNode;
        if (!i)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (o) {
          var c = qE(e, t, mS);
          i.__reactInternalMemoizedMergedChildContext = c, Kr(Pi, e), Kr(Pl, e), qr(Pl, c, e), qr(Pi, o, e);
        } else
          Kr(Pi, e), qr(Pi, o, e);
      }
    }
    function HM(e) {
      {
        if (!pl(e) || e.tag !== E)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case T:
              return t.stateNode.context;
            case E: {
              var o = t.type;
              if (Li(o))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Nu = 0, sg = 1, Ll = null, yS = !1, xS = !1;
    function ZE(e) {
      Ll === null ? Ll = [e] : Ll.push(e);
    }
    function $M(e) {
      yS = !0, ZE(e);
    }
    function JE() {
      yS && Au();
    }
    function Au() {
      if (!xS && Ll !== null) {
        xS = !0;
        var e = 0, t = Oo();
        try {
          var o = !0, i = Ll;
          for (Ln(Er); e < i.length; e++) {
            var c = i[e];
            do
              c = c(o);
            while (c !== null);
          }
          Ll = null, yS = !1;
        } catch (v) {
          throw Ll !== null && (Ll = Ll.slice(e + 1)), mp(Es, Au), v;
        } finally {
          Ln(t), xS = !1;
        }
      }
      return null;
    }
    var ed = [], td = 0, cg = null, fg = 0, ha = [], ma = 0, ac = null, jl = 1, zl = "";
    function VM(e) {
      return lc(), (e.flags & aa) !== nt;
    }
    function WM(e) {
      return lc(), fg;
    }
    function YM() {
      var e = zl, t = jl, o = t & ~GM(t);
      return o.toString(32) + e;
    }
    function ic(e, t) {
      lc(), ed[td++] = fg, ed[td++] = cg, cg = e, fg = t;
    }
    function ew(e, t, o) {
      lc(), ha[ma++] = jl, ha[ma++] = zl, ha[ma++] = ac, ac = e;
      var i = jl, c = zl, v = dg(i) - 1, y = i & ~(1 << v), b = o + 1, w = dg(t) + v;
      if (w > 30) {
        var M = v - v % 5, P = (1 << M) - 1, Q = (y & P).toString(32), Y = y >> M, ee = v - M, ne = dg(t) + ee, ue = b << ee, Ae = ue | Y, ot = Q + c;
        jl = 1 << ne | Ae, zl = ot;
      } else {
        var Je = b << v, Nt = Je | y, Ot = c;
        jl = 1 << w | Nt, zl = Ot;
      }
    }
    function SS(e) {
      lc();
      var t = e.return;
      if (t !== null) {
        var o = 1, i = 0;
        ic(e, o), ew(e, o, i);
      }
    }
    function dg(e) {
      return 32 - An(e);
    }
    function GM(e) {
      return 1 << dg(e) - 1;
    }
    function bS(e) {
      for (; e === cg; )
        cg = ed[--td], ed[td] = null, fg = ed[--td], ed[td] = null;
      for (; e === ac; )
        ac = ha[--ma], ha[ma] = null, zl = ha[--ma], ha[ma] = null, jl = ha[--ma], ha[ma] = null;
    }
    function QM() {
      return lc(), ac !== null ? {
        id: jl,
        overflow: zl
      } : null;
    }
    function KM(e, t) {
      lc(), ha[ma++] = jl, ha[ma++] = zl, ha[ma++] = ac, jl = t.id, zl = t.overflow, ac = e;
    }
    function lc() {
      Or() || m("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var _r = null, ga = null, Wa = !1, uc = !1, Pu = null;
    function qM() {
      Wa && m("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function tw() {
      uc = !0;
    }
    function XM() {
      return uc;
    }
    function ZM(e) {
      var t = e.stateNode.containerInfo;
      return ga = mM(t), _r = e, Wa = !0, Pu = null, uc = !1, !0;
    }
    function JM(e, t, o) {
      return ga = gM(t), _r = e, Wa = !0, Pu = null, uc = !1, o !== null && KM(e, o), !0;
    }
    function nw(e, t) {
      switch (e.tag) {
        case T: {
          _M(e.stateNode.containerInfo, t);
          break;
        }
        case N: {
          var o = (e.mode & Et) !== rt;
          DM(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            o
          );
          break;
        }
        case B: {
          var i = e.memoizedState;
          i.dehydrated !== null && OM(i.dehydrated, t);
          break;
        }
      }
    }
    function rw(e, t) {
      nw(e, t);
      var o = rL();
      o.stateNode = t, o.return = e;
      var i = e.deletions;
      i === null ? (e.deletions = [o], e.flags |= bo) : i.push(o);
    }
    function CS(e, t) {
      {
        if (uc)
          return;
        switch (e.tag) {
          case T: {
            var o = e.stateNode.containerInfo;
            switch (t.tag) {
              case N:
                var i = t.type;
                t.pendingProps, kM(o, i);
                break;
              case j:
                var c = t.pendingProps;
                MM(o, c);
                break;
            }
            break;
          }
          case N: {
            var v = e.type, y = e.memoizedProps, b = e.stateNode;
            switch (t.tag) {
              case N: {
                var w = t.type, M = t.pendingProps, P = (e.mode & Et) !== rt;
                PM(
                  v,
                  y,
                  b,
                  w,
                  M,
                  // TODO: Delete this argument when we remove the legacy root API.
                  P
                );
                break;
              }
              case j: {
                var Q = t.pendingProps, Y = (e.mode & Et) !== rt;
                LM(
                  v,
                  y,
                  b,
                  Q,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Y
                );
                break;
              }
            }
            break;
          }
          case B: {
            var ee = e.memoizedState, ne = ee.dehydrated;
            if (ne !== null) switch (t.tag) {
              case N:
                var ue = t.type;
                t.pendingProps, NM(ne, ue);
                break;
              case j:
                var Ae = t.pendingProps;
                AM(ne, Ae);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function ow(e, t) {
      t.flags = t.flags & -4097 | bn, CS(e, t);
    }
    function aw(e, t) {
      switch (e.tag) {
        case N: {
          var o = e.type;
          e.pendingProps;
          var i = cM(t, o);
          return i !== null ? (e.stateNode = i, _r = e, ga = hM(i), !0) : !1;
        }
        case j: {
          var c = e.pendingProps, v = fM(t, c);
          return v !== null ? (e.stateNode = v, _r = e, ga = null, !0) : !1;
        }
        case B: {
          var y = dM(t);
          if (y !== null) {
            var b = {
              dehydrated: y,
              treeContext: QM(),
              retryLane: io
            };
            e.memoizedState = b;
            var w = oL(y);
            return w.return = e, e.child = w, _r = e, ga = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function ES(e) {
      return (e.mode & Et) !== rt && (e.flags & tt) === nt;
    }
    function wS(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function TS(e) {
      if (Wa) {
        var t = ga;
        if (!t) {
          ES(e) && (CS(_r, e), wS()), ow(_r, e), Wa = !1, _r = e;
          return;
        }
        var o = t;
        if (!aw(e, t)) {
          ES(e) && (CS(_r, e), wS()), t = cv(o);
          var i = _r;
          if (!t || !aw(e, t)) {
            ow(_r, e), Wa = !1, _r = e;
            return;
          }
          rw(i, o);
        }
      }
    }
    function eN(e, t, o) {
      var i = e.stateNode, c = !uc, v = yM(i, e.type, e.memoizedProps, t, o, e, c);
      return e.updateQueue = v, v !== null;
    }
    function tN(e) {
      var t = e.stateNode, o = e.memoizedProps, i = xM(t, o, e);
      if (i) {
        var c = _r;
        if (c !== null)
          switch (c.tag) {
            case T: {
              var v = c.stateNode.containerInfo, y = (c.mode & Et) !== rt;
              TM(
                v,
                t,
                o,
                // TODO: Delete this argument when we remove the legacy root API.
                y
              );
              break;
            }
            case N: {
              var b = c.type, w = c.memoizedProps, M = c.stateNode, P = (c.mode & Et) !== rt;
              RM(
                b,
                w,
                M,
                t,
                o,
                // TODO: Delete this argument when we remove the legacy root API.
                P
              );
              break;
            }
          }
      }
      return i;
    }
    function nN(e) {
      var t = e.memoizedState, o = t !== null ? t.dehydrated : null;
      if (!o)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      SM(o, e);
    }
    function rN(e) {
      var t = e.memoizedState, o = t !== null ? t.dehydrated : null;
      if (!o)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return bM(o);
    }
    function iw(e) {
      for (var t = e.return; t !== null && t.tag !== N && t.tag !== T && t.tag !== B; )
        t = t.return;
      _r = t;
    }
    function pg(e) {
      if (e !== _r)
        return !1;
      if (!Wa)
        return iw(e), Wa = !0, !1;
      if (e.tag !== T && (e.tag !== N || wM(e.type) && !iS(e.type, e.memoizedProps))) {
        var t = ga;
        if (t)
          if (ES(e))
            lw(e), wS();
          else
            for (; t; )
              rw(e, t), t = cv(t);
      }
      return iw(e), e.tag === B ? ga = rN(e) : ga = _r ? cv(e.stateNode) : null, !0;
    }
    function oN() {
      return Wa && ga !== null;
    }
    function lw(e) {
      for (var t = ga; t; )
        nw(e, t), t = cv(t);
    }
    function nd() {
      _r = null, ga = null, Wa = !1, uc = !1;
    }
    function uw() {
      Pu !== null && (tR(Pu), Pu = null);
    }
    function Or() {
      return Wa;
    }
    function RS(e) {
      Pu === null ? Pu = [e] : Pu.push(e);
    }
    var aN = s.ReactCurrentBatchConfig, iN = null;
    function lN() {
      return aN.transition;
    }
    var Ya = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var uN = function(e) {
        for (var t = null, o = e; o !== null; )
          o.mode & Qt && (t = o), o = o.return;
        return t;
      }, sc = function(e) {
        var t = [];
        return e.forEach(function(o) {
          t.push(o);
        }), t.sort().join(", ");
      }, vv = [], hv = [], mv = [], gv = [], yv = [], xv = [], cc = /* @__PURE__ */ new Set();
      Ya.recordUnsafeLifecycleWarnings = function(e, t) {
        cc.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && vv.push(e), e.mode & Qt && typeof t.UNSAFE_componentWillMount == "function" && hv.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && mv.push(e), e.mode & Qt && typeof t.UNSAFE_componentWillReceiveProps == "function" && gv.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && yv.push(e), e.mode & Qt && typeof t.UNSAFE_componentWillUpdate == "function" && xv.push(e));
      }, Ya.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        vv.length > 0 && (vv.forEach(function(Y) {
          e.add(yt(Y) || "Component"), cc.add(Y.type);
        }), vv = []);
        var t = /* @__PURE__ */ new Set();
        hv.length > 0 && (hv.forEach(function(Y) {
          t.add(yt(Y) || "Component"), cc.add(Y.type);
        }), hv = []);
        var o = /* @__PURE__ */ new Set();
        mv.length > 0 && (mv.forEach(function(Y) {
          o.add(yt(Y) || "Component"), cc.add(Y.type);
        }), mv = []);
        var i = /* @__PURE__ */ new Set();
        gv.length > 0 && (gv.forEach(function(Y) {
          i.add(yt(Y) || "Component"), cc.add(Y.type);
        }), gv = []);
        var c = /* @__PURE__ */ new Set();
        yv.length > 0 && (yv.forEach(function(Y) {
          c.add(yt(Y) || "Component"), cc.add(Y.type);
        }), yv = []);
        var v = /* @__PURE__ */ new Set();
        if (xv.length > 0 && (xv.forEach(function(Y) {
          v.add(yt(Y) || "Component"), cc.add(Y.type);
        }), xv = []), t.size > 0) {
          var y = sc(t);
          m(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, y);
        }
        if (i.size > 0) {
          var b = sc(i);
          m(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, b);
        }
        if (v.size > 0) {
          var w = sc(v);
          m(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, w);
        }
        if (e.size > 0) {
          var M = sc(e);
          h(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (o.size > 0) {
          var P = sc(o);
          h(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, P);
        }
        if (c.size > 0) {
          var Q = sc(c);
          h(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Q);
        }
      };
      var vg = /* @__PURE__ */ new Map(), sw = /* @__PURE__ */ new Set();
      Ya.recordLegacyContextWarning = function(e, t) {
        var o = uN(e);
        if (o === null) {
          m("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!sw.has(e.type)) {
          var i = vg.get(o);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], vg.set(o, i)), i.push(e));
        }
      }, Ya.flushLegacyContextWarning = function() {
        vg.forEach(function(e, t) {
          if (e.length !== 0) {
            var o = e[0], i = /* @__PURE__ */ new Set();
            e.forEach(function(v) {
              i.add(yt(v) || "Component"), sw.add(v.type);
            });
            var c = sc(i);
            try {
              rn(o), m(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c);
            } finally {
              gn();
            }
          }
        });
      }, Ya.discardPendingWarnings = function() {
        vv = [], hv = [], mv = [], gv = [], yv = [], xv = [], vg = /* @__PURE__ */ new Map();
      };
    }
    var _S, OS, DS, kS, MS, cw = function(e, t) {
    };
    _S = !1, OS = !1, DS = {}, kS = {}, MS = {}, cw = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var o = yt(t) || "Component";
        kS[o] || (kS[o] = !0, m('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function sN(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function Sv(e, t, o) {
      var i = o.ref;
      if (i !== null && typeof i != "function" && typeof i != "object") {
        if ((e.mode & Qt || we) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(o._owner && o._self && o._owner.stateNode !== o._self) && // Will already throw with "Function components cannot have string refs"
        !(o._owner && o._owner.tag !== E) && // Will already warn with "Function components cannot be given refs"
        !(typeof o.type == "function" && !sN(o.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        o._owner) {
          var c = yt(e) || "Component";
          DS[c] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c, i), DS[c] = !0);
        }
        if (o._owner) {
          var v = o._owner, y;
          if (v) {
            var b = v;
            if (b.tag !== E)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            y = b.stateNode;
          }
          if (!y)
            throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
          var w = y;
          Gn(i, "ref");
          var M = "" + i;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === M)
            return t.ref;
          var P = function(Q) {
            var Y = w.refs;
            Q === null ? delete Y[M] : Y[M] = Q;
          };
          return P._stringRef = M, P;
        } else {
          if (typeof i != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!o._owner)
            throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return i;
    }
    function hg(e, t) {
      var o = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (o === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : o) + "). If you meant to render a collection of children, use an array instead.");
    }
    function mg(e) {
      {
        var t = yt(e) || "Component";
        if (MS[t])
          return;
        MS[t] = !0, m("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function fw(e) {
      var t = e._payload, o = e._init;
      return o(t);
    }
    function dw(e) {
      function t(q, se) {
        if (e) {
          var X = q.deletions;
          X === null ? (q.deletions = [se], q.flags |= bo) : X.push(se);
        }
      }
      function o(q, se) {
        if (!e)
          return null;
        for (var X = se; X !== null; )
          t(q, X), X = X.sibling;
        return null;
      }
      function i(q, se) {
        for (var X = /* @__PURE__ */ new Map(), Ce = se; Ce !== null; )
          Ce.key !== null ? X.set(Ce.key, Ce) : X.set(Ce.index, Ce), Ce = Ce.sibling;
        return X;
      }
      function c(q, se) {
        var X = xc(q, se);
        return X.index = 0, X.sibling = null, X;
      }
      function v(q, se, X) {
        if (q.index = X, !e)
          return q.flags |= aa, se;
        var Ce = q.alternate;
        if (Ce !== null) {
          var He = Ce.index;
          return He < se ? (q.flags |= bn, se) : He;
        } else
          return q.flags |= bn, se;
      }
      function y(q) {
        return e && q.alternate === null && (q.flags |= bn), q;
      }
      function b(q, se, X, Ce) {
        if (se === null || se.tag !== j) {
          var He = R0(X, q.mode, Ce);
          return He.return = q, He;
        } else {
          var ze = c(se, X);
          return ze.return = q, ze;
        }
      }
      function w(q, se, X, Ce) {
        var He = X.type;
        if (He === ui)
          return P(q, se, X.props.children, Ce, X.key);
        if (se !== null && (se.elementType === He || // Keep this check inline so it only runs on the false path:
        gR(se, X) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof He == "object" && He !== null && He.$$typeof === ht && fw(He) === se.type)) {
          var ze = c(se, X.props);
          return ze.ref = Sv(q, se, X), ze.return = q, ze._debugSource = X._source, ze._debugOwner = X._owner, ze;
        }
        var ct = T0(X, q.mode, Ce);
        return ct.ref = Sv(q, se, X), ct.return = q, ct;
      }
      function M(q, se, X, Ce) {
        if (se === null || se.tag !== O || se.stateNode.containerInfo !== X.containerInfo || se.stateNode.implementation !== X.implementation) {
          var He = _0(X, q.mode, Ce);
          return He.return = q, He;
        } else {
          var ze = c(se, X.children || []);
          return ze.return = q, ze;
        }
      }
      function P(q, se, X, Ce, He) {
        if (se === null || se.tag !== k) {
          var ze = Wu(X, q.mode, Ce, He);
          return ze.return = q, ze;
        } else {
          var ct = c(se, X);
          return ct.return = q, ct;
        }
      }
      function Q(q, se, X) {
        if (typeof se == "string" && se !== "" || typeof se == "number") {
          var Ce = R0("" + se, q.mode, X);
          return Ce.return = q, Ce;
        }
        if (typeof se == "object" && se !== null) {
          switch (se.$$typeof) {
            case Fo: {
              var He = T0(se, q.mode, X);
              return He.ref = Sv(q, null, se), He.return = q, He;
            }
            case jr: {
              var ze = _0(se, q.mode, X);
              return ze.return = q, ze;
            }
            case ht: {
              var ct = se._payload, pt = se._init;
              return Q(q, pt(ct), X);
            }
          }
          if (rr(se) || bt(se)) {
            var qt = Wu(se, q.mode, X, null);
            return qt.return = q, qt;
          }
          hg(q, se);
        }
        return typeof se == "function" && mg(q), null;
      }
      function Y(q, se, X, Ce) {
        var He = se !== null ? se.key : null;
        if (typeof X == "string" && X !== "" || typeof X == "number")
          return He !== null ? null : b(q, se, "" + X, Ce);
        if (typeof X == "object" && X !== null) {
          switch (X.$$typeof) {
            case Fo:
              return X.key === He ? w(q, se, X, Ce) : null;
            case jr:
              return X.key === He ? M(q, se, X, Ce) : null;
            case ht: {
              var ze = X._payload, ct = X._init;
              return Y(q, se, ct(ze), Ce);
            }
          }
          if (rr(X) || bt(X))
            return He !== null ? null : P(q, se, X, Ce, null);
          hg(q, X);
        }
        return typeof X == "function" && mg(q), null;
      }
      function ee(q, se, X, Ce, He) {
        if (typeof Ce == "string" && Ce !== "" || typeof Ce == "number") {
          var ze = q.get(X) || null;
          return b(se, ze, "" + Ce, He);
        }
        if (typeof Ce == "object" && Ce !== null) {
          switch (Ce.$$typeof) {
            case Fo: {
              var ct = q.get(Ce.key === null ? X : Ce.key) || null;
              return w(se, ct, Ce, He);
            }
            case jr: {
              var pt = q.get(Ce.key === null ? X : Ce.key) || null;
              return M(se, pt, Ce, He);
            }
            case ht:
              var qt = Ce._payload, It = Ce._init;
              return ee(q, se, X, It(qt), He);
          }
          if (rr(Ce) || bt(Ce)) {
            var Wn = q.get(X) || null;
            return P(se, Wn, Ce, He, null);
          }
          hg(se, Ce);
        }
        return typeof Ce == "function" && mg(se), null;
      }
      function ne(q, se, X) {
        {
          if (typeof q != "object" || q === null)
            return se;
          switch (q.$$typeof) {
            case Fo:
            case jr:
              cw(q, X);
              var Ce = q.key;
              if (typeof Ce != "string")
                break;
              if (se === null) {
                se = /* @__PURE__ */ new Set(), se.add(Ce);
                break;
              }
              if (!se.has(Ce)) {
                se.add(Ce);
                break;
              }
              m("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Ce);
              break;
            case ht:
              var He = q._payload, ze = q._init;
              ne(ze(He), se, X);
              break;
          }
        }
        return se;
      }
      function ue(q, se, X, Ce) {
        for (var He = null, ze = 0; ze < X.length; ze++) {
          var ct = X[ze];
          He = ne(ct, He, q);
        }
        for (var pt = null, qt = null, It = se, Wn = 0, Ut = 0, In = null; It !== null && Ut < X.length; Ut++) {
          It.index > Ut ? (In = It, It = null) : In = It.sibling;
          var Zr = Y(q, It, X[Ut], Ce);
          if (Zr === null) {
            It === null && (It = In);
            break;
          }
          e && It && Zr.alternate === null && t(q, It), Wn = v(Zr, Wn, Ut), qt === null ? pt = Zr : qt.sibling = Zr, qt = Zr, It = In;
        }
        if (Ut === X.length) {
          if (o(q, It), Or()) {
            var Lr = Ut;
            ic(q, Lr);
          }
          return pt;
        }
        if (It === null) {
          for (; Ut < X.length; Ut++) {
            var Zo = Q(q, X[Ut], Ce);
            Zo !== null && (Wn = v(Zo, Wn, Ut), qt === null ? pt = Zo : qt.sibling = Zo, qt = Zo);
          }
          if (Or()) {
            var po = Ut;
            ic(q, po);
          }
          return pt;
        }
        for (var vo = i(q, It); Ut < X.length; Ut++) {
          var Jr = ee(vo, q, Ut, X[Ut], Ce);
          Jr !== null && (e && Jr.alternate !== null && vo.delete(Jr.key === null ? Ut : Jr.key), Wn = v(Jr, Wn, Ut), qt === null ? pt = Jr : qt.sibling = Jr, qt = Jr);
        }
        if (e && vo.forEach(function(bd) {
          return t(q, bd);
        }), Or()) {
          var Vl = Ut;
          ic(q, Vl);
        }
        return pt;
      }
      function Ae(q, se, X, Ce) {
        var He = bt(X);
        if (typeof He != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          X[Symbol.toStringTag] === "Generator" && (OS || m("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), OS = !0), X.entries === He && (_S || m("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), _S = !0);
          var ze = He.call(X);
          if (ze)
            for (var ct = null, pt = ze.next(); !pt.done; pt = ze.next()) {
              var qt = pt.value;
              ct = ne(qt, ct, q);
            }
        }
        var It = He.call(X);
        if (It == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Wn = null, Ut = null, In = se, Zr = 0, Lr = 0, Zo = null, po = It.next(); In !== null && !po.done; Lr++, po = It.next()) {
          In.index > Lr ? (Zo = In, In = null) : Zo = In.sibling;
          var vo = Y(q, In, po.value, Ce);
          if (vo === null) {
            In === null && (In = Zo);
            break;
          }
          e && In && vo.alternate === null && t(q, In), Zr = v(vo, Zr, Lr), Ut === null ? Wn = vo : Ut.sibling = vo, Ut = vo, In = Zo;
        }
        if (po.done) {
          if (o(q, In), Or()) {
            var Jr = Lr;
            ic(q, Jr);
          }
          return Wn;
        }
        if (In === null) {
          for (; !po.done; Lr++, po = It.next()) {
            var Vl = Q(q, po.value, Ce);
            Vl !== null && (Zr = v(Vl, Zr, Lr), Ut === null ? Wn = Vl : Ut.sibling = Vl, Ut = Vl);
          }
          if (Or()) {
            var bd = Lr;
            ic(q, bd);
          }
          return Wn;
        }
        for (var Zv = i(q, In); !po.done; Lr++, po = It.next()) {
          var $i = ee(Zv, q, Lr, po.value, Ce);
          $i !== null && (e && $i.alternate !== null && Zv.delete($i.key === null ? Lr : $i.key), Zr = v($i, Zr, Lr), Ut === null ? Wn = $i : Ut.sibling = $i, Ut = $i);
        }
        if (e && Zv.forEach(function(LL) {
          return t(q, LL);
        }), Or()) {
          var PL = Lr;
          ic(q, PL);
        }
        return Wn;
      }
      function ot(q, se, X, Ce) {
        if (se !== null && se.tag === j) {
          o(q, se.sibling);
          var He = c(se, X);
          return He.return = q, He;
        }
        o(q, se);
        var ze = R0(X, q.mode, Ce);
        return ze.return = q, ze;
      }
      function Je(q, se, X, Ce) {
        for (var He = X.key, ze = se; ze !== null; ) {
          if (ze.key === He) {
            var ct = X.type;
            if (ct === ui) {
              if (ze.tag === k) {
                o(q, ze.sibling);
                var pt = c(ze, X.props.children);
                return pt.return = q, pt._debugSource = X._source, pt._debugOwner = X._owner, pt;
              }
            } else if (ze.elementType === ct || // Keep this check inline so it only runs on the false path:
            gR(ze, X) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof ct == "object" && ct !== null && ct.$$typeof === ht && fw(ct) === ze.type) {
              o(q, ze.sibling);
              var qt = c(ze, X.props);
              return qt.ref = Sv(q, ze, X), qt.return = q, qt._debugSource = X._source, qt._debugOwner = X._owner, qt;
            }
            o(q, ze);
            break;
          } else
            t(q, ze);
          ze = ze.sibling;
        }
        if (X.type === ui) {
          var It = Wu(X.props.children, q.mode, Ce, X.key);
          return It.return = q, It;
        } else {
          var Wn = T0(X, q.mode, Ce);
          return Wn.ref = Sv(q, se, X), Wn.return = q, Wn;
        }
      }
      function Nt(q, se, X, Ce) {
        for (var He = X.key, ze = se; ze !== null; ) {
          if (ze.key === He)
            if (ze.tag === O && ze.stateNode.containerInfo === X.containerInfo && ze.stateNode.implementation === X.implementation) {
              o(q, ze.sibling);
              var ct = c(ze, X.children || []);
              return ct.return = q, ct;
            } else {
              o(q, ze);
              break;
            }
          else
            t(q, ze);
          ze = ze.sibling;
        }
        var pt = _0(X, q.mode, Ce);
        return pt.return = q, pt;
      }
      function Ot(q, se, X, Ce) {
        var He = typeof X == "object" && X !== null && X.type === ui && X.key === null;
        if (He && (X = X.props.children), typeof X == "object" && X !== null) {
          switch (X.$$typeof) {
            case Fo:
              return y(Je(q, se, X, Ce));
            case jr:
              return y(Nt(q, se, X, Ce));
            case ht:
              var ze = X._payload, ct = X._init;
              return Ot(q, se, ct(ze), Ce);
          }
          if (rr(X))
            return ue(q, se, X, Ce);
          if (bt(X))
            return Ae(q, se, X, Ce);
          hg(q, X);
        }
        return typeof X == "string" && X !== "" || typeof X == "number" ? y(ot(q, se, "" + X, Ce)) : (typeof X == "function" && mg(q), o(q, se));
      }
      return Ot;
    }
    var rd = dw(!0), pw = dw(!1);
    function cN(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var o = t.child, i = xc(o, o.pendingProps);
        for (t.child = i, i.return = t; o.sibling !== null; )
          o = o.sibling, i = i.sibling = xc(o, o.pendingProps), i.return = t;
        i.sibling = null;
      }
    }
    function fN(e, t) {
      for (var o = e.child; o !== null; )
        ZP(o, t), o = o.sibling;
    }
    var NS = Mu(null), AS;
    AS = {};
    var gg = null, od = null, PS = null, yg = !1;
    function xg() {
      gg = null, od = null, PS = null, yg = !1;
    }
    function vw() {
      yg = !0;
    }
    function hw() {
      yg = !1;
    }
    function mw(e, t, o) {
      qr(NS, t._currentValue, e), t._currentValue = o, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== AS && m("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = AS;
    }
    function LS(e, t) {
      var o = NS.current;
      Kr(NS, t), e._currentValue = o;
    }
    function jS(e, t, o) {
      for (var i = e; i !== null; ) {
        var c = i.alternate;
        if (Rl(i.childLanes, t) ? c !== null && !Rl(c.childLanes, t) && (c.childLanes = xt(c.childLanes, t)) : (i.childLanes = xt(i.childLanes, t), c !== null && (c.childLanes = xt(c.childLanes, t))), i === o)
          break;
        i = i.return;
      }
      i !== o && m("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function dN(e, t, o) {
      pN(e, t, o);
    }
    function pN(e, t, o) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var c = void 0, v = i.dependencies;
        if (v !== null) {
          c = i.child;
          for (var y = v.firstContext; y !== null; ) {
            if (y.context === t) {
              if (i.tag === E) {
                var b = zs(o), w = Il(Jt, b);
                w.tag = bg;
                var M = i.updateQueue;
                if (M !== null) {
                  var P = M.shared, Q = P.pending;
                  Q === null ? w.next = w : (w.next = Q.next, Q.next = w), P.pending = w;
                }
              }
              i.lanes = xt(i.lanes, o);
              var Y = i.alternate;
              Y !== null && (Y.lanes = xt(Y.lanes, o)), jS(i.return, o, e), v.lanes = xt(v.lanes, o);
              break;
            }
            y = y.next;
          }
        } else if (i.tag === F)
          c = i.type === e.type ? null : i.child;
        else if (i.tag === me) {
          var ee = i.return;
          if (ee === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          ee.lanes = xt(ee.lanes, o);
          var ne = ee.alternate;
          ne !== null && (ne.lanes = xt(ne.lanes, o)), jS(ee, o, e), c = i.sibling;
        } else
          c = i.child;
        if (c !== null)
          c.return = i;
        else
          for (c = i; c !== null; ) {
            if (c === e) {
              c = null;
              break;
            }
            var ue = c.sibling;
            if (ue !== null) {
              ue.return = c.return, c = ue;
              break;
            }
            c = c.return;
          }
        i = c;
      }
    }
    function ad(e, t) {
      gg = e, od = null, PS = null;
      var o = e.dependencies;
      if (o !== null) {
        var i = o.firstContext;
        i !== null && (Wr(o.lanes, t) && Lv(), o.firstContext = null);
      }
    }
    function Jn(e) {
      yg && m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (PS !== e) {
        var o = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (od === null) {
          if (gg === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          od = o, gg.dependencies = {
            lanes: he,
            firstContext: o
          };
        } else
          od = od.next = o;
      }
      return t;
    }
    var fc = null;
    function zS(e) {
      fc === null ? fc = [e] : fc.push(e);
    }
    function vN() {
      if (fc !== null) {
        for (var e = 0; e < fc.length; e++) {
          var t = fc[e], o = t.interleaved;
          if (o !== null) {
            t.interleaved = null;
            var i = o.next, c = t.pending;
            if (c !== null) {
              var v = c.next;
              c.next = i, o.next = v;
            }
            t.pending = o;
          }
        }
        fc = null;
      }
    }
    function gw(e, t, o, i) {
      var c = t.interleaved;
      return c === null ? (o.next = o, zS(t)) : (o.next = c.next, c.next = o), t.interleaved = o, Sg(e, i);
    }
    function hN(e, t, o, i) {
      var c = t.interleaved;
      c === null ? (o.next = o, zS(t)) : (o.next = c.next, c.next = o), t.interleaved = o;
    }
    function mN(e, t, o, i) {
      var c = t.interleaved;
      return c === null ? (o.next = o, zS(t)) : (o.next = c.next, c.next = o), t.interleaved = o, Sg(e, i);
    }
    function Mo(e, t) {
      return Sg(e, t);
    }
    var gN = Sg;
    function Sg(e, t) {
      e.lanes = xt(e.lanes, t);
      var o = e.alternate;
      o !== null && (o.lanes = xt(o.lanes, t)), o === null && (e.flags & (bn | Co)) !== nt && pR(e);
      for (var i = e, c = e.return; c !== null; )
        c.childLanes = xt(c.childLanes, t), o = c.alternate, o !== null ? o.childLanes = xt(o.childLanes, t) : (c.flags & (bn | Co)) !== nt && pR(e), i = c, c = c.return;
      if (i.tag === T) {
        var v = i.stateNode;
        return v;
      } else
        return null;
    }
    var yw = 0, xw = 1, bg = 2, IS = 3, Cg = !1, US, Eg;
    US = !1, Eg = null;
    function FS(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: he
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function Sw(e, t) {
      var o = t.updateQueue, i = e.updateQueue;
      if (o === i) {
        var c = {
          baseState: i.baseState,
          firstBaseUpdate: i.firstBaseUpdate,
          lastBaseUpdate: i.lastBaseUpdate,
          shared: i.shared,
          effects: i.effects
        };
        t.updateQueue = c;
      }
    }
    function Il(e, t) {
      var o = {
        eventTime: e,
        lane: t,
        tag: yw,
        payload: null,
        callback: null,
        next: null
      };
      return o;
    }
    function Lu(e, t, o) {
      var i = e.updateQueue;
      if (i === null)
        return null;
      var c = i.shared;
      if (Eg === c && !US && (m("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), US = !0), hP()) {
        var v = c.pending;
        return v === null ? t.next = t : (t.next = v.next, v.next = t), c.pending = t, gN(e, o);
      } else
        return mN(e, c, t, o);
    }
    function wg(e, t, o) {
      var i = t.updateQueue;
      if (i !== null) {
        var c = i.shared;
        if (Ap(o)) {
          var v = c.lanes;
          v = Lp(v, e.pendingLanes);
          var y = xt(v, o);
          c.lanes = y, Mf(e, y);
        }
      }
    }
    function BS(e, t) {
      var o = e.updateQueue, i = e.alternate;
      if (i !== null) {
        var c = i.updateQueue;
        if (o === c) {
          var v = null, y = null, b = o.firstBaseUpdate;
          if (b !== null) {
            var w = b;
            do {
              var M = {
                eventTime: w.eventTime,
                lane: w.lane,
                tag: w.tag,
                payload: w.payload,
                callback: w.callback,
                next: null
              };
              y === null ? v = y = M : (y.next = M, y = M), w = w.next;
            } while (w !== null);
            y === null ? v = y = t : (y.next = t, y = t);
          } else
            v = y = t;
          o = {
            baseState: c.baseState,
            firstBaseUpdate: v,
            lastBaseUpdate: y,
            shared: c.shared,
            effects: c.effects
          }, e.updateQueue = o;
          return;
        }
      }
      var P = o.lastBaseUpdate;
      P === null ? o.firstBaseUpdate = t : P.next = t, o.lastBaseUpdate = t;
    }
    function yN(e, t, o, i, c, v) {
      switch (o.tag) {
        case xw: {
          var y = o.payload;
          if (typeof y == "function") {
            vw();
            var b = y.call(v, i, c);
            {
              if (e.mode & Qt) {
                pn(!0);
                try {
                  y.call(v, i, c);
                } finally {
                  pn(!1);
                }
              }
              hw();
            }
            return b;
          }
          return y;
        }
        case IS:
          e.flags = e.flags & -65537 | tt;
        case yw: {
          var w = o.payload, M;
          if (typeof w == "function") {
            vw(), M = w.call(v, i, c);
            {
              if (e.mode & Qt) {
                pn(!0);
                try {
                  w.call(v, i, c);
                } finally {
                  pn(!1);
                }
              }
              hw();
            }
          } else
            M = w;
          return M == null ? i : Ct({}, i, M);
        }
        case bg:
          return Cg = !0, i;
      }
      return i;
    }
    function Tg(e, t, o, i) {
      var c = e.updateQueue;
      Cg = !1, Eg = c.shared;
      var v = c.firstBaseUpdate, y = c.lastBaseUpdate, b = c.shared.pending;
      if (b !== null) {
        c.shared.pending = null;
        var w = b, M = w.next;
        w.next = null, y === null ? v = M : y.next = M, y = w;
        var P = e.alternate;
        if (P !== null) {
          var Q = P.updateQueue, Y = Q.lastBaseUpdate;
          Y !== y && (Y === null ? Q.firstBaseUpdate = M : Y.next = M, Q.lastBaseUpdate = w);
        }
      }
      if (v !== null) {
        var ee = c.baseState, ne = he, ue = null, Ae = null, ot = null, Je = v;
        do {
          var Nt = Je.lane, Ot = Je.eventTime;
          if (Rl(i, Nt)) {
            if (ot !== null) {
              var se = {
                eventTime: Ot,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Pt,
                tag: Je.tag,
                payload: Je.payload,
                callback: Je.callback,
                next: null
              };
              ot = ot.next = se;
            }
            ee = yN(e, c, Je, ee, t, o);
            var X = Je.callback;
            if (X !== null && // If the update was already committed, we should not queue its
            // callback again.
            Je.lane !== Pt) {
              e.flags |= nn;
              var Ce = c.effects;
              Ce === null ? c.effects = [Je] : Ce.push(Je);
            }
          } else {
            var q = {
              eventTime: Ot,
              lane: Nt,
              tag: Je.tag,
              payload: Je.payload,
              callback: Je.callback,
              next: null
            };
            ot === null ? (Ae = ot = q, ue = ee) : ot = ot.next = q, ne = xt(ne, Nt);
          }
          if (Je = Je.next, Je === null) {
            if (b = c.shared.pending, b === null)
              break;
            var He = b, ze = He.next;
            He.next = null, Je = ze, c.lastBaseUpdate = He, c.shared.pending = null;
          }
        } while (!0);
        ot === null && (ue = ee), c.baseState = ue, c.firstBaseUpdate = Ae, c.lastBaseUpdate = ot;
        var ct = c.shared.interleaved;
        if (ct !== null) {
          var pt = ct;
          do
            ne = xt(ne, pt.lane), pt = pt.next;
          while (pt !== ct);
        } else v === null && (c.shared.lanes = he);
        Gv(ne), e.lanes = ne, e.memoizedState = ee;
      }
      Eg = null;
    }
    function xN(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function bw() {
      Cg = !1;
    }
    function Rg() {
      return Cg;
    }
    function Cw(e, t, o) {
      var i = t.effects;
      if (t.effects = null, i !== null)
        for (var c = 0; c < i.length; c++) {
          var v = i[c], y = v.callback;
          y !== null && (v.callback = null, xN(y, o));
        }
    }
    var bv = {}, ju = Mu(bv), Cv = Mu(bv), _g = Mu(bv);
    function Og(e) {
      if (e === bv)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function Ew() {
      var e = Og(_g.current);
      return e;
    }
    function HS(e, t) {
      qr(_g, t, e), qr(Cv, e, e), qr(ju, bv, e);
      var o = jk(t);
      Kr(ju, e), qr(ju, o, e);
    }
    function id(e) {
      Kr(ju, e), Kr(Cv, e), Kr(_g, e);
    }
    function $S() {
      var e = Og(ju.current);
      return e;
    }
    function ww(e) {
      Og(_g.current);
      var t = Og(ju.current), o = zk(t, e.type);
      t !== o && (qr(Cv, e, e), qr(ju, o, e));
    }
    function VS(e) {
      Cv.current === e && (Kr(ju, e), Kr(Cv, e));
    }
    var SN = 0, Tw = 1, Rw = 1, Ev = 2, Ga = Mu(SN);
    function WS(e, t) {
      return (e & t) !== 0;
    }
    function ld(e) {
      return e & Tw;
    }
    function YS(e, t) {
      return e & Tw | t;
    }
    function bN(e, t) {
      return e | t;
    }
    function zu(e, t) {
      qr(Ga, t, e);
    }
    function ud(e) {
      Kr(Ga, e);
    }
    function CN(e, t) {
      var o = e.memoizedState;
      return o !== null ? o.dehydrated !== null : (e.memoizedProps, !0);
    }
    function Dg(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === B) {
          var o = t.memoizedState;
          if (o !== null) {
            var i = o.dehydrated;
            if (i === null || $E(i) || cS(i))
              return t;
          }
        } else if (t.tag === Te && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var c = (t.flags & tt) !== nt;
          if (c)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var No = (
      /*   */
      0
    ), ur = (
      /* */
      1
    ), ji = (
      /*  */
      2
    ), sr = (
      /*    */
      4
    ), Dr = (
      /*   */
      8
    ), GS = [];
    function QS() {
      for (var e = 0; e < GS.length; e++) {
        var t = GS[e];
        t._workInProgressVersionPrimary = null;
      }
      GS.length = 0;
    }
    function EN(e, t) {
      var o = t._getVersion, i = o(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
    }
    var Be = s.ReactCurrentDispatcher, wv = s.ReactCurrentBatchConfig, KS, sd;
    KS = /* @__PURE__ */ new Set();
    var dc = he, Kt = null, cr = null, fr = null, kg = !1, Tv = !1, Rv = 0, wN = 0, TN = 25, fe = null, ya = null, Iu = -1, qS = !1;
    function Bt() {
      {
        var e = fe;
        ya === null ? ya = [e] : ya.push(e);
      }
    }
    function De() {
      {
        var e = fe;
        ya !== null && (Iu++, ya[Iu] !== e && RN(e));
      }
    }
    function cd(e) {
      e != null && !rr(e) && m("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", fe, typeof e);
    }
    function RN(e) {
      {
        var t = yt(Kt);
        if (!KS.has(t) && (KS.add(t), ya !== null)) {
          for (var o = "", i = 30, c = 0; c <= Iu; c++) {
            for (var v = ya[c], y = c === Iu ? e : v, b = c + 1 + ". " + v; b.length < i; )
              b += " ";
            b += y + `
`, o += b;
          }
          m(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, o);
        }
      }
    }
    function Xr() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function XS(e, t) {
      if (qS)
        return !1;
      if (t === null)
        return m("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", fe), !1;
      e.length !== t.length && m(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, fe, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var o = 0; o < t.length && o < e.length; o++)
        if (!Se(e[o], t[o]))
          return !1;
      return !0;
    }
    function fd(e, t, o, i, c, v) {
      dc = v, Kt = t, ya = e !== null ? e._debugHookTypes : null, Iu = -1, qS = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = he, e !== null && e.memoizedState !== null ? Be.current = Qw : ya !== null ? Be.current = Gw : Be.current = Yw;
      var y = o(i, c);
      if (Tv) {
        var b = 0;
        do {
          if (Tv = !1, Rv = 0, b >= TN)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          b += 1, qS = !1, cr = null, fr = null, t.updateQueue = null, Iu = -1, Be.current = Kw, y = o(i, c);
        } while (Tv);
      }
      Be.current = $g, t._debugHookTypes = ya;
      var w = cr !== null && cr.next !== null;
      if (dc = he, Kt = null, cr = null, fr = null, fe = null, ya = null, Iu = -1, e !== null && (e.flags & Nn) !== (t.flags & Nn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & Et) !== rt && m("Internal React error: Expected static flag was missing. Please notify the React team."), kg = !1, w)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return y;
    }
    function dd() {
      var e = Rv !== 0;
      return Rv = 0, e;
    }
    function _w(e, t, o) {
      t.updateQueue = e.updateQueue, (t.mode & jt) !== rt ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = Is(e.lanes, o);
    }
    function Ow() {
      if (Be.current = $g, kg) {
        for (var e = Kt.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        kg = !1;
      }
      dc = he, Kt = null, cr = null, fr = null, ya = null, Iu = -1, fe = null, Bw = !1, Tv = !1, Rv = 0;
    }
    function zi() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return fr === null ? Kt.memoizedState = fr = e : fr = fr.next = e, fr;
    }
    function xa() {
      var e;
      if (cr === null) {
        var t = Kt.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = cr.next;
      var o;
      if (fr === null ? o = Kt.memoizedState : o = fr.next, o !== null)
        fr = o, o = fr.next, cr = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        cr = e;
        var i = {
          memoizedState: cr.memoizedState,
          baseState: cr.baseState,
          baseQueue: cr.baseQueue,
          queue: cr.queue,
          next: null
        };
        fr === null ? Kt.memoizedState = fr = i : fr = fr.next = i;
      }
      return fr;
    }
    function Dw() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function ZS(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function JS(e, t, o) {
      var i = zi(), c;
      o !== void 0 ? c = o(t) : c = t, i.memoizedState = i.baseState = c;
      var v = {
        pending: null,
        interleaved: null,
        lanes: he,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      };
      i.queue = v;
      var y = v.dispatch = kN.bind(null, Kt, v);
      return [i.memoizedState, y];
    }
    function eb(e, t, o) {
      var i = xa(), c = i.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var v = cr, y = v.baseQueue, b = c.pending;
      if (b !== null) {
        if (y !== null) {
          var w = y.next, M = b.next;
          y.next = M, b.next = w;
        }
        v.baseQueue !== y && m("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), v.baseQueue = y = b, c.pending = null;
      }
      if (y !== null) {
        var P = y.next, Q = v.baseState, Y = null, ee = null, ne = null, ue = P;
        do {
          var Ae = ue.lane;
          if (Rl(dc, Ae)) {
            if (ne !== null) {
              var Je = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Pt,
                action: ue.action,
                hasEagerState: ue.hasEagerState,
                eagerState: ue.eagerState,
                next: null
              };
              ne = ne.next = Je;
            }
            if (ue.hasEagerState)
              Q = ue.eagerState;
            else {
              var Nt = ue.action;
              Q = e(Q, Nt);
            }
          } else {
            var ot = {
              lane: Ae,
              action: ue.action,
              hasEagerState: ue.hasEagerState,
              eagerState: ue.eagerState,
              next: null
            };
            ne === null ? (ee = ne = ot, Y = Q) : ne = ne.next = ot, Kt.lanes = xt(Kt.lanes, Ae), Gv(Ae);
          }
          ue = ue.next;
        } while (ue !== null && ue !== P);
        ne === null ? Y = Q : ne.next = ee, Se(Q, i.memoizedState) || Lv(), i.memoizedState = Q, i.baseState = Y, i.baseQueue = ne, c.lastRenderedState = Q;
      }
      var Ot = c.interleaved;
      if (Ot !== null) {
        var q = Ot;
        do {
          var se = q.lane;
          Kt.lanes = xt(Kt.lanes, se), Gv(se), q = q.next;
        } while (q !== Ot);
      } else y === null && (c.lanes = he);
      var X = c.dispatch;
      return [i.memoizedState, X];
    }
    function tb(e, t, o) {
      var i = xa(), c = i.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var v = c.dispatch, y = c.pending, b = i.memoizedState;
      if (y !== null) {
        c.pending = null;
        var w = y.next, M = w;
        do {
          var P = M.action;
          b = e(b, P), M = M.next;
        } while (M !== w);
        Se(b, i.memoizedState) || Lv(), i.memoizedState = b, i.baseQueue === null && (i.baseState = b), c.lastRenderedState = b;
      }
      return [b, v];
    }
    function P3(e, t, o) {
    }
    function L3(e, t, o) {
    }
    function nb(e, t, o) {
      var i = Kt, c = zi(), v, y = Or();
      if (y) {
        if (o === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        v = o(), sd || v !== o() && (m("The result of getServerSnapshot should be cached to avoid an infinite loop"), sd = !0);
      } else {
        if (v = t(), !sd) {
          var b = t();
          Se(v, b) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), sd = !0);
        }
        var w = uy();
        if (w === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Df(w, dc) || kw(i, t, v);
      }
      c.memoizedState = v;
      var M = {
        value: v,
        getSnapshot: t
      };
      return c.queue = M, Lg(Nw.bind(null, i, M, e), [e]), i.flags |= Fr, _v(ur | Dr, Mw.bind(null, i, M, v, t), void 0, null), v;
    }
    function Mg(e, t, o) {
      var i = Kt, c = xa(), v = t();
      if (!sd) {
        var y = t();
        Se(v, y) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), sd = !0);
      }
      var b = c.memoizedState, w = !Se(b, v);
      w && (c.memoizedState = v, Lv());
      var M = c.queue;
      if (Dv(Nw.bind(null, i, M, e), [e]), M.getSnapshot !== t || w || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      fr !== null && fr.memoizedState.tag & ur) {
        i.flags |= Fr, _v(ur | Dr, Mw.bind(null, i, M, v, t), void 0, null);
        var P = uy();
        if (P === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Df(P, dc) || kw(i, t, v);
      }
      return v;
    }
    function kw(e, t, o) {
      e.flags |= hu;
      var i = {
        getSnapshot: t,
        value: o
      }, c = Kt.updateQueue;
      if (c === null)
        c = Dw(), Kt.updateQueue = c, c.stores = [i];
      else {
        var v = c.stores;
        v === null ? c.stores = [i] : v.push(i);
      }
    }
    function Mw(e, t, o, i) {
      t.value = o, t.getSnapshot = i, Aw(t) && Pw(e);
    }
    function Nw(e, t, o) {
      var i = function() {
        Aw(t) && Pw(e);
      };
      return o(i);
    }
    function Aw(e) {
      var t = e.getSnapshot, o = e.value;
      try {
        var i = t();
        return !Se(o, i);
      } catch {
        return !0;
      }
    }
    function Pw(e) {
      var t = Mo(e, st);
      t !== null && hr(t, e, st, Jt);
    }
    function Ng(e) {
      var t = zi();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var o = {
        pending: null,
        interleaved: null,
        lanes: he,
        dispatch: null,
        lastRenderedReducer: ZS,
        lastRenderedState: e
      };
      t.queue = o;
      var i = o.dispatch = MN.bind(null, Kt, o);
      return [t.memoizedState, i];
    }
    function rb(e) {
      return eb(ZS);
    }
    function ob(e) {
      return tb(ZS);
    }
    function _v(e, t, o, i) {
      var c = {
        tag: e,
        create: t,
        destroy: o,
        deps: i,
        // Circular
        next: null
      }, v = Kt.updateQueue;
      if (v === null)
        v = Dw(), Kt.updateQueue = v, v.lastEffect = c.next = c;
      else {
        var y = v.lastEffect;
        if (y === null)
          v.lastEffect = c.next = c;
        else {
          var b = y.next;
          y.next = c, c.next = b, v.lastEffect = c;
        }
      }
      return c;
    }
    function ab(e) {
      var t = zi();
      {
        var o = {
          current: e
        };
        return t.memoizedState = o, o;
      }
    }
    function Ag(e) {
      var t = xa();
      return t.memoizedState;
    }
    function Ov(e, t, o, i) {
      var c = zi(), v = i === void 0 ? null : i;
      Kt.flags |= e, c.memoizedState = _v(ur | t, o, void 0, v);
    }
    function Pg(e, t, o, i) {
      var c = xa(), v = i === void 0 ? null : i, y = void 0;
      if (cr !== null) {
        var b = cr.memoizedState;
        if (y = b.destroy, v !== null) {
          var w = b.deps;
          if (XS(v, w)) {
            c.memoizedState = _v(t, o, y, v);
            return;
          }
        }
      }
      Kt.flags |= e, c.memoizedState = _v(ur | t, o, y, v);
    }
    function Lg(e, t) {
      return (Kt.mode & jt) !== rt ? Ov(ia | Fr | tf, Dr, e, t) : Ov(Fr | tf, Dr, e, t);
    }
    function Dv(e, t) {
      return Pg(Fr, Dr, e, t);
    }
    function ib(e, t) {
      return Ov(Dt, ji, e, t);
    }
    function jg(e, t) {
      return Pg(Dt, ji, e, t);
    }
    function lb(e, t) {
      var o = Dt;
      return o |= La, (Kt.mode & jt) !== rt && (o |= yi), Ov(o, sr, e, t);
    }
    function zg(e, t) {
      return Pg(Dt, sr, e, t);
    }
    function Lw(e, t) {
      if (typeof t == "function") {
        var o = t, i = e();
        return o(i), function() {
          o(null);
        };
      } else if (t != null) {
        var c = t;
        c.hasOwnProperty("current") || m("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(c).join(", ") + "}");
        var v = e();
        return c.current = v, function() {
          c.current = null;
        };
      }
    }
    function ub(e, t, o) {
      typeof t != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = o != null ? o.concat([e]) : null, c = Dt;
      return c |= La, (Kt.mode & jt) !== rt && (c |= yi), Ov(c, sr, Lw.bind(null, t, e), i);
    }
    function Ig(e, t, o) {
      typeof t != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = o != null ? o.concat([e]) : null;
      return Pg(Dt, sr, Lw.bind(null, t, e), i);
    }
    function _N(e, t) {
    }
    var Ug = _N;
    function sb(e, t) {
      var o = zi(), i = t === void 0 ? null : t;
      return o.memoizedState = [e, i], e;
    }
    function Fg(e, t) {
      var o = xa(), i = t === void 0 ? null : t, c = o.memoizedState;
      if (c !== null && i !== null) {
        var v = c[1];
        if (XS(i, v))
          return c[0];
      }
      return o.memoizedState = [e, i], e;
    }
    function cb(e, t) {
      var o = zi(), i = t === void 0 ? null : t, c = e();
      return o.memoizedState = [c, i], c;
    }
    function Bg(e, t) {
      var o = xa(), i = t === void 0 ? null : t, c = o.memoizedState;
      if (c !== null && i !== null) {
        var v = c[1];
        if (XS(i, v))
          return c[0];
      }
      var y = e();
      return o.memoizedState = [y, i], y;
    }
    function fb(e) {
      var t = zi();
      return t.memoizedState = e, e;
    }
    function jw(e) {
      var t = xa(), o = cr, i = o.memoizedState;
      return Iw(t, i, e);
    }
    function zw(e) {
      var t = xa();
      if (cr === null)
        return t.memoizedState = e, e;
      var o = cr.memoizedState;
      return Iw(t, o, e);
    }
    function Iw(e, t, o) {
      var i = !Mp(dc);
      if (i) {
        if (!Se(o, t)) {
          var c = Pp();
          Kt.lanes = xt(Kt.lanes, c), Gv(c), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, Lv()), e.memoizedState = o, o;
    }
    function ON(e, t, o) {
      var i = Oo();
      Ln(ym(i, ca)), e(!0);
      var c = wv.transition;
      wv.transition = {};
      var v = wv.transition;
      wv.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (Ln(i), wv.transition = c, c === null && v._updatedFibers) {
          var y = v._updatedFibers.size;
          y > 10 && h("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), v._updatedFibers.clear();
        }
      }
    }
    function db() {
      var e = Ng(!1), t = e[0], o = e[1], i = ON.bind(null, o), c = zi();
      return c.memoizedState = i, [t, i];
    }
    function Uw() {
      var e = rb(), t = e[0], o = xa(), i = o.memoizedState;
      return [t, i];
    }
    function Fw() {
      var e = ob(), t = e[0], o = xa(), i = o.memoizedState;
      return [t, i];
    }
    var Bw = !1;
    function DN() {
      return Bw;
    }
    function pb() {
      var e = zi(), t = uy(), o = t.identifierPrefix, i;
      if (Or()) {
        var c = YM();
        i = ":" + o + "R" + c;
        var v = Rv++;
        v > 0 && (i += "H" + v.toString(32)), i += ":";
      } else {
        var y = wN++;
        i = ":" + o + "r" + y.toString(32) + ":";
      }
      return e.memoizedState = i, i;
    }
    function Hg() {
      var e = xa(), t = e.memoizedState;
      return t;
    }
    function kN(e, t, o) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = $u(e), c = {
        lane: i,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Hw(e))
        $w(t, c);
      else {
        var v = gw(e, t, c, i);
        if (v !== null) {
          var y = fo();
          hr(v, e, i, y), Vw(v, t, i);
        }
      }
      Ww(e, i);
    }
    function MN(e, t, o) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = $u(e), c = {
        lane: i,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Hw(e))
        $w(t, c);
      else {
        var v = e.alternate;
        if (e.lanes === he && (v === null || v.lanes === he)) {
          var y = t.lastRenderedReducer;
          if (y !== null) {
            var b;
            b = Be.current, Be.current = Qa;
            try {
              var w = t.lastRenderedState, M = y(w, o);
              if (c.hasEagerState = !0, c.eagerState = M, Se(M, w)) {
                hN(e, t, c, i);
                return;
              }
            } catch {
            } finally {
              Be.current = b;
            }
          }
        }
        var P = gw(e, t, c, i);
        if (P !== null) {
          var Q = fo();
          hr(P, e, i, Q), Vw(P, t, i);
        }
      }
      Ww(e, i);
    }
    function Hw(e) {
      var t = e.alternate;
      return e === Kt || t !== null && t === Kt;
    }
    function $w(e, t) {
      Tv = kg = !0;
      var o = e.pending;
      o === null ? t.next = t : (t.next = o.next, o.next = t), e.pending = t;
    }
    function Vw(e, t, o) {
      if (Ap(o)) {
        var i = t.lanes;
        i = Lp(i, e.pendingLanes);
        var c = xt(i, o);
        t.lanes = c, Mf(e, c);
      }
    }
    function Ww(e, t, o) {
      Os(e, t);
    }
    var $g = {
      readContext: Jn,
      useCallback: Xr,
      useContext: Xr,
      useEffect: Xr,
      useImperativeHandle: Xr,
      useInsertionEffect: Xr,
      useLayoutEffect: Xr,
      useMemo: Xr,
      useReducer: Xr,
      useRef: Xr,
      useState: Xr,
      useDebugValue: Xr,
      useDeferredValue: Xr,
      useTransition: Xr,
      useMutableSource: Xr,
      useSyncExternalStore: Xr,
      useId: Xr,
      unstable_isNewReconciler: oe
    }, Yw = null, Gw = null, Qw = null, Kw = null, Ii = null, Qa = null, Vg = null;
    {
      var vb = function() {
        m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, dt = function() {
        m("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      Yw = {
        readContext: function(e) {
          return Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", Bt(), cd(t), sb(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", Bt(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", Bt(), cd(t), Lg(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", Bt(), cd(o), ub(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", Bt(), cd(t), ib(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", Bt(), cd(t), lb(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", Bt(), cd(t);
          var o = Be.current;
          Be.current = Ii;
          try {
            return cb(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", Bt();
          var i = Be.current;
          Be.current = Ii;
          try {
            return JS(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", Bt(), ab(e);
        },
        useState: function(e) {
          fe = "useState", Bt();
          var t = Be.current;
          Be.current = Ii;
          try {
            return Ng(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", Bt(), void 0;
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", Bt(), fb(e);
        },
        useTransition: function() {
          return fe = "useTransition", Bt(), db();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", Bt(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", Bt(), nb(e, t, o);
        },
        useId: function() {
          return fe = "useId", Bt(), pb();
        },
        unstable_isNewReconciler: oe
      }, Gw = {
        readContext: function(e) {
          return Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", De(), sb(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", De(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", De(), Lg(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", De(), ub(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", De(), ib(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", De(), lb(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", De();
          var o = Be.current;
          Be.current = Ii;
          try {
            return cb(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", De();
          var i = Be.current;
          Be.current = Ii;
          try {
            return JS(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", De(), ab(e);
        },
        useState: function(e) {
          fe = "useState", De();
          var t = Be.current;
          Be.current = Ii;
          try {
            return Ng(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", De(), void 0;
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", De(), fb(e);
        },
        useTransition: function() {
          return fe = "useTransition", De(), db();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", De(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", De(), nb(e, t, o);
        },
        useId: function() {
          return fe = "useId", De(), pb();
        },
        unstable_isNewReconciler: oe
      }, Qw = {
        readContext: function(e) {
          return Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", De(), Fg(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", De(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", De(), Dv(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", De(), Ig(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", De(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", De(), zg(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", De();
          var o = Be.current;
          Be.current = Qa;
          try {
            return Bg(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", De();
          var i = Be.current;
          Be.current = Qa;
          try {
            return eb(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", De(), Ag();
        },
        useState: function(e) {
          fe = "useState", De();
          var t = Be.current;
          Be.current = Qa;
          try {
            return rb(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", De(), Ug();
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", De(), jw(e);
        },
        useTransition: function() {
          return fe = "useTransition", De(), Uw();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", De(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", De(), Mg(e, t);
        },
        useId: function() {
          return fe = "useId", De(), Hg();
        },
        unstable_isNewReconciler: oe
      }, Kw = {
        readContext: function(e) {
          return Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", De(), Fg(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", De(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", De(), Dv(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", De(), Ig(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", De(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", De(), zg(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", De();
          var o = Be.current;
          Be.current = Vg;
          try {
            return Bg(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", De();
          var i = Be.current;
          Be.current = Vg;
          try {
            return tb(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", De(), Ag();
        },
        useState: function(e) {
          fe = "useState", De();
          var t = Be.current;
          Be.current = Vg;
          try {
            return ob(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", De(), Ug();
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", De(), zw(e);
        },
        useTransition: function() {
          return fe = "useTransition", De(), Fw();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", De(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", De(), Mg(e, t);
        },
        useId: function() {
          return fe = "useId", De(), Hg();
        },
        unstable_isNewReconciler: oe
      }, Ii = {
        readContext: function(e) {
          return vb(), Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", dt(), Bt(), sb(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", dt(), Bt(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", dt(), Bt(), Lg(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", dt(), Bt(), ub(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", dt(), Bt(), ib(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", dt(), Bt(), lb(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", dt(), Bt();
          var o = Be.current;
          Be.current = Ii;
          try {
            return cb(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", dt(), Bt();
          var i = Be.current;
          Be.current = Ii;
          try {
            return JS(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", dt(), Bt(), ab(e);
        },
        useState: function(e) {
          fe = "useState", dt(), Bt();
          var t = Be.current;
          Be.current = Ii;
          try {
            return Ng(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", dt(), Bt(), void 0;
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", dt(), Bt(), fb(e);
        },
        useTransition: function() {
          return fe = "useTransition", dt(), Bt(), db();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", dt(), Bt(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", dt(), Bt(), nb(e, t, o);
        },
        useId: function() {
          return fe = "useId", dt(), Bt(), pb();
        },
        unstable_isNewReconciler: oe
      }, Qa = {
        readContext: function(e) {
          return vb(), Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", dt(), De(), Fg(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", dt(), De(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", dt(), De(), Dv(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", dt(), De(), Ig(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", dt(), De(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", dt(), De(), zg(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", dt(), De();
          var o = Be.current;
          Be.current = Qa;
          try {
            return Bg(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", dt(), De();
          var i = Be.current;
          Be.current = Qa;
          try {
            return eb(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", dt(), De(), Ag();
        },
        useState: function(e) {
          fe = "useState", dt(), De();
          var t = Be.current;
          Be.current = Qa;
          try {
            return rb(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", dt(), De(), Ug();
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", dt(), De(), jw(e);
        },
        useTransition: function() {
          return fe = "useTransition", dt(), De(), Uw();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", dt(), De(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", dt(), De(), Mg(e, t);
        },
        useId: function() {
          return fe = "useId", dt(), De(), Hg();
        },
        unstable_isNewReconciler: oe
      }, Vg = {
        readContext: function(e) {
          return vb(), Jn(e);
        },
        useCallback: function(e, t) {
          return fe = "useCallback", dt(), De(), Fg(e, t);
        },
        useContext: function(e) {
          return fe = "useContext", dt(), De(), Jn(e);
        },
        useEffect: function(e, t) {
          return fe = "useEffect", dt(), De(), Dv(e, t);
        },
        useImperativeHandle: function(e, t, o) {
          return fe = "useImperativeHandle", dt(), De(), Ig(e, t, o);
        },
        useInsertionEffect: function(e, t) {
          return fe = "useInsertionEffect", dt(), De(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return fe = "useLayoutEffect", dt(), De(), zg(e, t);
        },
        useMemo: function(e, t) {
          fe = "useMemo", dt(), De();
          var o = Be.current;
          Be.current = Qa;
          try {
            return Bg(e, t);
          } finally {
            Be.current = o;
          }
        },
        useReducer: function(e, t, o) {
          fe = "useReducer", dt(), De();
          var i = Be.current;
          Be.current = Qa;
          try {
            return tb(e, t, o);
          } finally {
            Be.current = i;
          }
        },
        useRef: function(e) {
          return fe = "useRef", dt(), De(), Ag();
        },
        useState: function(e) {
          fe = "useState", dt(), De();
          var t = Be.current;
          Be.current = Qa;
          try {
            return ob(e);
          } finally {
            Be.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return fe = "useDebugValue", dt(), De(), Ug();
        },
        useDeferredValue: function(e) {
          return fe = "useDeferredValue", dt(), De(), zw(e);
        },
        useTransition: function() {
          return fe = "useTransition", dt(), De(), Fw();
        },
        useMutableSource: function(e, t, o) {
          return fe = "useMutableSource", dt(), De(), void 0;
        },
        useSyncExternalStore: function(e, t, o) {
          return fe = "useSyncExternalStore", dt(), De(), Mg(e, t);
        },
        useId: function() {
          return fe = "useId", dt(), De(), Hg();
        },
        unstable_isNewReconciler: oe
      };
    }
    var Uu = u.unstable_now, qw = 0, Wg = -1, kv = -1, Yg = -1, hb = !1, Gg = !1;
    function Xw() {
      return hb;
    }
    function NN() {
      Gg = !0;
    }
    function AN() {
      hb = !1, Gg = !1;
    }
    function PN() {
      hb = Gg, Gg = !1;
    }
    function Zw() {
      return qw;
    }
    function Jw() {
      qw = Uu();
    }
    function mb(e) {
      kv = Uu(), e.actualStartTime < 0 && (e.actualStartTime = Uu());
    }
    function eT(e) {
      kv = -1;
    }
    function Qg(e, t) {
      if (kv >= 0) {
        var o = Uu() - kv;
        e.actualDuration += o, t && (e.selfBaseDuration = o), kv = -1;
      }
    }
    function Ui(e) {
      if (Wg >= 0) {
        var t = Uu() - Wg;
        Wg = -1;
        for (var o = e.return; o !== null; ) {
          switch (o.tag) {
            case T:
              var i = o.stateNode;
              i.effectDuration += t;
              return;
            case V:
              var c = o.stateNode;
              c.effectDuration += t;
              return;
          }
          o = o.return;
        }
      }
    }
    function gb(e) {
      if (Yg >= 0) {
        var t = Uu() - Yg;
        Yg = -1;
        for (var o = e.return; o !== null; ) {
          switch (o.tag) {
            case T:
              var i = o.stateNode;
              i !== null && (i.passiveEffectDuration += t);
              return;
            case V:
              var c = o.stateNode;
              c !== null && (c.passiveEffectDuration += t);
              return;
          }
          o = o.return;
        }
      }
    }
    function Fi() {
      Wg = Uu();
    }
    function yb() {
      Yg = Uu();
    }
    function xb(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function Ka(e, t) {
      if (e && e.defaultProps) {
        var o = Ct({}, t), i = e.defaultProps;
        for (var c in i)
          o[c] === void 0 && (o[c] = i[c]);
        return o;
      }
      return t;
    }
    var Sb = {}, bb, Cb, Eb, wb, Tb, tT, Kg, Rb, _b, Ob, Mv;
    {
      bb = /* @__PURE__ */ new Set(), Cb = /* @__PURE__ */ new Set(), Eb = /* @__PURE__ */ new Set(), wb = /* @__PURE__ */ new Set(), Rb = /* @__PURE__ */ new Set(), Tb = /* @__PURE__ */ new Set(), _b = /* @__PURE__ */ new Set(), Ob = /* @__PURE__ */ new Set(), Mv = /* @__PURE__ */ new Set();
      var nT = /* @__PURE__ */ new Set();
      Kg = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var o = t + "_" + e;
          nT.has(o) || (nT.add(o), m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, tT = function(e, t) {
        if (t === void 0) {
          var o = Wt(e) || "Component";
          Tb.has(o) || (Tb.add(o), m("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", o));
        }
      }, Object.defineProperty(Sb, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Sb);
    }
    function Db(e, t, o, i) {
      var c = e.memoizedState, v = o(i, c);
      {
        if (e.mode & Qt) {
          pn(!0);
          try {
            v = o(i, c);
          } finally {
            pn(!1);
          }
        }
        tT(t, v);
      }
      var y = v == null ? c : Ct({}, c, v);
      if (e.memoizedState = y, e.lanes === he) {
        var b = e.updateQueue;
        b.baseState = y;
      }
    }
    var kb = {
      isMounted: nm,
      enqueueSetState: function(e, t, o) {
        var i = vu(e), c = fo(), v = $u(i), y = Il(c, v);
        y.payload = t, o != null && (Kg(o, "setState"), y.callback = o);
        var b = Lu(i, y, v);
        b !== null && (hr(b, i, v, c), wg(b, i, v)), Os(i, v);
      },
      enqueueReplaceState: function(e, t, o) {
        var i = vu(e), c = fo(), v = $u(i), y = Il(c, v);
        y.tag = xw, y.payload = t, o != null && (Kg(o, "replaceState"), y.callback = o);
        var b = Lu(i, y, v);
        b !== null && (hr(b, i, v, c), wg(b, i, v)), Os(i, v);
      },
      enqueueForceUpdate: function(e, t) {
        var o = vu(e), i = fo(), c = $u(o), v = Il(i, c);
        v.tag = bg, t != null && (Kg(t, "forceUpdate"), v.callback = t);
        var y = Lu(o, v, c);
        y !== null && (hr(y, o, c, i), wg(y, o, c)), sf(o, c);
      }
    };
    function rT(e, t, o, i, c, v, y) {
      var b = e.stateNode;
      if (typeof b.shouldComponentUpdate == "function") {
        var w = b.shouldComponentUpdate(i, v, y);
        {
          if (e.mode & Qt) {
            pn(!0);
            try {
              w = b.shouldComponentUpdate(i, v, y);
            } finally {
              pn(!1);
            }
          }
          w === void 0 && m("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Wt(t) || "Component");
        }
        return w;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !Ye(o, i) || !Ye(c, v) : !0;
    }
    function LN(e, t, o) {
      var i = e.stateNode;
      {
        var c = Wt(t) || "Component", v = i.render;
        v || (t.prototype && typeof t.prototype.render == "function" ? m("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", c) : m("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", c)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && m("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", c), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && m("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", c), i.propTypes && m("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", c), i.contextType && m("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", c), t.childContextTypes && !Mv.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Qt) === rt && (Mv.add(t), m(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), t.contextTypes && !Mv.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Qt) === rt && (Mv.add(t), m(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), i.contextTypes && m("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", c), t.contextType && t.contextTypes && !_b.has(t) && (_b.add(t), m("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", c)), typeof i.componentShouldUpdate == "function" && m("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", c), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && m("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Wt(t) || "A pure component"), typeof i.componentDidUnmount == "function" && m("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", c), typeof i.componentDidReceiveProps == "function" && m("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", c), typeof i.componentWillRecieveProps == "function" && m("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", c), typeof i.UNSAFE_componentWillRecieveProps == "function" && m("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", c);
        var y = i.props !== o;
        i.props !== void 0 && y && m("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", c, c), i.defaultProps && m("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", c, c), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !Eb.has(t) && (Eb.add(t), m("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Wt(t))), typeof i.getDerivedStateFromProps == "function" && m("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof i.getDerivedStateFromError == "function" && m("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof t.getSnapshotBeforeUpdate == "function" && m("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", c);
        var b = i.state;
        b && (typeof b != "object" || rr(b)) && m("%s.state: must be set to an object or null", c), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && m("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", c);
      }
    }
    function oT(e, t) {
      t.updater = kb, e.stateNode = t, dl(t, e), t._reactInternalInstance = Sb;
    }
    function aT(e, t, o) {
      var i = !1, c = qo, v = qo, y = t.contextType;
      if ("contextType" in t) {
        var b = (
          // Allow null for conditional declaration
          y === null || y !== void 0 && y.$$typeof === H && y._context === void 0
        );
        if (!b && !Ob.has(t)) {
          Ob.add(t);
          var w = "";
          y === void 0 ? w = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof y != "object" ? w = " However, it is set to a " + typeof y + "." : y.$$typeof === ci ? w = " Did you accidentally pass the Context.Provider instead?" : y._context !== void 0 ? w = " Did you accidentally pass the Context.Consumer instead?" : w = " However, it is set to an object with keys {" + Object.keys(y).join(", ") + "}.", m("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Wt(t) || "Component", w);
        }
      }
      if (typeof y == "object" && y !== null)
        v = Jn(y);
      else {
        c = Zf(e, t, !0);
        var M = t.contextTypes;
        i = M != null, v = i ? Jf(e, c) : qo;
      }
      var P = new t(o, v);
      if (e.mode & Qt) {
        pn(!0);
        try {
          P = new t(o, v);
        } finally {
          pn(!1);
        }
      }
      var Q = e.memoizedState = P.state !== null && P.state !== void 0 ? P.state : null;
      oT(e, P);
      {
        if (typeof t.getDerivedStateFromProps == "function" && Q === null) {
          var Y = Wt(t) || "Component";
          Cb.has(Y) || (Cb.add(Y), m("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Y, P.state === null ? "null" : "undefined", Y));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof P.getSnapshotBeforeUpdate == "function") {
          var ee = null, ne = null, ue = null;
          if (typeof P.componentWillMount == "function" && P.componentWillMount.__suppressDeprecationWarning !== !0 ? ee = "componentWillMount" : typeof P.UNSAFE_componentWillMount == "function" && (ee = "UNSAFE_componentWillMount"), typeof P.componentWillReceiveProps == "function" && P.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ne = "componentWillReceiveProps" : typeof P.UNSAFE_componentWillReceiveProps == "function" && (ne = "UNSAFE_componentWillReceiveProps"), typeof P.componentWillUpdate == "function" && P.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ue = "componentWillUpdate" : typeof P.UNSAFE_componentWillUpdate == "function" && (ue = "UNSAFE_componentWillUpdate"), ee !== null || ne !== null || ue !== null) {
            var Ae = Wt(t) || "Component", ot = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            wb.has(Ae) || (wb.add(Ae), m(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ae, ot, ee !== null ? `
  ` + ee : "", ne !== null ? `
  ` + ne : "", ue !== null ? `
  ` + ue : ""));
          }
        }
      }
      return i && QE(e, c, v), P;
    }
    function jN(e, t) {
      var o = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), o !== t.state && (m("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", yt(e) || "Component"), kb.enqueueReplaceState(t, t.state, null));
    }
    function iT(e, t, o, i) {
      var c = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(o, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(o, i), t.state !== c) {
        {
          var v = yt(e) || "Component";
          bb.has(v) || (bb.add(v), m("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", v));
        }
        kb.enqueueReplaceState(t, t.state, null);
      }
    }
    function Mb(e, t, o, i) {
      LN(e, t, o);
      var c = e.stateNode;
      c.props = o, c.state = e.memoizedState, c.refs = {}, FS(e);
      var v = t.contextType;
      if (typeof v == "object" && v !== null)
        c.context = Jn(v);
      else {
        var y = Zf(e, t, !0);
        c.context = Jf(e, y);
      }
      {
        if (c.state === o) {
          var b = Wt(t) || "Component";
          Rb.has(b) || (Rb.add(b), m("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", b));
        }
        e.mode & Qt && Ya.recordLegacyContextWarning(e, c), Ya.recordUnsafeLifecycleWarnings(e, c);
      }
      c.state = e.memoizedState;
      var w = t.getDerivedStateFromProps;
      if (typeof w == "function" && (Db(e, t, w, o), c.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof c.getSnapshotBeforeUpdate != "function" && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (jN(e, c), Tg(e, o, c, i), c.state = e.memoizedState), typeof c.componentDidMount == "function") {
        var M = Dt;
        M |= La, (e.mode & jt) !== rt && (M |= yi), e.flags |= M;
      }
    }
    function zN(e, t, o, i) {
      var c = e.stateNode, v = e.memoizedProps;
      c.props = v;
      var y = c.context, b = t.contextType, w = qo;
      if (typeof b == "object" && b !== null)
        w = Jn(b);
      else {
        var M = Zf(e, t, !0);
        w = Jf(e, M);
      }
      var P = t.getDerivedStateFromProps, Q = typeof P == "function" || typeof c.getSnapshotBeforeUpdate == "function";
      !Q && (typeof c.UNSAFE_componentWillReceiveProps == "function" || typeof c.componentWillReceiveProps == "function") && (v !== o || y !== w) && iT(e, c, o, w), bw();
      var Y = e.memoizedState, ee = c.state = Y;
      if (Tg(e, o, c, i), ee = e.memoizedState, v === o && Y === ee && !ig() && !Rg()) {
        if (typeof c.componentDidMount == "function") {
          var ne = Dt;
          ne |= La, (e.mode & jt) !== rt && (ne |= yi), e.flags |= ne;
        }
        return !1;
      }
      typeof P == "function" && (Db(e, t, P, o), ee = e.memoizedState);
      var ue = Rg() || rT(e, t, v, o, Y, ee, w);
      if (ue) {
        if (!Q && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount()), typeof c.componentDidMount == "function") {
          var Ae = Dt;
          Ae |= La, (e.mode & jt) !== rt && (Ae |= yi), e.flags |= Ae;
        }
      } else {
        if (typeof c.componentDidMount == "function") {
          var ot = Dt;
          ot |= La, (e.mode & jt) !== rt && (ot |= yi), e.flags |= ot;
        }
        e.memoizedProps = o, e.memoizedState = ee;
      }
      return c.props = o, c.state = ee, c.context = w, ue;
    }
    function IN(e, t, o, i, c) {
      var v = t.stateNode;
      Sw(e, t);
      var y = t.memoizedProps, b = t.type === t.elementType ? y : Ka(t.type, y);
      v.props = b;
      var w = t.pendingProps, M = v.context, P = o.contextType, Q = qo;
      if (typeof P == "object" && P !== null)
        Q = Jn(P);
      else {
        var Y = Zf(t, o, !0);
        Q = Jf(t, Y);
      }
      var ee = o.getDerivedStateFromProps, ne = typeof ee == "function" || typeof v.getSnapshotBeforeUpdate == "function";
      !ne && (typeof v.UNSAFE_componentWillReceiveProps == "function" || typeof v.componentWillReceiveProps == "function") && (y !== w || M !== Q) && iT(t, v, i, Q), bw();
      var ue = t.memoizedState, Ae = v.state = ue;
      if (Tg(t, i, v, c), Ae = t.memoizedState, y === w && ue === Ae && !ig() && !Rg())
        return typeof v.componentDidUpdate == "function" && (y !== e.memoizedProps || ue !== e.memoizedState) && (t.flags |= Dt), typeof v.getSnapshotBeforeUpdate == "function" && (y !== e.memoizedProps || ue !== e.memoizedState) && (t.flags |= Hn), !1;
      typeof ee == "function" && (Db(t, o, ee, i), Ae = t.memoizedState);
      var ot = Rg() || rT(t, o, b, i, ue, Ae, Q) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      le;
      return ot ? (!ne && (typeof v.UNSAFE_componentWillUpdate == "function" || typeof v.componentWillUpdate == "function") && (typeof v.componentWillUpdate == "function" && v.componentWillUpdate(i, Ae, Q), typeof v.UNSAFE_componentWillUpdate == "function" && v.UNSAFE_componentWillUpdate(i, Ae, Q)), typeof v.componentDidUpdate == "function" && (t.flags |= Dt), typeof v.getSnapshotBeforeUpdate == "function" && (t.flags |= Hn)) : (typeof v.componentDidUpdate == "function" && (y !== e.memoizedProps || ue !== e.memoizedState) && (t.flags |= Dt), typeof v.getSnapshotBeforeUpdate == "function" && (y !== e.memoizedProps || ue !== e.memoizedState) && (t.flags |= Hn), t.memoizedProps = i, t.memoizedState = Ae), v.props = i, v.state = Ae, v.context = Q, ot;
    }
    function pc(e, t) {
      return {
        value: e,
        source: t,
        stack: Dc(t),
        digest: null
      };
    }
    function Nb(e, t, o) {
      return {
        value: e,
        source: null,
        stack: o ?? null,
        digest: t ?? null
      };
    }
    function UN(e, t) {
      return !0;
    }
    function Ab(e, t) {
      try {
        var o = UN(e, t);
        if (o === !1)
          return;
        var i = t.value, c = t.source, v = t.stack, y = v !== null ? v : "";
        if (i != null && i._suppressLogging) {
          if (e.tag === E)
            return;
          console.error(i);
        }
        var b = c ? yt(c) : null, w = b ? "The above error occurred in the <" + b + "> component:" : "The above error occurred in one of your React components:", M;
        if (e.tag === T)
          M = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var P = yt(e) || "Anonymous";
          M = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + P + ".");
        }
        var Q = w + `
` + y + `

` + ("" + M);
        console.error(Q);
      } catch (Y) {
        setTimeout(function() {
          throw Y;
        });
      }
    }
    var FN = typeof WeakMap == "function" ? WeakMap : Map;
    function lT(e, t, o) {
      var i = Il(Jt, o);
      i.tag = IS, i.payload = {
        element: null
      };
      var c = t.value;
      return i.callback = function() {
        NP(c), Ab(e, t);
      }, i;
    }
    function Pb(e, t, o) {
      var i = Il(Jt, o);
      i.tag = IS;
      var c = e.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var v = t.value;
        i.payload = function() {
          return c(v);
        }, i.callback = function() {
          yR(e), Ab(e, t);
        };
      }
      var y = e.stateNode;
      return y !== null && typeof y.componentDidCatch == "function" && (i.callback = function() {
        yR(e), Ab(e, t), typeof c != "function" && kP(this);
        var w = t.value, M = t.stack;
        this.componentDidCatch(w, {
          componentStack: M !== null ? M : ""
        }), typeof c != "function" && (Wr(e.lanes, st) || m("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", yt(e) || "Unknown"));
      }), i;
    }
    function uT(e, t, o) {
      var i = e.pingCache, c;
      if (i === null ? (i = e.pingCache = new FN(), c = /* @__PURE__ */ new Set(), i.set(t, c)) : (c = i.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), i.set(t, c))), !c.has(o)) {
        c.add(o);
        var v = AP.bind(null, e, t, o);
        Vr && Qv(e, o), t.then(v, v);
      }
    }
    function BN(e, t, o, i) {
      var c = e.updateQueue;
      if (c === null) {
        var v = /* @__PURE__ */ new Set();
        v.add(o), e.updateQueue = v;
      } else
        c.add(o);
    }
    function HN(e, t) {
      var o = e.tag;
      if ((e.mode & Et) === rt && (o === C || o === I || o === Z)) {
        var i = e.alternate;
        i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function sT(e) {
      var t = e;
      do {
        if (t.tag === B && CN(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function cT(e, t, o, i, c) {
      if ((e.mode & Et) === rt) {
        if (e === t)
          e.flags |= Br;
        else {
          if (e.flags |= tt, o.flags |= ef, o.flags &= -52805, o.tag === E) {
            var v = o.alternate;
            if (v === null)
              o.tag = de;
            else {
              var y = Il(Jt, st);
              y.tag = bg, Lu(o, y, st);
            }
          }
          o.lanes = xt(o.lanes, st);
        }
        return e;
      }
      return e.flags |= Br, e.lanes = c, e;
    }
    function $N(e, t, o, i, c) {
      if (o.flags |= Cs, Vr && Qv(e, c), i !== null && typeof i == "object" && typeof i.then == "function") {
        var v = i;
        HN(o), Or() && o.mode & Et && tw();
        var y = sT(t);
        if (y !== null) {
          y.flags &= -257, cT(y, t, o, e, c), y.mode & Et && uT(e, v, c), BN(y, e, v);
          return;
        } else {
          if (!cm(c)) {
            uT(e, v, c), p0();
            return;
          }
          var b = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          i = b;
        }
      } else if (Or() && o.mode & Et) {
        tw();
        var w = sT(t);
        if (w !== null) {
          (w.flags & Br) === nt && (w.flags |= Ur), cT(w, t, o, e, c), RS(pc(i, o));
          return;
        }
      }
      i = pc(i, o), CP(i);
      var M = t;
      do {
        switch (M.tag) {
          case T: {
            var P = i;
            M.flags |= Br;
            var Q = zs(c);
            M.lanes = xt(M.lanes, Q);
            var Y = lT(M, P, Q);
            BS(M, Y);
            return;
          }
          case E:
            var ee = i, ne = M.type, ue = M.stateNode;
            if ((M.flags & tt) === nt && (typeof ne.getDerivedStateFromError == "function" || ue !== null && typeof ue.componentDidCatch == "function" && !sR(ue))) {
              M.flags |= Br;
              var Ae = zs(c);
              M.lanes = xt(M.lanes, Ae);
              var ot = Pb(M, ee, Ae);
              BS(M, ot);
              return;
            }
            break;
        }
        M = M.return;
      } while (M !== null);
    }
    function VN() {
      return null;
    }
    var Nv = s.ReactCurrentOwner, qa = !1, Lb, Av, jb, zb, Ib, vc, Ub, qg, Pv;
    Lb = {}, Av = {}, jb = {}, zb = {}, Ib = {}, vc = !1, Ub = {}, qg = {}, Pv = {};
    function so(e, t, o, i) {
      e === null ? t.child = pw(t, null, o, i) : t.child = rd(t, e.child, o, i);
    }
    function WN(e, t, o, i) {
      t.child = rd(t, e.child, null, i), t.child = rd(t, null, o, i);
    }
    function fT(e, t, o, i, c) {
      if (t.type !== t.elementType) {
        var v = o.propTypes;
        v && Va(
          v,
          i,
          // Resolved props
          "prop",
          Wt(o)
        );
      }
      var y = o.render, b = t.ref, w, M;
      ad(t, c), oo(t);
      {
        if (Nv.current = t, nr(!0), w = fd(e, t, y, i, b, c), M = dd(), t.mode & Qt) {
          pn(!0);
          try {
            w = fd(e, t, y, i, b, c), M = dd();
          } finally {
            pn(!1);
          }
        }
        nr(!1);
      }
      return ao(), e !== null && !qa ? (_w(e, t, c), Ul(e, t, c)) : (Or() && M && SS(t), t.flags |= Vo, so(e, t, w, c), t.child);
    }
    function dT(e, t, o, i, c) {
      if (e === null) {
        var v = o.type;
        if (qP(v) && o.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        o.defaultProps === void 0) {
          var y = v;
          return y = Sd(v), t.tag = Z, t.type = y, Hb(t, v), pT(e, t, y, i, c);
        }
        {
          var b = v.propTypes;
          if (b && Va(
            b,
            i,
            // Resolved props
            "prop",
            Wt(v)
          ), o.defaultProps !== void 0) {
            var w = Wt(v) || "Unknown";
            Pv[w] || (m("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", w), Pv[w] = !0);
          }
        }
        var M = w0(o.type, null, i, t, t.mode, c);
        return M.ref = t.ref, M.return = t, t.child = M, M;
      }
      {
        var P = o.type, Q = P.propTypes;
        Q && Va(
          Q,
          i,
          // Resolved props
          "prop",
          Wt(P)
        );
      }
      var Y = e.child, ee = Qb(e, c);
      if (!ee) {
        var ne = Y.memoizedProps, ue = o.compare;
        if (ue = ue !== null ? ue : Ye, ue(ne, i) && e.ref === t.ref)
          return Ul(e, t, c);
      }
      t.flags |= Vo;
      var Ae = xc(Y, i);
      return Ae.ref = t.ref, Ae.return = t, t.child = Ae, Ae;
    }
    function pT(e, t, o, i, c) {
      if (t.type !== t.elementType) {
        var v = t.elementType;
        if (v.$$typeof === ht) {
          var y = v, b = y._payload, w = y._init;
          try {
            v = w(b);
          } catch {
            v = null;
          }
          var M = v && v.propTypes;
          M && Va(
            M,
            i,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Wt(v)
          );
        }
      }
      if (e !== null) {
        var P = e.memoizedProps;
        if (Ye(P, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (qa = !1, t.pendingProps = i = P, Qb(e, c))
            (e.flags & ef) !== nt && (qa = !0);
          else return t.lanes = e.lanes, Ul(e, t, c);
      }
      return Fb(e, t, o, i, c);
    }
    function vT(e, t, o) {
      var i = t.pendingProps, c = i.children, v = e !== null ? e.memoizedState : null;
      if (i.mode === "hidden" || W)
        if ((t.mode & Et) === rt) {
          var y = {
            baseLanes: he,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = y, sy(t, o);
        } else if (Wr(o, io)) {
          var Q = {
            baseLanes: he,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = Q;
          var Y = v !== null ? v.baseLanes : o;
          sy(t, Y);
        } else {
          var b = null, w;
          if (v !== null) {
            var M = v.baseLanes;
            w = xt(M, o);
          } else
            w = o;
          t.lanes = t.childLanes = io;
          var P = {
            baseLanes: w,
            cachePool: b,
            transitions: null
          };
          return t.memoizedState = P, t.updateQueue = null, sy(t, w), null;
        }
      else {
        var ee;
        v !== null ? (ee = xt(v.baseLanes, o), t.memoizedState = null) : ee = o, sy(t, ee);
      }
      return so(e, t, c, o), t.child;
    }
    function YN(e, t, o) {
      var i = t.pendingProps;
      return so(e, t, i, o), t.child;
    }
    function GN(e, t, o) {
      var i = t.pendingProps.children;
      return so(e, t, i, o), t.child;
    }
    function QN(e, t, o) {
      {
        t.flags |= Dt;
        {
          var i = t.stateNode;
          i.effectDuration = 0, i.passiveEffectDuration = 0;
        }
      }
      var c = t.pendingProps, v = c.children;
      return so(e, t, v, o), t.child;
    }
    function hT(e, t) {
      var o = t.ref;
      (e === null && o !== null || e !== null && e.ref !== o) && (t.flags |= yn, t.flags |= mu);
    }
    function Fb(e, t, o, i, c) {
      if (t.type !== t.elementType) {
        var v = o.propTypes;
        v && Va(
          v,
          i,
          // Resolved props
          "prop",
          Wt(o)
        );
      }
      var y;
      {
        var b = Zf(t, o, !0);
        y = Jf(t, b);
      }
      var w, M;
      ad(t, c), oo(t);
      {
        if (Nv.current = t, nr(!0), w = fd(e, t, o, i, y, c), M = dd(), t.mode & Qt) {
          pn(!0);
          try {
            w = fd(e, t, o, i, y, c), M = dd();
          } finally {
            pn(!1);
          }
        }
        nr(!1);
      }
      return ao(), e !== null && !qa ? (_w(e, t, c), Ul(e, t, c)) : (Or() && M && SS(t), t.flags |= Vo, so(e, t, w, c), t.child);
    }
    function mT(e, t, o, i, c) {
      {
        switch (fL(t)) {
          case !1: {
            var v = t.stateNode, y = t.type, b = new y(t.memoizedProps, v.context), w = b.state;
            v.updater.enqueueSetState(v, w, null);
            break;
          }
          case !0: {
            t.flags |= tt, t.flags |= Br;
            var M = new Error("Simulated error coming from DevTools"), P = zs(c);
            t.lanes = xt(t.lanes, P);
            var Q = Pb(t, pc(M, t), P);
            BS(t, Q);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var Y = o.propTypes;
          Y && Va(
            Y,
            i,
            // Resolved props
            "prop",
            Wt(o)
          );
        }
      }
      var ee;
      Li(o) ? (ee = !0, ug(t)) : ee = !1, ad(t, c);
      var ne = t.stateNode, ue;
      ne === null ? (Zg(e, t), aT(t, o, i), Mb(t, o, i, c), ue = !0) : e === null ? ue = zN(t, o, i, c) : ue = IN(e, t, o, i, c);
      var Ae = Bb(e, t, o, ue, ee, c);
      {
        var ot = t.stateNode;
        ue && ot.props !== i && (vc || m("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", yt(t) || "a component"), vc = !0);
      }
      return Ae;
    }
    function Bb(e, t, o, i, c, v) {
      hT(e, t);
      var y = (t.flags & tt) !== nt;
      if (!i && !y)
        return c && XE(t, o, !1), Ul(e, t, v);
      var b = t.stateNode;
      Nv.current = t;
      var w;
      if (y && typeof o.getDerivedStateFromError != "function")
        w = null, eT();
      else {
        oo(t);
        {
          if (nr(!0), w = b.render(), t.mode & Qt) {
            pn(!0);
            try {
              b.render();
            } finally {
              pn(!1);
            }
          }
          nr(!1);
        }
        ao();
      }
      return t.flags |= Vo, e !== null && y ? WN(e, t, w, v) : so(e, t, w, v), t.memoizedState = b.state, c && XE(t, o, !0), t.child;
    }
    function gT(e) {
      var t = e.stateNode;
      t.pendingContext ? KE(e, t.pendingContext, t.pendingContext !== t.context) : t.context && KE(e, t.context, !1), HS(e, t.containerInfo);
    }
    function KN(e, t, o) {
      if (gT(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var i = t.pendingProps, c = t.memoizedState, v = c.element;
      Sw(e, t), Tg(t, i, null, o);
      var y = t.memoizedState;
      t.stateNode;
      var b = y.element;
      if (c.isDehydrated) {
        var w = {
          element: b,
          isDehydrated: !1,
          cache: y.cache,
          pendingSuspenseBoundaries: y.pendingSuspenseBoundaries,
          transitions: y.transitions
        }, M = t.updateQueue;
        if (M.baseState = w, t.memoizedState = w, t.flags & Ur) {
          var P = pc(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return yT(e, t, b, o, P);
        } else if (b !== v) {
          var Q = pc(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return yT(e, t, b, o, Q);
        } else {
          ZM(t);
          var Y = pw(t, null, b, o);
          t.child = Y;
          for (var ee = Y; ee; )
            ee.flags = ee.flags & -3 | Co, ee = ee.sibling;
        }
      } else {
        if (nd(), b === v)
          return Ul(e, t, o);
        so(e, t, b, o);
      }
      return t.child;
    }
    function yT(e, t, o, i, c) {
      return nd(), RS(c), t.flags |= Ur, so(e, t, o, i), t.child;
    }
    function qN(e, t, o) {
      ww(t), e === null && TS(t);
      var i = t.type, c = t.pendingProps, v = e !== null ? e.memoizedProps : null, y = c.children, b = iS(i, c);
      return b ? y = null : v !== null && iS(i, v) && (t.flags |= Wo), hT(e, t), so(e, t, y, o), t.child;
    }
    function XN(e, t) {
      return e === null && TS(t), null;
    }
    function ZN(e, t, o, i) {
      Zg(e, t);
      var c = t.pendingProps, v = o, y = v._payload, b = v._init, w = b(y);
      t.type = w;
      var M = t.tag = XP(w), P = Ka(w, c), Q;
      switch (M) {
        case C:
          return Hb(t, w), t.type = w = Sd(w), Q = Fb(null, t, w, P, i), Q;
        case E:
          return t.type = w = y0(w), Q = mT(null, t, w, P, i), Q;
        case I:
          return t.type = w = x0(w), Q = fT(null, t, w, P, i), Q;
        case ae: {
          if (t.type !== t.elementType) {
            var Y = w.propTypes;
            Y && Va(
              Y,
              P,
              // Resolved for outer only
              "prop",
              Wt(w)
            );
          }
          return Q = dT(
            null,
            t,
            w,
            Ka(w.type, P),
            // The inner type can have defaults too
            i
          ), Q;
        }
      }
      var ee = "";
      throw w !== null && typeof w == "object" && w.$$typeof === ht && (ee = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + w + ". " + ("Lazy element type must resolve to a class or function." + ee));
    }
    function JN(e, t, o, i, c) {
      Zg(e, t), t.tag = E;
      var v;
      return Li(o) ? (v = !0, ug(t)) : v = !1, ad(t, c), aT(t, o, i), Mb(t, o, i, c), Bb(null, t, o, !0, v, c);
    }
    function eA(e, t, o, i) {
      Zg(e, t);
      var c = t.pendingProps, v;
      {
        var y = Zf(t, o, !1);
        v = Jf(t, y);
      }
      ad(t, i);
      var b, w;
      oo(t);
      {
        if (o.prototype && typeof o.prototype.render == "function") {
          var M = Wt(o) || "Unknown";
          Lb[M] || (m("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", M, M), Lb[M] = !0);
        }
        t.mode & Qt && Ya.recordLegacyContextWarning(t, null), nr(!0), Nv.current = t, b = fd(null, t, o, c, v, i), w = dd(), nr(!1);
      }
      if (ao(), t.flags |= Vo, typeof b == "object" && b !== null && typeof b.render == "function" && b.$$typeof === void 0) {
        var P = Wt(o) || "Unknown";
        Av[P] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", P, P, P), Av[P] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof b == "object" && b !== null && typeof b.render == "function" && b.$$typeof === void 0
      ) {
        {
          var Q = Wt(o) || "Unknown";
          Av[Q] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Q, Q, Q), Av[Q] = !0);
        }
        t.tag = E, t.memoizedState = null, t.updateQueue = null;
        var Y = !1;
        return Li(o) ? (Y = !0, ug(t)) : Y = !1, t.memoizedState = b.state !== null && b.state !== void 0 ? b.state : null, FS(t), oT(t, b), Mb(t, o, c, i), Bb(null, t, o, !0, Y, i);
      } else {
        if (t.tag = C, t.mode & Qt) {
          pn(!0);
          try {
            b = fd(null, t, o, c, v, i), w = dd();
          } finally {
            pn(!1);
          }
        }
        return Or() && w && SS(t), so(null, t, b, i), Hb(t, o), t.child;
      }
    }
    function Hb(e, t) {
      {
        if (t && t.childContextTypes && m("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var o = "", i = yo();
          i && (o += `

Check the render method of \`` + i + "`.");
          var c = i || "", v = e._debugSource;
          v && (c = v.fileName + ":" + v.lineNumber), Ib[c] || (Ib[c] = !0, m("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", o));
        }
        if (t.defaultProps !== void 0) {
          var y = Wt(t) || "Unknown";
          Pv[y] || (m("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", y), Pv[y] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var b = Wt(t) || "Unknown";
          zb[b] || (m("%s: Function components do not support getDerivedStateFromProps.", b), zb[b] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var w = Wt(t) || "Unknown";
          jb[w] || (m("%s: Function components do not support contextType.", w), jb[w] = !0);
        }
      }
    }
    var $b = {
      dehydrated: null,
      treeContext: null,
      retryLane: Pt
    };
    function Vb(e) {
      return {
        baseLanes: e,
        cachePool: VN(),
        transitions: null
      };
    }
    function tA(e, t) {
      var o = null;
      return {
        baseLanes: xt(e.baseLanes, t),
        cachePool: o,
        transitions: e.transitions
      };
    }
    function nA(e, t, o, i) {
      if (t !== null) {
        var c = t.memoizedState;
        if (c === null)
          return !1;
      }
      return WS(e, Ev);
    }
    function rA(e, t) {
      return Is(e.childLanes, t);
    }
    function xT(e, t, o) {
      var i = t.pendingProps;
      dL(t) && (t.flags |= tt);
      var c = Ga.current, v = !1, y = (t.flags & tt) !== nt;
      if (y || nA(c, e) ? (v = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (c = bN(c, Rw)), c = ld(c), zu(t, c), e === null) {
        TS(t);
        var b = t.memoizedState;
        if (b !== null) {
          var w = b.dehydrated;
          if (w !== null)
            return uA(t, w);
        }
        var M = i.children, P = i.fallback;
        if (v) {
          var Q = oA(t, M, P, o), Y = t.child;
          return Y.memoizedState = Vb(o), t.memoizedState = $b, Q;
        } else
          return Wb(t, M);
      } else {
        var ee = e.memoizedState;
        if (ee !== null) {
          var ne = ee.dehydrated;
          if (ne !== null)
            return sA(e, t, y, i, ne, ee, o);
        }
        if (v) {
          var ue = i.fallback, Ae = i.children, ot = iA(e, t, Ae, ue, o), Je = t.child, Nt = e.child.memoizedState;
          return Je.memoizedState = Nt === null ? Vb(o) : tA(Nt, o), Je.childLanes = rA(e, o), t.memoizedState = $b, ot;
        } else {
          var Ot = i.children, q = aA(e, t, Ot, o);
          return t.memoizedState = null, q;
        }
      }
    }
    function Wb(e, t, o) {
      var i = e.mode, c = {
        mode: "visible",
        children: t
      }, v = Yb(c, i);
      return v.return = e, e.child = v, v;
    }
    function oA(e, t, o, i) {
      var c = e.mode, v = e.child, y = {
        mode: "hidden",
        children: t
      }, b, w;
      return (c & Et) === rt && v !== null ? (b = v, b.childLanes = he, b.pendingProps = y, e.mode & Lt && (b.actualDuration = 0, b.actualStartTime = -1, b.selfBaseDuration = 0, b.treeBaseDuration = 0), w = Wu(o, c, i, null)) : (b = Yb(y, c), w = Wu(o, c, i, null)), b.return = e, w.return = e, b.sibling = w, e.child = b, w;
    }
    function Yb(e, t, o) {
      return SR(e, t, he, null);
    }
    function ST(e, t) {
      return xc(e, t);
    }
    function aA(e, t, o, i) {
      var c = e.child, v = c.sibling, y = ST(c, {
        mode: "visible",
        children: o
      });
      if ((t.mode & Et) === rt && (y.lanes = i), y.return = t, y.sibling = null, v !== null) {
        var b = t.deletions;
        b === null ? (t.deletions = [v], t.flags |= bo) : b.push(v);
      }
      return t.child = y, y;
    }
    function iA(e, t, o, i, c) {
      var v = t.mode, y = e.child, b = y.sibling, w = {
        mode: "hidden",
        children: o
      }, M;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (v & Et) === rt && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== y
      ) {
        var P = t.child;
        M = P, M.childLanes = he, M.pendingProps = w, t.mode & Lt && (M.actualDuration = 0, M.actualStartTime = -1, M.selfBaseDuration = y.selfBaseDuration, M.treeBaseDuration = y.treeBaseDuration), t.deletions = null;
      } else
        M = ST(y, w), M.subtreeFlags = y.subtreeFlags & Nn;
      var Q;
      return b !== null ? Q = xc(b, i) : (Q = Wu(i, v, c, null), Q.flags |= bn), Q.return = t, M.return = t, M.sibling = Q, t.child = M, Q;
    }
    function Xg(e, t, o, i) {
      i !== null && RS(i), rd(t, e.child, null, o);
      var c = t.pendingProps, v = c.children, y = Wb(t, v);
      return y.flags |= bn, t.memoizedState = null, y;
    }
    function lA(e, t, o, i, c) {
      var v = t.mode, y = {
        mode: "visible",
        children: o
      }, b = Yb(y, v), w = Wu(i, v, c, null);
      return w.flags |= bn, b.return = t, w.return = t, b.sibling = w, t.child = b, (t.mode & Et) !== rt && rd(t, e.child, null, c), w;
    }
    function uA(e, t, o) {
      return (e.mode & Et) === rt ? (m("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = st) : cS(t) ? e.lanes = mr : e.lanes = io, null;
    }
    function sA(e, t, o, i, c, v, y) {
      if (o)
        if (t.flags & Ur) {
          t.flags &= -257;
          var q = Nb(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Xg(e, t, y, q);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= tt, null;
          var se = i.children, X = i.fallback, Ce = lA(e, t, se, X, y), He = t.child;
          return He.memoizedState = Vb(y), t.memoizedState = $b, Ce;
        }
      else {
        if (qM(), (t.mode & Et) === rt)
          return Xg(
            e,
            t,
            y,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (cS(c)) {
          var b, w, M;
          {
            var P = pM(c);
            b = P.digest, w = P.message, M = P.stack;
          }
          var Q;
          w ? Q = new Error(w) : Q = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Y = Nb(Q, b, M);
          return Xg(e, t, y, Y);
        }
        var ee = Wr(y, e.childLanes);
        if (qa || ee) {
          var ne = uy();
          if (ne !== null) {
            var ue = zp(ne, y);
            if (ue !== Pt && ue !== v.retryLane) {
              v.retryLane = ue;
              var Ae = Jt;
              Mo(e, ue), hr(ne, e, ue, Ae);
            }
          }
          p0();
          var ot = Nb(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Xg(e, t, y, ot);
        } else if ($E(c)) {
          t.flags |= tt, t.child = e.child;
          var Je = PP.bind(null, e);
          return vM(c, Je), null;
        } else {
          JM(t, c, v.treeContext);
          var Nt = i.children, Ot = Wb(t, Nt);
          return Ot.flags |= Co, Ot;
        }
      }
    }
    function bT(e, t, o) {
      e.lanes = xt(e.lanes, t);
      var i = e.alternate;
      i !== null && (i.lanes = xt(i.lanes, t)), jS(e.return, t, o);
    }
    function cA(e, t, o) {
      for (var i = t; i !== null; ) {
        if (i.tag === B) {
          var c = i.memoizedState;
          c !== null && bT(i, o, e);
        } else if (i.tag === Te)
          bT(i, o, e);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function fA(e) {
      for (var t = e, o = null; t !== null; ) {
        var i = t.alternate;
        i !== null && Dg(i) === null && (o = t), t = t.sibling;
      }
      return o;
    }
    function dA(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !Ub[e])
        if (Ub[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              m('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          m('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function pA(e, t) {
      e !== void 0 && !qg[e] && (e !== "collapsed" && e !== "hidden" ? (qg[e] = !0, m('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (qg[e] = !0, m('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function CT(e, t) {
      {
        var o = rr(e), i = !o && typeof bt(e) == "function";
        if (o || i) {
          var c = o ? "array" : "iterable";
          return m("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", c, t, c), !1;
        }
      }
      return !0;
    }
    function vA(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (rr(e)) {
          for (var o = 0; o < e.length; o++)
            if (!CT(e[o], o))
              return;
        } else {
          var i = bt(e);
          if (typeof i == "function") {
            var c = i.call(e);
            if (c)
              for (var v = c.next(), y = 0; !v.done; v = c.next()) {
                if (!CT(v.value, y))
                  return;
                y++;
              }
          } else
            m('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function Gb(e, t, o, i, c) {
      var v = e.memoizedState;
      v === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: o,
        tailMode: c
      } : (v.isBackwards = t, v.rendering = null, v.renderingStartTime = 0, v.last = i, v.tail = o, v.tailMode = c);
    }
    function ET(e, t, o) {
      var i = t.pendingProps, c = i.revealOrder, v = i.tail, y = i.children;
      dA(c), pA(v, c), vA(y, c), so(e, t, y, o);
      var b = Ga.current, w = WS(b, Ev);
      if (w)
        b = YS(b, Ev), t.flags |= tt;
      else {
        var M = e !== null && (e.flags & tt) !== nt;
        M && cA(t, t.child, o), b = ld(b);
      }
      if (zu(t, b), (t.mode & Et) === rt)
        t.memoizedState = null;
      else
        switch (c) {
          case "forwards": {
            var P = fA(t.child), Q;
            P === null ? (Q = t.child, t.child = null) : (Q = P.sibling, P.sibling = null), Gb(
              t,
              !1,
              // isBackwards
              Q,
              P,
              v
            );
            break;
          }
          case "backwards": {
            var Y = null, ee = t.child;
            for (t.child = null; ee !== null; ) {
              var ne = ee.alternate;
              if (ne !== null && Dg(ne) === null) {
                t.child = ee;
                break;
              }
              var ue = ee.sibling;
              ee.sibling = Y, Y = ee, ee = ue;
            }
            Gb(
              t,
              !0,
              // isBackwards
              Y,
              null,
              // last
              v
            );
            break;
          }
          case "together": {
            Gb(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function hA(e, t, o) {
      HS(t, t.stateNode.containerInfo);
      var i = t.pendingProps;
      return e === null ? t.child = rd(t, null, i, o) : so(e, t, i, o), t.child;
    }
    var wT = !1;
    function mA(e, t, o) {
      var i = t.type, c = i._context, v = t.pendingProps, y = t.memoizedProps, b = v.value;
      {
        "value" in v || wT || (wT = !0, m("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var w = t.type.propTypes;
        w && Va(w, v, "prop", "Context.Provider");
      }
      if (mw(t, c, b), y !== null) {
        var M = y.value;
        if (Se(M, b)) {
          if (y.children === v.children && !ig())
            return Ul(e, t, o);
        } else
          dN(t, c, o);
      }
      var P = v.children;
      return so(e, t, P, o), t.child;
    }
    var TT = !1;
    function gA(e, t, o) {
      var i = t.type;
      i._context === void 0 ? i !== i.Consumer && (TT || (TT = !0, m("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
      var c = t.pendingProps, v = c.children;
      typeof v != "function" && m("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), ad(t, o);
      var y = Jn(i);
      oo(t);
      var b;
      return Nv.current = t, nr(!0), b = v(y), nr(!1), ao(), t.flags |= Vo, so(e, t, b, o), t.child;
    }
    function Lv() {
      qa = !0;
    }
    function Zg(e, t) {
      (t.mode & Et) === rt && e !== null && (e.alternate = null, t.alternate = null, t.flags |= bn);
    }
    function Ul(e, t, o) {
      return e !== null && (t.dependencies = e.dependencies), eT(), Gv(t.lanes), Wr(o, t.childLanes) ? (cN(e, t), t.child) : null;
    }
    function yA(e, t, o) {
      {
        var i = t.return;
        if (i === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, o.index = t.index, o.sibling = t.sibling, o.return = t.return, o.ref = t.ref, t === i.child)
          i.child = o;
        else {
          var c = i.child;
          if (c === null)
            throw new Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw new Error("Expected to find the previous sibling.");
          c.sibling = o;
        }
        var v = i.deletions;
        return v === null ? (i.deletions = [e], i.flags |= bo) : v.push(e), o.flags |= bn, o;
      }
    }
    function Qb(e, t) {
      var o = e.lanes;
      return !!Wr(o, t);
    }
    function xA(e, t, o) {
      switch (t.tag) {
        case T:
          gT(t), t.stateNode, nd();
          break;
        case N:
          ww(t);
          break;
        case E: {
          var i = t.type;
          Li(i) && ug(t);
          break;
        }
        case O:
          HS(t, t.stateNode.containerInfo);
          break;
        case F: {
          var c = t.memoizedProps.value, v = t.type._context;
          mw(t, v, c);
          break;
        }
        case V:
          {
            var y = Wr(o, t.childLanes);
            y && (t.flags |= Dt);
            {
              var b = t.stateNode;
              b.effectDuration = 0, b.passiveEffectDuration = 0;
            }
          }
          break;
        case B: {
          var w = t.memoizedState;
          if (w !== null) {
            if (w.dehydrated !== null)
              return zu(t, ld(Ga.current)), t.flags |= tt, null;
            var M = t.child, P = M.childLanes;
            if (Wr(o, P))
              return xT(e, t, o);
            zu(t, ld(Ga.current));
            var Q = Ul(e, t, o);
            return Q !== null ? Q.sibling : null;
          } else
            zu(t, ld(Ga.current));
          break;
        }
        case Te: {
          var Y = (e.flags & tt) !== nt, ee = Wr(o, t.childLanes);
          if (Y) {
            if (ee)
              return ET(e, t, o);
            t.flags |= tt;
          }
          var ne = t.memoizedState;
          if (ne !== null && (ne.rendering = null, ne.tail = null, ne.lastEffect = null), zu(t, Ga.current), ee)
            break;
          return null;
        }
        case ce:
        case Ee:
          return t.lanes = he, vT(e, t, o);
      }
      return Ul(e, t, o);
    }
    function RT(e, t, o) {
      if (t._debugNeedsRemount && e !== null)
        return yA(e, t, w0(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var i = e.memoizedProps, c = t.pendingProps;
        if (i !== c || ig() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          qa = !0;
        else {
          var v = Qb(e, o);
          if (!v && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & tt) === nt)
            return qa = !1, xA(e, t, o);
          (e.flags & ef) !== nt ? qa = !0 : qa = !1;
        }
      } else if (qa = !1, Or() && VM(t)) {
        var y = t.index, b = WM();
        ew(t, b, y);
      }
      switch (t.lanes = he, t.tag) {
        case R:
          return eA(e, t, t.type, o);
        case pe: {
          var w = t.elementType;
          return ZN(e, t, w, o);
        }
        case C: {
          var M = t.type, P = t.pendingProps, Q = t.elementType === M ? P : Ka(M, P);
          return Fb(e, t, M, Q, o);
        }
        case E: {
          var Y = t.type, ee = t.pendingProps, ne = t.elementType === Y ? ee : Ka(Y, ee);
          return mT(e, t, Y, ne, o);
        }
        case T:
          return KN(e, t, o);
        case N:
          return qN(e, t, o);
        case j:
          return XN(e, t);
        case B:
          return xT(e, t, o);
        case O:
          return hA(e, t, o);
        case I: {
          var ue = t.type, Ae = t.pendingProps, ot = t.elementType === ue ? Ae : Ka(ue, Ae);
          return fT(e, t, ue, ot, o);
        }
        case k:
          return YN(e, t, o);
        case A:
          return GN(e, t, o);
        case V:
          return QN(e, t, o);
        case F:
          return mA(e, t, o);
        case z:
          return gA(e, t, o);
        case ae: {
          var Je = t.type, Nt = t.pendingProps, Ot = Ka(Je, Nt);
          if (t.type !== t.elementType) {
            var q = Je.propTypes;
            q && Va(
              q,
              Ot,
              // Resolved for outer only
              "prop",
              Wt(Je)
            );
          }
          return Ot = Ka(Je.type, Ot), dT(e, t, Je, Ot, o);
        }
        case Z:
          return pT(e, t, t.type, t.pendingProps, o);
        case de: {
          var se = t.type, X = t.pendingProps, Ce = t.elementType === se ? X : Ka(se, X);
          return JN(e, t, se, Ce, o);
        }
        case Te:
          return ET(e, t, o);
        case ve:
          break;
        case ce:
          return vT(e, t, o);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function pd(e) {
      e.flags |= Dt;
    }
    function _T(e) {
      e.flags |= yn, e.flags |= mu;
    }
    var OT, Kb, DT, kT;
    OT = function(e, t, o, i) {
      for (var c = t.child; c !== null; ) {
        if (c.tag === N || c.tag === j)
          Bk(e, c.stateNode);
        else if (c.tag !== O) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }, Kb = function(e, t) {
    }, DT = function(e, t, o, i, c) {
      var v = e.memoizedProps;
      if (v !== i) {
        var y = t.stateNode, b = $S(), w = $k(y, o, v, i, c, b);
        t.updateQueue = w, w && pd(t);
      }
    }, kT = function(e, t, o, i) {
      o !== i && pd(t);
    };
    function jv(e, t) {
      if (!Or())
        switch (e.tailMode) {
          case "hidden": {
            for (var o = e.tail, i = null; o !== null; )
              o.alternate !== null && (i = o), o = o.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          }
          case "collapsed": {
            for (var c = e.tail, v = null; c !== null; )
              c.alternate !== null && (v = c), c = c.sibling;
            v === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : v.sibling = null;
            break;
          }
        }
    }
    function kr(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, o = he, i = nt;
      if (t) {
        if ((e.mode & Lt) !== rt) {
          for (var w = e.selfBaseDuration, M = e.child; M !== null; )
            o = xt(o, xt(M.lanes, M.childLanes)), i |= M.subtreeFlags & Nn, i |= M.flags & Nn, w += M.treeBaseDuration, M = M.sibling;
          e.treeBaseDuration = w;
        } else
          for (var P = e.child; P !== null; )
            o = xt(o, xt(P.lanes, P.childLanes)), i |= P.subtreeFlags & Nn, i |= P.flags & Nn, P.return = e, P = P.sibling;
        e.subtreeFlags |= i;
      } else {
        if ((e.mode & Lt) !== rt) {
          for (var c = e.actualDuration, v = e.selfBaseDuration, y = e.child; y !== null; )
            o = xt(o, xt(y.lanes, y.childLanes)), i |= y.subtreeFlags, i |= y.flags, c += y.actualDuration, v += y.treeBaseDuration, y = y.sibling;
          e.actualDuration = c, e.treeBaseDuration = v;
        } else
          for (var b = e.child; b !== null; )
            o = xt(o, xt(b.lanes, b.childLanes)), i |= b.subtreeFlags, i |= b.flags, b.return = e, b = b.sibling;
        e.subtreeFlags |= i;
      }
      return e.childLanes = o, t;
    }
    function SA(e, t, o) {
      if (oN() && (t.mode & Et) !== rt && (t.flags & tt) === nt)
        return lw(t), nd(), t.flags |= Ur | Cs | Br, !1;
      var i = pg(t);
      if (o !== null && o.dehydrated !== null)
        if (e === null) {
          if (!i)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (nN(t), kr(t), (t.mode & Lt) !== rt) {
            var c = o !== null;
            if (c) {
              var v = t.child;
              v !== null && (t.treeBaseDuration -= v.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (nd(), (t.flags & tt) === nt && (t.memoizedState = null), t.flags |= Dt, kr(t), (t.mode & Lt) !== rt) {
            var y = o !== null;
            if (y) {
              var b = t.child;
              b !== null && (t.treeBaseDuration -= b.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return uw(), !0;
    }
    function MT(e, t, o) {
      var i = t.pendingProps;
      switch (bS(t), t.tag) {
        case R:
        case pe:
        case Z:
        case C:
        case I:
        case k:
        case A:
        case V:
        case z:
        case ae:
          return kr(t), null;
        case E: {
          var c = t.type;
          return Li(c) && lg(t), kr(t), null;
        }
        case T: {
          var v = t.stateNode;
          if (id(t), gS(t), QS(), v.pendingContext && (v.context = v.pendingContext, v.pendingContext = null), e === null || e.child === null) {
            var y = pg(t);
            if (y)
              pd(t);
            else if (e !== null) {
              var b = e.memoizedState;
              // Check if this is a client root
              (!b.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & Ur) !== nt) && (t.flags |= Hn, uw());
            }
          }
          return Kb(e, t), kr(t), null;
        }
        case N: {
          VS(t);
          var w = Ew(), M = t.type;
          if (e !== null && t.stateNode != null)
            DT(e, t, M, i, w), e.ref !== t.ref && _T(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return kr(t), null;
            }
            var P = $S(), Q = pg(t);
            if (Q)
              eN(t, w, P) && pd(t);
            else {
              var Y = Fk(M, i, w, P, t);
              OT(Y, t, !1, !1), t.stateNode = Y, Hk(Y, M, i, w) && pd(t);
            }
            t.ref !== null && _T(t);
          }
          return kr(t), null;
        }
        case j: {
          var ee = i;
          if (e && t.stateNode != null) {
            var ne = e.memoizedProps;
            kT(e, t, ne, ee);
          } else {
            if (typeof ee != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var ue = Ew(), Ae = $S(), ot = pg(t);
            ot ? tN(t) && pd(t) : t.stateNode = Vk(ee, ue, Ae, t);
          }
          return kr(t), null;
        }
        case B: {
          ud(t);
          var Je = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var Nt = SA(e, t, Je);
            if (!Nt)
              return t.flags & Br ? t : null;
          }
          if ((t.flags & tt) !== nt)
            return t.lanes = o, (t.mode & Lt) !== rt && xb(t), t;
          var Ot = Je !== null, q = e !== null && e.memoizedState !== null;
          if (Ot !== q && Ot) {
            var se = t.child;
            if (se.flags |= Mn, (t.mode & Et) !== rt) {
              var X = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              X || WS(Ga.current, Rw) ? bP() : p0();
            }
          }
          var Ce = t.updateQueue;
          if (Ce !== null && (t.flags |= Dt), kr(t), (t.mode & Lt) !== rt && Ot) {
            var He = t.child;
            He !== null && (t.treeBaseDuration -= He.treeBaseDuration);
          }
          return null;
        }
        case O:
          return id(t), Kb(e, t), e === null && zM(t.stateNode.containerInfo), kr(t), null;
        case F:
          var ze = t.type._context;
          return LS(ze, t), kr(t), null;
        case de: {
          var ct = t.type;
          return Li(ct) && lg(t), kr(t), null;
        }
        case Te: {
          ud(t);
          var pt = t.memoizedState;
          if (pt === null)
            return kr(t), null;
          var qt = (t.flags & tt) !== nt, It = pt.rendering;
          if (It === null)
            if (qt)
              jv(pt, !1);
            else {
              var Wn = EP() && (e === null || (e.flags & tt) === nt);
              if (!Wn)
                for (var Ut = t.child; Ut !== null; ) {
                  var In = Dg(Ut);
                  if (In !== null) {
                    qt = !0, t.flags |= tt, jv(pt, !1);
                    var Zr = In.updateQueue;
                    return Zr !== null && (t.updateQueue = Zr, t.flags |= Dt), t.subtreeFlags = nt, fN(t, o), zu(t, YS(Ga.current, Ev)), t.child;
                  }
                  Ut = Ut.sibling;
                }
              pt.tail !== null && $n() > ZT() && (t.flags |= tt, qt = !0, jv(pt, !1), t.lanes = Op);
            }
          else {
            if (!qt) {
              var Lr = Dg(It);
              if (Lr !== null) {
                t.flags |= tt, qt = !0;
                var Zo = Lr.updateQueue;
                if (Zo !== null && (t.updateQueue = Zo, t.flags |= Dt), jv(pt, !0), pt.tail === null && pt.tailMode === "hidden" && !It.alternate && !Or())
                  return kr(t), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              $n() * 2 - pt.renderingStartTime > ZT() && o !== io && (t.flags |= tt, qt = !0, jv(pt, !1), t.lanes = Op);
            }
            if (pt.isBackwards)
              It.sibling = t.child, t.child = It;
            else {
              var po = pt.last;
              po !== null ? po.sibling = It : t.child = It, pt.last = It;
            }
          }
          if (pt.tail !== null) {
            var vo = pt.tail;
            pt.rendering = vo, pt.tail = vo.sibling, pt.renderingStartTime = $n(), vo.sibling = null;
            var Jr = Ga.current;
            return qt ? Jr = YS(Jr, Ev) : Jr = ld(Jr), zu(t, Jr), vo;
          }
          return kr(t), null;
        }
        case ve:
          break;
        case ce:
        case Ee: {
          d0(t);
          var Vl = t.memoizedState, bd = Vl !== null;
          if (e !== null) {
            var Zv = e.memoizedState, $i = Zv !== null;
            $i !== bd && (t.flags |= Mn);
          }
          return !bd || (t.mode & Et) === rt ? kr(t) : Wr(Hi, io) && (kr(t), t.subtreeFlags & (bn | Dt) && (t.flags |= Mn)), null;
        }
        case Ue:
          return null;
        case Re:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function bA(e, t, o) {
      switch (bS(t), t.tag) {
        case E: {
          var i = t.type;
          Li(i) && lg(t);
          var c = t.flags;
          return c & Br ? (t.flags = c & -65537 | tt, (t.mode & Lt) !== rt && xb(t), t) : null;
        }
        case T: {
          t.stateNode, id(t), gS(t), QS();
          var v = t.flags;
          return (v & Br) !== nt && (v & tt) === nt ? (t.flags = v & -65537 | tt, t) : null;
        }
        case N:
          return VS(t), null;
        case B: {
          ud(t);
          var y = t.memoizedState;
          if (y !== null && y.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            nd();
          }
          var b = t.flags;
          return b & Br ? (t.flags = b & -65537 | tt, (t.mode & Lt) !== rt && xb(t), t) : null;
        }
        case Te:
          return ud(t), null;
        case O:
          return id(t), null;
        case F:
          var w = t.type._context;
          return LS(w, t), null;
        case ce:
        case Ee:
          return d0(t), null;
        case Ue:
          return null;
        default:
          return null;
      }
    }
    function NT(e, t, o) {
      switch (bS(t), t.tag) {
        case E: {
          var i = t.type.childContextTypes;
          i != null && lg(t);
          break;
        }
        case T: {
          t.stateNode, id(t), gS(t), QS();
          break;
        }
        case N: {
          VS(t);
          break;
        }
        case O:
          id(t);
          break;
        case B:
          ud(t);
          break;
        case Te:
          ud(t);
          break;
        case F:
          var c = t.type._context;
          LS(c, t);
          break;
        case ce:
        case Ee:
          d0(t);
          break;
      }
    }
    var AT = null;
    AT = /* @__PURE__ */ new Set();
    var Jg = !1, Mr = !1, CA = typeof WeakSet == "function" ? WeakSet : Set, Ge = null, vd = null, hd = null;
    function EA(e) {
      gi(null, function() {
        throw e;
      }), bs();
    }
    var wA = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Lt)
        try {
          Fi(), t.componentWillUnmount();
        } finally {
          Ui(e);
        }
      else
        t.componentWillUnmount();
    };
    function PT(e, t) {
      try {
        Fu(sr, e);
      } catch (o) {
        on(e, t, o);
      }
    }
    function qb(e, t, o) {
      try {
        wA(e, o);
      } catch (i) {
        on(e, t, i);
      }
    }
    function TA(e, t, o) {
      try {
        o.componentDidMount();
      } catch (i) {
        on(e, t, i);
      }
    }
    function LT(e, t) {
      try {
        zT(e);
      } catch (o) {
        on(e, t, o);
      }
    }
    function md(e, t) {
      var o = e.ref;
      if (o !== null)
        if (typeof o == "function") {
          var i;
          try {
            if (ke && et && e.mode & Lt)
              try {
                Fi(), i = o(null);
              } finally {
                Ui(e);
              }
            else
              i = o(null);
          } catch (c) {
            on(e, t, c);
          }
          typeof i == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", yt(e));
        } else
          o.current = null;
    }
    function ey(e, t, o) {
      try {
        o();
      } catch (i) {
        on(e, t, i);
      }
    }
    var jT = !1;
    function RA(e, t) {
      Ik(e.containerInfo), Ge = t, _A();
      var o = jT;
      return jT = !1, o;
    }
    function _A() {
      for (; Ge !== null; ) {
        var e = Ge, t = e.child;
        (e.subtreeFlags & xi) !== nt && t !== null ? (t.return = e, Ge = t) : OA();
      }
    }
    function OA() {
      for (; Ge !== null; ) {
        var e = Ge;
        rn(e);
        try {
          DA(e);
        } catch (o) {
          on(e, e.return, o);
        }
        gn();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, Ge = t;
          return;
        }
        Ge = e.return;
      }
    }
    function DA(e) {
      var t = e.alternate, o = e.flags;
      if ((o & Hn) !== nt) {
        switch (rn(e), e.tag) {
          case C:
          case I:
          case Z:
            break;
          case E: {
            if (t !== null) {
              var i = t.memoizedProps, c = t.memoizedState, v = e.stateNode;
              e.type === e.elementType && !vc && (v.props !== e.memoizedProps && m("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", yt(e) || "instance"), v.state !== e.memoizedState && m("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", yt(e) || "instance"));
              var y = v.getSnapshotBeforeUpdate(e.elementType === e.type ? i : Ka(e.type, i), c);
              {
                var b = AT;
                y === void 0 && !b.has(e.type) && (b.add(e.type), m("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", yt(e)));
              }
              v.__reactInternalSnapshotBeforeUpdate = y;
            }
            break;
          }
          case T: {
            {
              var w = e.stateNode;
              sM(w.containerInfo);
            }
            break;
          }
          case N:
          case j:
          case O:
          case de:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        gn();
      }
    }
    function Xa(e, t, o) {
      var i = t.updateQueue, c = i !== null ? i.lastEffect : null;
      if (c !== null) {
        var v = c.next, y = v;
        do {
          if ((y.tag & e) === e) {
            var b = y.destroy;
            y.destroy = void 0, b !== void 0 && ((e & Dr) !== No ? Ia(t) : (e & sr) !== No && ws(t), (e & ji) !== No && Kv(!0), ey(t, o, b), (e & ji) !== No && Kv(!1), (e & Dr) !== No ? Ei() : (e & sr) !== No && Rp());
          }
          y = y.next;
        } while (y !== v);
      }
    }
    function Fu(e, t) {
      var o = t.updateQueue, i = o !== null ? o.lastEffect : null;
      if (i !== null) {
        var c = i.next, v = c;
        do {
          if ((v.tag & e) === e) {
            (e & Dr) !== No ? Tp(t) : (e & sr) !== No && lf(t);
            var y = v.create;
            (e & ji) !== No && Kv(!0), v.destroy = y(), (e & ji) !== No && Kv(!1), (e & Dr) !== No ? am() : (e & sr) !== No && im();
            {
              var b = v.destroy;
              if (b !== void 0 && typeof b != "function") {
                var w = void 0;
                (v.tag & sr) !== nt ? w = "useLayoutEffect" : (v.tag & ji) !== nt ? w = "useInsertionEffect" : w = "useEffect";
                var M = void 0;
                b === null ? M = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof b.then == "function" ? M = `

It looks like you wrote ` + w + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + w + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : M = " You returned: " + b, m("%s must not return anything besides a function, which is used for clean-up.%s", w, M);
              }
            }
          }
          v = v.next;
        } while (v !== c);
      }
    }
    function kA(e, t) {
      if ((t.flags & Dt) !== nt)
        switch (t.tag) {
          case V: {
            var o = t.stateNode.passiveEffectDuration, i = t.memoizedProps, c = i.id, v = i.onPostCommit, y = Zw(), b = t.alternate === null ? "mount" : "update";
            Xw() && (b = "nested-update"), typeof v == "function" && v(c, b, o, y);
            var w = t.return;
            e: for (; w !== null; ) {
              switch (w.tag) {
                case T:
                  var M = w.stateNode;
                  M.passiveEffectDuration += o;
                  break e;
                case V:
                  var P = w.stateNode;
                  P.passiveEffectDuration += o;
                  break e;
              }
              w = w.return;
            }
            break;
          }
        }
    }
    function MA(e, t, o, i) {
      if ((o.flags & bi) !== nt)
        switch (o.tag) {
          case C:
          case I:
          case Z: {
            if (!Mr)
              if (o.mode & Lt)
                try {
                  Fi(), Fu(sr | ur, o);
                } finally {
                  Ui(o);
                }
              else
                Fu(sr | ur, o);
            break;
          }
          case E: {
            var c = o.stateNode;
            if (o.flags & Dt && !Mr)
              if (t === null)
                if (o.type === o.elementType && !vc && (c.props !== o.memoizedProps && m("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", yt(o) || "instance"), c.state !== o.memoizedState && m("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", yt(o) || "instance")), o.mode & Lt)
                  try {
                    Fi(), c.componentDidMount();
                  } finally {
                    Ui(o);
                  }
                else
                  c.componentDidMount();
              else {
                var v = o.elementType === o.type ? t.memoizedProps : Ka(o.type, t.memoizedProps), y = t.memoizedState;
                if (o.type === o.elementType && !vc && (c.props !== o.memoizedProps && m("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", yt(o) || "instance"), c.state !== o.memoizedState && m("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", yt(o) || "instance")), o.mode & Lt)
                  try {
                    Fi(), c.componentDidUpdate(v, y, c.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Ui(o);
                  }
                else
                  c.componentDidUpdate(v, y, c.__reactInternalSnapshotBeforeUpdate);
              }
            var b = o.updateQueue;
            b !== null && (o.type === o.elementType && !vc && (c.props !== o.memoizedProps && m("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", yt(o) || "instance"), c.state !== o.memoizedState && m("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", yt(o) || "instance")), Cw(o, b, c));
            break;
          }
          case T: {
            var w = o.updateQueue;
            if (w !== null) {
              var M = null;
              if (o.child !== null)
                switch (o.child.tag) {
                  case N:
                    M = o.child.stateNode;
                    break;
                  case E:
                    M = o.child.stateNode;
                    break;
                }
              Cw(o, w, M);
            }
            break;
          }
          case N: {
            var P = o.stateNode;
            if (t === null && o.flags & Dt) {
              var Q = o.type, Y = o.memoizedProps;
              Kk(P, Q, Y);
            }
            break;
          }
          case j:
            break;
          case O:
            break;
          case V: {
            {
              var ee = o.memoizedProps, ne = ee.onCommit, ue = ee.onRender, Ae = o.stateNode.effectDuration, ot = Zw(), Je = t === null ? "mount" : "update";
              Xw() && (Je = "nested-update"), typeof ue == "function" && ue(o.memoizedProps.id, Je, o.actualDuration, o.treeBaseDuration, o.actualStartTime, ot);
              {
                typeof ne == "function" && ne(o.memoizedProps.id, Je, Ae, ot), OP(o);
                var Nt = o.return;
                e: for (; Nt !== null; ) {
                  switch (Nt.tag) {
                    case T:
                      var Ot = Nt.stateNode;
                      Ot.effectDuration += Ae;
                      break e;
                    case V:
                      var q = Nt.stateNode;
                      q.effectDuration += Ae;
                      break e;
                  }
                  Nt = Nt.return;
                }
              }
            }
            break;
          }
          case B: {
            UA(e, o);
            break;
          }
          case Te:
          case de:
          case ve:
          case ce:
          case Ee:
          case Re:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Mr || o.flags & yn && zT(o);
    }
    function NA(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          if (e.mode & Lt)
            try {
              Fi(), PT(e, e.return);
            } finally {
              Ui(e);
            }
          else
            PT(e, e.return);
          break;
        }
        case E: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && TA(e, e.return, t), LT(e, e.return);
          break;
        }
        case N: {
          LT(e, e.return);
          break;
        }
      }
    }
    function AA(e, t) {
      for (var o = null, i = e; ; ) {
        if (i.tag === N) {
          if (o === null) {
            o = i;
            try {
              var c = i.stateNode;
              t ? aM(c) : lM(i.stateNode, i.memoizedProps);
            } catch (y) {
              on(e, e.return, y);
            }
          }
        } else if (i.tag === j) {
          if (o === null)
            try {
              var v = i.stateNode;
              t ? iM(v) : uM(v, i.memoizedProps);
            } catch (y) {
              on(e, e.return, y);
            }
        } else if (!((i.tag === ce || i.tag === Ee) && i.memoizedState !== null && i !== e)) {
          if (i.child !== null) {
            i.child.return = i, i = i.child;
            continue;
          }
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          o === i && (o = null), i = i.return;
        }
        o === i && (o = null), i.sibling.return = i.return, i = i.sibling;
      }
    }
    function zT(e) {
      var t = e.ref;
      if (t !== null) {
        var o = e.stateNode, i;
        switch (e.tag) {
          case N:
            i = o;
            break;
          default:
            i = o;
        }
        if (typeof t == "function") {
          var c;
          if (e.mode & Lt)
            try {
              Fi(), c = t(i);
            } finally {
              Ui(e);
            }
          else
            c = t(i);
          typeof c == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", yt(e));
        } else
          t.hasOwnProperty("current") || m("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", yt(e)), t.current = i;
      }
    }
    function PA(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function IT(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, IT(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === N) {
          var o = e.stateNode;
          o !== null && FM(o);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function LA(e) {
      for (var t = e.return; t !== null; ) {
        if (UT(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function UT(e) {
      return e.tag === N || e.tag === T || e.tag === O;
    }
    function FT(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || UT(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== N && t.tag !== j && t.tag !== me; ) {
          if (t.flags & bn || t.child === null || t.tag === O)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & bn))
          return t.stateNode;
      }
    }
    function jA(e) {
      var t = LA(e);
      switch (t.tag) {
        case N: {
          var o = t.stateNode;
          t.flags & Wo && (HE(o), t.flags &= -33);
          var i = FT(e);
          Zb(e, i, o);
          break;
        }
        case T:
        case O: {
          var c = t.stateNode.containerInfo, v = FT(e);
          Xb(e, v, c);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Xb(e, t, o) {
      var i = e.tag, c = i === N || i === j;
      if (c) {
        var v = e.stateNode;
        t ? tM(o, v, t) : Jk(o, v);
      } else if (i !== O) {
        var y = e.child;
        if (y !== null) {
          Xb(y, t, o);
          for (var b = y.sibling; b !== null; )
            Xb(b, t, o), b = b.sibling;
        }
      }
    }
    function Zb(e, t, o) {
      var i = e.tag, c = i === N || i === j;
      if (c) {
        var v = e.stateNode;
        t ? eM(o, v, t) : Zk(o, v);
      } else if (i !== O) {
        var y = e.child;
        if (y !== null) {
          Zb(y, t, o);
          for (var b = y.sibling; b !== null; )
            Zb(b, t, o), b = b.sibling;
        }
      }
    }
    var Nr = null, Za = !1;
    function zA(e, t, o) {
      {
        var i = t;
        e: for (; i !== null; ) {
          switch (i.tag) {
            case N: {
              Nr = i.stateNode, Za = !1;
              break e;
            }
            case T: {
              Nr = i.stateNode.containerInfo, Za = !0;
              break e;
            }
            case O: {
              Nr = i.stateNode.containerInfo, Za = !0;
              break e;
            }
          }
          i = i.return;
        }
        if (Nr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        BT(e, t, o), Nr = null, Za = !1;
      }
      PA(o);
    }
    function Bu(e, t, o) {
      for (var i = o.child; i !== null; )
        BT(e, t, i), i = i.sibling;
    }
    function BT(e, t, o) {
      switch (Cp(o), o.tag) {
        case N:
          Mr || md(o, t);
        case j: {
          {
            var i = Nr, c = Za;
            Nr = null, Bu(e, t, o), Nr = i, Za = c, Nr !== null && (Za ? rM(Nr, o.stateNode) : nM(Nr, o.stateNode));
          }
          return;
        }
        case me: {
          Nr !== null && (Za ? oM(Nr, o.stateNode) : sS(Nr, o.stateNode));
          return;
        }
        case O: {
          {
            var v = Nr, y = Za;
            Nr = o.stateNode.containerInfo, Za = !0, Bu(e, t, o), Nr = v, Za = y;
          }
          return;
        }
        case C:
        case I:
        case ae:
        case Z: {
          if (!Mr) {
            var b = o.updateQueue;
            if (b !== null) {
              var w = b.lastEffect;
              if (w !== null) {
                var M = w.next, P = M;
                do {
                  var Q = P, Y = Q.destroy, ee = Q.tag;
                  Y !== void 0 && ((ee & ji) !== No ? ey(o, t, Y) : (ee & sr) !== No && (ws(o), o.mode & Lt ? (Fi(), ey(o, t, Y), Ui(o)) : ey(o, t, Y), Rp())), P = P.next;
                } while (P !== M);
              }
            }
          }
          Bu(e, t, o);
          return;
        }
        case E: {
          if (!Mr) {
            md(o, t);
            var ne = o.stateNode;
            typeof ne.componentWillUnmount == "function" && qb(o, t, ne);
          }
          Bu(e, t, o);
          return;
        }
        case ve: {
          Bu(e, t, o);
          return;
        }
        case ce: {
          if (
            // TODO: Remove this dead flag
            o.mode & Et
          ) {
            var ue = Mr;
            Mr = ue || o.memoizedState !== null, Bu(e, t, o), Mr = ue;
          } else
            Bu(e, t, o);
          break;
        }
        default: {
          Bu(e, t, o);
          return;
        }
      }
    }
    function IA(e) {
      e.memoizedState;
    }
    function UA(e, t) {
      var o = t.memoizedState;
      if (o === null) {
        var i = t.alternate;
        if (i !== null) {
          var c = i.memoizedState;
          if (c !== null) {
            var v = c.dehydrated;
            v !== null && EM(v);
          }
        }
      }
    }
    function HT(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var o = e.stateNode;
        o === null && (o = e.stateNode = new CA()), t.forEach(function(i) {
          var c = LP.bind(null, e, i);
          if (!o.has(i)) {
            if (o.add(i), Vr)
              if (vd !== null && hd !== null)
                Qv(hd, vd);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            i.then(c, c);
          }
        });
      }
    }
    function FA(e, t, o) {
      vd = o, hd = e, rn(t), $T(t, e), rn(t), vd = null, hd = null;
    }
    function Ja(e, t, o) {
      var i = t.deletions;
      if (i !== null)
        for (var c = 0; c < i.length; c++) {
          var v = i[c];
          try {
            zA(e, t, v);
          } catch (w) {
            on(v, t, w);
          }
        }
      var y = as();
      if (t.subtreeFlags & Si)
        for (var b = t.child; b !== null; )
          rn(b), $T(b, e), b = b.sibling;
      rn(y);
    }
    function $T(e, t, o) {
      var i = e.alternate, c = e.flags;
      switch (e.tag) {
        case C:
        case I:
        case ae:
        case Z: {
          if (Ja(t, e), Bi(e), c & Dt) {
            try {
              Xa(ji | ur, e, e.return), Fu(ji | ur, e);
            } catch (ct) {
              on(e, e.return, ct);
            }
            if (e.mode & Lt) {
              try {
                Fi(), Xa(sr | ur, e, e.return);
              } catch (ct) {
                on(e, e.return, ct);
              }
              Ui(e);
            } else
              try {
                Xa(sr | ur, e, e.return);
              } catch (ct) {
                on(e, e.return, ct);
              }
          }
          return;
        }
        case E: {
          Ja(t, e), Bi(e), c & yn && i !== null && md(i, i.return);
          return;
        }
        case N: {
          Ja(t, e), Bi(e), c & yn && i !== null && md(i, i.return);
          {
            if (e.flags & Wo) {
              var v = e.stateNode;
              try {
                HE(v);
              } catch (ct) {
                on(e, e.return, ct);
              }
            }
            if (c & Dt) {
              var y = e.stateNode;
              if (y != null) {
                var b = e.memoizedProps, w = i !== null ? i.memoizedProps : b, M = e.type, P = e.updateQueue;
                if (e.updateQueue = null, P !== null)
                  try {
                    qk(y, P, M, w, b, e);
                  } catch (ct) {
                    on(e, e.return, ct);
                  }
              }
            }
          }
          return;
        }
        case j: {
          if (Ja(t, e), Bi(e), c & Dt) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Q = e.stateNode, Y = e.memoizedProps, ee = i !== null ? i.memoizedProps : Y;
            try {
              Xk(Q, ee, Y);
            } catch (ct) {
              on(e, e.return, ct);
            }
          }
          return;
        }
        case T: {
          if (Ja(t, e), Bi(e), c & Dt && i !== null) {
            var ne = i.memoizedState;
            if (ne.isDehydrated)
              try {
                CM(t.containerInfo);
              } catch (ct) {
                on(e, e.return, ct);
              }
          }
          return;
        }
        case O: {
          Ja(t, e), Bi(e);
          return;
        }
        case B: {
          Ja(t, e), Bi(e);
          var ue = e.child;
          if (ue.flags & Mn) {
            var Ae = ue.stateNode, ot = ue.memoizedState, Je = ot !== null;
            if (Ae.isHidden = Je, Je) {
              var Nt = ue.alternate !== null && ue.alternate.memoizedState !== null;
              Nt || SP();
            }
          }
          if (c & Dt) {
            try {
              IA(e);
            } catch (ct) {
              on(e, e.return, ct);
            }
            HT(e);
          }
          return;
        }
        case ce: {
          var Ot = i !== null && i.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & Et
          ) {
            var q = Mr;
            Mr = q || Ot, Ja(t, e), Mr = q;
          } else
            Ja(t, e);
          if (Bi(e), c & Mn) {
            var se = e.stateNode, X = e.memoizedState, Ce = X !== null, He = e;
            if (se.isHidden = Ce, Ce && !Ot && (He.mode & Et) !== rt) {
              Ge = He;
              for (var ze = He.child; ze !== null; )
                Ge = ze, HA(ze), ze = ze.sibling;
            }
            AA(He, Ce);
          }
          return;
        }
        case Te: {
          Ja(t, e), Bi(e), c & Dt && HT(e);
          return;
        }
        case ve:
          return;
        default: {
          Ja(t, e), Bi(e);
          return;
        }
      }
    }
    function Bi(e) {
      var t = e.flags;
      if (t & bn) {
        try {
          jA(e);
        } catch (o) {
          on(e, e.return, o);
        }
        e.flags &= -3;
      }
      t & Co && (e.flags &= -4097);
    }
    function BA(e, t, o) {
      vd = o, hd = t, Ge = e, VT(e, t, o), vd = null, hd = null;
    }
    function VT(e, t, o) {
      for (var i = (e.mode & Et) !== rt; Ge !== null; ) {
        var c = Ge, v = c.child;
        if (c.tag === ce && i) {
          var y = c.memoizedState !== null, b = y || Jg;
          if (b) {
            Jb(e, t, o);
            continue;
          } else {
            var w = c.alternate, M = w !== null && w.memoizedState !== null, P = M || Mr, Q = Jg, Y = Mr;
            Jg = b, Mr = P, Mr && !Y && (Ge = c, $A(c));
            for (var ee = v; ee !== null; )
              Ge = ee, VT(
                ee,
                // New root; bubble back up to here and stop.
                t,
                o
              ), ee = ee.sibling;
            Ge = c, Jg = Q, Mr = Y, Jb(e, t, o);
            continue;
          }
        }
        (c.subtreeFlags & bi) !== nt && v !== null ? (v.return = c, Ge = v) : Jb(e, t, o);
      }
    }
    function Jb(e, t, o) {
      for (; Ge !== null; ) {
        var i = Ge;
        if ((i.flags & bi) !== nt) {
          var c = i.alternate;
          rn(i);
          try {
            MA(t, c, i, o);
          } catch (y) {
            on(i, i.return, y);
          }
          gn();
        }
        if (i === e) {
          Ge = null;
          return;
        }
        var v = i.sibling;
        if (v !== null) {
          v.return = i.return, Ge = v;
          return;
        }
        Ge = i.return;
      }
    }
    function HA(e) {
      for (; Ge !== null; ) {
        var t = Ge, o = t.child;
        switch (t.tag) {
          case C:
          case I:
          case ae:
          case Z: {
            if (t.mode & Lt)
              try {
                Fi(), Xa(sr, t, t.return);
              } finally {
                Ui(t);
              }
            else
              Xa(sr, t, t.return);
            break;
          }
          case E: {
            md(t, t.return);
            var i = t.stateNode;
            typeof i.componentWillUnmount == "function" && qb(t, t.return, i);
            break;
          }
          case N: {
            md(t, t.return);
            break;
          }
          case ce: {
            var c = t.memoizedState !== null;
            if (c) {
              WT(e);
              continue;
            }
            break;
          }
        }
        o !== null ? (o.return = t, Ge = o) : WT(e);
      }
    }
    function WT(e) {
      for (; Ge !== null; ) {
        var t = Ge;
        if (t === e) {
          Ge = null;
          return;
        }
        var o = t.sibling;
        if (o !== null) {
          o.return = t.return, Ge = o;
          return;
        }
        Ge = t.return;
      }
    }
    function $A(e) {
      for (; Ge !== null; ) {
        var t = Ge, o = t.child;
        if (t.tag === ce) {
          var i = t.memoizedState !== null;
          if (i) {
            YT(e);
            continue;
          }
        }
        o !== null ? (o.return = t, Ge = o) : YT(e);
      }
    }
    function YT(e) {
      for (; Ge !== null; ) {
        var t = Ge;
        rn(t);
        try {
          NA(t);
        } catch (i) {
          on(t, t.return, i);
        }
        if (gn(), t === e) {
          Ge = null;
          return;
        }
        var o = t.sibling;
        if (o !== null) {
          o.return = t.return, Ge = o;
          return;
        }
        Ge = t.return;
      }
    }
    function VA(e, t, o, i) {
      Ge = t, WA(t, e, o, i);
    }
    function WA(e, t, o, i) {
      for (; Ge !== null; ) {
        var c = Ge, v = c.child;
        (c.subtreeFlags & ja) !== nt && v !== null ? (v.return = c, Ge = v) : YA(e, t, o, i);
      }
    }
    function YA(e, t, o, i) {
      for (; Ge !== null; ) {
        var c = Ge;
        if ((c.flags & Fr) !== nt) {
          rn(c);
          try {
            GA(t, c, o, i);
          } catch (y) {
            on(c, c.return, y);
          }
          gn();
        }
        if (c === e) {
          Ge = null;
          return;
        }
        var v = c.sibling;
        if (v !== null) {
          v.return = c.return, Ge = v;
          return;
        }
        Ge = c.return;
      }
    }
    function GA(e, t, o, i) {
      switch (t.tag) {
        case C:
        case I:
        case Z: {
          if (t.mode & Lt) {
            yb();
            try {
              Fu(Dr | ur, t);
            } finally {
              gb(t);
            }
          } else
            Fu(Dr | ur, t);
          break;
        }
      }
    }
    function QA(e) {
      Ge = e, KA();
    }
    function KA() {
      for (; Ge !== null; ) {
        var e = Ge, t = e.child;
        if ((Ge.flags & bo) !== nt) {
          var o = e.deletions;
          if (o !== null) {
            for (var i = 0; i < o.length; i++) {
              var c = o[i];
              Ge = c, ZA(c, e);
            }
            {
              var v = e.alternate;
              if (v !== null) {
                var y = v.child;
                if (y !== null) {
                  v.child = null;
                  do {
                    var b = y.sibling;
                    y.sibling = null, y = b;
                  } while (y !== null);
                }
              }
            }
            Ge = e;
          }
        }
        (e.subtreeFlags & ja) !== nt && t !== null ? (t.return = e, Ge = t) : qA();
      }
    }
    function qA() {
      for (; Ge !== null; ) {
        var e = Ge;
        (e.flags & Fr) !== nt && (rn(e), XA(e), gn());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, Ge = t;
          return;
        }
        Ge = e.return;
      }
    }
    function XA(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          e.mode & Lt ? (yb(), Xa(Dr | ur, e, e.return), gb(e)) : Xa(Dr | ur, e, e.return);
          break;
        }
      }
    }
    function ZA(e, t) {
      for (; Ge !== null; ) {
        var o = Ge;
        rn(o), eP(o, t), gn();
        var i = o.child;
        i !== null ? (i.return = o, Ge = i) : JA(e);
      }
    }
    function JA(e) {
      for (; Ge !== null; ) {
        var t = Ge, o = t.sibling, i = t.return;
        if (IT(t), t === e) {
          Ge = null;
          return;
        }
        if (o !== null) {
          o.return = i, Ge = o;
          return;
        }
        Ge = i;
      }
    }
    function eP(e, t) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          e.mode & Lt ? (yb(), Xa(Dr, e, t), gb(e)) : Xa(Dr, e, t);
          break;
        }
      }
    }
    function tP(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          try {
            Fu(sr | ur, e);
          } catch (o) {
            on(e, e.return, o);
          }
          break;
        }
        case E: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (o) {
            on(e, e.return, o);
          }
          break;
        }
      }
    }
    function nP(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          try {
            Fu(Dr | ur, e);
          } catch (t) {
            on(e, e.return, t);
          }
          break;
        }
      }
    }
    function rP(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z: {
          try {
            Xa(sr | ur, e, e.return);
          } catch (o) {
            on(e, e.return, o);
          }
          break;
        }
        case E: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && qb(e, e.return, t);
          break;
        }
      }
    }
    function oP(e) {
      switch (e.tag) {
        case C:
        case I:
        case Z:
          try {
            Xa(Dr | ur, e, e.return);
          } catch (t) {
            on(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var zv = Symbol.for;
      zv("selector.component"), zv("selector.has_pseudo_class"), zv("selector.role"), zv("selector.test_id"), zv("selector.text");
    }
    var aP = [];
    function iP() {
      aP.forEach(function(e) {
        return e();
      });
    }
    var lP = s.ReactCurrentActQueue;
    function uP(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), o = typeof jest < "u";
        return o && t !== !1;
      }
    }
    function GT() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && lP.current !== null && m("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var sP = Math.ceil, e0 = s.ReactCurrentDispatcher, t0 = s.ReactCurrentOwner, Ar = s.ReactCurrentBatchConfig, ei = s.ReactCurrentActQueue, dr = (
      /*             */
      0
    ), QT = (
      /*               */
      1
    ), Pr = (
      /*                */
      2
    ), Sa = (
      /*                */
      4
    ), Fl = 0, Iv = 1, hc = 2, ty = 3, Uv = 4, KT = 5, n0 = 6, Mt = dr, co = null, _n = null, pr = he, Hi = he, r0 = Mu(he), vr = Fl, Fv = null, ny = he, Bv = he, ry = he, Hv = null, Ao = null, o0 = 0, qT = 500, XT = 1 / 0, cP = 500, Bl = null;
    function $v() {
      XT = $n() + cP;
    }
    function ZT() {
      return XT;
    }
    var oy = !1, a0 = null, gd = null, mc = !1, Hu = null, Vv = he, i0 = [], l0 = null, fP = 50, Wv = 0, u0 = null, s0 = !1, ay = !1, dP = 50, yd = 0, iy = null, Yv = Jt, ly = he, JT = !1;
    function uy() {
      return co;
    }
    function fo() {
      return (Mt & (Pr | Sa)) !== dr ? $n() : (Yv !== Jt || (Yv = $n()), Yv);
    }
    function $u(e) {
      var t = e.mode;
      if ((t & Et) === rt)
        return st;
      if ((Mt & Pr) !== dr && pr !== he)
        return zs(pr);
      var o = lN() !== iN;
      if (o) {
        if (Ar.transition !== null) {
          var i = Ar.transition;
          i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
        }
        return ly === Pt && (ly = Pp()), ly;
      }
      var c = Oo();
      if (c !== Pt)
        return c;
      var v = Wk();
      return v;
    }
    function pP(e) {
      var t = e.mode;
      return (t & Et) === rt ? st : dm();
    }
    function hr(e, t, o, i) {
      zP(), JT && m("useInsertionEffect must not schedule updates."), s0 && (ay = !0), Su(e, o, i), (Mt & Pr) !== he && e === co ? FP(t) : (Vr && Fs(e, t, o), BP(t), e === co && ((Mt & Pr) === dr && (Bv = xt(Bv, o)), vr === Uv && Vu(e, pr)), Po(e, i), o === st && Mt === dr && (t.mode & Et) === rt && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !ei.isBatchingLegacy && ($v(), JE()));
    }
    function vP(e, t, o) {
      var i = e.current;
      i.lanes = t, Su(e, t, o), Po(e, o);
    }
    function hP(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Mt & Pr) !== dr
      );
    }
    function Po(e, t) {
      var o = e.callbackNode;
      _f(e, t);
      var i = Rf(e, e === co ? pr : he);
      if (i === he) {
        o !== null && hR(o), e.callbackNode = null, e.callbackPriority = Pt;
        return;
      }
      var c = Ri(i), v = e.callbackPriority;
      if (v === c && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(ei.current !== null && o !== m0)) {
        o == null && v !== st && m("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      o != null && hR(o);
      var y;
      if (c === st)
        e.tag === Nu ? (ei.isBatchingLegacy !== null && (ei.didScheduleLegacyUpdate = !0), $M(nR.bind(null, e))) : ZE(nR.bind(null, e)), ei.current !== null ? ei.current.push(Au) : Gk(function() {
          (Mt & (Pr | Sa)) === dr && Au();
        }), y = null;
      else {
        var b;
        switch (xm(i)) {
          case Er:
            b = Es;
            break;
          case ca:
            b = Ci;
            break;
          case Ro:
            b = za;
            break;
          case _o:
            b = vl;
            break;
          default:
            b = za;
            break;
        }
        y = g0(b, eR.bind(null, e));
      }
      e.callbackPriority = c, e.callbackNode = y;
    }
    function eR(e, t) {
      if (AN(), Yv = Jt, ly = he, (Mt & (Pr | Sa)) !== dr)
        throw new Error("Should not already be working.");
      var o = e.callbackNode, i = $l();
      if (i && e.callbackNode !== o)
        return null;
      var c = Rf(e, e === co ? pr : he);
      if (c === he)
        return null;
      var v = !Df(e, c) && !fm(e, c) && !t, y = v ? TP(e, c) : cy(e, c);
      if (y !== Fl) {
        if (y === hc) {
          var b = Of(e);
          b !== he && (c = b, y = c0(e, b));
        }
        if (y === Iv) {
          var w = Fv;
          throw gc(e, he), Vu(e, c), Po(e, $n()), w;
        }
        if (y === n0)
          Vu(e, c);
        else {
          var M = !Df(e, c), P = e.current.alternate;
          if (M && !gP(P)) {
            if (y = cy(e, c), y === hc) {
              var Q = Of(e);
              Q !== he && (c = Q, y = c0(e, Q));
            }
            if (y === Iv) {
              var Y = Fv;
              throw gc(e, he), Vu(e, c), Po(e, $n()), Y;
            }
          }
          e.finishedWork = P, e.finishedLanes = c, mP(e, y, c);
        }
      }
      return Po(e, $n()), e.callbackNode === o ? eR.bind(null, e) : null;
    }
    function c0(e, t) {
      var o = Hv;
      if (Nf(e)) {
        var i = gc(e, t);
        i.flags |= Ur, jM(e.containerInfo);
      }
      var c = cy(e, t);
      if (c !== hc) {
        var v = Ao;
        Ao = o, v !== null && tR(v);
      }
      return c;
    }
    function tR(e) {
      Ao === null ? Ao = e : Ao.push.apply(Ao, e);
    }
    function mP(e, t, o) {
      switch (t) {
        case Fl:
        case Iv:
          throw new Error("Root did not complete. This is a bug in React.");
        case hc: {
          yc(e, Ao, Bl);
          break;
        }
        case ty: {
          if (Vu(e, o), Tl(o) && // do not delay if we're inside an act() scope
          !mR()) {
            var i = o0 + qT - $n();
            if (i > 10) {
              var c = Rf(e, he);
              if (c !== he)
                break;
              var v = e.suspendedLanes;
              if (!Rl(v, o)) {
                fo(), kf(e, v);
                break;
              }
              e.timeoutHandle = lS(yc.bind(null, e, Ao, Bl), i);
              break;
            }
          }
          yc(e, Ao, Bl);
          break;
        }
        case Uv: {
          if (Vu(e, o), Np(o))
            break;
          if (!mR()) {
            var y = Go(e, o), b = y, w = $n() - b, M = jP(w) - w;
            if (M > 10) {
              e.timeoutHandle = lS(yc.bind(null, e, Ao, Bl), M);
              break;
            }
          }
          yc(e, Ao, Bl);
          break;
        }
        case KT: {
          yc(e, Ao, Bl);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function gP(e) {
      for (var t = e; ; ) {
        if (t.flags & hu) {
          var o = t.updateQueue;
          if (o !== null) {
            var i = o.stores;
            if (i !== null)
              for (var c = 0; c < i.length; c++) {
                var v = i[c], y = v.getSnapshot, b = v.value;
                try {
                  if (!Se(y(), b))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var w = t.child;
        if (t.subtreeFlags & hu && w !== null) {
          w.return = t, t = w;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function Vu(e, t) {
      t = Is(t, ry), t = Is(t, Bv), hm(e, t);
    }
    function nR(e) {
      if (PN(), (Mt & (Pr | Sa)) !== dr)
        throw new Error("Should not already be working.");
      $l();
      var t = Rf(e, he);
      if (!Wr(t, st))
        return Po(e, $n()), null;
      var o = cy(e, t);
      if (e.tag !== Nu && o === hc) {
        var i = Of(e);
        i !== he && (t = i, o = c0(e, i));
      }
      if (o === Iv) {
        var c = Fv;
        throw gc(e, he), Vu(e, t), Po(e, $n()), c;
      }
      if (o === n0)
        throw new Error("Root did not complete. This is a bug in React.");
      var v = e.current.alternate;
      return e.finishedWork = v, e.finishedLanes = t, yc(e, Ao, Bl), Po(e, $n()), null;
    }
    function yP(e, t) {
      t !== he && (Mf(e, xt(t, st)), Po(e, $n()), (Mt & (Pr | Sa)) === dr && ($v(), Au()));
    }
    function f0(e, t) {
      var o = Mt;
      Mt |= QT;
      try {
        return e(t);
      } finally {
        Mt = o, Mt === dr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !ei.isBatchingLegacy && ($v(), JE());
      }
    }
    function xP(e, t, o, i, c) {
      var v = Oo(), y = Ar.transition;
      try {
        return Ar.transition = null, Ln(Er), e(t, o, i, c);
      } finally {
        Ln(v), Ar.transition = y, Mt === dr && $v();
      }
    }
    function Hl(e) {
      Hu !== null && Hu.tag === Nu && (Mt & (Pr | Sa)) === dr && $l();
      var t = Mt;
      Mt |= QT;
      var o = Ar.transition, i = Oo();
      try {
        return Ar.transition = null, Ln(Er), e ? e() : void 0;
      } finally {
        Ln(i), Ar.transition = o, Mt = t, (Mt & (Pr | Sa)) === dr && Au();
      }
    }
    function rR() {
      return (Mt & (Pr | Sa)) !== dr;
    }
    function sy(e, t) {
      qr(r0, Hi, e), Hi = xt(Hi, t);
    }
    function d0(e) {
      Hi = r0.current, Kr(r0, e);
    }
    function gc(e, t) {
      e.finishedWork = null, e.finishedLanes = he;
      var o = e.timeoutHandle;
      if (o !== uS && (e.timeoutHandle = uS, Yk(o)), _n !== null)
        for (var i = _n.return; i !== null; ) {
          var c = i.alternate;
          NT(c, i), i = i.return;
        }
      co = e;
      var v = xc(e.current, null);
      return _n = v, pr = Hi = t, vr = Fl, Fv = null, ny = he, Bv = he, ry = he, Hv = null, Ao = null, vN(), Ya.discardPendingWarnings(), v;
    }
    function oR(e, t) {
      do {
        var o = _n;
        try {
          if (xg(), Ow(), gn(), t0.current = null, o === null || o.return === null) {
            vr = Iv, Fv = t, _n = null;
            return;
          }
          if (ke && o.mode & Lt && Qg(o, !0), je)
            if (ao(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var i = t;
              sa(o, i, pr);
            } else
              Ts(o, t, pr);
          $N(e, o.return, o, t, pr), uR(o);
        } catch (c) {
          t = c, _n === o && o !== null ? (o = o.return, _n = o) : o = _n;
          continue;
        }
        return;
      } while (!0);
    }
    function aR() {
      var e = e0.current;
      return e0.current = $g, e === null ? $g : e;
    }
    function iR(e) {
      e0.current = e;
    }
    function SP() {
      o0 = $n();
    }
    function Gv(e) {
      ny = xt(e, ny);
    }
    function bP() {
      vr === Fl && (vr = ty);
    }
    function p0() {
      (vr === Fl || vr === ty || vr === hc) && (vr = Uv), co !== null && (js(ny) || js(Bv)) && Vu(co, pr);
    }
    function CP(e) {
      vr !== Uv && (vr = hc), Hv === null ? Hv = [e] : Hv.push(e);
    }
    function EP() {
      return vr === Fl;
    }
    function cy(e, t) {
      var o = Mt;
      Mt |= Pr;
      var i = aR();
      if (co !== e || pr !== t) {
        if (Vr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (Qv(e, pr), c.clear()), mm(e, t);
        }
        Bl = Ip(), gc(e, t);
      }
      yl(t);
      do
        try {
          wP();
          break;
        } catch (v) {
          oR(e, v);
        }
      while (!0);
      if (xg(), Mt = o, iR(i), _n !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return uf(), co = null, pr = he, vr;
    }
    function wP() {
      for (; _n !== null; )
        lR(_n);
    }
    function TP(e, t) {
      var o = Mt;
      Mt |= Pr;
      var i = aR();
      if (co !== e || pr !== t) {
        if (Vr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (Qv(e, pr), c.clear()), mm(e, t);
        }
        Bl = Ip(), $v(), gc(e, t);
      }
      yl(t);
      do
        try {
          RP();
          break;
        } catch (v) {
          oR(e, v);
        }
      while (!0);
      return xg(), iR(i), Mt = o, _n !== null ? (lm(), Fl) : (uf(), co = null, pr = he, vr);
    }
    function RP() {
      for (; _n !== null && !gp(); )
        lR(_n);
    }
    function lR(e) {
      var t = e.alternate;
      rn(e);
      var o;
      (e.mode & Lt) !== rt ? (mb(e), o = v0(t, e, Hi), Qg(e, !0)) : o = v0(t, e, Hi), gn(), e.memoizedProps = e.pendingProps, o === null ? uR(e) : _n = o, t0.current = null;
    }
    function uR(e) {
      var t = e;
      do {
        var o = t.alternate, i = t.return;
        if ((t.flags & Cs) === nt) {
          rn(t);
          var c = void 0;
          if ((t.mode & Lt) === rt ? c = MT(o, t, Hi) : (mb(t), c = MT(o, t, Hi), Qg(t, !1)), gn(), c !== null) {
            _n = c;
            return;
          }
        } else {
          var v = bA(o, t);
          if (v !== null) {
            v.flags &= tm, _n = v;
            return;
          }
          if ((t.mode & Lt) !== rt) {
            Qg(t, !1);
            for (var y = t.actualDuration, b = t.child; b !== null; )
              y += b.actualDuration, b = b.sibling;
            t.actualDuration = y;
          }
          if (i !== null)
            i.flags |= Cs, i.subtreeFlags = nt, i.deletions = null;
          else {
            vr = n0, _n = null;
            return;
          }
        }
        var w = t.sibling;
        if (w !== null) {
          _n = w;
          return;
        }
        t = i, _n = t;
      } while (t !== null);
      vr === Fl && (vr = KT);
    }
    function yc(e, t, o) {
      var i = Oo(), c = Ar.transition;
      try {
        Ar.transition = null, Ln(Er), _P(e, t, o, i);
      } finally {
        Ar.transition = c, Ln(i);
      }
      return null;
    }
    function _P(e, t, o, i) {
      do
        $l();
      while (Hu !== null);
      if (IP(), (Mt & (Pr | Sa)) !== dr)
        throw new Error("Should not already be working.");
      var c = e.finishedWork, v = e.finishedLanes;
      if (Ep(v), c === null)
        return wp(), null;
      if (v === he && m("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = he, c === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Pt;
      var y = xt(c.lanes, c.childLanes);
      jp(e, y), e === co && (co = null, _n = null, pr = he), ((c.subtreeFlags & ja) !== nt || (c.flags & ja) !== nt) && (mc || (mc = !0, l0 = o, g0(za, function() {
        return $l(), null;
      })));
      var b = (c.subtreeFlags & (xi | Si | bi | ja)) !== nt, w = (c.flags & (xi | Si | bi | ja)) !== nt;
      if (b || w) {
        var M = Ar.transition;
        Ar.transition = null;
        var P = Oo();
        Ln(Er);
        var Q = Mt;
        Mt |= Sa, t0.current = null, RA(e, c), Jw(), FA(e, c, v), Uk(e.containerInfo), e.current = c, Rs(v), BA(c, e, v), _s(), yp(), Mt = Q, Ln(P), Ar.transition = M;
      } else
        e.current = c, Jw();
      var Y = mc;
      if (mc ? (mc = !1, Hu = e, Vv = v) : (yd = 0, iy = null), y = e.pendingLanes, y === he && (gd = null), Y || dR(e.current, !1), Sp(c.stateNode, i), Vr && e.memoizedUpdaters.clear(), iP(), Po(e, $n()), t !== null)
        for (var ee = e.onRecoverableError, ne = 0; ne < t.length; ne++) {
          var ue = t[ne], Ae = ue.stack, ot = ue.digest;
          ee(ue.value, {
            componentStack: Ae,
            digest: ot
          });
        }
      if (oy) {
        oy = !1;
        var Je = a0;
        throw a0 = null, Je;
      }
      return Wr(Vv, st) && e.tag !== Nu && $l(), y = e.pendingLanes, Wr(y, st) ? (NN(), e === u0 ? Wv++ : (Wv = 0, u0 = e)) : Wv = 0, Au(), wp(), null;
    }
    function $l() {
      if (Hu !== null) {
        var e = xm(Vv), t = Hs(Ro, e), o = Ar.transition, i = Oo();
        try {
          return Ar.transition = null, Ln(t), DP();
        } finally {
          Ln(i), Ar.transition = o;
        }
      }
      return !1;
    }
    function OP(e) {
      i0.push(e), mc || (mc = !0, g0(za, function() {
        return $l(), null;
      }));
    }
    function DP() {
      if (Hu === null)
        return !1;
      var e = l0;
      l0 = null;
      var t = Hu, o = Vv;
      if (Hu = null, Vv = he, (Mt & (Pr | Sa)) !== dr)
        throw new Error("Cannot flush passive effects while already rendering.");
      s0 = !0, ay = !1, gl(o);
      var i = Mt;
      Mt |= Sa, QA(t.current), VA(t, t.current, o, e);
      {
        var c = i0;
        i0 = [];
        for (var v = 0; v < c.length; v++) {
          var y = c[v];
          kA(t, y);
        }
      }
      _p(), dR(t.current, !0), Mt = i, Au(), ay ? t === iy ? yd++ : (yd = 0, iy = t) : yd = 0, s0 = !1, ay = !1, bp(t);
      {
        var b = t.current.stateNode;
        b.effectDuration = 0, b.passiveEffectDuration = 0;
      }
      return !0;
    }
    function sR(e) {
      return gd !== null && gd.has(e);
    }
    function kP(e) {
      gd === null ? gd = /* @__PURE__ */ new Set([e]) : gd.add(e);
    }
    function MP(e) {
      oy || (oy = !0, a0 = e);
    }
    var NP = MP;
    function cR(e, t, o) {
      var i = pc(o, t), c = lT(e, i, st), v = Lu(e, c, st), y = fo();
      v !== null && (Su(v, st, y), Po(v, y));
    }
    function on(e, t, o) {
      if (EA(o), Kv(!1), e.tag === T) {
        cR(e, e, o);
        return;
      }
      var i = null;
      for (i = t; i !== null; ) {
        if (i.tag === T) {
          cR(i, e, o);
          return;
        } else if (i.tag === E) {
          var c = i.type, v = i.stateNode;
          if (typeof c.getDerivedStateFromError == "function" || typeof v.componentDidCatch == "function" && !sR(v)) {
            var y = pc(o, e), b = Pb(i, y, st), w = Lu(i, b, st), M = fo();
            w !== null && (Su(w, st, M), Po(w, M));
            return;
          }
        }
        i = i.return;
      }
      m(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, o);
    }
    function AP(e, t, o) {
      var i = e.pingCache;
      i !== null && i.delete(t);
      var c = fo();
      kf(e, o), HP(e), co === e && Rl(pr, o) && (vr === Uv || vr === ty && Tl(pr) && $n() - o0 < qT ? gc(e, he) : ry = xt(ry, o)), Po(e, c);
    }
    function fR(e, t) {
      t === Pt && (t = pP(e));
      var o = fo(), i = Mo(e, t);
      i !== null && (Su(i, t, o), Po(i, o));
    }
    function PP(e) {
      var t = e.memoizedState, o = Pt;
      t !== null && (o = t.retryLane), fR(e, o);
    }
    function LP(e, t) {
      var o = Pt, i;
      switch (e.tag) {
        case B:
          i = e.stateNode;
          var c = e.memoizedState;
          c !== null && (o = c.retryLane);
          break;
        case Te:
          i = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      i !== null && i.delete(t), fR(e, o);
    }
    function jP(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : sP(e / 1960) * 1960;
    }
    function zP() {
      if (Wv > fP)
        throw Wv = 0, u0 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      yd > dP && (yd = 0, iy = null, m("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function IP() {
      Ya.flushLegacyContextWarning(), Ya.flushPendingUnsafeLifecycleWarnings();
    }
    function dR(e, t) {
      rn(e), fy(e, yi, rP), t && fy(e, ia, oP), fy(e, yi, tP), t && fy(e, ia, nP), gn();
    }
    function fy(e, t, o) {
      for (var i = e, c = null; i !== null; ) {
        var v = i.subtreeFlags & t;
        i !== c && i.child !== null && v !== nt ? i = i.child : ((i.flags & t) !== nt && o(i), i.sibling !== null ? i = i.sibling : i = c = i.return);
      }
    }
    var dy = null;
    function pR(e) {
      {
        if ((Mt & Pr) !== dr || !(e.mode & Et))
          return;
        var t = e.tag;
        if (t !== R && t !== T && t !== E && t !== C && t !== I && t !== ae && t !== Z)
          return;
        var o = yt(e) || "ReactComponent";
        if (dy !== null) {
          if (dy.has(o))
            return;
          dy.add(o);
        } else
          dy = /* @__PURE__ */ new Set([o]);
        var i = Cr;
        try {
          rn(e), m("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          i ? rn(e) : gn();
        }
      }
    }
    var v0;
    {
      var UP = null;
      v0 = function(e, t, o) {
        var i = bR(UP, t);
        try {
          return RT(e, t, o);
        } catch (v) {
          if (XM() || v !== null && typeof v == "object" && typeof v.then == "function")
            throw v;
          if (xg(), Ow(), NT(e, t), bR(t, i), t.mode & Lt && mb(t), gi(null, RT, null, e, t, o), Pa()) {
            var c = bs();
            typeof c == "object" && c !== null && c._suppressLogging && typeof v == "object" && v !== null && !v._suppressLogging && (v._suppressLogging = !0);
          }
          throw v;
        }
      };
    }
    var vR = !1, h0;
    h0 = /* @__PURE__ */ new Set();
    function FP(e) {
      if (fi && !DN())
        switch (e.tag) {
          case C:
          case I:
          case Z: {
            var t = _n && yt(_n) || "Unknown", o = t;
            if (!h0.has(o)) {
              h0.add(o);
              var i = yt(e) || "Unknown";
              m("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
            }
            break;
          }
          case E: {
            vR || (m("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), vR = !0);
            break;
          }
        }
    }
    function Qv(e, t) {
      if (Vr) {
        var o = e.memoizedUpdaters;
        o.forEach(function(i) {
          Fs(e, i, t);
        });
      }
    }
    var m0 = {};
    function g0(e, t) {
      {
        var o = ei.current;
        return o !== null ? (o.push(t), m0) : mp(e, t);
      }
    }
    function hR(e) {
      if (e !== m0)
        return rm(e);
    }
    function mR() {
      return ei.current !== null;
    }
    function BP(e) {
      {
        if (e.mode & Et) {
          if (!GT())
            return;
        } else if (!uP() || Mt !== dr || e.tag !== C && e.tag !== I && e.tag !== Z)
          return;
        if (ei.current === null) {
          var t = Cr;
          try {
            rn(e), m(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, yt(e));
          } finally {
            t ? rn(e) : gn();
          }
        }
      }
    }
    function HP(e) {
      e.tag !== Nu && GT() && ei.current === null && m(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Kv(e) {
      JT = e;
    }
    var ba = null, xd = null, $P = function(e) {
      ba = e;
    };
    function Sd(e) {
      {
        if (ba === null)
          return e;
        var t = ba(e);
        return t === void 0 ? e : t.current;
      }
    }
    function y0(e) {
      return Sd(e);
    }
    function x0(e) {
      {
        if (ba === null)
          return e;
        var t = ba(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var o = Sd(e.render);
            if (e.render !== o) {
              var i = {
                $$typeof: ye,
                render: o
              };
              return e.displayName !== void 0 && (i.displayName = e.displayName), i;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function gR(e, t) {
      {
        if (ba === null)
          return !1;
        var o = e.elementType, i = t.type, c = !1, v = typeof i == "object" && i !== null ? i.$$typeof : null;
        switch (e.tag) {
          case E: {
            typeof i == "function" && (c = !0);
            break;
          }
          case C: {
            (typeof i == "function" || v === ht) && (c = !0);
            break;
          }
          case I: {
            (v === ye || v === ht) && (c = !0);
            break;
          }
          case ae:
          case Z: {
            (v === St || v === ht) && (c = !0);
            break;
          }
          default:
            return !1;
        }
        if (c) {
          var y = ba(o);
          if (y !== void 0 && y === ba(i))
            return !0;
        }
        return !1;
      }
    }
    function yR(e) {
      {
        if (ba === null || typeof WeakSet != "function")
          return;
        xd === null && (xd = /* @__PURE__ */ new WeakSet()), xd.add(e);
      }
    }
    var VP = function(e, t) {
      {
        if (ba === null)
          return;
        var o = t.staleFamilies, i = t.updatedFamilies;
        $l(), Hl(function() {
          S0(e.current, i, o);
        });
      }
    }, WP = function(e, t) {
      {
        if (e.context !== qo)
          return;
        $l(), Hl(function() {
          qv(t, e, null, null);
        });
      }
    };
    function S0(e, t, o) {
      {
        var i = e.alternate, c = e.child, v = e.sibling, y = e.tag, b = e.type, w = null;
        switch (y) {
          case C:
          case Z:
          case E:
            w = b;
            break;
          case I:
            w = b.render;
            break;
        }
        if (ba === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var M = !1, P = !1;
        if (w !== null) {
          var Q = ba(w);
          Q !== void 0 && (o.has(Q) ? P = !0 : t.has(Q) && (y === E ? P = !0 : M = !0));
        }
        if (xd !== null && (xd.has(e) || i !== null && xd.has(i)) && (P = !0), P && (e._debugNeedsRemount = !0), P || M) {
          var Y = Mo(e, st);
          Y !== null && hr(Y, e, st, Jt);
        }
        c !== null && !P && S0(c, t, o), v !== null && S0(v, t, o);
      }
    }
    var YP = function(e, t) {
      {
        var o = /* @__PURE__ */ new Set(), i = new Set(t.map(function(c) {
          return c.current;
        }));
        return b0(e.current, i, o), o;
      }
    };
    function b0(e, t, o) {
      {
        var i = e.child, c = e.sibling, v = e.tag, y = e.type, b = null;
        switch (v) {
          case C:
          case Z:
          case E:
            b = y;
            break;
          case I:
            b = y.render;
            break;
        }
        var w = !1;
        b !== null && t.has(b) && (w = !0), w ? GP(e, o) : i !== null && b0(i, t, o), c !== null && b0(c, t, o);
      }
    }
    function GP(e, t) {
      {
        var o = QP(e, t);
        if (o)
          return;
        for (var i = e; ; ) {
          switch (i.tag) {
            case N:
              t.add(i.stateNode);
              return;
            case O:
              t.add(i.stateNode.containerInfo);
              return;
            case T:
              t.add(i.stateNode.containerInfo);
              return;
          }
          if (i.return === null)
            throw new Error("Expected to reach root first.");
          i = i.return;
        }
      }
    }
    function QP(e, t) {
      for (var o = e, i = !1; ; ) {
        if (o.tag === N)
          i = !0, t.add(o.stateNode);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === e)
          return i;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === e)
            return i;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return !1;
    }
    var C0;
    {
      C0 = !1;
      try {
        var xR = Object.preventExtensions({});
      } catch {
        C0 = !0;
      }
    }
    function KP(e, t, o, i) {
      this.tag = e, this.key = o, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = nt, this.subtreeFlags = nt, this.deletions = null, this.lanes = he, this.childLanes = he, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !C0 && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Xo = function(e, t, o, i) {
      return new KP(e, t, o, i);
    };
    function E0(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function qP(e) {
      return typeof e == "function" && !E0(e) && e.defaultProps === void 0;
    }
    function XP(e) {
      if (typeof e == "function")
        return E0(e) ? E : C;
      if (e != null) {
        var t = e.$$typeof;
        if (t === ye)
          return I;
        if (t === St)
          return ae;
      }
      return R;
    }
    function xc(e, t) {
      var o = e.alternate;
      o === null ? (o = Xo(e.tag, t, e.key, e.mode), o.elementType = e.elementType, o.type = e.type, o.stateNode = e.stateNode, o._debugSource = e._debugSource, o._debugOwner = e._debugOwner, o._debugHookTypes = e._debugHookTypes, o.alternate = e, e.alternate = o) : (o.pendingProps = t, o.type = e.type, o.flags = nt, o.subtreeFlags = nt, o.deletions = null, o.actualDuration = 0, o.actualStartTime = -1), o.flags = e.flags & Nn, o.childLanes = e.childLanes, o.lanes = e.lanes, o.child = e.child, o.memoizedProps = e.memoizedProps, o.memoizedState = e.memoizedState, o.updateQueue = e.updateQueue;
      var i = e.dependencies;
      switch (o.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, o.sibling = e.sibling, o.index = e.index, o.ref = e.ref, o.selfBaseDuration = e.selfBaseDuration, o.treeBaseDuration = e.treeBaseDuration, o._debugNeedsRemount = e._debugNeedsRemount, o.tag) {
        case R:
        case C:
        case Z:
          o.type = Sd(e.type);
          break;
        case E:
          o.type = y0(e.type);
          break;
        case I:
          o.type = x0(e.type);
          break;
      }
      return o;
    }
    function ZP(e, t) {
      e.flags &= Nn | bn;
      var o = e.alternate;
      if (o === null)
        e.childLanes = he, e.lanes = t, e.child = null, e.subtreeFlags = nt, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = o.childLanes, e.lanes = o.lanes, e.child = o.child, e.subtreeFlags = nt, e.deletions = null, e.memoizedProps = o.memoizedProps, e.memoizedState = o.memoizedState, e.updateQueue = o.updateQueue, e.type = o.type;
        var i = o.dependencies;
        e.dependencies = i === null ? null : {
          lanes: i.lanes,
          firstContext: i.firstContext
        }, e.selfBaseDuration = o.selfBaseDuration, e.treeBaseDuration = o.treeBaseDuration;
      }
      return e;
    }
    function JP(e, t, o) {
      var i;
      return e === sg ? (i = Et, t === !0 && (i |= Qt, i |= jt)) : i = rt, Vr && (i |= Lt), Xo(T, null, null, i);
    }
    function w0(e, t, o, i, c, v) {
      var y = R, b = e;
      if (typeof e == "function")
        E0(e) ? (y = E, b = y0(b)) : b = Sd(b);
      else if (typeof e == "string")
        y = N;
      else
        e: switch (e) {
          case ui:
            return Wu(o.children, c, v, t);
          case Ta:
            y = A, c |= Qt, (c & Et) !== rt && (c |= jt);
            break;
          case si:
            return eL(o, c, v, t);
          case Le:
            return tL(o, c, v, t);
          case lt:
            return nL(o, c, v, t);
          case Bn:
            return SR(o, c, v, t);
          case sn:
          case _t:
          case dn:
          case br:
          case Rt:
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case ci:
                  y = F;
                  break e;
                case H:
                  y = z;
                  break e;
                case ye:
                  y = I, b = x0(b);
                  break e;
                case St:
                  y = ae;
                  break e;
                case ht:
                  y = pe, b = null;
                  break e;
              }
            var w = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var M = i ? yt(i) : null;
              M && (w += `

Check the render method of \`` + M + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + w));
          }
        }
      var P = Xo(y, o, t, c);
      return P.elementType = e, P.type = b, P.lanes = v, P._debugOwner = i, P;
    }
    function T0(e, t, o) {
      var i = null;
      i = e._owner;
      var c = e.type, v = e.key, y = e.props, b = w0(c, v, y, i, t, o);
      return b._debugSource = e._source, b._debugOwner = e._owner, b;
    }
    function Wu(e, t, o, i) {
      var c = Xo(k, e, i, t);
      return c.lanes = o, c;
    }
    function eL(e, t, o, i) {
      typeof e.id != "string" && m('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var c = Xo(V, e, i, t | Lt);
      return c.elementType = si, c.lanes = o, c.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, c;
    }
    function tL(e, t, o, i) {
      var c = Xo(B, e, i, t);
      return c.elementType = Le, c.lanes = o, c;
    }
    function nL(e, t, o, i) {
      var c = Xo(Te, e, i, t);
      return c.elementType = lt, c.lanes = o, c;
    }
    function SR(e, t, o, i) {
      var c = Xo(ce, e, i, t);
      c.elementType = Bn, c.lanes = o;
      var v = {
        isHidden: !1
      };
      return c.stateNode = v, c;
    }
    function R0(e, t, o) {
      var i = Xo(j, e, null, t);
      return i.lanes = o, i;
    }
    function rL() {
      var e = Xo(N, null, null, rt);
      return e.elementType = "DELETED", e;
    }
    function oL(e) {
      var t = Xo(me, null, null, rt);
      return t.stateNode = e, t;
    }
    function _0(e, t, o) {
      var i = e.children !== null ? e.children : [], c = Xo(O, i, e.key, t);
      return c.lanes = o, c.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, c;
    }
    function bR(e, t) {
      return e === null && (e = Xo(R, null, null, rt)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function aL(e, t, o, i, c) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = uS, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Pt, this.eventTimes = Us(he), this.expirationTimes = Us(Jt), this.pendingLanes = he, this.suspendedLanes = he, this.pingedLanes = he, this.expiredLanes = he, this.mutableReadLanes = he, this.finishedLanes = he, this.entangledLanes = he, this.entanglements = Us(he), this.identifierPrefix = i, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var v = this.pendingUpdatersLaneMap = [], y = 0; y < xl; y++)
          v.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case sg:
          this._debugRootType = o ? "hydrateRoot()" : "createRoot()";
          break;
        case Nu:
          this._debugRootType = o ? "hydrate()" : "render()";
          break;
      }
    }
    function CR(e, t, o, i, c, v, y, b, w, M) {
      var P = new aL(e, t, o, b, w), Q = JP(t, v);
      P.current = Q, Q.stateNode = P;
      {
        var Y = {
          element: i,
          isDehydrated: o,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Q.memoizedState = Y;
      }
      return FS(Q), P;
    }
    var O0 = "18.3.1";
    function iL(e, t, o) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return xn(i), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: jr,
        key: i == null ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: o
      };
    }
    var D0, k0;
    D0 = !1, k0 = {};
    function ER(e) {
      if (!e)
        return qo;
      var t = vu(e), o = HM(t);
      if (t.tag === E) {
        var i = t.type;
        if (Li(i))
          return qE(t, i, o);
      }
      return o;
    }
    function lL(e, t) {
      {
        var o = vu(e);
        if (o === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var i = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
        }
        var c = Hr(o);
        if (c === null)
          return null;
        if (c.mode & Qt) {
          var v = yt(o) || "Component";
          if (!k0[v]) {
            k0[v] = !0;
            var y = Cr;
            try {
              rn(c), o.mode & Qt ? m("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, v) : m("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, v);
            } finally {
              y ? rn(y) : gn();
            }
          }
        }
        return c.stateNode;
      }
    }
    function wR(e, t, o, i, c, v, y, b) {
      var w = !1, M = null;
      return CR(e, t, w, M, o, i, c, v, y);
    }
    function TR(e, t, o, i, c, v, y, b, w, M) {
      var P = !0, Q = CR(o, i, P, e, c, v, y, b, w);
      Q.context = ER(null);
      var Y = Q.current, ee = fo(), ne = $u(Y), ue = Il(ee, ne);
      return ue.callback = t ?? null, Lu(Y, ue, ne), vP(Q, ne, ee), Q;
    }
    function qv(e, t, o, i) {
      xp(t, e);
      var c = t.current, v = fo(), y = $u(c);
      vn(y);
      var b = ER(o);
      t.context === null ? t.context = b : t.pendingContext = b, fi && Cr !== null && !D0 && (D0 = !0, m(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, yt(Cr) || "Unknown"));
      var w = Il(v, y);
      w.payload = {
        element: e
      }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && m("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), w.callback = i);
      var M = Lu(c, w, y);
      return M !== null && (hr(M, c, y, v), wg(M, c, y)), y;
    }
    function py(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case N:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function uL(e) {
      switch (e.tag) {
        case T: {
          var t = e.stateNode;
          if (Nf(t)) {
            var o = sm(t);
            yP(t, o);
          }
          break;
        }
        case B: {
          Hl(function() {
            var c = Mo(e, st);
            if (c !== null) {
              var v = fo();
              hr(c, e, st, v);
            }
          });
          var i = st;
          M0(e, i);
          break;
        }
      }
    }
    function RR(e, t) {
      var o = e.memoizedState;
      o !== null && o.dehydrated !== null && (o.retryLane = vm(o.retryLane, t));
    }
    function M0(e, t) {
      RR(e, t);
      var o = e.alternate;
      o && RR(o, t);
    }
    function sL(e) {
      if (e.tag === B) {
        var t = As, o = Mo(e, t);
        if (o !== null) {
          var i = fo();
          hr(o, e, t, i);
        }
        M0(e, t);
      }
    }
    function cL(e) {
      if (e.tag === B) {
        var t = $u(e), o = Mo(e, t);
        if (o !== null) {
          var i = fo();
          hr(o, e, t, i);
        }
        M0(e, t);
      }
    }
    function _R(e) {
      var t = cn(e);
      return t === null ? null : t.stateNode;
    }
    var OR = function(e) {
      return null;
    };
    function fL(e) {
      return OR(e);
    }
    var DR = function(e) {
      return !1;
    };
    function dL(e) {
      return DR(e);
    }
    var kR = null, MR = null, NR = null, AR = null, PR = null, LR = null, jR = null, zR = null, IR = null;
    {
      var UR = function(e, t, o) {
        var i = t[o], c = rr(e) ? e.slice() : Ct({}, e);
        return o + 1 === t.length ? (rr(c) ? c.splice(i, 1) : delete c[i], c) : (c[i] = UR(e[i], t, o + 1), c);
      }, FR = function(e, t) {
        return UR(e, t, 0);
      }, BR = function(e, t, o, i) {
        var c = t[i], v = rr(e) ? e.slice() : Ct({}, e);
        if (i + 1 === t.length) {
          var y = o[i];
          v[y] = v[c], rr(v) ? v.splice(c, 1) : delete v[c];
        } else
          v[c] = BR(
            // $FlowFixMe number or string is fine here
            e[c],
            t,
            o,
            i + 1
          );
        return v;
      }, HR = function(e, t, o) {
        if (t.length !== o.length) {
          h("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var i = 0; i < o.length - 1; i++)
            if (t[i] !== o[i]) {
              h("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return BR(e, t, o, 0);
      }, $R = function(e, t, o, i) {
        if (o >= t.length)
          return i;
        var c = t[o], v = rr(e) ? e.slice() : Ct({}, e);
        return v[c] = $R(e[c], t, o + 1, i), v;
      }, VR = function(e, t, o) {
        return $R(e, t, 0, o);
      }, N0 = function(e, t) {
        for (var o = e.memoizedState; o !== null && t > 0; )
          o = o.next, t--;
        return o;
      };
      kR = function(e, t, o, i) {
        var c = N0(e, t);
        if (c !== null) {
          var v = VR(c.memoizedState, o, i);
          c.memoizedState = v, c.baseState = v, e.memoizedProps = Ct({}, e.memoizedProps);
          var y = Mo(e, st);
          y !== null && hr(y, e, st, Jt);
        }
      }, MR = function(e, t, o) {
        var i = N0(e, t);
        if (i !== null) {
          var c = FR(i.memoizedState, o);
          i.memoizedState = c, i.baseState = c, e.memoizedProps = Ct({}, e.memoizedProps);
          var v = Mo(e, st);
          v !== null && hr(v, e, st, Jt);
        }
      }, NR = function(e, t, o, i) {
        var c = N0(e, t);
        if (c !== null) {
          var v = HR(c.memoizedState, o, i);
          c.memoizedState = v, c.baseState = v, e.memoizedProps = Ct({}, e.memoizedProps);
          var y = Mo(e, st);
          y !== null && hr(y, e, st, Jt);
        }
      }, AR = function(e, t, o) {
        e.pendingProps = VR(e.memoizedProps, t, o), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Mo(e, st);
        i !== null && hr(i, e, st, Jt);
      }, PR = function(e, t) {
        e.pendingProps = FR(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var o = Mo(e, st);
        o !== null && hr(o, e, st, Jt);
      }, LR = function(e, t, o) {
        e.pendingProps = HR(e.memoizedProps, t, o), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Mo(e, st);
        i !== null && hr(i, e, st, Jt);
      }, jR = function(e) {
        var t = Mo(e, st);
        t !== null && hr(t, e, st, Jt);
      }, zR = function(e) {
        OR = e;
      }, IR = function(e) {
        DR = e;
      };
    }
    function pL(e) {
      var t = Hr(e);
      return t === null ? null : t.stateNode;
    }
    function vL(e) {
      return null;
    }
    function hL() {
      return Cr;
    }
    function mL(e) {
      var t = e.findFiberByHostInstance, o = s.ReactCurrentDispatcher;
      return gu({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: kR,
        overrideHookStateDeletePath: MR,
        overrideHookStateRenamePath: NR,
        overrideProps: AR,
        overridePropsDeletePath: PR,
        overridePropsRenamePath: LR,
        setErrorHandler: zR,
        setSuspenseHandler: IR,
        scheduleUpdate: jR,
        currentDispatcherRef: o,
        findHostInstanceByFiber: pL,
        findFiberByHostInstance: t || vL,
        // React Refresh
        findHostInstancesForRefresh: YP,
        scheduleRefresh: VP,
        scheduleRoot: WP,
        setRefreshHandler: $P,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: hL,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: O0
      });
    }
    var WR = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function A0(e) {
      this._internalRoot = e;
    }
    vy.prototype.render = A0.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? m("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : hy(arguments[1]) ? m("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && m("You passed a second argument to root.render(...) but it only accepts one argument.");
        var o = t.containerInfo;
        if (o.nodeType !== kn) {
          var i = _R(t.current);
          i && i.parentNode !== o && m("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      qv(e, t, null, null);
    }, vy.prototype.unmount = A0.prototype.unmount = function() {
      typeof arguments[0] == "function" && m("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        rR() && m("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Hl(function() {
          qv(null, e, null, null);
        }), WE(t);
      }
    };
    function gL(e, t) {
      if (!hy(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      YR(e);
      var o = !1, i = !1, c = "", v = WR;
      t != null && (t.hydrate ? h("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === Fo && m(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (o = !0), t.identifierPrefix !== void 0 && (c = t.identifierPrefix), t.onRecoverableError !== void 0 && (v = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var y = wR(e, sg, null, o, i, c, v);
      ng(y.current, e);
      var b = e.nodeType === kn ? e.parentNode : e;
      return nv(b), new A0(y);
    }
    function vy(e) {
      this._internalRoot = e;
    }
    function yL(e) {
      e && wm(e);
    }
    vy.prototype.unstable_scheduleHydration = yL;
    function xL(e, t, o) {
      if (!hy(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      YR(e), t === void 0 && m("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var i = o ?? null, c = o != null && o.hydratedSources || null, v = !1, y = !1, b = "", w = WR;
      o != null && (o.unstable_strictMode === !0 && (v = !0), o.identifierPrefix !== void 0 && (b = o.identifierPrefix), o.onRecoverableError !== void 0 && (w = o.onRecoverableError));
      var M = TR(t, null, e, sg, i, v, y, b, w);
      if (ng(M.current, e), nv(e), c)
        for (var P = 0; P < c.length; P++) {
          var Q = c[P];
          EN(M, Q);
        }
      return new vy(M);
    }
    function hy(e) {
      return !!(e && (e.nodeType === Ir || e.nodeType === Aa || e.nodeType === op));
    }
    function Xv(e) {
      return !!(e && (e.nodeType === Ir || e.nodeType === Aa || e.nodeType === op || e.nodeType === kn && e.nodeValue === " react-mount-point-unstable "));
    }
    function YR(e) {
      e.nodeType === Ir && e.tagName && e.tagName.toUpperCase() === "BODY" && m("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), pv(e) && (e._reactRootContainer ? m("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : m("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var SL = s.ReactCurrentOwner, GR;
    GR = function(e) {
      if (e._reactRootContainer && e.nodeType !== kn) {
        var t = _R(e._reactRootContainer.current);
        t && t.parentNode !== e && m("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var o = !!e._reactRootContainer, i = P0(e), c = !!(i && ku(i));
      c && !o && m("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Ir && e.tagName && e.tagName.toUpperCase() === "BODY" && m("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function P0(e) {
      return e ? e.nodeType === Aa ? e.documentElement : e.firstChild : null;
    }
    function QR() {
    }
    function bL(e, t, o, i, c) {
      if (c) {
        if (typeof i == "function") {
          var v = i;
          i = function() {
            var Y = py(y);
            v.call(Y);
          };
        }
        var y = TR(
          t,
          i,
          e,
          Nu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          QR
        );
        e._reactRootContainer = y, ng(y.current, e);
        var b = e.nodeType === kn ? e.parentNode : e;
        return nv(b), Hl(), y;
      } else {
        for (var w; w = e.lastChild; )
          e.removeChild(w);
        if (typeof i == "function") {
          var M = i;
          i = function() {
            var Y = py(P);
            M.call(Y);
          };
        }
        var P = wR(
          e,
          Nu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          QR
        );
        e._reactRootContainer = P, ng(P.current, e);
        var Q = e.nodeType === kn ? e.parentNode : e;
        return nv(Q), Hl(function() {
          qv(t, P, o, i);
        }), P;
      }
    }
    function CL(e, t) {
      e !== null && typeof e != "function" && m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function my(e, t, o, i, c) {
      GR(o), CL(c === void 0 ? null : c, "render");
      var v = o._reactRootContainer, y;
      if (!v)
        y = bL(o, t, e, c, i);
      else {
        if (y = v, typeof c == "function") {
          var b = c;
          c = function() {
            var w = py(y);
            b.call(w);
          };
        }
        qv(t, y, e, c);
      }
      return py(y);
    }
    var KR = !1;
    function EL(e) {
      {
        KR || (KR = !0, m("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = SL.current;
        if (t !== null && t.stateNode !== null) {
          var o = t.stateNode._warnedAboutRefsInRender;
          o || m("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Wt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Ir ? e : lL(e, "findDOMNode");
    }
    function wL(e, t, o) {
      if (m("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Xv(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = pv(t) && t._reactRootContainer === void 0;
        i && m("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return my(null, e, t, !0, o);
    }
    function TL(e, t, o) {
      if (m("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Xv(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = pv(t) && t._reactRootContainer === void 0;
        i && m("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return my(null, e, t, !1, o);
    }
    function RL(e, t, o, i) {
      if (m("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Xv(o))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !Mx(e))
        throw new Error("parentComponent must be a valid React Component");
      return my(e, t, o, !1, i);
    }
    var qR = !1;
    function _L(e) {
      if (qR || (qR = !0, m("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Xv(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = pv(e) && e._reactRootContainer === void 0;
        t && m("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var o = P0(e), i = o && !ku(o);
          i && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Hl(function() {
          my(null, null, e, !1, function() {
            e._reactRootContainer = null, WE(e);
          });
        }), !0;
      } else {
        {
          var c = P0(e), v = !!(c && ku(c)), y = e.nodeType === Ir && Xv(e.parentNode) && !!e.parentNode._reactRootContainer;
          v && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", y ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    gr(uL), bu(sL), Sm(cL), Vs(Oo), Up(gm), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && m("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Qc(Dk), kx(f0, xP, Hl);
    function OL(e, t) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!hy(t))
        throw new Error("Target container is not a DOM element.");
      return iL(e, t, null, o);
    }
    function DL(e, t, o, i) {
      return RL(e, t, o, i);
    }
    var L0 = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [ku, Xf, rg, cu, Kc, f0]
    };
    function kL(e, t) {
      return L0.usingClientEntryPoint || m('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), gL(e, t);
    }
    function ML(e, t, o) {
      return L0.usingClientEntryPoint || m('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), xL(e, t, o);
    }
    function NL(e) {
      return rR() && m("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Hl(e);
    }
    var AL = mL({
      findFiberByHostInstance: oc,
      bundleType: 1,
      version: O0,
      rendererPackageName: "react-dom"
    });
    if (!AL && Qe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var XR = window.location.protocol;
      /^(https?|file):$/.test(XR) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (XR === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    jo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L0, jo.createPortal = OL, jo.createRoot = kL, jo.findDOMNode = EL, jo.flushSync = NL, jo.hydrate = wL, jo.hydrateRoot = ML, jo.render = TL, jo.unmountComponentAtNode = _L, jo.unstable_batchedUpdates = f0, jo.unstable_renderSubtreeIntoContainer = DL, jo.version = O0, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), jo;
}
function p_() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(p_);
    } catch (a) {
      console.error(a);
    }
  }
}
process.env.NODE_ENV === "production" ? (p_(), gC.exports = wz()) : gC.exports = Tz();
var FC = gC.exports;
const Rz = /* @__PURE__ */ Q1(FC);
// @__NO_SIDE_EFFECTS__
function kd(a) {
  const u = /* @__PURE__ */ _z(a), s = L.forwardRef((f, p) => {
    const { children: h, ...m } = f, x = L.Children.toArray(h), C = x.find(Dz);
    if (C) {
      const E = C.props.children, R = x.map((T) => T === C ? L.Children.count(E) > 1 ? L.Children.only(null) : L.isValidElement(E) ? E.props.children : null : T);
      return /* @__PURE__ */ D.jsx(u, { ...m, ref: p, children: L.isValidElement(E) ? L.cloneElement(E, void 0, R) : null });
    }
    return /* @__PURE__ */ D.jsx(u, { ...m, ref: p, children: h });
  });
  return s.displayName = `${a}.Slot`, s;
}
// @__NO_SIDE_EFFECTS__
function _z(a) {
  const u = L.forwardRef((s, f) => {
    const { children: p, ...h } = s;
    if (L.isValidElement(p)) {
      const m = Mz(p), x = kz(h, p.props);
      return p.type !== L.Fragment && (x.ref = f ? Wy(f, m) : m), L.cloneElement(p, x);
    }
    return L.Children.count(p) > 1 ? L.Children.only(null) : null;
  });
  return u.displayName = `${a}.SlotClone`, u;
}
var Oz = Symbol("radix.slottable");
function Dz(a) {
  return L.isValidElement(a) && typeof a.type == "function" && "__radixId" in a.type && a.type.__radixId === Oz;
}
function kz(a, u) {
  const s = { ...u };
  for (const f in u) {
    const p = a[f], h = u[f];
    /^on[A-Z]/.test(f) ? p && h ? s[f] = (...x) => {
      h(...x), p(...x);
    } : p && (s[f] = p) : f === "style" ? s[f] = { ...p, ...h } : f === "className" && (s[f] = [p, h].filter(Boolean).join(" "));
  }
  return { ...a, ...s };
}
function Mz(a) {
  var f, p;
  let u = (f = Object.getOwnPropertyDescriptor(a.props, "ref")) == null ? void 0 : f.get, s = u && "isReactWarning" in u && u.isReactWarning;
  return s ? a.ref : (u = (p = Object.getOwnPropertyDescriptor(a, "ref")) == null ? void 0 : p.get, s = u && "isReactWarning" in u && u.isReactWarning, s ? a.props.ref : a.props.ref || a.ref);
}
var Nz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], an = Nz.reduce((a, u) => {
  const s = /* @__PURE__ */ kd(`Primitive.${u}`), f = L.forwardRef((p, h) => {
    const { asChild: m, ...x } = p, C = m ? s : u;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ D.jsx(C, { ...x, ref: h });
  });
  return f.displayName = `Primitive.${u}`, { ...a, [u]: f };
}, {});
function v_(a, u) {
  a && FC.flushSync(() => a.dispatchEvent(u));
}
function BC(a) {
  const u = a + "CollectionProvider", [s, f] = Zl(u), [p, h] = s(
    u,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), m = (k) => {
    const { scope: A, children: z } = k, F = ut.useRef(null), I = ut.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ D.jsx(p, { scope: A, itemMap: I, collectionRef: F, children: z });
  };
  m.displayName = u;
  const x = a + "CollectionSlot", C = /* @__PURE__ */ kd(x), E = ut.forwardRef(
    (k, A) => {
      const { scope: z, children: F } = k, I = h(x, z), V = Yn(A, I.collectionRef);
      return /* @__PURE__ */ D.jsx(C, { ref: V, children: F });
    }
  );
  E.displayName = x;
  const R = a + "CollectionItemSlot", T = "data-radix-collection-item", O = /* @__PURE__ */ kd(R), N = ut.forwardRef(
    (k, A) => {
      const { scope: z, children: F, ...I } = k, V = ut.useRef(null), B = Yn(A, V), ae = h(R, z);
      return ut.useEffect(() => (ae.itemMap.set(V, { ref: V, ...I }), () => void ae.itemMap.delete(V))), /* @__PURE__ */ D.jsx(O, { [T]: "", ref: B, children: F });
    }
  );
  N.displayName = R;
  function j(k) {
    const A = h(a + "CollectionConsumer", k);
    return ut.useCallback(() => {
      const F = A.collectionRef.current;
      if (!F) return [];
      const I = Array.from(F.querySelectorAll(`[${T}]`));
      return Array.from(A.itemMap.values()).sort(
        (ae, Z) => I.indexOf(ae.ref.current) - I.indexOf(Z.ref.current)
      );
    }, [A.collectionRef, A.itemMap]);
  }
  return [
    { Provider: m, Slot: E, ItemSlot: N },
    j,
    f
  ];
}
var Az = L.createContext(void 0);
function HC(a) {
  const u = L.useContext(Az);
  return a || u || "ltr";
}
function Kl(a) {
  const u = L.useRef(a);
  return L.useEffect(() => {
    u.current = a;
  }), L.useMemo(() => (...s) => {
    var f;
    return (f = u.current) == null ? void 0 : f.call(u, ...s);
  }, []);
}
function Pz(a, u = globalThis == null ? void 0 : globalThis.document) {
  const s = Kl(a);
  L.useEffect(() => {
    const f = (p) => {
      p.key === "Escape" && s(p);
    };
    return u.addEventListener("keydown", f, { capture: !0 }), () => u.removeEventListener("keydown", f, { capture: !0 });
  }, [s, u]);
}
var Lz = "DismissableLayer", yC = "dismissableLayer.update", jz = "dismissableLayer.pointerDownOutside", zz = "dismissableLayer.focusOutside", w1, h_ = L.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Yy = L.forwardRef(
  (a, u) => {
    const {
      disableOutsidePointerEvents: s = !1,
      onEscapeKeyDown: f,
      onPointerDownOutside: p,
      onFocusOutside: h,
      onInteractOutside: m,
      onDismiss: x,
      ...C
    } = a, E = L.useContext(h_), [R, T] = L.useState(null), O = (R == null ? void 0 : R.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, N] = L.useState({}), j = Yn(u, (Z) => T(Z)), k = Array.from(E.layers), [A] = [...E.layersWithOutsidePointerEventsDisabled].slice(-1), z = k.indexOf(A), F = R ? k.indexOf(R) : -1, I = E.layersWithOutsidePointerEventsDisabled.size > 0, V = F >= z, B = Fz((Z) => {
      const pe = Z.target, de = [...E.branches].some((me) => me.contains(pe));
      !V || de || (p == null || p(Z), m == null || m(Z), Z.defaultPrevented || x == null || x());
    }, O), ae = Bz((Z) => {
      const pe = Z.target;
      [...E.branches].some((me) => me.contains(pe)) || (h == null || h(Z), m == null || m(Z), Z.defaultPrevented || x == null || x());
    }, O);
    return Pz((Z) => {
      F === E.layers.size - 1 && (f == null || f(Z), !Z.defaultPrevented && x && (Z.preventDefault(), x()));
    }, O), L.useEffect(() => {
      if (R)
        return s && (E.layersWithOutsidePointerEventsDisabled.size === 0 && (w1 = O.body.style.pointerEvents, O.body.style.pointerEvents = "none"), E.layersWithOutsidePointerEventsDisabled.add(R)), E.layers.add(R), T1(), () => {
          s && E.layersWithOutsidePointerEventsDisabled.size === 1 && (O.body.style.pointerEvents = w1);
        };
    }, [R, O, s, E]), L.useEffect(() => () => {
      R && (E.layers.delete(R), E.layersWithOutsidePointerEventsDisabled.delete(R), T1());
    }, [R, E]), L.useEffect(() => {
      const Z = () => N({});
      return document.addEventListener(yC, Z), () => document.removeEventListener(yC, Z);
    }, []), /* @__PURE__ */ D.jsx(
      an.div,
      {
        ...C,
        ref: j,
        style: {
          pointerEvents: I ? V ? "auto" : "none" : void 0,
          ...a.style
        },
        onFocusCapture: mt(a.onFocusCapture, ae.onFocusCapture),
        onBlurCapture: mt(a.onBlurCapture, ae.onBlurCapture),
        onPointerDownCapture: mt(
          a.onPointerDownCapture,
          B.onPointerDownCapture
        )
      }
    );
  }
);
Yy.displayName = Lz;
var Iz = "DismissableLayerBranch", Uz = L.forwardRef((a, u) => {
  const s = L.useContext(h_), f = L.useRef(null), p = Yn(u, f);
  return L.useEffect(() => {
    const h = f.current;
    if (h)
      return s.branches.add(h), () => {
        s.branches.delete(h);
      };
  }, [s.branches]), /* @__PURE__ */ D.jsx(an.div, { ...a, ref: p });
});
Uz.displayName = Iz;
function Fz(a, u = globalThis == null ? void 0 : globalThis.document) {
  const s = Kl(a), f = L.useRef(!1), p = L.useRef(() => {
  });
  return L.useEffect(() => {
    const h = (x) => {
      if (x.target && !f.current) {
        let C = function() {
          m_(
            jz,
            s,
            E,
            { discrete: !0 }
          );
        };
        const E = { originalEvent: x };
        x.pointerType === "touch" ? (u.removeEventListener("click", p.current), p.current = C, u.addEventListener("click", p.current, { once: !0 })) : C();
      } else
        u.removeEventListener("click", p.current);
      f.current = !1;
    }, m = window.setTimeout(() => {
      u.addEventListener("pointerdown", h);
    }, 0);
    return () => {
      window.clearTimeout(m), u.removeEventListener("pointerdown", h), u.removeEventListener("click", p.current);
    };
  }, [u, s]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => f.current = !0
  };
}
function Bz(a, u = globalThis == null ? void 0 : globalThis.document) {
  const s = Kl(a), f = L.useRef(!1);
  return L.useEffect(() => {
    const p = (h) => {
      h.target && !f.current && m_(zz, s, { originalEvent: h }, {
        discrete: !1
      });
    };
    return u.addEventListener("focusin", p), () => u.removeEventListener("focusin", p);
  }, [u, s]), {
    onFocusCapture: () => f.current = !0,
    onBlurCapture: () => f.current = !1
  };
}
function T1() {
  const a = new CustomEvent(yC);
  document.dispatchEvent(a);
}
function m_(a, u, s, { discrete: f }) {
  const p = s.originalEvent.target, h = new CustomEvent(a, { bubbles: !1, cancelable: !0, detail: s });
  u && p.addEventListener(a, u, { once: !0 }), f ? v_(p, h) : p.dispatchEvent(h);
}
var W0 = 0;
function $C() {
  L.useEffect(() => {
    const a = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", a[0] ?? R1()), document.body.insertAdjacentElement("beforeend", a[1] ?? R1()), W0++, () => {
      W0 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((u) => u.remove()), W0--;
    };
  }, []);
}
function R1() {
  const a = document.createElement("span");
  return a.setAttribute("data-radix-focus-guard", ""), a.tabIndex = 0, a.style.outline = "none", a.style.opacity = "0", a.style.position = "fixed", a.style.pointerEvents = "none", a;
}
var Y0 = "focusScope.autoFocusOnMount", G0 = "focusScope.autoFocusOnUnmount", _1 = { bubbles: !1, cancelable: !0 }, Hz = "FocusScope", Gy = L.forwardRef((a, u) => {
  const {
    loop: s = !1,
    trapped: f = !1,
    onMountAutoFocus: p,
    onUnmountAutoFocus: h,
    ...m
  } = a, [x, C] = L.useState(null), E = Kl(p), R = Kl(h), T = L.useRef(null), O = Yn(u, (k) => C(k)), N = L.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  L.useEffect(() => {
    if (f) {
      let k = function(I) {
        if (N.paused || !x) return;
        const V = I.target;
        x.contains(V) ? T.current = V : Qu(T.current, { select: !0 });
      }, A = function(I) {
        if (N.paused || !x) return;
        const V = I.relatedTarget;
        V !== null && (x.contains(V) || Qu(T.current, { select: !0 }));
      }, z = function(I) {
        if (document.activeElement === document.body)
          for (const B of I)
            B.removedNodes.length > 0 && Qu(x);
      };
      document.addEventListener("focusin", k), document.addEventListener("focusout", A);
      const F = new MutationObserver(z);
      return x && F.observe(x, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", k), document.removeEventListener("focusout", A), F.disconnect();
      };
    }
  }, [f, x, N.paused]), L.useEffect(() => {
    if (x) {
      D1.add(N);
      const k = document.activeElement;
      if (!x.contains(k)) {
        const z = new CustomEvent(Y0, _1);
        x.addEventListener(Y0, E), x.dispatchEvent(z), z.defaultPrevented || ($z(Qz(g_(x)), { select: !0 }), document.activeElement === k && Qu(x));
      }
      return () => {
        x.removeEventListener(Y0, E), setTimeout(() => {
          const z = new CustomEvent(G0, _1);
          x.addEventListener(G0, R), x.dispatchEvent(z), z.defaultPrevented || Qu(k ?? document.body, { select: !0 }), x.removeEventListener(G0, R), D1.remove(N);
        }, 0);
      };
    }
  }, [x, E, R, N]);
  const j = L.useCallback(
    (k) => {
      if (!s && !f || N.paused) return;
      const A = k.key === "Tab" && !k.altKey && !k.ctrlKey && !k.metaKey, z = document.activeElement;
      if (A && z) {
        const F = k.currentTarget, [I, V] = Vz(F);
        I && V ? !k.shiftKey && z === V ? (k.preventDefault(), s && Qu(I, { select: !0 })) : k.shiftKey && z === I && (k.preventDefault(), s && Qu(V, { select: !0 })) : z === F && k.preventDefault();
      }
    },
    [s, f, N.paused]
  );
  return /* @__PURE__ */ D.jsx(an.div, { tabIndex: -1, ...m, ref: O, onKeyDown: j });
});
Gy.displayName = Hz;
function $z(a, { select: u = !1 } = {}) {
  const s = document.activeElement;
  for (const f of a)
    if (Qu(f, { select: u }), document.activeElement !== s) return;
}
function Vz(a) {
  const u = g_(a), s = O1(u, a), f = O1(u.reverse(), a);
  return [s, f];
}
function g_(a) {
  const u = [], s = document.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (f) => {
      const p = f.tagName === "INPUT" && f.type === "hidden";
      return f.disabled || f.hidden || p ? NodeFilter.FILTER_SKIP : f.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; s.nextNode(); ) u.push(s.currentNode);
  return u;
}
function O1(a, u) {
  for (const s of a)
    if (!Wz(s, { upTo: u })) return s;
}
function Wz(a, { upTo: u }) {
  if (getComputedStyle(a).visibility === "hidden") return !0;
  for (; a; ) {
    if (u !== void 0 && a === u) return !1;
    if (getComputedStyle(a).display === "none") return !0;
    a = a.parentElement;
  }
  return !1;
}
function Yz(a) {
  return a instanceof HTMLInputElement && "select" in a;
}
function Qu(a, { select: u = !1 } = {}) {
  if (a && a.focus) {
    const s = document.activeElement;
    a.focus({ preventScroll: !0 }), a !== s && Yz(a) && u && a.select();
  }
}
var D1 = Gz();
function Gz() {
  let a = [];
  return {
    add(u) {
      const s = a[0];
      u !== s && (s == null || s.pause()), a = k1(a, u), a.unshift(u);
    },
    remove(u) {
      var s;
      a = k1(a, u), (s = a[0]) == null || s.resume();
    }
  };
}
function k1(a, u) {
  const s = [...a], f = s.indexOf(u);
  return f !== -1 && s.splice(f, 1), s;
}
function Qz(a) {
  return a.filter((u) => u.tagName !== "A");
}
var Kz = L[" useId ".trim().toString()] || (() => {
}), qz = 0;
function Yl(a) {
  const [u, s] = L.useState(Kz());
  return Ql(() => {
    s((f) => f ?? String(qz++));
  }, [a]), u ? `radix-${u}` : "";
}
const Xz = ["top", "right", "bottom", "left"], Xu = Math.min, Jo = Math.max, Ay = Math.round, Sy = Math.floor, Wi = (a) => ({
  x: a,
  y: a
}), Zz = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Jz = {
  start: "end",
  end: "start"
};
function xC(a, u, s) {
  return Jo(a, Xu(u, s));
}
function ql(a, u) {
  return typeof a == "function" ? a(u) : a;
}
function Xl(a) {
  return a.split("-")[0];
}
function Ld(a) {
  return a.split("-")[1];
}
function VC(a) {
  return a === "x" ? "y" : "x";
}
function WC(a) {
  return a === "y" ? "height" : "width";
}
function Zu(a) {
  return ["top", "bottom"].includes(Xl(a)) ? "y" : "x";
}
function YC(a) {
  return VC(Zu(a));
}
function eI(a, u, s) {
  s === void 0 && (s = !1);
  const f = Ld(a), p = YC(a), h = WC(p);
  let m = p === "x" ? f === (s ? "end" : "start") ? "right" : "left" : f === "start" ? "bottom" : "top";
  return u.reference[h] > u.floating[h] && (m = Py(m)), [m, Py(m)];
}
function tI(a) {
  const u = Py(a);
  return [SC(a), u, SC(u)];
}
function SC(a) {
  return a.replace(/start|end/g, (u) => Jz[u]);
}
function nI(a, u, s) {
  const f = ["left", "right"], p = ["right", "left"], h = ["top", "bottom"], m = ["bottom", "top"];
  switch (a) {
    case "top":
    case "bottom":
      return s ? u ? p : f : u ? f : p;
    case "left":
    case "right":
      return u ? h : m;
    default:
      return [];
  }
}
function rI(a, u, s, f) {
  const p = Ld(a);
  let h = nI(Xl(a), s === "start", f);
  return p && (h = h.map((m) => m + "-" + p), u && (h = h.concat(h.map(SC)))), h;
}
function Py(a) {
  return a.replace(/left|right|bottom|top/g, (u) => Zz[u]);
}
function oI(a) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...a
  };
}
function y_(a) {
  return typeof a != "number" ? oI(a) : {
    top: a,
    right: a,
    bottom: a,
    left: a
  };
}
function Ly(a) {
  const {
    x: u,
    y: s,
    width: f,
    height: p
  } = a;
  return {
    width: f,
    height: p,
    top: s,
    left: u,
    right: u + f,
    bottom: s + p,
    x: u,
    y: s
  };
}
function M1(a, u, s) {
  let {
    reference: f,
    floating: p
  } = a;
  const h = Zu(u), m = YC(u), x = WC(m), C = Xl(u), E = h === "y", R = f.x + f.width / 2 - p.width / 2, T = f.y + f.height / 2 - p.height / 2, O = f[x] / 2 - p[x] / 2;
  let N;
  switch (C) {
    case "top":
      N = {
        x: R,
        y: f.y - p.height
      };
      break;
    case "bottom":
      N = {
        x: R,
        y: f.y + f.height
      };
      break;
    case "right":
      N = {
        x: f.x + f.width,
        y: T
      };
      break;
    case "left":
      N = {
        x: f.x - p.width,
        y: T
      };
      break;
    default:
      N = {
        x: f.x,
        y: f.y
      };
  }
  switch (Ld(u)) {
    case "start":
      N[m] -= O * (s && E ? -1 : 1);
      break;
    case "end":
      N[m] += O * (s && E ? -1 : 1);
      break;
  }
  return N;
}
const aI = async (a, u, s) => {
  const {
    placement: f = "bottom",
    strategy: p = "absolute",
    middleware: h = [],
    platform: m
  } = s, x = h.filter(Boolean), C = await (m.isRTL == null ? void 0 : m.isRTL(u));
  let E = await m.getElementRects({
    reference: a,
    floating: u,
    strategy: p
  }), {
    x: R,
    y: T
  } = M1(E, f, C), O = f, N = {}, j = 0;
  for (let k = 0; k < x.length; k++) {
    const {
      name: A,
      fn: z
    } = x[k], {
      x: F,
      y: I,
      data: V,
      reset: B
    } = await z({
      x: R,
      y: T,
      initialPlacement: f,
      placement: O,
      strategy: p,
      middlewareData: N,
      rects: E,
      platform: m,
      elements: {
        reference: a,
        floating: u
      }
    });
    R = F ?? R, T = I ?? T, N = {
      ...N,
      [A]: {
        ...N[A],
        ...V
      }
    }, B && j <= 50 && (j++, typeof B == "object" && (B.placement && (O = B.placement), B.rects && (E = B.rects === !0 ? await m.getElementRects({
      reference: a,
      floating: u,
      strategy: p
    }) : B.rects), {
      x: R,
      y: T
    } = M1(E, O, C)), k = -1);
  }
  return {
    x: R,
    y: T,
    placement: O,
    strategy: p,
    middlewareData: N
  };
};
async function ch(a, u) {
  var s;
  u === void 0 && (u = {});
  const {
    x: f,
    y: p,
    platform: h,
    rects: m,
    elements: x,
    strategy: C
  } = a, {
    boundary: E = "clippingAncestors",
    rootBoundary: R = "viewport",
    elementContext: T = "floating",
    altBoundary: O = !1,
    padding: N = 0
  } = ql(u, a), j = y_(N), A = x[O ? T === "floating" ? "reference" : "floating" : T], z = Ly(await h.getClippingRect({
    element: (s = await (h.isElement == null ? void 0 : h.isElement(A))) == null || s ? A : A.contextElement || await (h.getDocumentElement == null ? void 0 : h.getDocumentElement(x.floating)),
    boundary: E,
    rootBoundary: R,
    strategy: C
  })), F = T === "floating" ? {
    x: f,
    y: p,
    width: m.floating.width,
    height: m.floating.height
  } : m.reference, I = await (h.getOffsetParent == null ? void 0 : h.getOffsetParent(x.floating)), V = await (h.isElement == null ? void 0 : h.isElement(I)) ? await (h.getScale == null ? void 0 : h.getScale(I)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, B = Ly(h.convertOffsetParentRelativeRectToViewportRelativeRect ? await h.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: x,
    rect: F,
    offsetParent: I,
    strategy: C
  }) : F);
  return {
    top: (z.top - B.top + j.top) / V.y,
    bottom: (B.bottom - z.bottom + j.bottom) / V.y,
    left: (z.left - B.left + j.left) / V.x,
    right: (B.right - z.right + j.right) / V.x
  };
}
const iI = (a) => ({
  name: "arrow",
  options: a,
  async fn(u) {
    const {
      x: s,
      y: f,
      placement: p,
      rects: h,
      platform: m,
      elements: x,
      middlewareData: C
    } = u, {
      element: E,
      padding: R = 0
    } = ql(a, u) || {};
    if (E == null)
      return {};
    const T = y_(R), O = {
      x: s,
      y: f
    }, N = YC(p), j = WC(N), k = await m.getDimensions(E), A = N === "y", z = A ? "top" : "left", F = A ? "bottom" : "right", I = A ? "clientHeight" : "clientWidth", V = h.reference[j] + h.reference[N] - O[N] - h.floating[j], B = O[N] - h.reference[N], ae = await (m.getOffsetParent == null ? void 0 : m.getOffsetParent(E));
    let Z = ae ? ae[I] : 0;
    (!Z || !await (m.isElement == null ? void 0 : m.isElement(ae))) && (Z = x.floating[I] || h.floating[j]);
    const pe = V / 2 - B / 2, de = Z / 2 - k[j] / 2 - 1, me = Xu(T[z], de), Te = Xu(T[F], de), ve = me, ce = Z - k[j] - Te, Ee = Z / 2 - k[j] / 2 + pe, Ue = xC(ve, Ee, ce), Re = !C.arrow && Ld(p) != null && Ee !== Ue && h.reference[j] / 2 - (Ee < ve ? me : Te) - k[j] / 2 < 0, Ke = Re ? Ee < ve ? Ee - ve : Ee - ce : 0;
    return {
      [N]: O[N] + Ke,
      data: {
        [N]: Ue,
        centerOffset: Ee - Ue - Ke,
        ...Re && {
          alignmentOffset: Ke
        }
      },
      reset: Re
    };
  }
}), lI = function(a) {
  return a === void 0 && (a = {}), {
    name: "flip",
    options: a,
    async fn(u) {
      var s, f;
      const {
        placement: p,
        middlewareData: h,
        rects: m,
        initialPlacement: x,
        platform: C,
        elements: E
      } = u, {
        mainAxis: R = !0,
        crossAxis: T = !0,
        fallbackPlacements: O,
        fallbackStrategy: N = "bestFit",
        fallbackAxisSideDirection: j = "none",
        flipAlignment: k = !0,
        ...A
      } = ql(a, u);
      if ((s = h.arrow) != null && s.alignmentOffset)
        return {};
      const z = Xl(p), F = Zu(x), I = Xl(x) === x, V = await (C.isRTL == null ? void 0 : C.isRTL(E.floating)), B = O || (I || !k ? [Py(x)] : tI(x)), ae = j !== "none";
      !O && ae && B.push(...rI(x, k, j, V));
      const Z = [x, ...B], pe = await ch(u, A), de = [];
      let me = ((f = h.flip) == null ? void 0 : f.overflows) || [];
      if (R && de.push(pe[z]), T) {
        const Ee = eI(p, m, V);
        de.push(pe[Ee[0]], pe[Ee[1]]);
      }
      if (me = [...me, {
        placement: p,
        overflows: de
      }], !de.every((Ee) => Ee <= 0)) {
        var Te, ve;
        const Ee = (((Te = h.flip) == null ? void 0 : Te.index) || 0) + 1, Ue = Z[Ee];
        if (Ue)
          return {
            data: {
              index: Ee,
              overflows: me
            },
            reset: {
              placement: Ue
            }
          };
        let Re = (ve = me.filter((Ke) => Ke.overflows[0] <= 0).sort((Ke, oe) => Ke.overflows[1] - oe.overflows[1])[0]) == null ? void 0 : ve.placement;
        if (!Re)
          switch (N) {
            case "bestFit": {
              var ce;
              const Ke = (ce = me.filter((oe) => {
                if (ae) {
                  const le = Zu(oe.placement);
                  return le === F || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  le === "y";
                }
                return !0;
              }).map((oe) => [oe.placement, oe.overflows.filter((le) => le > 0).reduce((le, W) => le + W, 0)]).sort((oe, le) => oe[1] - le[1])[0]) == null ? void 0 : ce[0];
              Ke && (Re = Ke);
              break;
            }
            case "initialPlacement":
              Re = x;
              break;
          }
        if (p !== Re)
          return {
            reset: {
              placement: Re
            }
          };
      }
      return {};
    }
  };
};
function N1(a, u) {
  return {
    top: a.top - u.height,
    right: a.right - u.width,
    bottom: a.bottom - u.height,
    left: a.left - u.width
  };
}
function A1(a) {
  return Xz.some((u) => a[u] >= 0);
}
const uI = function(a) {
  return a === void 0 && (a = {}), {
    name: "hide",
    options: a,
    async fn(u) {
      const {
        rects: s
      } = u, {
        strategy: f = "referenceHidden",
        ...p
      } = ql(a, u);
      switch (f) {
        case "referenceHidden": {
          const h = await ch(u, {
            ...p,
            elementContext: "reference"
          }), m = N1(h, s.reference);
          return {
            data: {
              referenceHiddenOffsets: m,
              referenceHidden: A1(m)
            }
          };
        }
        case "escaped": {
          const h = await ch(u, {
            ...p,
            altBoundary: !0
          }), m = N1(h, s.floating);
          return {
            data: {
              escapedOffsets: m,
              escaped: A1(m)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function sI(a, u) {
  const {
    placement: s,
    platform: f,
    elements: p
  } = a, h = await (f.isRTL == null ? void 0 : f.isRTL(p.floating)), m = Xl(s), x = Ld(s), C = Zu(s) === "y", E = ["left", "top"].includes(m) ? -1 : 1, R = h && C ? -1 : 1, T = ql(u, a);
  let {
    mainAxis: O,
    crossAxis: N,
    alignmentAxis: j
  } = typeof T == "number" ? {
    mainAxis: T,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: T.mainAxis || 0,
    crossAxis: T.crossAxis || 0,
    alignmentAxis: T.alignmentAxis
  };
  return x && typeof j == "number" && (N = x === "end" ? j * -1 : j), C ? {
    x: N * R,
    y: O * E
  } : {
    x: O * E,
    y: N * R
  };
}
const cI = function(a) {
  return a === void 0 && (a = 0), {
    name: "offset",
    options: a,
    async fn(u) {
      var s, f;
      const {
        x: p,
        y: h,
        placement: m,
        middlewareData: x
      } = u, C = await sI(u, a);
      return m === ((s = x.offset) == null ? void 0 : s.placement) && (f = x.arrow) != null && f.alignmentOffset ? {} : {
        x: p + C.x,
        y: h + C.y,
        data: {
          ...C,
          placement: m
        }
      };
    }
  };
}, fI = function(a) {
  return a === void 0 && (a = {}), {
    name: "shift",
    options: a,
    async fn(u) {
      const {
        x: s,
        y: f,
        placement: p
      } = u, {
        mainAxis: h = !0,
        crossAxis: m = !1,
        limiter: x = {
          fn: (A) => {
            let {
              x: z,
              y: F
            } = A;
            return {
              x: z,
              y: F
            };
          }
        },
        ...C
      } = ql(a, u), E = {
        x: s,
        y: f
      }, R = await ch(u, C), T = Zu(Xl(p)), O = VC(T);
      let N = E[O], j = E[T];
      if (h) {
        const A = O === "y" ? "top" : "left", z = O === "y" ? "bottom" : "right", F = N + R[A], I = N - R[z];
        N = xC(F, N, I);
      }
      if (m) {
        const A = T === "y" ? "top" : "left", z = T === "y" ? "bottom" : "right", F = j + R[A], I = j - R[z];
        j = xC(F, j, I);
      }
      const k = x.fn({
        ...u,
        [O]: N,
        [T]: j
      });
      return {
        ...k,
        data: {
          x: k.x - s,
          y: k.y - f,
          enabled: {
            [O]: h,
            [T]: m
          }
        }
      };
    }
  };
}, dI = function(a) {
  return a === void 0 && (a = {}), {
    options: a,
    fn(u) {
      const {
        x: s,
        y: f,
        placement: p,
        rects: h,
        middlewareData: m
      } = u, {
        offset: x = 0,
        mainAxis: C = !0,
        crossAxis: E = !0
      } = ql(a, u), R = {
        x: s,
        y: f
      }, T = Zu(p), O = VC(T);
      let N = R[O], j = R[T];
      const k = ql(x, u), A = typeof k == "number" ? {
        mainAxis: k,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...k
      };
      if (C) {
        const I = O === "y" ? "height" : "width", V = h.reference[O] - h.floating[I] + A.mainAxis, B = h.reference[O] + h.reference[I] - A.mainAxis;
        N < V ? N = V : N > B && (N = B);
      }
      if (E) {
        var z, F;
        const I = O === "y" ? "width" : "height", V = ["top", "left"].includes(Xl(p)), B = h.reference[T] - h.floating[I] + (V && ((z = m.offset) == null ? void 0 : z[T]) || 0) + (V ? 0 : A.crossAxis), ae = h.reference[T] + h.reference[I] + (V ? 0 : ((F = m.offset) == null ? void 0 : F[T]) || 0) - (V ? A.crossAxis : 0);
        j < B ? j = B : j > ae && (j = ae);
      }
      return {
        [O]: N,
        [T]: j
      };
    }
  };
}, pI = function(a) {
  return a === void 0 && (a = {}), {
    name: "size",
    options: a,
    async fn(u) {
      var s, f;
      const {
        placement: p,
        rects: h,
        platform: m,
        elements: x
      } = u, {
        apply: C = () => {
        },
        ...E
      } = ql(a, u), R = await ch(u, E), T = Xl(p), O = Ld(p), N = Zu(p) === "y", {
        width: j,
        height: k
      } = h.floating;
      let A, z;
      T === "top" || T === "bottom" ? (A = T, z = O === (await (m.isRTL == null ? void 0 : m.isRTL(x.floating)) ? "start" : "end") ? "left" : "right") : (z = T, A = O === "end" ? "top" : "bottom");
      const F = k - R.top - R.bottom, I = j - R.left - R.right, V = Xu(k - R[A], F), B = Xu(j - R[z], I), ae = !u.middlewareData.shift;
      let Z = V, pe = B;
      if ((s = u.middlewareData.shift) != null && s.enabled.x && (pe = I), (f = u.middlewareData.shift) != null && f.enabled.y && (Z = F), ae && !O) {
        const me = Jo(R.left, 0), Te = Jo(R.right, 0), ve = Jo(R.top, 0), ce = Jo(R.bottom, 0);
        N ? pe = j - 2 * (me !== 0 || Te !== 0 ? me + Te : Jo(R.left, R.right)) : Z = k - 2 * (ve !== 0 || ce !== 0 ? ve + ce : Jo(R.top, R.bottom));
      }
      await C({
        ...u,
        availableWidth: pe,
        availableHeight: Z
      });
      const de = await m.getDimensions(x.floating);
      return j !== de.width || k !== de.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Qy() {
  return typeof window < "u";
}
function jd(a) {
  return x_(a) ? (a.nodeName || "").toLowerCase() : "#document";
}
function ea(a) {
  var u;
  return (a == null || (u = a.ownerDocument) == null ? void 0 : u.defaultView) || window;
}
function Zi(a) {
  var u;
  return (u = (x_(a) ? a.ownerDocument : a.document) || window.document) == null ? void 0 : u.documentElement;
}
function x_(a) {
  return Qy() ? a instanceof Node || a instanceof ea(a).Node : !1;
}
function ni(a) {
  return Qy() ? a instanceof Element || a instanceof ea(a).Element : !1;
}
function Ki(a) {
  return Qy() ? a instanceof HTMLElement || a instanceof ea(a).HTMLElement : !1;
}
function P1(a) {
  return !Qy() || typeof ShadowRoot > "u" ? !1 : a instanceof ShadowRoot || a instanceof ea(a).ShadowRoot;
}
function mh(a) {
  const {
    overflow: u,
    overflowX: s,
    overflowY: f,
    display: p
  } = ri(a);
  return /auto|scroll|overlay|hidden|clip/.test(u + f + s) && !["inline", "contents"].includes(p);
}
function vI(a) {
  return ["table", "td", "th"].includes(jd(a));
}
function Ky(a) {
  return [":popover-open", ":modal"].some((u) => {
    try {
      return a.matches(u);
    } catch {
      return !1;
    }
  });
}
function GC(a) {
  const u = QC(), s = ni(a) ? ri(a) : a;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((f) => s[f] ? s[f] !== "none" : !1) || (s.containerType ? s.containerType !== "normal" : !1) || !u && (s.backdropFilter ? s.backdropFilter !== "none" : !1) || !u && (s.filter ? s.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((f) => (s.willChange || "").includes(f)) || ["paint", "layout", "strict", "content"].some((f) => (s.contain || "").includes(f));
}
function hI(a) {
  let u = Ju(a);
  for (; Ki(u) && !Md(u); ) {
    if (GC(u))
      return u;
    if (Ky(u))
      return null;
    u = Ju(u);
  }
  return null;
}
function QC() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Md(a) {
  return ["html", "body", "#document"].includes(jd(a));
}
function ri(a) {
  return ea(a).getComputedStyle(a);
}
function qy(a) {
  return ni(a) ? {
    scrollLeft: a.scrollLeft,
    scrollTop: a.scrollTop
  } : {
    scrollLeft: a.scrollX,
    scrollTop: a.scrollY
  };
}
function Ju(a) {
  if (jd(a) === "html")
    return a;
  const u = (
    // Step into the shadow DOM of the parent of a slotted node.
    a.assignedSlot || // DOM Element detected.
    a.parentNode || // ShadowRoot detected.
    P1(a) && a.host || // Fallback.
    Zi(a)
  );
  return P1(u) ? u.host : u;
}
function S_(a) {
  const u = Ju(a);
  return Md(u) ? a.ownerDocument ? a.ownerDocument.body : a.body : Ki(u) && mh(u) ? u : S_(u);
}
function fh(a, u, s) {
  var f;
  u === void 0 && (u = []), s === void 0 && (s = !0);
  const p = S_(a), h = p === ((f = a.ownerDocument) == null ? void 0 : f.body), m = ea(p);
  if (h) {
    const x = bC(m);
    return u.concat(m, m.visualViewport || [], mh(p) ? p : [], x && s ? fh(x) : []);
  }
  return u.concat(p, fh(p, [], s));
}
function bC(a) {
  return a.parent && Object.getPrototypeOf(a.parent) ? a.frameElement : null;
}
function b_(a) {
  const u = ri(a);
  let s = parseFloat(u.width) || 0, f = parseFloat(u.height) || 0;
  const p = Ki(a), h = p ? a.offsetWidth : s, m = p ? a.offsetHeight : f, x = Ay(s) !== h || Ay(f) !== m;
  return x && (s = h, f = m), {
    width: s,
    height: f,
    $: x
  };
}
function KC(a) {
  return ni(a) ? a : a.contextElement;
}
function _d(a) {
  const u = KC(a);
  if (!Ki(u))
    return Wi(1);
  const s = u.getBoundingClientRect(), {
    width: f,
    height: p,
    $: h
  } = b_(u);
  let m = (h ? Ay(s.width) : s.width) / f, x = (h ? Ay(s.height) : s.height) / p;
  return (!m || !Number.isFinite(m)) && (m = 1), (!x || !Number.isFinite(x)) && (x = 1), {
    x: m,
    y: x
  };
}
const mI = /* @__PURE__ */ Wi(0);
function C_(a) {
  const u = ea(a);
  return !QC() || !u.visualViewport ? mI : {
    x: u.visualViewport.offsetLeft,
    y: u.visualViewport.offsetTop
  };
}
function gI(a, u, s) {
  return u === void 0 && (u = !1), !s || u && s !== ea(a) ? !1 : u;
}
function Cc(a, u, s, f) {
  u === void 0 && (u = !1), s === void 0 && (s = !1);
  const p = a.getBoundingClientRect(), h = KC(a);
  let m = Wi(1);
  u && (f ? ni(f) && (m = _d(f)) : m = _d(a));
  const x = gI(h, s, f) ? C_(h) : Wi(0);
  let C = (p.left + x.x) / m.x, E = (p.top + x.y) / m.y, R = p.width / m.x, T = p.height / m.y;
  if (h) {
    const O = ea(h), N = f && ni(f) ? ea(f) : f;
    let j = O, k = bC(j);
    for (; k && f && N !== j; ) {
      const A = _d(k), z = k.getBoundingClientRect(), F = ri(k), I = z.left + (k.clientLeft + parseFloat(F.paddingLeft)) * A.x, V = z.top + (k.clientTop + parseFloat(F.paddingTop)) * A.y;
      C *= A.x, E *= A.y, R *= A.x, T *= A.y, C += I, E += V, j = ea(k), k = bC(j);
    }
  }
  return Ly({
    width: R,
    height: T,
    x: C,
    y: E
  });
}
function qC(a, u) {
  const s = qy(a).scrollLeft;
  return u ? u.left + s : Cc(Zi(a)).left + s;
}
function E_(a, u, s) {
  s === void 0 && (s = !1);
  const f = a.getBoundingClientRect(), p = f.left + u.scrollLeft - (s ? 0 : (
    // RTL <body> scrollbar.
    qC(a, f)
  )), h = f.top + u.scrollTop;
  return {
    x: p,
    y: h
  };
}
function yI(a) {
  let {
    elements: u,
    rect: s,
    offsetParent: f,
    strategy: p
  } = a;
  const h = p === "fixed", m = Zi(f), x = u ? Ky(u.floating) : !1;
  if (f === m || x && h)
    return s;
  let C = {
    scrollLeft: 0,
    scrollTop: 0
  }, E = Wi(1);
  const R = Wi(0), T = Ki(f);
  if ((T || !T && !h) && ((jd(f) !== "body" || mh(m)) && (C = qy(f)), Ki(f))) {
    const N = Cc(f);
    E = _d(f), R.x = N.x + f.clientLeft, R.y = N.y + f.clientTop;
  }
  const O = m && !T && !h ? E_(m, C, !0) : Wi(0);
  return {
    width: s.width * E.x,
    height: s.height * E.y,
    x: s.x * E.x - C.scrollLeft * E.x + R.x + O.x,
    y: s.y * E.y - C.scrollTop * E.y + R.y + O.y
  };
}
function xI(a) {
  return Array.from(a.getClientRects());
}
function SI(a) {
  const u = Zi(a), s = qy(a), f = a.ownerDocument.body, p = Jo(u.scrollWidth, u.clientWidth, f.scrollWidth, f.clientWidth), h = Jo(u.scrollHeight, u.clientHeight, f.scrollHeight, f.clientHeight);
  let m = -s.scrollLeft + qC(a);
  const x = -s.scrollTop;
  return ri(f).direction === "rtl" && (m += Jo(u.clientWidth, f.clientWidth) - p), {
    width: p,
    height: h,
    x: m,
    y: x
  };
}
function bI(a, u) {
  const s = ea(a), f = Zi(a), p = s.visualViewport;
  let h = f.clientWidth, m = f.clientHeight, x = 0, C = 0;
  if (p) {
    h = p.width, m = p.height;
    const E = QC();
    (!E || E && u === "fixed") && (x = p.offsetLeft, C = p.offsetTop);
  }
  return {
    width: h,
    height: m,
    x,
    y: C
  };
}
function CI(a, u) {
  const s = Cc(a, !0, u === "fixed"), f = s.top + a.clientTop, p = s.left + a.clientLeft, h = Ki(a) ? _d(a) : Wi(1), m = a.clientWidth * h.x, x = a.clientHeight * h.y, C = p * h.x, E = f * h.y;
  return {
    width: m,
    height: x,
    x: C,
    y: E
  };
}
function L1(a, u, s) {
  let f;
  if (u === "viewport")
    f = bI(a, s);
  else if (u === "document")
    f = SI(Zi(a));
  else if (ni(u))
    f = CI(u, s);
  else {
    const p = C_(a);
    f = {
      x: u.x - p.x,
      y: u.y - p.y,
      width: u.width,
      height: u.height
    };
  }
  return Ly(f);
}
function w_(a, u) {
  const s = Ju(a);
  return s === u || !ni(s) || Md(s) ? !1 : ri(s).position === "fixed" || w_(s, u);
}
function EI(a, u) {
  const s = u.get(a);
  if (s)
    return s;
  let f = fh(a, [], !1).filter((x) => ni(x) && jd(x) !== "body"), p = null;
  const h = ri(a).position === "fixed";
  let m = h ? Ju(a) : a;
  for (; ni(m) && !Md(m); ) {
    const x = ri(m), C = GC(m);
    !C && x.position === "fixed" && (p = null), (h ? !C && !p : !C && x.position === "static" && !!p && ["absolute", "fixed"].includes(p.position) || mh(m) && !C && w_(a, m)) ? f = f.filter((R) => R !== m) : p = x, m = Ju(m);
  }
  return u.set(a, f), f;
}
function wI(a) {
  let {
    element: u,
    boundary: s,
    rootBoundary: f,
    strategy: p
  } = a;
  const m = [...s === "clippingAncestors" ? Ky(u) ? [] : EI(u, this._c) : [].concat(s), f], x = m[0], C = m.reduce((E, R) => {
    const T = L1(u, R, p);
    return E.top = Jo(T.top, E.top), E.right = Xu(T.right, E.right), E.bottom = Xu(T.bottom, E.bottom), E.left = Jo(T.left, E.left), E;
  }, L1(u, x, p));
  return {
    width: C.right - C.left,
    height: C.bottom - C.top,
    x: C.left,
    y: C.top
  };
}
function TI(a) {
  const {
    width: u,
    height: s
  } = b_(a);
  return {
    width: u,
    height: s
  };
}
function RI(a, u, s) {
  const f = Ki(u), p = Zi(u), h = s === "fixed", m = Cc(a, !0, h, u);
  let x = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const C = Wi(0);
  if (f || !f && !h)
    if ((jd(u) !== "body" || mh(p)) && (x = qy(u)), f) {
      const O = Cc(u, !0, h, u);
      C.x = O.x + u.clientLeft, C.y = O.y + u.clientTop;
    } else p && (C.x = qC(p));
  const E = p && !f && !h ? E_(p, x) : Wi(0), R = m.left + x.scrollLeft - C.x - E.x, T = m.top + x.scrollTop - C.y - E.y;
  return {
    x: R,
    y: T,
    width: m.width,
    height: m.height
  };
}
function Q0(a) {
  return ri(a).position === "static";
}
function j1(a, u) {
  if (!Ki(a) || ri(a).position === "fixed")
    return null;
  if (u)
    return u(a);
  let s = a.offsetParent;
  return Zi(a) === s && (s = s.ownerDocument.body), s;
}
function T_(a, u) {
  const s = ea(a);
  if (Ky(a))
    return s;
  if (!Ki(a)) {
    let p = Ju(a);
    for (; p && !Md(p); ) {
      if (ni(p) && !Q0(p))
        return p;
      p = Ju(p);
    }
    return s;
  }
  let f = j1(a, u);
  for (; f && vI(f) && Q0(f); )
    f = j1(f, u);
  return f && Md(f) && Q0(f) && !GC(f) ? s : f || hI(a) || s;
}
const _I = async function(a) {
  const u = this.getOffsetParent || T_, s = this.getDimensions, f = await s(a.floating);
  return {
    reference: RI(a.reference, await u(a.floating), a.strategy),
    floating: {
      x: 0,
      y: 0,
      width: f.width,
      height: f.height
    }
  };
};
function OI(a) {
  return ri(a).direction === "rtl";
}
const DI = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yI,
  getDocumentElement: Zi,
  getClippingRect: wI,
  getOffsetParent: T_,
  getElementRects: _I,
  getClientRects: xI,
  getDimensions: TI,
  getScale: _d,
  isElement: ni,
  isRTL: OI
};
function R_(a, u) {
  return a.x === u.x && a.y === u.y && a.width === u.width && a.height === u.height;
}
function kI(a, u) {
  let s = null, f;
  const p = Zi(a);
  function h() {
    var x;
    clearTimeout(f), (x = s) == null || x.disconnect(), s = null;
  }
  function m(x, C) {
    x === void 0 && (x = !1), C === void 0 && (C = 1), h();
    const E = a.getBoundingClientRect(), {
      left: R,
      top: T,
      width: O,
      height: N
    } = E;
    if (x || u(), !O || !N)
      return;
    const j = Sy(T), k = Sy(p.clientWidth - (R + O)), A = Sy(p.clientHeight - (T + N)), z = Sy(R), I = {
      rootMargin: -j + "px " + -k + "px " + -A + "px " + -z + "px",
      threshold: Jo(0, Xu(1, C)) || 1
    };
    let V = !0;
    function B(ae) {
      const Z = ae[0].intersectionRatio;
      if (Z !== C) {
        if (!V)
          return m();
        Z ? m(!1, Z) : f = setTimeout(() => {
          m(!1, 1e-7);
        }, 1e3);
      }
      Z === 1 && !R_(E, a.getBoundingClientRect()) && m(), V = !1;
    }
    try {
      s = new IntersectionObserver(B, {
        ...I,
        // Handle <iframe>s
        root: p.ownerDocument
      });
    } catch {
      s = new IntersectionObserver(B, I);
    }
    s.observe(a);
  }
  return m(!0), h;
}
function MI(a, u, s, f) {
  f === void 0 && (f = {});
  const {
    ancestorScroll: p = !0,
    ancestorResize: h = !0,
    elementResize: m = typeof ResizeObserver == "function",
    layoutShift: x = typeof IntersectionObserver == "function",
    animationFrame: C = !1
  } = f, E = KC(a), R = p || h ? [...E ? fh(E) : [], ...fh(u)] : [];
  R.forEach((z) => {
    p && z.addEventListener("scroll", s, {
      passive: !0
    }), h && z.addEventListener("resize", s);
  });
  const T = E && x ? kI(E, s) : null;
  let O = -1, N = null;
  m && (N = new ResizeObserver((z) => {
    let [F] = z;
    F && F.target === E && N && (N.unobserve(u), cancelAnimationFrame(O), O = requestAnimationFrame(() => {
      var I;
      (I = N) == null || I.observe(u);
    })), s();
  }), E && !C && N.observe(E), N.observe(u));
  let j, k = C ? Cc(a) : null;
  C && A();
  function A() {
    const z = Cc(a);
    k && !R_(k, z) && s(), k = z, j = requestAnimationFrame(A);
  }
  return s(), () => {
    var z;
    R.forEach((F) => {
      p && F.removeEventListener("scroll", s), h && F.removeEventListener("resize", s);
    }), T == null || T(), (z = N) == null || z.disconnect(), N = null, C && cancelAnimationFrame(j);
  };
}
const NI = cI, AI = fI, PI = lI, LI = pI, jI = uI, z1 = iI, zI = dI, II = (a, u, s) => {
  const f = /* @__PURE__ */ new Map(), p = {
    platform: DI,
    ...s
  }, h = {
    ...p.platform,
    _c: f
  };
  return aI(a, u, {
    ...p,
    platform: h
  });
};
var Ry = typeof document < "u" ? jL : zo;
function jy(a, u) {
  if (a === u)
    return !0;
  if (typeof a != typeof u)
    return !1;
  if (typeof a == "function" && a.toString() === u.toString())
    return !0;
  let s, f, p;
  if (a && u && typeof a == "object") {
    if (Array.isArray(a)) {
      if (s = a.length, s !== u.length) return !1;
      for (f = s; f-- !== 0; )
        if (!jy(a[f], u[f]))
          return !1;
      return !0;
    }
    if (p = Object.keys(a), s = p.length, s !== Object.keys(u).length)
      return !1;
    for (f = s; f-- !== 0; )
      if (!{}.hasOwnProperty.call(u, p[f]))
        return !1;
    for (f = s; f-- !== 0; ) {
      const h = p[f];
      if (!(h === "_owner" && a.$$typeof) && !jy(a[h], u[h]))
        return !1;
    }
    return !0;
  }
  return a !== a && u !== u;
}
function __(a) {
  return typeof window > "u" ? 1 : (a.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function I1(a, u) {
  const s = __(a);
  return Math.round(u * s) / s;
}
function K0(a) {
  const u = L.useRef(a);
  return Ry(() => {
    u.current = a;
  }), u;
}
function UI(a) {
  a === void 0 && (a = {});
  const {
    placement: u = "bottom",
    strategy: s = "absolute",
    middleware: f = [],
    platform: p,
    elements: {
      reference: h,
      floating: m
    } = {},
    transform: x = !0,
    whileElementsMounted: C,
    open: E
  } = a, [R, T] = L.useState({
    x: 0,
    y: 0,
    strategy: s,
    placement: u,
    middlewareData: {},
    isPositioned: !1
  }), [O, N] = L.useState(f);
  jy(O, f) || N(f);
  const [j, k] = L.useState(null), [A, z] = L.useState(null), F = L.useCallback((oe) => {
    oe !== ae.current && (ae.current = oe, k(oe));
  }, []), I = L.useCallback((oe) => {
    oe !== Z.current && (Z.current = oe, z(oe));
  }, []), V = h || j, B = m || A, ae = L.useRef(null), Z = L.useRef(null), pe = L.useRef(R), de = C != null, me = K0(C), Te = K0(p), ve = K0(E), ce = L.useCallback(() => {
    if (!ae.current || !Z.current)
      return;
    const oe = {
      placement: u,
      strategy: s,
      middleware: O
    };
    Te.current && (oe.platform = Te.current), II(ae.current, Z.current, oe).then((le) => {
      const W = {
        ...le,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: ve.current !== !1
      };
      Ee.current && !jy(pe.current, W) && (pe.current = W, FC.flushSync(() => {
        T(W);
      }));
    });
  }, [O, u, s, Te, ve]);
  Ry(() => {
    E === !1 && pe.current.isPositioned && (pe.current.isPositioned = !1, T((oe) => ({
      ...oe,
      isPositioned: !1
    })));
  }, [E]);
  const Ee = L.useRef(!1);
  Ry(() => (Ee.current = !0, () => {
    Ee.current = !1;
  }), []), Ry(() => {
    if (V && (ae.current = V), B && (Z.current = B), V && B) {
      if (me.current)
        return me.current(V, B, ce);
      ce();
    }
  }, [V, B, ce, me, de]);
  const Ue = L.useMemo(() => ({
    reference: ae,
    floating: Z,
    setReference: F,
    setFloating: I
  }), [F, I]), Re = L.useMemo(() => ({
    reference: V,
    floating: B
  }), [V, B]), Ke = L.useMemo(() => {
    const oe = {
      position: s,
      left: 0,
      top: 0
    };
    if (!Re.floating)
      return oe;
    const le = I1(Re.floating, R.x), W = I1(Re.floating, R.y);
    return x ? {
      ...oe,
      transform: "translate(" + le + "px, " + W + "px)",
      ...__(Re.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: s,
      left: le,
      top: W
    };
  }, [s, x, Re.floating, R.x, R.y]);
  return L.useMemo(() => ({
    ...R,
    update: ce,
    refs: Ue,
    elements: Re,
    floatingStyles: Ke
  }), [R, ce, Ue, Re, Ke]);
}
const FI = (a) => {
  function u(s) {
    return {}.hasOwnProperty.call(s, "current");
  }
  return {
    name: "arrow",
    options: a,
    fn(s) {
      const {
        element: f,
        padding: p
      } = typeof a == "function" ? a(s) : a;
      return f && u(f) ? f.current != null ? z1({
        element: f.current,
        padding: p
      }).fn(s) : {} : f ? z1({
        element: f,
        padding: p
      }).fn(s) : {};
    }
  };
}, BI = (a, u) => ({
  ...NI(a),
  options: [a, u]
}), HI = (a, u) => ({
  ...AI(a),
  options: [a, u]
}), $I = (a, u) => ({
  ...zI(a),
  options: [a, u]
}), VI = (a, u) => ({
  ...PI(a),
  options: [a, u]
}), WI = (a, u) => ({
  ...LI(a),
  options: [a, u]
}), YI = (a, u) => ({
  ...jI(a),
  options: [a, u]
}), GI = (a, u) => ({
  ...FI(a),
  options: [a, u]
});
var QI = "Arrow", O_ = L.forwardRef((a, u) => {
  const { children: s, width: f = 10, height: p = 5, ...h } = a;
  return /* @__PURE__ */ D.jsx(
    an.svg,
    {
      ...h,
      ref: u,
      width: f,
      height: p,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: a.asChild ? s : /* @__PURE__ */ D.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
O_.displayName = QI;
var KI = O_;
function qI(a) {
  const [u, s] = L.useState(void 0);
  return Ql(() => {
    if (a) {
      s({ width: a.offsetWidth, height: a.offsetHeight });
      const f = new ResizeObserver((p) => {
        if (!Array.isArray(p) || !p.length)
          return;
        const h = p[0];
        let m, x;
        if ("borderBoxSize" in h) {
          const C = h.borderBoxSize, E = Array.isArray(C) ? C[0] : C;
          m = E.inlineSize, x = E.blockSize;
        } else
          m = a.offsetWidth, x = a.offsetHeight;
        s({ width: m, height: x });
      });
      return f.observe(a, { box: "border-box" }), () => f.unobserve(a);
    } else
      s(void 0);
  }, [a]), u;
}
var XC = "Popper", [D_, Xy] = Zl(XC), [XI, k_] = D_(XC), M_ = (a) => {
  const { __scopePopper: u, children: s } = a, [f, p] = L.useState(null);
  return /* @__PURE__ */ D.jsx(XI, { scope: u, anchor: f, onAnchorChange: p, children: s });
};
M_.displayName = XC;
var N_ = "PopperAnchor", A_ = L.forwardRef(
  (a, u) => {
    const { __scopePopper: s, virtualRef: f, ...p } = a, h = k_(N_, s), m = L.useRef(null), x = Yn(u, m);
    return L.useEffect(() => {
      h.onAnchorChange((f == null ? void 0 : f.current) || m.current);
    }), f ? null : /* @__PURE__ */ D.jsx(an.div, { ...p, ref: x });
  }
);
A_.displayName = N_;
var ZC = "PopperContent", [ZI, JI] = D_(ZC), P_ = L.forwardRef(
  (a, u) => {
    var Oe, Me, Ie, $e, Qe, re;
    const {
      __scopePopper: s,
      side: f = "bottom",
      sideOffset: p = 0,
      align: h = "center",
      alignOffset: m = 0,
      arrowPadding: x = 0,
      avoidCollisions: C = !0,
      collisionBoundary: E = [],
      collisionPadding: R = 0,
      sticky: T = "partial",
      hideWhenDetached: O = !1,
      updatePositionStrategy: N = "optimized",
      onPlaced: j,
      ...k
    } = a, A = k_(ZC, s), [z, F] = L.useState(null), I = Yn(u, (qe) => F(qe)), [V, B] = L.useState(null), ae = qI(V), Z = (ae == null ? void 0 : ae.width) ?? 0, pe = (ae == null ? void 0 : ae.height) ?? 0, de = f + (h !== "center" ? "-" + h : ""), me = typeof R == "number" ? R : { top: 0, right: 0, bottom: 0, left: 0, ...R }, Te = Array.isArray(E) ? E : [E], ve = Te.length > 0, ce = {
      padding: me,
      boundary: Te.filter(tU),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: ve
    }, { refs: Ee, floatingStyles: Ue, placement: Re, isPositioned: Ke, middlewareData: oe } = UI({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: de,
      whileElementsMounted: (...qe) => MI(...qe, {
        animationFrame: N === "always"
      }),
      elements: {
        reference: A.anchor
      },
      middleware: [
        BI({ mainAxis: p + pe, alignmentAxis: m }),
        C && HI({
          mainAxis: !0,
          crossAxis: !1,
          limiter: T === "partial" ? $I() : void 0,
          ...ce
        }),
        C && VI({ ...ce }),
        WI({
          ...ce,
          apply: ({ elements: qe, rects: vt, availableWidth: Tt, availableHeight: $t }) => {
            const { width: xn, height: Gn } = vt.reference, ln = qe.floating.style;
            ln.setProperty("--radix-popper-available-width", `${Tt}px`), ln.setProperty("--radix-popper-available-height", `${$t}px`), ln.setProperty("--radix-popper-anchor-width", `${xn}px`), ln.setProperty("--radix-popper-anchor-height", `${Gn}px`);
          }
        }),
        V && GI({ element: V, padding: x }),
        nU({ arrowWidth: Z, arrowHeight: pe }),
        O && YI({ strategy: "referenceHidden", ...ce })
      ]
    }), [le, W] = z_(Re), ie = Kl(j);
    Ql(() => {
      Ke && (ie == null || ie());
    }, [Ke, ie]);
    const we = (Oe = oe.arrow) == null ? void 0 : Oe.x, je = (Me = oe.arrow) == null ? void 0 : Me.y, ke = ((Ie = oe.arrow) == null ? void 0 : Ie.centerOffset) !== 0, [et, Pe] = L.useState();
    return Ql(() => {
      z && Pe(window.getComputedStyle(z).zIndex);
    }, [z]), /* @__PURE__ */ D.jsx(
      "div",
      {
        ref: Ee.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Ue,
          transform: Ke ? Ue.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: et,
          "--radix-popper-transform-origin": [
            ($e = oe.transformOrigin) == null ? void 0 : $e.x,
            (Qe = oe.transformOrigin) == null ? void 0 : Qe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((re = oe.hide) == null ? void 0 : re.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: a.dir,
        children: /* @__PURE__ */ D.jsx(
          ZI,
          {
            scope: s,
            placedSide: le,
            onArrowChange: B,
            arrowX: we,
            arrowY: je,
            shouldHideArrow: ke,
            children: /* @__PURE__ */ D.jsx(
              an.div,
              {
                "data-side": le,
                "data-align": W,
                ...k,
                ref: I,
                style: {
                  ...k.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Ke ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
P_.displayName = ZC;
var L_ = "PopperArrow", eU = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, j_ = L.forwardRef(function(u, s) {
  const { __scopePopper: f, ...p } = u, h = JI(L_, f), m = eU[h.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ D.jsx(
      "span",
      {
        ref: h.onArrowChange,
        style: {
          position: "absolute",
          left: h.arrowX,
          top: h.arrowY,
          [m]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[h.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[h.placedSide],
          visibility: h.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ D.jsx(
          KI,
          {
            ...p,
            ref: s,
            style: {
              ...p.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
j_.displayName = L_;
function tU(a) {
  return a !== null;
}
var nU = (a) => ({
  name: "transformOrigin",
  options: a,
  fn(u) {
    var A, z, F;
    const { placement: s, rects: f, middlewareData: p } = u, m = ((A = p.arrow) == null ? void 0 : A.centerOffset) !== 0, x = m ? 0 : a.arrowWidth, C = m ? 0 : a.arrowHeight, [E, R] = z_(s), T = { start: "0%", center: "50%", end: "100%" }[R], O = (((z = p.arrow) == null ? void 0 : z.x) ?? 0) + x / 2, N = (((F = p.arrow) == null ? void 0 : F.y) ?? 0) + C / 2;
    let j = "", k = "";
    return E === "bottom" ? (j = m ? T : `${O}px`, k = `${-C}px`) : E === "top" ? (j = m ? T : `${O}px`, k = `${f.floating.height + C}px`) : E === "right" ? (j = `${-C}px`, k = m ? T : `${N}px`) : E === "left" && (j = `${f.floating.width + C}px`, k = m ? T : `${N}px`), { data: { x: j, y: k } };
  }
});
function z_(a) {
  const [u, s = "center"] = a.split("-");
  return [u, s];
}
var I_ = M_, JC = A_, U_ = P_, F_ = j_, rU = "Portal", Zy = L.forwardRef((a, u) => {
  var x;
  const { container: s, ...f } = a, [p, h] = L.useState(!1);
  Ql(() => h(!0), []);
  const m = s || p && ((x = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : x.body);
  return m ? Rz.createPortal(/* @__PURE__ */ D.jsx(an.div, { ...f, ref: u }), m) : null;
});
Zy.displayName = rU;
function oU(a, u) {
  return L.useReducer((s, f) => u[s][f] ?? s, a);
}
var oi = (a) => {
  const { present: u, children: s } = a, f = aU(u), p = typeof s == "function" ? s({ present: f.isPresent }) : L.Children.only(s), h = Yn(f.ref, iU(p));
  return typeof s == "function" || f.isPresent ? L.cloneElement(p, { ref: h }) : null;
};
oi.displayName = "Presence";
function aU(a) {
  const [u, s] = L.useState(), f = L.useRef(null), p = L.useRef(a), h = L.useRef("none"), m = a ? "mounted" : "unmounted", [x, C] = oU(m, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return L.useEffect(() => {
    const E = by(f.current);
    h.current = x === "mounted" ? E : "none";
  }, [x]), Ql(() => {
    const E = f.current, R = p.current;
    if (R !== a) {
      const O = h.current, N = by(E);
      a ? C("MOUNT") : N === "none" || (E == null ? void 0 : E.display) === "none" ? C("UNMOUNT") : C(R && O !== N ? "ANIMATION_OUT" : "UNMOUNT"), p.current = a;
    }
  }, [a, C]), Ql(() => {
    if (u) {
      let E;
      const R = u.ownerDocument.defaultView ?? window, T = (N) => {
        const k = by(f.current).includes(N.animationName);
        if (N.target === u && k && (C("ANIMATION_END"), !p.current)) {
          const A = u.style.animationFillMode;
          u.style.animationFillMode = "forwards", E = R.setTimeout(() => {
            u.style.animationFillMode === "forwards" && (u.style.animationFillMode = A);
          });
        }
      }, O = (N) => {
        N.target === u && (h.current = by(f.current));
      };
      return u.addEventListener("animationstart", O), u.addEventListener("animationcancel", T), u.addEventListener("animationend", T), () => {
        R.clearTimeout(E), u.removeEventListener("animationstart", O), u.removeEventListener("animationcancel", T), u.removeEventListener("animationend", T);
      };
    } else
      C("ANIMATION_END");
  }, [u, C]), {
    isPresent: ["mounted", "unmountSuspended"].includes(x),
    ref: L.useCallback((E) => {
      f.current = E ? getComputedStyle(E) : null, s(E);
    }, [])
  };
}
function by(a) {
  return (a == null ? void 0 : a.animationName) || "none";
}
function iU(a) {
  var f, p;
  let u = (f = Object.getOwnPropertyDescriptor(a.props, "ref")) == null ? void 0 : f.get, s = u && "isReactWarning" in u && u.isReactWarning;
  return s ? a.ref : (u = (p = Object.getOwnPropertyDescriptor(a, "ref")) == null ? void 0 : p.get, s = u && "isReactWarning" in u && u.isReactWarning, s ? a.props.ref : a.props.ref || a.ref);
}
var q0 = "rovingFocusGroup.onEntryFocus", lU = { bubbles: !1, cancelable: !0 }, gh = "RovingFocusGroup", [CC, B_, uU] = BC(gh), [sU, H_] = Zl(
  gh,
  [uU]
), [cU, fU] = sU(gh), $_ = L.forwardRef(
  (a, u) => /* @__PURE__ */ D.jsx(CC.Provider, { scope: a.__scopeRovingFocusGroup, children: /* @__PURE__ */ D.jsx(CC.Slot, { scope: a.__scopeRovingFocusGroup, children: /* @__PURE__ */ D.jsx(dU, { ...a, ref: u }) }) })
);
$_.displayName = gh;
var dU = L.forwardRef((a, u) => {
  const {
    __scopeRovingFocusGroup: s,
    orientation: f,
    loop: p = !1,
    dir: h,
    currentTabStopId: m,
    defaultCurrentTabStopId: x,
    onCurrentTabStopIdChange: C,
    onEntryFocus: E,
    preventScrollOnEntryFocus: R = !1,
    ...T
  } = a, O = L.useRef(null), N = Yn(u, O), j = HC(h), [k, A] = Tc({
    prop: m,
    defaultProp: x ?? null,
    onChange: C,
    caller: gh
  }), [z, F] = L.useState(!1), I = Kl(E), V = B_(s), B = L.useRef(!1), [ae, Z] = L.useState(0);
  return L.useEffect(() => {
    const pe = O.current;
    if (pe)
      return pe.addEventListener(q0, I), () => pe.removeEventListener(q0, I);
  }, [I]), /* @__PURE__ */ D.jsx(
    cU,
    {
      scope: s,
      orientation: f,
      dir: j,
      loop: p,
      currentTabStopId: k,
      onItemFocus: L.useCallback(
        (pe) => A(pe),
        [A]
      ),
      onItemShiftTab: L.useCallback(() => F(!0), []),
      onFocusableItemAdd: L.useCallback(
        () => Z((pe) => pe + 1),
        []
      ),
      onFocusableItemRemove: L.useCallback(
        () => Z((pe) => pe - 1),
        []
      ),
      children: /* @__PURE__ */ D.jsx(
        an.div,
        {
          tabIndex: z || ae === 0 ? -1 : 0,
          "data-orientation": f,
          ...T,
          ref: N,
          style: { outline: "none", ...a.style },
          onMouseDown: mt(a.onMouseDown, () => {
            B.current = !0;
          }),
          onFocus: mt(a.onFocus, (pe) => {
            const de = !B.current;
            if (pe.target === pe.currentTarget && de && !z) {
              const me = new CustomEvent(q0, lU);
              if (pe.currentTarget.dispatchEvent(me), !me.defaultPrevented) {
                const Te = V().filter((Re) => Re.focusable), ve = Te.find((Re) => Re.active), ce = Te.find((Re) => Re.id === k), Ue = [ve, ce, ...Te].filter(
                  Boolean
                ).map((Re) => Re.ref.current);
                Y_(Ue, R);
              }
            }
            B.current = !1;
          }),
          onBlur: mt(a.onBlur, () => F(!1))
        }
      )
    }
  );
}), V_ = "RovingFocusGroupItem", W_ = L.forwardRef(
  (a, u) => {
    const {
      __scopeRovingFocusGroup: s,
      focusable: f = !0,
      active: p = !1,
      tabStopId: h,
      children: m,
      ...x
    } = a, C = Yl(), E = h || C, R = fU(V_, s), T = R.currentTabStopId === E, O = B_(s), { onFocusableItemAdd: N, onFocusableItemRemove: j, currentTabStopId: k } = R;
    return L.useEffect(() => {
      if (f)
        return N(), () => j();
    }, [f, N, j]), /* @__PURE__ */ D.jsx(
      CC.ItemSlot,
      {
        scope: s,
        id: E,
        focusable: f,
        active: p,
        children: /* @__PURE__ */ D.jsx(
          an.span,
          {
            tabIndex: T ? 0 : -1,
            "data-orientation": R.orientation,
            ...x,
            ref: u,
            onMouseDown: mt(a.onMouseDown, (A) => {
              f ? R.onItemFocus(E) : A.preventDefault();
            }),
            onFocus: mt(a.onFocus, () => R.onItemFocus(E)),
            onKeyDown: mt(a.onKeyDown, (A) => {
              if (A.key === "Tab" && A.shiftKey) {
                R.onItemShiftTab();
                return;
              }
              if (A.target !== A.currentTarget) return;
              const z = hU(A, R.orientation, R.dir);
              if (z !== void 0) {
                if (A.metaKey || A.ctrlKey || A.altKey || A.shiftKey) return;
                A.preventDefault();
                let I = O().filter((V) => V.focusable).map((V) => V.ref.current);
                if (z === "last") I.reverse();
                else if (z === "prev" || z === "next") {
                  z === "prev" && I.reverse();
                  const V = I.indexOf(A.currentTarget);
                  I = R.loop ? mU(I, V + 1) : I.slice(V + 1);
                }
                setTimeout(() => Y_(I));
              }
            }),
            children: typeof m == "function" ? m({ isCurrentTabStop: T, hasTabStop: k != null }) : m
          }
        )
      }
    );
  }
);
W_.displayName = V_;
var pU = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function vU(a, u) {
  return u !== "rtl" ? a : a === "ArrowLeft" ? "ArrowRight" : a === "ArrowRight" ? "ArrowLeft" : a;
}
function hU(a, u, s) {
  const f = vU(a.key, s);
  if (!(u === "vertical" && ["ArrowLeft", "ArrowRight"].includes(f)) && !(u === "horizontal" && ["ArrowUp", "ArrowDown"].includes(f)))
    return pU[f];
}
function Y_(a, u = !1) {
  const s = document.activeElement;
  for (const f of a)
    if (f === s || (f.focus({ preventScroll: u }), document.activeElement !== s)) return;
}
function mU(a, u) {
  return a.map((s, f) => a[(u + f) % a.length]);
}
var gU = $_, yU = W_, xU = function(a) {
  if (typeof document > "u")
    return null;
  var u = Array.isArray(a) ? a[0] : a;
  return u.ownerDocument.body;
}, Cd = /* @__PURE__ */ new WeakMap(), Cy = /* @__PURE__ */ new WeakMap(), Ey = {}, X0 = 0, G_ = function(a) {
  return a && (a.host || G_(a.parentNode));
}, SU = function(a, u) {
  return u.map(function(s) {
    if (a.contains(s))
      return s;
    var f = G_(s);
    return f && a.contains(f) ? f : (console.error("aria-hidden", s, "in not contained inside", a, ". Doing nothing"), null);
  }).filter(function(s) {
    return !!s;
  });
}, bU = function(a, u, s, f) {
  var p = SU(u, Array.isArray(a) ? a : [a]);
  Ey[s] || (Ey[s] = /* @__PURE__ */ new WeakMap());
  var h = Ey[s], m = [], x = /* @__PURE__ */ new Set(), C = new Set(p), E = function(T) {
    !T || x.has(T) || (x.add(T), E(T.parentNode));
  };
  p.forEach(E);
  var R = function(T) {
    !T || C.has(T) || Array.prototype.forEach.call(T.children, function(O) {
      if (x.has(O))
        R(O);
      else
        try {
          var N = O.getAttribute(f), j = N !== null && N !== "false", k = (Cd.get(O) || 0) + 1, A = (h.get(O) || 0) + 1;
          Cd.set(O, k), h.set(O, A), m.push(O), k === 1 && j && Cy.set(O, !0), A === 1 && O.setAttribute(s, "true"), j || O.setAttribute(f, "true");
        } catch (z) {
          console.error("aria-hidden: cannot operate on ", O, z);
        }
    });
  };
  return R(u), x.clear(), X0++, function() {
    m.forEach(function(T) {
      var O = Cd.get(T) - 1, N = h.get(T) - 1;
      Cd.set(T, O), h.set(T, N), O || (Cy.has(T) || T.removeAttribute(f), Cy.delete(T)), N || T.removeAttribute(s);
    }), X0--, X0 || (Cd = /* @__PURE__ */ new WeakMap(), Cd = /* @__PURE__ */ new WeakMap(), Cy = /* @__PURE__ */ new WeakMap(), Ey = {});
  };
}, eE = function(a, u, s) {
  s === void 0 && (s = "data-aria-hidden");
  var f = Array.from(Array.isArray(a) ? a : [a]), p = xU(a);
  return p ? (f.push.apply(f, Array.from(p.querySelectorAll("[aria-live]"))), bU(f, p, s, "aria-hidden")) : function() {
    return null;
  };
}, Vi = function() {
  return Vi = Object.assign || function(u) {
    for (var s, f = 1, p = arguments.length; f < p; f++) {
      s = arguments[f];
      for (var h in s) Object.prototype.hasOwnProperty.call(s, h) && (u[h] = s[h]);
    }
    return u;
  }, Vi.apply(this, arguments);
};
function Q_(a, u) {
  var s = {};
  for (var f in a) Object.prototype.hasOwnProperty.call(a, f) && u.indexOf(f) < 0 && (s[f] = a[f]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var p = 0, f = Object.getOwnPropertySymbols(a); p < f.length; p++)
      u.indexOf(f[p]) < 0 && Object.prototype.propertyIsEnumerable.call(a, f[p]) && (s[f[p]] = a[f[p]]);
  return s;
}
function CU(a, u, s) {
  if (s || arguments.length === 2) for (var f = 0, p = u.length, h; f < p; f++)
    (h || !(f in u)) && (h || (h = Array.prototype.slice.call(u, 0, f)), h[f] = u[f]);
  return a.concat(h || Array.prototype.slice.call(u));
}
var _y = "right-scroll-bar-position", Oy = "width-before-scroll-bar", EU = "with-scroll-bars-hidden", wU = "--removed-body-scroll-bar-size";
function Z0(a, u) {
  return typeof a == "function" ? a(u) : a && (a.current = u), a;
}
function TU(a, u) {
  var s = Gi(function() {
    return {
      // value
      value: a,
      // last callback
      callback: u,
      // "memoized" public interface
      facade: {
        get current() {
          return s.value;
        },
        set current(f) {
          var p = s.value;
          p !== f && (s.value = f, s.callback(f, p));
        }
      }
    };
  })[0];
  return s.callback = u, s.facade;
}
var RU = typeof window < "u" ? L.useLayoutEffect : L.useEffect, U1 = /* @__PURE__ */ new WeakMap();
function _U(a, u) {
  var s = TU(null, function(f) {
    return a.forEach(function(p) {
      return Z0(p, f);
    });
  });
  return RU(function() {
    var f = U1.get(s);
    if (f) {
      var p = new Set(f), h = new Set(a), m = s.current;
      p.forEach(function(x) {
        h.has(x) || Z0(x, null);
      }), h.forEach(function(x) {
        p.has(x) || Z0(x, m);
      });
    }
    U1.set(s, a);
  }, [a]), s;
}
function OU(a) {
  return a;
}
function DU(a, u) {
  u === void 0 && (u = OU);
  var s = [], f = !1, p = {
    read: function() {
      if (f)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return s.length ? s[s.length - 1] : a;
    },
    useMedium: function(h) {
      var m = u(h, f);
      return s.push(m), function() {
        s = s.filter(function(x) {
          return x !== m;
        });
      };
    },
    assignSyncMedium: function(h) {
      for (f = !0; s.length; ) {
        var m = s;
        s = [], m.forEach(h);
      }
      s = {
        push: function(x) {
          return h(x);
        },
        filter: function() {
          return s;
        }
      };
    },
    assignMedium: function(h) {
      f = !0;
      var m = [];
      if (s.length) {
        var x = s;
        s = [], x.forEach(h), m = s;
      }
      var C = function() {
        var R = m;
        m = [], R.forEach(h);
      }, E = function() {
        return Promise.resolve().then(C);
      };
      E(), s = {
        push: function(R) {
          m.push(R), E();
        },
        filter: function(R) {
          return m = m.filter(R), s;
        }
      };
    }
  };
  return p;
}
function kU(a) {
  a === void 0 && (a = {});
  var u = DU(null);
  return u.options = Vi({ async: !0, ssr: !1 }, a), u;
}
var K_ = function(a) {
  var u = a.sideCar, s = Q_(a, ["sideCar"]);
  if (!u)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var f = u.read();
  if (!f)
    throw new Error("Sidecar medium not found");
  return L.createElement(f, Vi({}, s));
};
K_.isSideCarExport = !0;
function MU(a, u) {
  return a.useMedium(u), K_;
}
var q_ = kU(), J0 = function() {
}, Jy = L.forwardRef(function(a, u) {
  var s = L.useRef(null), f = L.useState({
    onScrollCapture: J0,
    onWheelCapture: J0,
    onTouchMoveCapture: J0
  }), p = f[0], h = f[1], m = a.forwardProps, x = a.children, C = a.className, E = a.removeScrollBar, R = a.enabled, T = a.shards, O = a.sideCar, N = a.noIsolation, j = a.inert, k = a.allowPinchZoom, A = a.as, z = A === void 0 ? "div" : A, F = a.gapMode, I = Q_(a, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), V = O, B = _U([s, u]), ae = Vi(Vi({}, I), p);
  return L.createElement(
    L.Fragment,
    null,
    R && L.createElement(V, { sideCar: q_, removeScrollBar: E, shards: T, noIsolation: N, inert: j, setCallbacks: h, allowPinchZoom: !!k, lockRef: s, gapMode: F }),
    m ? L.cloneElement(L.Children.only(x), Vi(Vi({}, ae), { ref: B })) : L.createElement(z, Vi({}, ae, { className: C, ref: B }), x)
  );
});
Jy.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Jy.classNames = {
  fullWidth: Oy,
  zeroRight: _y
};
var NU = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function AU() {
  if (!document)
    return null;
  var a = document.createElement("style");
  a.type = "text/css";
  var u = NU();
  return u && a.setAttribute("nonce", u), a;
}
function PU(a, u) {
  a.styleSheet ? a.styleSheet.cssText = u : a.appendChild(document.createTextNode(u));
}
function LU(a) {
  var u = document.head || document.getElementsByTagName("head")[0];
  u.appendChild(a);
}
var jU = function() {
  var a = 0, u = null;
  return {
    add: function(s) {
      a == 0 && (u = AU()) && (PU(u, s), LU(u)), a++;
    },
    remove: function() {
      a--, !a && u && (u.parentNode && u.parentNode.removeChild(u), u = null);
    }
  };
}, zU = function() {
  var a = jU();
  return function(u, s) {
    L.useEffect(function() {
      return a.add(u), function() {
        a.remove();
      };
    }, [u && s]);
  };
}, X_ = function() {
  var a = zU(), u = function(s) {
    var f = s.styles, p = s.dynamic;
    return a(f, p), null;
  };
  return u;
}, IU = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, eC = function(a) {
  return parseInt(a || "", 10) || 0;
}, UU = function(a) {
  var u = window.getComputedStyle(document.body), s = u[a === "padding" ? "paddingLeft" : "marginLeft"], f = u[a === "padding" ? "paddingTop" : "marginTop"], p = u[a === "padding" ? "paddingRight" : "marginRight"];
  return [eC(s), eC(f), eC(p)];
}, FU = function(a) {
  if (a === void 0 && (a = "margin"), typeof window > "u")
    return IU;
  var u = UU(a), s = document.documentElement.clientWidth, f = window.innerWidth;
  return {
    left: u[0],
    top: u[1],
    right: u[2],
    gap: Math.max(0, f - s + u[2] - u[0])
  };
}, BU = X_(), Od = "data-scroll-locked", HU = function(a, u, s, f) {
  var p = a.left, h = a.top, m = a.right, x = a.gap;
  return s === void 0 && (s = "margin"), `
  .`.concat(EU, ` {
   overflow: hidden `).concat(f, `;
   padding-right: `).concat(x, "px ").concat(f, `;
  }
  body[`).concat(Od, `] {
    overflow: hidden `).concat(f, `;
    overscroll-behavior: contain;
    `).concat([
    u && "position: relative ".concat(f, ";"),
    s === "margin" && `
    padding-left: `.concat(p, `px;
    padding-top: `).concat(h, `px;
    padding-right: `).concat(m, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(x, "px ").concat(f, `;
    `),
    s === "padding" && "padding-right: ".concat(x, "px ").concat(f, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(_y, ` {
    right: `).concat(x, "px ").concat(f, `;
  }
  
  .`).concat(Oy, ` {
    margin-right: `).concat(x, "px ").concat(f, `;
  }
  
  .`).concat(_y, " .").concat(_y, ` {
    right: 0 `).concat(f, `;
  }
  
  .`).concat(Oy, " .").concat(Oy, ` {
    margin-right: 0 `).concat(f, `;
  }
  
  body[`).concat(Od, `] {
    `).concat(wU, ": ").concat(x, `px;
  }
`);
}, F1 = function() {
  var a = parseInt(document.body.getAttribute(Od) || "0", 10);
  return isFinite(a) ? a : 0;
}, $U = function() {
  L.useEffect(function() {
    return document.body.setAttribute(Od, (F1() + 1).toString()), function() {
      var a = F1() - 1;
      a <= 0 ? document.body.removeAttribute(Od) : document.body.setAttribute(Od, a.toString());
    };
  }, []);
}, VU = function(a) {
  var u = a.noRelative, s = a.noImportant, f = a.gapMode, p = f === void 0 ? "margin" : f;
  $U();
  var h = L.useMemo(function() {
    return FU(p);
  }, [p]);
  return L.createElement(BU, { styles: HU(h, !u, p, s ? "" : "!important") });
}, EC = !1;
if (typeof window < "u")
  try {
    var wy = Object.defineProperty({}, "passive", {
      get: function() {
        return EC = !0, !0;
      }
    });
    window.addEventListener("test", wy, wy), window.removeEventListener("test", wy, wy);
  } catch {
    EC = !1;
  }
var Ed = EC ? { passive: !1 } : !1, WU = function(a) {
  return a.tagName === "TEXTAREA";
}, Z_ = function(a, u) {
  if (!(a instanceof Element))
    return !1;
  var s = window.getComputedStyle(a);
  return (
    // not-not-scrollable
    s[u] !== "hidden" && // contains scroll inside self
    !(s.overflowY === s.overflowX && !WU(a) && s[u] === "visible")
  );
}, YU = function(a) {
  return Z_(a, "overflowY");
}, GU = function(a) {
  return Z_(a, "overflowX");
}, B1 = function(a, u) {
  var s = u.ownerDocument, f = u;
  do {
    typeof ShadowRoot < "u" && f instanceof ShadowRoot && (f = f.host);
    var p = J_(a, f);
    if (p) {
      var h = eO(a, f), m = h[1], x = h[2];
      if (m > x)
        return !0;
    }
    f = f.parentNode;
  } while (f && f !== s.body);
  return !1;
}, QU = function(a) {
  var u = a.scrollTop, s = a.scrollHeight, f = a.clientHeight;
  return [
    u,
    s,
    f
  ];
}, KU = function(a) {
  var u = a.scrollLeft, s = a.scrollWidth, f = a.clientWidth;
  return [
    u,
    s,
    f
  ];
}, J_ = function(a, u) {
  return a === "v" ? YU(u) : GU(u);
}, eO = function(a, u) {
  return a === "v" ? QU(u) : KU(u);
}, qU = function(a, u) {
  return a === "h" && u === "rtl" ? -1 : 1;
}, XU = function(a, u, s, f, p) {
  var h = qU(a, window.getComputedStyle(u).direction), m = h * f, x = s.target, C = u.contains(x), E = !1, R = m > 0, T = 0, O = 0;
  do {
    var N = eO(a, x), j = N[0], k = N[1], A = N[2], z = k - A - h * j;
    (j || z) && J_(a, x) && (T += z, O += j), x instanceof ShadowRoot ? x = x.host : x = x.parentNode;
  } while (
    // portaled content
    !C && x !== document.body || // self content
    C && (u.contains(x) || u === x)
  );
  return (R && Math.abs(T) < 1 || !R && Math.abs(O) < 1) && (E = !0), E;
}, Ty = function(a) {
  return "changedTouches" in a ? [a.changedTouches[0].clientX, a.changedTouches[0].clientY] : [0, 0];
}, H1 = function(a) {
  return [a.deltaX, a.deltaY];
}, $1 = function(a) {
  return a && "current" in a ? a.current : a;
}, ZU = function(a, u) {
  return a[0] === u[0] && a[1] === u[1];
}, JU = function(a) {
  return `
  .block-interactivity-`.concat(a, ` {pointer-events: none;}
  .allow-interactivity-`).concat(a, ` {pointer-events: all;}
`);
}, eF = 0, wd = [];
function tF(a) {
  var u = L.useRef([]), s = L.useRef([0, 0]), f = L.useRef(), p = L.useState(eF++)[0], h = L.useState(X_)[0], m = L.useRef(a);
  L.useEffect(function() {
    m.current = a;
  }, [a]), L.useEffect(function() {
    if (a.inert) {
      document.body.classList.add("block-interactivity-".concat(p));
      var k = CU([a.lockRef.current], (a.shards || []).map($1), !0).filter(Boolean);
      return k.forEach(function(A) {
        return A.classList.add("allow-interactivity-".concat(p));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(p)), k.forEach(function(A) {
          return A.classList.remove("allow-interactivity-".concat(p));
        });
      };
    }
  }, [a.inert, a.lockRef.current, a.shards]);
  var x = L.useCallback(function(k, A) {
    if ("touches" in k && k.touches.length === 2 || k.type === "wheel" && k.ctrlKey)
      return !m.current.allowPinchZoom;
    var z = Ty(k), F = s.current, I = "deltaX" in k ? k.deltaX : F[0] - z[0], V = "deltaY" in k ? k.deltaY : F[1] - z[1], B, ae = k.target, Z = Math.abs(I) > Math.abs(V) ? "h" : "v";
    if ("touches" in k && Z === "h" && ae.type === "range")
      return !1;
    var pe = B1(Z, ae);
    if (!pe)
      return !0;
    if (pe ? B = Z : (B = Z === "v" ? "h" : "v", pe = B1(Z, ae)), !pe)
      return !1;
    if (!f.current && "changedTouches" in k && (I || V) && (f.current = B), !B)
      return !0;
    var de = f.current || B;
    return XU(de, A, k, de === "h" ? I : V);
  }, []), C = L.useCallback(function(k) {
    var A = k;
    if (!(!wd.length || wd[wd.length - 1] !== h)) {
      var z = "deltaY" in A ? H1(A) : Ty(A), F = u.current.filter(function(B) {
        return B.name === A.type && (B.target === A.target || A.target === B.shadowParent) && ZU(B.delta, z);
      })[0];
      if (F && F.should) {
        A.cancelable && A.preventDefault();
        return;
      }
      if (!F) {
        var I = (m.current.shards || []).map($1).filter(Boolean).filter(function(B) {
          return B.contains(A.target);
        }), V = I.length > 0 ? x(A, I[0]) : !m.current.noIsolation;
        V && A.cancelable && A.preventDefault();
      }
    }
  }, []), E = L.useCallback(function(k, A, z, F) {
    var I = { name: k, delta: A, target: z, should: F, shadowParent: nF(z) };
    u.current.push(I), setTimeout(function() {
      u.current = u.current.filter(function(V) {
        return V !== I;
      });
    }, 1);
  }, []), R = L.useCallback(function(k) {
    s.current = Ty(k), f.current = void 0;
  }, []), T = L.useCallback(function(k) {
    E(k.type, H1(k), k.target, x(k, a.lockRef.current));
  }, []), O = L.useCallback(function(k) {
    E(k.type, Ty(k), k.target, x(k, a.lockRef.current));
  }, []);
  L.useEffect(function() {
    return wd.push(h), a.setCallbacks({
      onScrollCapture: T,
      onWheelCapture: T,
      onTouchMoveCapture: O
    }), document.addEventListener("wheel", C, Ed), document.addEventListener("touchmove", C, Ed), document.addEventListener("touchstart", R, Ed), function() {
      wd = wd.filter(function(k) {
        return k !== h;
      }), document.removeEventListener("wheel", C, Ed), document.removeEventListener("touchmove", C, Ed), document.removeEventListener("touchstart", R, Ed);
    };
  }, []);
  var N = a.removeScrollBar, j = a.inert;
  return L.createElement(
    L.Fragment,
    null,
    j ? L.createElement(h, { styles: JU(p) }) : null,
    N ? L.createElement(VU, { gapMode: a.gapMode }) : null
  );
}
function nF(a) {
  for (var u = null; a !== null; )
    a instanceof ShadowRoot && (u = a.host, a = a.host), a = a.parentNode;
  return u;
}
const rF = MU(q_, tF);
var ex = L.forwardRef(function(a, u) {
  return L.createElement(Jy, Vi({}, a, { ref: u, sideCar: rF }));
});
ex.classNames = Jy.classNames;
var wC = ["Enter", " "], oF = ["ArrowDown", "PageUp", "Home"], tO = ["ArrowUp", "PageDown", "End"], aF = [...oF, ...tO], iF = {
  ltr: [...wC, "ArrowRight"],
  rtl: [...wC, "ArrowLeft"]
}, lF = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, yh = "Menu", [dh, uF, sF] = BC(yh), [Rc, nO] = Zl(yh, [
  sF,
  Xy,
  H_
]), tx = Xy(), rO = H_(), [cF, _c] = Rc(yh), [fF, xh] = Rc(yh), oO = (a) => {
  const { __scopeMenu: u, open: s = !1, children: f, dir: p, onOpenChange: h, modal: m = !0 } = a, x = tx(u), [C, E] = L.useState(null), R = L.useRef(!1), T = Kl(h), O = HC(p);
  return L.useEffect(() => {
    const N = () => {
      R.current = !0, document.addEventListener("pointerdown", j, { capture: !0, once: !0 }), document.addEventListener("pointermove", j, { capture: !0, once: !0 });
    }, j = () => R.current = !1;
    return document.addEventListener("keydown", N, { capture: !0 }), () => {
      document.removeEventListener("keydown", N, { capture: !0 }), document.removeEventListener("pointerdown", j, { capture: !0 }), document.removeEventListener("pointermove", j, { capture: !0 });
    };
  }, []), /* @__PURE__ */ D.jsx(I_, { ...x, children: /* @__PURE__ */ D.jsx(
    cF,
    {
      scope: u,
      open: s,
      onOpenChange: T,
      content: C,
      onContentChange: E,
      children: /* @__PURE__ */ D.jsx(
        fF,
        {
          scope: u,
          onClose: L.useCallback(() => T(!1), [T]),
          isUsingKeyboardRef: R,
          dir: O,
          modal: m,
          children: f
        }
      )
    }
  ) });
};
oO.displayName = yh;
var dF = "MenuAnchor", tE = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, ...f } = a, p = tx(s);
    return /* @__PURE__ */ D.jsx(JC, { ...p, ...f, ref: u });
  }
);
tE.displayName = dF;
var nE = "MenuPortal", [pF, aO] = Rc(nE, {
  forceMount: void 0
}), iO = (a) => {
  const { __scopeMenu: u, forceMount: s, children: f, container: p } = a, h = _c(nE, u);
  return /* @__PURE__ */ D.jsx(pF, { scope: u, forceMount: s, children: /* @__PURE__ */ D.jsx(oi, { present: s || h.open, children: /* @__PURE__ */ D.jsx(Zy, { asChild: !0, container: p, children: f }) }) });
};
iO.displayName = nE;
var Ca = "MenuContent", [vF, rE] = Rc(Ca), lO = L.forwardRef(
  (a, u) => {
    const s = aO(Ca, a.__scopeMenu), { forceMount: f = s.forceMount, ...p } = a, h = _c(Ca, a.__scopeMenu), m = xh(Ca, a.__scopeMenu);
    return /* @__PURE__ */ D.jsx(dh.Provider, { scope: a.__scopeMenu, children: /* @__PURE__ */ D.jsx(oi, { present: f || h.open, children: /* @__PURE__ */ D.jsx(dh.Slot, { scope: a.__scopeMenu, children: m.modal ? /* @__PURE__ */ D.jsx(hF, { ...p, ref: u }) : /* @__PURE__ */ D.jsx(mF, { ...p, ref: u }) }) }) });
  }
), hF = L.forwardRef(
  (a, u) => {
    const s = _c(Ca, a.__scopeMenu), f = L.useRef(null), p = Yn(u, f);
    return L.useEffect(() => {
      const h = f.current;
      if (h) return eE(h);
    }, []), /* @__PURE__ */ D.jsx(
      oE,
      {
        ...a,
        ref: p,
        trapFocus: s.open,
        disableOutsidePointerEvents: s.open,
        disableOutsideScroll: !0,
        onFocusOutside: mt(
          a.onFocusOutside,
          (h) => h.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => s.onOpenChange(!1)
      }
    );
  }
), mF = L.forwardRef((a, u) => {
  const s = _c(Ca, a.__scopeMenu);
  return /* @__PURE__ */ D.jsx(
    oE,
    {
      ...a,
      ref: u,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => s.onOpenChange(!1)
    }
  );
}), gF = /* @__PURE__ */ kd("MenuContent.ScrollLock"), oE = L.forwardRef(
  (a, u) => {
    const {
      __scopeMenu: s,
      loop: f = !1,
      trapFocus: p,
      onOpenAutoFocus: h,
      onCloseAutoFocus: m,
      disableOutsidePointerEvents: x,
      onEntryFocus: C,
      onEscapeKeyDown: E,
      onPointerDownOutside: R,
      onFocusOutside: T,
      onInteractOutside: O,
      onDismiss: N,
      disableOutsideScroll: j,
      ...k
    } = a, A = _c(Ca, s), z = xh(Ca, s), F = tx(s), I = rO(s), V = uF(s), [B, ae] = L.useState(null), Z = L.useRef(null), pe = Yn(u, Z, A.onContentChange), de = L.useRef(0), me = L.useRef(""), Te = L.useRef(0), ve = L.useRef(null), ce = L.useRef("right"), Ee = L.useRef(0), Ue = j ? ex : L.Fragment, Re = j ? { as: gF, allowPinchZoom: !0 } : void 0, Ke = (le) => {
      var Oe, Me;
      const W = me.current + le, ie = V().filter((Ie) => !Ie.disabled), we = document.activeElement, je = (Oe = ie.find((Ie) => Ie.ref.current === we)) == null ? void 0 : Oe.textValue, ke = ie.map((Ie) => Ie.textValue), et = DF(ke, W, je), Pe = (Me = ie.find((Ie) => Ie.textValue === et)) == null ? void 0 : Me.ref.current;
      (function Ie($e) {
        me.current = $e, window.clearTimeout(de.current), $e !== "" && (de.current = window.setTimeout(() => Ie(""), 1e3));
      })(W), Pe && setTimeout(() => Pe.focus());
    };
    L.useEffect(() => () => window.clearTimeout(de.current), []), $C();
    const oe = L.useCallback((le) => {
      var ie, we;
      return ce.current === ((ie = ve.current) == null ? void 0 : ie.side) && MF(le, (we = ve.current) == null ? void 0 : we.area);
    }, []);
    return /* @__PURE__ */ D.jsx(
      vF,
      {
        scope: s,
        searchRef: me,
        onItemEnter: L.useCallback(
          (le) => {
            oe(le) && le.preventDefault();
          },
          [oe]
        ),
        onItemLeave: L.useCallback(
          (le) => {
            var W;
            oe(le) || ((W = Z.current) == null || W.focus(), ae(null));
          },
          [oe]
        ),
        onTriggerLeave: L.useCallback(
          (le) => {
            oe(le) && le.preventDefault();
          },
          [oe]
        ),
        pointerGraceTimerRef: Te,
        onPointerGraceIntentChange: L.useCallback((le) => {
          ve.current = le;
        }, []),
        children: /* @__PURE__ */ D.jsx(Ue, { ...Re, children: /* @__PURE__ */ D.jsx(
          Gy,
          {
            asChild: !0,
            trapped: p,
            onMountAutoFocus: mt(h, (le) => {
              var W;
              le.preventDefault(), (W = Z.current) == null || W.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: m,
            children: /* @__PURE__ */ D.jsx(
              Yy,
              {
                asChild: !0,
                disableOutsidePointerEvents: x,
                onEscapeKeyDown: E,
                onPointerDownOutside: R,
                onFocusOutside: T,
                onInteractOutside: O,
                onDismiss: N,
                children: /* @__PURE__ */ D.jsx(
                  gU,
                  {
                    asChild: !0,
                    ...I,
                    dir: z.dir,
                    orientation: "vertical",
                    loop: f,
                    currentTabStopId: B,
                    onCurrentTabStopIdChange: ae,
                    onEntryFocus: mt(C, (le) => {
                      z.isUsingKeyboardRef.current || le.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ D.jsx(
                      U_,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": EO(A.open),
                        "data-radix-menu-content": "",
                        dir: z.dir,
                        ...F,
                        ...k,
                        ref: pe,
                        style: { outline: "none", ...k.style },
                        onKeyDown: mt(k.onKeyDown, (le) => {
                          const ie = le.target.closest("[data-radix-menu-content]") === le.currentTarget, we = le.ctrlKey || le.altKey || le.metaKey, je = le.key.length === 1;
                          ie && (le.key === "Tab" && le.preventDefault(), !we && je && Ke(le.key));
                          const ke = Z.current;
                          if (le.target !== ke || !aF.includes(le.key)) return;
                          le.preventDefault();
                          const Pe = V().filter((Oe) => !Oe.disabled).map((Oe) => Oe.ref.current);
                          tO.includes(le.key) && Pe.reverse(), _F(Pe);
                        }),
                        onBlur: mt(a.onBlur, (le) => {
                          le.currentTarget.contains(le.target) || (window.clearTimeout(de.current), me.current = "");
                        }),
                        onPointerMove: mt(
                          a.onPointerMove,
                          ph((le) => {
                            const W = le.target, ie = Ee.current !== le.clientX;
                            if (le.currentTarget.contains(W) && ie) {
                              const we = le.clientX > Ee.current ? "right" : "left";
                              ce.current = we, Ee.current = le.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
lO.displayName = Ca;
var yF = "MenuGroup", aE = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, ...f } = a;
    return /* @__PURE__ */ D.jsx(an.div, { role: "group", ...f, ref: u });
  }
);
aE.displayName = yF;
var xF = "MenuLabel", uO = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, ...f } = a;
    return /* @__PURE__ */ D.jsx(an.div, { ...f, ref: u });
  }
);
uO.displayName = xF;
var zy = "MenuItem", V1 = "menu.itemSelect", nx = L.forwardRef(
  (a, u) => {
    const { disabled: s = !1, onSelect: f, ...p } = a, h = L.useRef(null), m = xh(zy, a.__scopeMenu), x = rE(zy, a.__scopeMenu), C = Yn(u, h), E = L.useRef(!1), R = () => {
      const T = h.current;
      if (!s && T) {
        const O = new CustomEvent(V1, { bubbles: !0, cancelable: !0 });
        T.addEventListener(V1, (N) => f == null ? void 0 : f(N), { once: !0 }), v_(T, O), O.defaultPrevented ? E.current = !1 : m.onClose();
      }
    };
    return /* @__PURE__ */ D.jsx(
      sO,
      {
        ...p,
        ref: C,
        disabled: s,
        onClick: mt(a.onClick, R),
        onPointerDown: (T) => {
          var O;
          (O = a.onPointerDown) == null || O.call(a, T), E.current = !0;
        },
        onPointerUp: mt(a.onPointerUp, (T) => {
          var O;
          E.current || (O = T.currentTarget) == null || O.click();
        }),
        onKeyDown: mt(a.onKeyDown, (T) => {
          const O = x.searchRef.current !== "";
          s || O && T.key === " " || wC.includes(T.key) && (T.currentTarget.click(), T.preventDefault());
        })
      }
    );
  }
);
nx.displayName = zy;
var sO = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, disabled: f = !1, textValue: p, ...h } = a, m = rE(zy, s), x = rO(s), C = L.useRef(null), E = Yn(u, C), [R, T] = L.useState(!1), [O, N] = L.useState("");
    return L.useEffect(() => {
      const j = C.current;
      j && N((j.textContent ?? "").trim());
    }, [h.children]), /* @__PURE__ */ D.jsx(
      dh.ItemSlot,
      {
        scope: s,
        disabled: f,
        textValue: p ?? O,
        children: /* @__PURE__ */ D.jsx(yU, { asChild: !0, ...x, focusable: !f, children: /* @__PURE__ */ D.jsx(
          an.div,
          {
            role: "menuitem",
            "data-highlighted": R ? "" : void 0,
            "aria-disabled": f || void 0,
            "data-disabled": f ? "" : void 0,
            ...h,
            ref: E,
            onPointerMove: mt(
              a.onPointerMove,
              ph((j) => {
                f ? m.onItemLeave(j) : (m.onItemEnter(j), j.defaultPrevented || j.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: mt(
              a.onPointerLeave,
              ph((j) => m.onItemLeave(j))
            ),
            onFocus: mt(a.onFocus, () => T(!0)),
            onBlur: mt(a.onBlur, () => T(!1))
          }
        ) })
      }
    );
  }
), SF = "MenuCheckboxItem", cO = L.forwardRef(
  (a, u) => {
    const { checked: s = !1, onCheckedChange: f, ...p } = a;
    return /* @__PURE__ */ D.jsx(hO, { scope: a.__scopeMenu, checked: s, children: /* @__PURE__ */ D.jsx(
      nx,
      {
        role: "menuitemcheckbox",
        "aria-checked": Iy(s) ? "mixed" : s,
        ...p,
        ref: u,
        "data-state": lE(s),
        onSelect: mt(
          p.onSelect,
          () => f == null ? void 0 : f(Iy(s) ? !0 : !s),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
cO.displayName = SF;
var fO = "MenuRadioGroup", [bF, CF] = Rc(
  fO,
  { value: void 0, onValueChange: () => {
  } }
), dO = L.forwardRef(
  (a, u) => {
    const { value: s, onValueChange: f, ...p } = a, h = Kl(f);
    return /* @__PURE__ */ D.jsx(bF, { scope: a.__scopeMenu, value: s, onValueChange: h, children: /* @__PURE__ */ D.jsx(aE, { ...p, ref: u }) });
  }
);
dO.displayName = fO;
var pO = "MenuRadioItem", vO = L.forwardRef(
  (a, u) => {
    const { value: s, ...f } = a, p = CF(pO, a.__scopeMenu), h = s === p.value;
    return /* @__PURE__ */ D.jsx(hO, { scope: a.__scopeMenu, checked: h, children: /* @__PURE__ */ D.jsx(
      nx,
      {
        role: "menuitemradio",
        "aria-checked": h,
        ...f,
        ref: u,
        "data-state": lE(h),
        onSelect: mt(
          f.onSelect,
          () => {
            var m;
            return (m = p.onValueChange) == null ? void 0 : m.call(p, s);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
vO.displayName = pO;
var iE = "MenuItemIndicator", [hO, EF] = Rc(
  iE,
  { checked: !1 }
), mO = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, forceMount: f, ...p } = a, h = EF(iE, s);
    return /* @__PURE__ */ D.jsx(
      oi,
      {
        present: f || Iy(h.checked) || h.checked === !0,
        children: /* @__PURE__ */ D.jsx(
          an.span,
          {
            ...p,
            ref: u,
            "data-state": lE(h.checked)
          }
        )
      }
    );
  }
);
mO.displayName = iE;
var wF = "MenuSeparator", gO = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, ...f } = a;
    return /* @__PURE__ */ D.jsx(
      an.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...f,
        ref: u
      }
    );
  }
);
gO.displayName = wF;
var TF = "MenuArrow", yO = L.forwardRef(
  (a, u) => {
    const { __scopeMenu: s, ...f } = a, p = tx(s);
    return /* @__PURE__ */ D.jsx(F_, { ...p, ...f, ref: u });
  }
);
yO.displayName = TF;
var RF = "MenuSub", [G3, xO] = Rc(RF), oh = "MenuSubTrigger", SO = L.forwardRef(
  (a, u) => {
    const s = _c(oh, a.__scopeMenu), f = xh(oh, a.__scopeMenu), p = xO(oh, a.__scopeMenu), h = rE(oh, a.__scopeMenu), m = L.useRef(null), { pointerGraceTimerRef: x, onPointerGraceIntentChange: C } = h, E = { __scopeMenu: a.__scopeMenu }, R = L.useCallback(() => {
      m.current && window.clearTimeout(m.current), m.current = null;
    }, []);
    return L.useEffect(() => R, [R]), L.useEffect(() => {
      const T = x.current;
      return () => {
        window.clearTimeout(T), C(null);
      };
    }, [x, C]), /* @__PURE__ */ D.jsx(tE, { asChild: !0, ...E, children: /* @__PURE__ */ D.jsx(
      sO,
      {
        id: p.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": p.contentId,
        "data-state": EO(s.open),
        ...a,
        ref: Wy(u, p.onTriggerChange),
        onClick: (T) => {
          var O;
          (O = a.onClick) == null || O.call(a, T), !(a.disabled || T.defaultPrevented) && (T.currentTarget.focus(), s.open || s.onOpenChange(!0));
        },
        onPointerMove: mt(
          a.onPointerMove,
          ph((T) => {
            h.onItemEnter(T), !T.defaultPrevented && !a.disabled && !s.open && !m.current && (h.onPointerGraceIntentChange(null), m.current = window.setTimeout(() => {
              s.onOpenChange(!0), R();
            }, 100));
          })
        ),
        onPointerLeave: mt(
          a.onPointerLeave,
          ph((T) => {
            var N, j;
            R();
            const O = (N = s.content) == null ? void 0 : N.getBoundingClientRect();
            if (O) {
              const k = (j = s.content) == null ? void 0 : j.dataset.side, A = k === "right", z = A ? -5 : 5, F = O[A ? "left" : "right"], I = O[A ? "right" : "left"];
              h.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: T.clientX + z, y: T.clientY },
                  { x: F, y: O.top },
                  { x: I, y: O.top },
                  { x: I, y: O.bottom },
                  { x: F, y: O.bottom }
                ],
                side: k
              }), window.clearTimeout(x.current), x.current = window.setTimeout(
                () => h.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (h.onTriggerLeave(T), T.defaultPrevented) return;
              h.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: mt(a.onKeyDown, (T) => {
          var N;
          const O = h.searchRef.current !== "";
          a.disabled || O && T.key === " " || iF[f.dir].includes(T.key) && (s.onOpenChange(!0), (N = s.content) == null || N.focus(), T.preventDefault());
        })
      }
    ) });
  }
);
SO.displayName = oh;
var bO = "MenuSubContent", CO = L.forwardRef(
  (a, u) => {
    const s = aO(Ca, a.__scopeMenu), { forceMount: f = s.forceMount, ...p } = a, h = _c(Ca, a.__scopeMenu), m = xh(Ca, a.__scopeMenu), x = xO(bO, a.__scopeMenu), C = L.useRef(null), E = Yn(u, C);
    return /* @__PURE__ */ D.jsx(dh.Provider, { scope: a.__scopeMenu, children: /* @__PURE__ */ D.jsx(oi, { present: f || h.open, children: /* @__PURE__ */ D.jsx(dh.Slot, { scope: a.__scopeMenu, children: /* @__PURE__ */ D.jsx(
      oE,
      {
        id: x.contentId,
        "aria-labelledby": x.triggerId,
        ...p,
        ref: E,
        align: "start",
        side: m.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (R) => {
          var T;
          m.isUsingKeyboardRef.current && ((T = C.current) == null || T.focus()), R.preventDefault();
        },
        onCloseAutoFocus: (R) => R.preventDefault(),
        onFocusOutside: mt(a.onFocusOutside, (R) => {
          R.target !== x.trigger && h.onOpenChange(!1);
        }),
        onEscapeKeyDown: mt(a.onEscapeKeyDown, (R) => {
          m.onClose(), R.preventDefault();
        }),
        onKeyDown: mt(a.onKeyDown, (R) => {
          var N;
          const T = R.currentTarget.contains(R.target), O = lF[m.dir].includes(R.key);
          T && O && (h.onOpenChange(!1), (N = x.trigger) == null || N.focus(), R.preventDefault());
        })
      }
    ) }) }) });
  }
);
CO.displayName = bO;
function EO(a) {
  return a ? "open" : "closed";
}
function Iy(a) {
  return a === "indeterminate";
}
function lE(a) {
  return Iy(a) ? "indeterminate" : a ? "checked" : "unchecked";
}
function _F(a) {
  const u = document.activeElement;
  for (const s of a)
    if (s === u || (s.focus(), document.activeElement !== u)) return;
}
function OF(a, u) {
  return a.map((s, f) => a[(u + f) % a.length]);
}
function DF(a, u, s) {
  const p = u.length > 1 && Array.from(u).every((E) => E === u[0]) ? u[0] : u, h = s ? a.indexOf(s) : -1;
  let m = OF(a, Math.max(h, 0));
  p.length === 1 && (m = m.filter((E) => E !== s));
  const C = m.find(
    (E) => E.toLowerCase().startsWith(p.toLowerCase())
  );
  return C !== s ? C : void 0;
}
function kF(a, u) {
  const { x: s, y: f } = a;
  let p = !1;
  for (let h = 0, m = u.length - 1; h < u.length; m = h++) {
    const x = u[h], C = u[m], E = x.x, R = x.y, T = C.x, O = C.y;
    R > f != O > f && s < (T - E) * (f - R) / (O - R) + E && (p = !p);
  }
  return p;
}
function MF(a, u) {
  if (!u) return !1;
  const s = { x: a.clientX, y: a.clientY };
  return kF(s, u);
}
function ph(a) {
  return (u) => u.pointerType === "mouse" ? a(u) : void 0;
}
var NF = oO, AF = tE, PF = iO, LF = lO, jF = aE, zF = uO, IF = nx, UF = cO, FF = dO, BF = vO, HF = mO, $F = gO, VF = yO, WF = SO, YF = CO, rx = "DropdownMenu", [GF, Q3] = Zl(
  rx,
  [nO]
), ho = nO(), [QF, wO] = GF(rx), TO = (a) => {
  const {
    __scopeDropdownMenu: u,
    children: s,
    dir: f,
    open: p,
    defaultOpen: h,
    onOpenChange: m,
    modal: x = !0
  } = a, C = ho(u), E = L.useRef(null), [R, T] = Tc({
    prop: p,
    defaultProp: h ?? !1,
    onChange: m,
    caller: rx
  });
  return /* @__PURE__ */ D.jsx(
    QF,
    {
      scope: u,
      triggerId: Yl(),
      triggerRef: E,
      contentId: Yl(),
      open: R,
      onOpenChange: T,
      onOpenToggle: L.useCallback(() => T((O) => !O), [T]),
      modal: x,
      children: /* @__PURE__ */ D.jsx(NF, { ...C, open: R, onOpenChange: T, dir: f, modal: x, children: s })
    }
  );
};
TO.displayName = rx;
var RO = "DropdownMenuTrigger", _O = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, disabled: f = !1, ...p } = a, h = wO(RO, s), m = ho(s);
    return /* @__PURE__ */ D.jsx(AF, { asChild: !0, ...m, children: /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        id: h.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": h.open,
        "aria-controls": h.open ? h.contentId : void 0,
        "data-state": h.open ? "open" : "closed",
        "data-disabled": f ? "" : void 0,
        disabled: f,
        ...p,
        ref: Wy(u, h.triggerRef),
        onPointerDown: mt(a.onPointerDown, (x) => {
          !f && x.button === 0 && x.ctrlKey === !1 && (h.onOpenToggle(), h.open || x.preventDefault());
        }),
        onKeyDown: mt(a.onKeyDown, (x) => {
          f || (["Enter", " "].includes(x.key) && h.onOpenToggle(), x.key === "ArrowDown" && h.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(x.key) && x.preventDefault());
        })
      }
    ) });
  }
);
_O.displayName = RO;
var KF = "DropdownMenuPortal", OO = (a) => {
  const { __scopeDropdownMenu: u, ...s } = a, f = ho(u);
  return /* @__PURE__ */ D.jsx(PF, { ...f, ...s });
};
OO.displayName = KF;
var DO = "DropdownMenuContent", kO = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, ...f } = a, p = wO(DO, s), h = ho(s), m = L.useRef(!1);
    return /* @__PURE__ */ D.jsx(
      LF,
      {
        id: p.contentId,
        "aria-labelledby": p.triggerId,
        ...h,
        ...f,
        ref: u,
        onCloseAutoFocus: mt(a.onCloseAutoFocus, (x) => {
          var C;
          m.current || (C = p.triggerRef.current) == null || C.focus(), m.current = !1, x.preventDefault();
        }),
        onInteractOutside: mt(a.onInteractOutside, (x) => {
          const C = x.detail.originalEvent, E = C.button === 0 && C.ctrlKey === !0, R = C.button === 2 || E;
          (!p.modal || R) && (m.current = !0);
        }),
        style: {
          ...a.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
kO.displayName = DO;
var qF = "DropdownMenuGroup", XF = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
    return /* @__PURE__ */ D.jsx(jF, { ...p, ...f, ref: u });
  }
);
XF.displayName = qF;
var ZF = "DropdownMenuLabel", MO = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
    return /* @__PURE__ */ D.jsx(zF, { ...p, ...f, ref: u });
  }
);
MO.displayName = ZF;
var JF = "DropdownMenuItem", NO = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
    return /* @__PURE__ */ D.jsx(IF, { ...p, ...f, ref: u });
  }
);
NO.displayName = JF;
var eB = "DropdownMenuCheckboxItem", AO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(UF, { ...p, ...f, ref: u });
});
AO.displayName = eB;
var tB = "DropdownMenuRadioGroup", nB = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(FF, { ...p, ...f, ref: u });
});
nB.displayName = tB;
var rB = "DropdownMenuRadioItem", PO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(BF, { ...p, ...f, ref: u });
});
PO.displayName = rB;
var oB = "DropdownMenuItemIndicator", LO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(HF, { ...p, ...f, ref: u });
});
LO.displayName = oB;
var aB = "DropdownMenuSeparator", jO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx($F, { ...p, ...f, ref: u });
});
jO.displayName = aB;
var iB = "DropdownMenuArrow", lB = L.forwardRef(
  (a, u) => {
    const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
    return /* @__PURE__ */ D.jsx(VF, { ...p, ...f, ref: u });
  }
);
lB.displayName = iB;
var uB = "DropdownMenuSubTrigger", zO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(WF, { ...p, ...f, ref: u });
});
zO.displayName = uB;
var sB = "DropdownMenuSubContent", IO = L.forwardRef((a, u) => {
  const { __scopeDropdownMenu: s, ...f } = a, p = ho(s);
  return /* @__PURE__ */ D.jsx(
    YF,
    {
      ...p,
      ...f,
      ref: u,
      style: {
        ...a.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
IO.displayName = sB;
var cB = TO, fB = _O, dB = OO, UO = kO, FO = MO, BO = NO, HO = AO, $O = PO, VO = LO, WO = jO, YO = zO, GO = IO;
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pB = (a) => a.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), vB = (a) => a.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (u, s, f) => f ? f.toUpperCase() : s.toLowerCase()
), W1 = (a) => {
  const u = vB(a);
  return u.charAt(0).toUpperCase() + u.slice(1);
}, QO = (...a) => a.filter((u, s, f) => !!u && u.trim() !== "" && f.indexOf(u) === s).join(" ").trim();
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var hB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mB = qi(
  ({
    color: a = "currentColor",
    size: u = 24,
    strokeWidth: s = 2,
    absoluteStrokeWidth: f,
    className: p = "",
    children: h,
    iconNode: m,
    ...x
  }, C) => tC(
    "svg",
    {
      ref: C,
      ...hB,
      width: u,
      height: u,
      stroke: a,
      strokeWidth: f ? Number(s) * 24 / Number(u) : s,
      className: QO("lucide", p),
      ...x
    },
    [
      ...m.map(([E, R]) => tC(E, R)),
      ...Array.isArray(h) ? h : [h]
    ]
  )
);
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ox = (a, u) => {
  const s = qi(
    ({ className: f, ...p }, h) => tC(mB, {
      ref: h,
      iconNode: u,
      className: QO(
        `lucide-${pB(W1(a))}`,
        `lucide-${a}`,
        f
      ),
      ...p
    })
  );
  return s.displayName = W1(a), s;
};
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gB = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], yB = ox("check", gB);
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xB = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], SB = ox("chevron-down", xB);
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bB = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], CB = ox("chevron-right", bB);
/**
 * @license lucide-react v0.487.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EB = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], wB = ox("circle", EB);
function KO(a) {
  var u, s, f = "";
  if (typeof a == "string" || typeof a == "number") f += a;
  else if (typeof a == "object") if (Array.isArray(a)) for (u = 0; u < a.length; u++) a[u] && (s = KO(a[u])) && (f && (f += " "), f += s);
  else for (u in a) a[u] && (f && (f += " "), f += u);
  return f;
}
function TB() {
  for (var a, u, s = 0, f = ""; s < arguments.length; ) (a = arguments[s++]) && (u = KO(a)) && (f && (f += " "), f += u);
  return f;
}
function Un(...a) {
  return mC(TB(a));
}
const RB = cB, _B = fB, OB = L.forwardRef(({ className: a, inset: u, children: s, ...f }, p) => /* @__PURE__ */ D.jsxs(
  YO,
  {
    ref: p,
    className: Un(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      u && "pl-8",
      a
    ),
    ...f,
    children: [
      s,
      /* @__PURE__ */ D.jsx(CB, { className: "ml-auto" })
    ]
  }
));
OB.displayName = YO.displayName;
const DB = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  GO,
  {
    ref: s,
    className: Un(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]",
      a
    ),
    ...u
  }
));
DB.displayName = GO.displayName;
const qO = L.forwardRef(({ className: a, sideOffset: u = 4, ...s }, f) => /* @__PURE__ */ D.jsx(dB, { children: /* @__PURE__ */ D.jsx(
  UO,
  {
    ref: f,
    sideOffset: u,
    className: Un(
      "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]",
      a
    ),
    ...s
  }
) }));
qO.displayName = UO.displayName;
const XO = L.forwardRef(({ className: a, inset: u, ...s }, f) => /* @__PURE__ */ D.jsx(
  BO,
  {
    ref: f,
    className: Un(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0",
      u && "pl-8",
      a
    ),
    ...s
  }
));
XO.displayName = BO.displayName;
const kB = L.forwardRef(({ className: a, children: u, checked: s, ...f }, p) => /* @__PURE__ */ D.jsxs(
  HO,
  {
    ref: p,
    className: Un(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      a
    ),
    checked: s,
    ...f,
    children: [
      /* @__PURE__ */ D.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ D.jsx(VO, { children: /* @__PURE__ */ D.jsx(yB, { className: "h-4 w-4" }) }) }),
      u
    ]
  }
));
kB.displayName = HO.displayName;
const MB = L.forwardRef(({ className: a, children: u, ...s }, f) => /* @__PURE__ */ D.jsxs(
  $O,
  {
    ref: f,
    className: Un(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      a
    ),
    ...s,
    children: [
      /* @__PURE__ */ D.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ D.jsx(VO, { children: /* @__PURE__ */ D.jsx(wB, { className: "h-2 w-2 fill-current" }) }) }),
      u
    ]
  }
));
MB.displayName = $O.displayName;
const NB = L.forwardRef(({ className: a, inset: u, ...s }, f) => /* @__PURE__ */ D.jsx(
  FO,
  {
    ref: f,
    className: Un(
      "px-2 py-1.5 text-sm font-semibold",
      u && "pl-8",
      a
    ),
    ...s
  }
));
NB.displayName = FO.displayName;
const AB = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  WO,
  {
    ref: s,
    className: Un("-mx-1 my-1 h-px bg-muted", a),
    ...u
  }
));
AB.displayName = WO.displayName;
function K3({
  options: a,
  value: u,
  onChange: s,
  trigger: f,
  placeholder: p = "Select option",
  disabled: h = !1
}) {
  const m = Yi(
    () => a.find((x) => x.value === u),
    [a, u]
  );
  return /* @__PURE__ */ D.jsxs(RB, { children: [
    /* @__PURE__ */ D.jsx(
      _B,
      {
        disabled: h,
        className: Un(
          "ui-bg-white",
          "ui-border ui-rounded-md",
          "ui-text-sm ui-font-medium",
          "flex w-full items-center justify-between gap-2 px-3 py-2",
          "ui-focus:outline-none ui-focus:ring-2",
          "ui-disabled:opacity-50 ui-disabled:cursor-not-allowed ui-disabled:bg-gray-50 ui-disabled:text-gray-light"
        ),
        children: f || /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
          /* @__PURE__ */ D.jsx("span", { className: Un("truncate", h && "ui-text-gray-dark"), children: (m == null ? void 0 : m.title) || p }),
          /* @__PURE__ */ D.jsx(SB, { className: "w-4 h-4 opacity-50 shrink-0" })
        ] })
      }
    ),
    /* @__PURE__ */ D.jsx(
      qO,
      {
        align: "start",
        className: Un(
          "ui-w-[var(--radix-popper-anchor-width)]",
          "ui-overflow-auto ui-py-2",
          "ui-border ui-border-gray-200 ui-shadow-lg ui-bg-white"
        ),
        children: a.map((x, C) => /* @__PURE__ */ D.jsx(
          XO,
          {
            onClick: () => s(x.value),
            className: Un(
              "hover:ui-bg-gray-100 ui-bg-white ui-cursor-pointer py-2"
            ),
            children: x.node || /* @__PURE__ */ D.jsx("span", { className: "ui-text-sm ui-font-medium", children: x.title })
          },
          `${x.value}-${C}`
        ))
      }
    )
  ] });
}
var ax = "Collapsible", [PB, ZO] = Zl(ax), [LB, uE] = PB(ax), JO = L.forwardRef(
  (a, u) => {
    const {
      __scopeCollapsible: s,
      open: f,
      defaultOpen: p,
      disabled: h,
      onOpenChange: m,
      ...x
    } = a, [C, E] = Tc({
      prop: f,
      defaultProp: p ?? !1,
      onChange: m,
      caller: ax
    });
    return /* @__PURE__ */ D.jsx(
      LB,
      {
        scope: s,
        disabled: h,
        contentId: Yl(),
        open: C,
        onOpenToggle: L.useCallback(() => E((R) => !R), [E]),
        children: /* @__PURE__ */ D.jsx(
          an.div,
          {
            "data-state": cE(C),
            "data-disabled": h ? "" : void 0,
            ...x,
            ref: u
          }
        )
      }
    );
  }
);
JO.displayName = ax;
var eD = "CollapsibleTrigger", tD = L.forwardRef(
  (a, u) => {
    const { __scopeCollapsible: s, ...f } = a, p = uE(eD, s);
    return /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        "aria-controls": p.contentId,
        "aria-expanded": p.open || !1,
        "data-state": cE(p.open),
        "data-disabled": p.disabled ? "" : void 0,
        disabled: p.disabled,
        ...f,
        ref: u,
        onClick: mt(a.onClick, p.onOpenToggle)
      }
    );
  }
);
tD.displayName = eD;
var sE = "CollapsibleContent", nD = L.forwardRef(
  (a, u) => {
    const { forceMount: s, ...f } = a, p = uE(sE, a.__scopeCollapsible);
    return /* @__PURE__ */ D.jsx(oi, { present: s || p.open, children: ({ present: h }) => /* @__PURE__ */ D.jsx(jB, { ...f, ref: u, present: h }) });
  }
);
nD.displayName = sE;
var jB = L.forwardRef((a, u) => {
  const { __scopeCollapsible: s, present: f, children: p, ...h } = a, m = uE(sE, s), [x, C] = L.useState(f), E = L.useRef(null), R = Yn(u, E), T = L.useRef(0), O = T.current, N = L.useRef(0), j = N.current, k = m.open || x, A = L.useRef(k), z = L.useRef(void 0);
  return L.useEffect(() => {
    const F = requestAnimationFrame(() => A.current = !1);
    return () => cancelAnimationFrame(F);
  }, []), Ql(() => {
    const F = E.current;
    if (F) {
      z.current = z.current || {
        transitionDuration: F.style.transitionDuration,
        animationName: F.style.animationName
      }, F.style.transitionDuration = "0s", F.style.animationName = "none";
      const I = F.getBoundingClientRect();
      T.current = I.height, N.current = I.width, A.current || (F.style.transitionDuration = z.current.transitionDuration, F.style.animationName = z.current.animationName), C(f);
    }
  }, [m.open, f]), /* @__PURE__ */ D.jsx(
    an.div,
    {
      "data-state": cE(m.open),
      "data-disabled": m.disabled ? "" : void 0,
      id: m.contentId,
      hidden: !k,
      ...h,
      ref: R,
      style: {
        "--radix-collapsible-content-height": O ? `${O}px` : void 0,
        "--radix-collapsible-content-width": j ? `${j}px` : void 0,
        ...a.style
      },
      children: k && p
    }
  );
});
function cE(a) {
  return a ? "open" : "closed";
}
var zB = JO, IB = tD, UB = nD, ai = "Accordion", FB = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [fE, BB, HB] = BC(ai), [ix, q3] = Zl(ai, [
  HB,
  ZO
]), dE = ZO(), rD = ut.forwardRef(
  (a, u) => {
    const { type: s, ...f } = a, p = f, h = f;
    return /* @__PURE__ */ D.jsx(fE.Provider, { scope: a.__scopeAccordion, children: s === "multiple" ? /* @__PURE__ */ D.jsx(YB, { ...h, ref: u }) : /* @__PURE__ */ D.jsx(WB, { ...p, ref: u }) });
  }
);
rD.displayName = ai;
var [oD, $B] = ix(ai), [aD, VB] = ix(
  ai,
  { collapsible: !1 }
), WB = ut.forwardRef(
  (a, u) => {
    const {
      value: s,
      defaultValue: f,
      onValueChange: p = () => {
      },
      collapsible: h = !1,
      ...m
    } = a, [x, C] = Tc({
      prop: s,
      defaultProp: f ?? "",
      onChange: p,
      caller: ai
    });
    return /* @__PURE__ */ D.jsx(
      oD,
      {
        scope: a.__scopeAccordion,
        value: ut.useMemo(() => x ? [x] : [], [x]),
        onItemOpen: C,
        onItemClose: ut.useCallback(() => h && C(""), [h, C]),
        children: /* @__PURE__ */ D.jsx(aD, { scope: a.__scopeAccordion, collapsible: h, children: /* @__PURE__ */ D.jsx(iD, { ...m, ref: u }) })
      }
    );
  }
), YB = ut.forwardRef((a, u) => {
  const {
    value: s,
    defaultValue: f,
    onValueChange: p = () => {
    },
    ...h
  } = a, [m, x] = Tc({
    prop: s,
    defaultProp: f ?? [],
    onChange: p,
    caller: ai
  }), C = ut.useCallback(
    (R) => x((T = []) => [...T, R]),
    [x]
  ), E = ut.useCallback(
    (R) => x((T = []) => T.filter((O) => O !== R)),
    [x]
  );
  return /* @__PURE__ */ D.jsx(
    oD,
    {
      scope: a.__scopeAccordion,
      value: m,
      onItemOpen: C,
      onItemClose: E,
      children: /* @__PURE__ */ D.jsx(aD, { scope: a.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ D.jsx(iD, { ...h, ref: u }) })
    }
  );
}), [GB, lx] = ix(ai), iD = ut.forwardRef(
  (a, u) => {
    const { __scopeAccordion: s, disabled: f, dir: p, orientation: h = "vertical", ...m } = a, x = ut.useRef(null), C = Yn(x, u), E = BB(s), T = HC(p) === "ltr", O = mt(a.onKeyDown, (N) => {
      var pe;
      if (!FB.includes(N.key)) return;
      const j = N.target, k = E().filter((de) => {
        var me;
        return !((me = de.ref.current) != null && me.disabled);
      }), A = k.findIndex((de) => de.ref.current === j), z = k.length;
      if (A === -1) return;
      N.preventDefault();
      let F = A;
      const I = 0, V = z - 1, B = () => {
        F = A + 1, F > V && (F = I);
      }, ae = () => {
        F = A - 1, F < I && (F = V);
      };
      switch (N.key) {
        case "Home":
          F = I;
          break;
        case "End":
          F = V;
          break;
        case "ArrowRight":
          h === "horizontal" && (T ? B() : ae());
          break;
        case "ArrowDown":
          h === "vertical" && B();
          break;
        case "ArrowLeft":
          h === "horizontal" && (T ? ae() : B());
          break;
        case "ArrowUp":
          h === "vertical" && ae();
          break;
      }
      const Z = F % z;
      (pe = k[Z].ref.current) == null || pe.focus();
    });
    return /* @__PURE__ */ D.jsx(
      GB,
      {
        scope: s,
        disabled: f,
        direction: p,
        orientation: h,
        children: /* @__PURE__ */ D.jsx(fE.Slot, { scope: s, children: /* @__PURE__ */ D.jsx(
          an.div,
          {
            ...m,
            "data-orientation": h,
            ref: C,
            onKeyDown: f ? void 0 : O
          }
        ) })
      }
    );
  }
), Uy = "AccordionItem", [QB, pE] = ix(Uy), lD = ut.forwardRef(
  (a, u) => {
    const { __scopeAccordion: s, value: f, ...p } = a, h = lx(Uy, s), m = $B(Uy, s), x = dE(s), C = Yl(), E = f && m.value.includes(f) || !1, R = h.disabled || a.disabled;
    return /* @__PURE__ */ D.jsx(
      QB,
      {
        scope: s,
        open: E,
        disabled: R,
        triggerId: C,
        children: /* @__PURE__ */ D.jsx(
          zB,
          {
            "data-orientation": h.orientation,
            "data-state": pD(E),
            ...x,
            ...p,
            ref: u,
            disabled: R,
            open: E,
            onOpenChange: (T) => {
              T ? m.onItemOpen(f) : m.onItemClose(f);
            }
          }
        )
      }
    );
  }
);
lD.displayName = Uy;
var uD = "AccordionHeader", sD = ut.forwardRef(
  (a, u) => {
    const { __scopeAccordion: s, ...f } = a, p = lx(ai, s), h = pE(uD, s);
    return /* @__PURE__ */ D.jsx(
      an.h3,
      {
        "data-orientation": p.orientation,
        "data-state": pD(h.open),
        "data-disabled": h.disabled ? "" : void 0,
        ...f,
        ref: u
      }
    );
  }
);
sD.displayName = uD;
var TC = "AccordionTrigger", cD = ut.forwardRef(
  (a, u) => {
    const { __scopeAccordion: s, ...f } = a, p = lx(ai, s), h = pE(TC, s), m = VB(TC, s), x = dE(s);
    return /* @__PURE__ */ D.jsx(fE.ItemSlot, { scope: s, children: /* @__PURE__ */ D.jsx(
      IB,
      {
        "aria-disabled": h.open && !m.collapsible || void 0,
        "data-orientation": p.orientation,
        id: h.triggerId,
        ...x,
        ...f,
        ref: u
      }
    ) });
  }
);
cD.displayName = TC;
var fD = "AccordionContent", dD = ut.forwardRef(
  (a, u) => {
    const { __scopeAccordion: s, ...f } = a, p = lx(ai, s), h = pE(fD, s), m = dE(s);
    return /* @__PURE__ */ D.jsx(
      UB,
      {
        role: "region",
        "aria-labelledby": h.triggerId,
        "data-orientation": p.orientation,
        ...m,
        ...f,
        ref: u,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...a.style
        }
      }
    );
  }
);
dD.displayName = fD;
function pD(a) {
  return a ? "open" : "closed";
}
var KB = rD, qB = lD, XB = sD, vD = cD, hD = dD;
const X3 = KB, ZB = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  qB,
  {
    ref: s,
    className: Un("", a),
    ...u
  }
));
ZB.displayName = "AccordionItem";
const JB = L.forwardRef(({ className: a, children: u, ...s }, f) => /* @__PURE__ */ D.jsx(XB, { className: "flex", children: /* @__PURE__ */ D.jsx(
  vD,
  {
    ref: f,
    className: Un(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all  text-left [&[data-state=open]>svg]:rotate-180",
      a
    ),
    ...s,
    children: u
  }
) }));
JB.displayName = vD.displayName;
const e3 = L.forwardRef(({ className: a, children: u, ...s }, f) => /* @__PURE__ */ D.jsx(
  hD,
  {
    ref: f,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...s,
    children: /* @__PURE__ */ D.jsx("div", { className: Un("pb-4 pt-0", a), children: u })
  }
));
e3.displayName = hD.displayName;
var ux = "Popover", [mD, Z3] = Zl(ux, [
  Xy
]), Sh = Xy(), [t3, es] = mD(ux), gD = (a) => {
  const {
    __scopePopover: u,
    children: s,
    open: f,
    defaultOpen: p,
    onOpenChange: h,
    modal: m = !1
  } = a, x = Sh(u), C = L.useRef(null), [E, R] = L.useState(!1), [T, O] = Tc({
    prop: f,
    defaultProp: p ?? !1,
    onChange: h,
    caller: ux
  });
  return /* @__PURE__ */ D.jsx(I_, { ...x, children: /* @__PURE__ */ D.jsx(
    t3,
    {
      scope: u,
      contentId: Yl(),
      triggerRef: C,
      open: T,
      onOpenChange: O,
      onOpenToggle: L.useCallback(() => O((N) => !N), [O]),
      hasCustomAnchor: E,
      onCustomAnchorAdd: L.useCallback(() => R(!0), []),
      onCustomAnchorRemove: L.useCallback(() => R(!1), []),
      modal: m,
      children: s
    }
  ) });
};
gD.displayName = ux;
var yD = "PopoverAnchor", xD = L.forwardRef(
  (a, u) => {
    const { __scopePopover: s, ...f } = a, p = es(yD, s), h = Sh(s), { onCustomAnchorAdd: m, onCustomAnchorRemove: x } = p;
    return L.useEffect(() => (m(), () => x()), [m, x]), /* @__PURE__ */ D.jsx(JC, { ...h, ...f, ref: u });
  }
);
xD.displayName = yD;
var SD = "PopoverTrigger", bD = L.forwardRef(
  (a, u) => {
    const { __scopePopover: s, ...f } = a, p = es(SD, s), h = Sh(s), m = Yn(u, p.triggerRef), x = /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": p.open,
        "aria-controls": p.contentId,
        "data-state": RD(p.open),
        ...f,
        ref: m,
        onClick: mt(a.onClick, p.onOpenToggle)
      }
    );
    return p.hasCustomAnchor ? x : /* @__PURE__ */ D.jsx(JC, { asChild: !0, ...h, children: x });
  }
);
bD.displayName = SD;
var vE = "PopoverPortal", [n3, r3] = mD(vE, {
  forceMount: void 0
}), CD = (a) => {
  const { __scopePopover: u, forceMount: s, children: f, container: p } = a, h = es(vE, u);
  return /* @__PURE__ */ D.jsx(n3, { scope: u, forceMount: s, children: /* @__PURE__ */ D.jsx(oi, { present: s || h.open, children: /* @__PURE__ */ D.jsx(Zy, { asChild: !0, container: p, children: f }) }) });
};
CD.displayName = vE;
var Nd = "PopoverContent", ED = L.forwardRef(
  (a, u) => {
    const s = r3(Nd, a.__scopePopover), { forceMount: f = s.forceMount, ...p } = a, h = es(Nd, a.__scopePopover);
    return /* @__PURE__ */ D.jsx(oi, { present: f || h.open, children: h.modal ? /* @__PURE__ */ D.jsx(a3, { ...p, ref: u }) : /* @__PURE__ */ D.jsx(i3, { ...p, ref: u }) });
  }
);
ED.displayName = Nd;
var o3 = /* @__PURE__ */ kd("PopoverContent.RemoveScroll"), a3 = L.forwardRef(
  (a, u) => {
    const s = es(Nd, a.__scopePopover), f = L.useRef(null), p = Yn(u, f), h = L.useRef(!1);
    return L.useEffect(() => {
      const m = f.current;
      if (m) return eE(m);
    }, []), /* @__PURE__ */ D.jsx(ex, { as: o3, allowPinchZoom: !0, children: /* @__PURE__ */ D.jsx(
      wD,
      {
        ...a,
        ref: p,
        trapFocus: s.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: mt(a.onCloseAutoFocus, (m) => {
          var x;
          m.preventDefault(), h.current || (x = s.triggerRef.current) == null || x.focus();
        }),
        onPointerDownOutside: mt(
          a.onPointerDownOutside,
          (m) => {
            const x = m.detail.originalEvent, C = x.button === 0 && x.ctrlKey === !0, E = x.button === 2 || C;
            h.current = E;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: mt(
          a.onFocusOutside,
          (m) => m.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), i3 = L.forwardRef(
  (a, u) => {
    const s = es(Nd, a.__scopePopover), f = L.useRef(!1), p = L.useRef(!1);
    return /* @__PURE__ */ D.jsx(
      wD,
      {
        ...a,
        ref: u,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (h) => {
          var m, x;
          (m = a.onCloseAutoFocus) == null || m.call(a, h), h.defaultPrevented || (f.current || (x = s.triggerRef.current) == null || x.focus(), h.preventDefault()), f.current = !1, p.current = !1;
        },
        onInteractOutside: (h) => {
          var C, E;
          (C = a.onInteractOutside) == null || C.call(a, h), h.defaultPrevented || (f.current = !0, h.detail.originalEvent.type === "pointerdown" && (p.current = !0));
          const m = h.target;
          ((E = s.triggerRef.current) == null ? void 0 : E.contains(m)) && h.preventDefault(), h.detail.originalEvent.type === "focusin" && p.current && h.preventDefault();
        }
      }
    );
  }
), wD = L.forwardRef(
  (a, u) => {
    const {
      __scopePopover: s,
      trapFocus: f,
      onOpenAutoFocus: p,
      onCloseAutoFocus: h,
      disableOutsidePointerEvents: m,
      onEscapeKeyDown: x,
      onPointerDownOutside: C,
      onFocusOutside: E,
      onInteractOutside: R,
      ...T
    } = a, O = es(Nd, s), N = Sh(s);
    return $C(), /* @__PURE__ */ D.jsx(
      Gy,
      {
        asChild: !0,
        loop: !0,
        trapped: f,
        onMountAutoFocus: p,
        onUnmountAutoFocus: h,
        children: /* @__PURE__ */ D.jsx(
          Yy,
          {
            asChild: !0,
            disableOutsidePointerEvents: m,
            onInteractOutside: R,
            onEscapeKeyDown: x,
            onPointerDownOutside: C,
            onFocusOutside: E,
            onDismiss: () => O.onOpenChange(!1),
            children: /* @__PURE__ */ D.jsx(
              U_,
              {
                "data-state": RD(O.open),
                role: "dialog",
                id: O.contentId,
                ...N,
                ...T,
                ref: u,
                style: {
                  ...T.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), TD = "PopoverClose", l3 = L.forwardRef(
  (a, u) => {
    const { __scopePopover: s, ...f } = a, p = es(TD, s);
    return /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        ...f,
        ref: u,
        onClick: mt(a.onClick, () => p.onOpenChange(!1))
      }
    );
  }
);
l3.displayName = TD;
var u3 = "PopoverArrow", s3 = L.forwardRef(
  (a, u) => {
    const { __scopePopover: s, ...f } = a, p = Sh(s);
    return /* @__PURE__ */ D.jsx(F_, { ...p, ...f, ref: u });
  }
);
s3.displayName = u3;
function RD(a) {
  return a ? "open" : "closed";
}
var c3 = gD, f3 = xD, d3 = bD, p3 = CD, _D = ED;
const J3 = c3, e4 = d3, t4 = f3, v3 = L.forwardRef(({ className: a, align: u = "center", sideOffset: s = 4, ...f }, p) => /* @__PURE__ */ D.jsx(p3, { children: /* @__PURE__ */ D.jsx(
  _D,
  {
    ref: p,
    align: u,
    sideOffset: s,
    className: Un(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]",
      a
    ),
    ...f
  }
) }));
v3.displayName = _D.displayName;
var sx = "Dialog", [OD, n4] = Zl(sx), [h3, ii] = OD(sx), DD = (a) => {
  const {
    __scopeDialog: u,
    children: s,
    open: f,
    defaultOpen: p,
    onOpenChange: h,
    modal: m = !0
  } = a, x = L.useRef(null), C = L.useRef(null), [E, R] = Tc({
    prop: f,
    defaultProp: p ?? !1,
    onChange: h,
    caller: sx
  });
  return /* @__PURE__ */ D.jsx(
    h3,
    {
      scope: u,
      triggerRef: x,
      contentRef: C,
      contentId: Yl(),
      titleId: Yl(),
      descriptionId: Yl(),
      open: E,
      onOpenChange: R,
      onOpenToggle: L.useCallback(() => R((T) => !T), [R]),
      modal: m,
      children: s
    }
  );
};
DD.displayName = sx;
var kD = "DialogTrigger", MD = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, ...f } = a, p = ii(kD, s), h = Yn(u, p.triggerRef);
    return /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": p.open,
        "aria-controls": p.contentId,
        "data-state": gE(p.open),
        ...f,
        ref: h,
        onClick: mt(a.onClick, p.onOpenToggle)
      }
    );
  }
);
MD.displayName = kD;
var hE = "DialogPortal", [m3, ND] = OD(hE, {
  forceMount: void 0
}), AD = (a) => {
  const { __scopeDialog: u, forceMount: s, children: f, container: p } = a, h = ii(hE, u);
  return /* @__PURE__ */ D.jsx(m3, { scope: u, forceMount: s, children: L.Children.map(f, (m) => /* @__PURE__ */ D.jsx(oi, { present: s || h.open, children: /* @__PURE__ */ D.jsx(Zy, { asChild: !0, container: p, children: m }) })) });
};
AD.displayName = hE;
var Fy = "DialogOverlay", PD = L.forwardRef(
  (a, u) => {
    const s = ND(Fy, a.__scopeDialog), { forceMount: f = s.forceMount, ...p } = a, h = ii(Fy, a.__scopeDialog);
    return h.modal ? /* @__PURE__ */ D.jsx(oi, { present: f || h.open, children: /* @__PURE__ */ D.jsx(y3, { ...p, ref: u }) }) : null;
  }
);
PD.displayName = Fy;
var g3 = /* @__PURE__ */ kd("DialogOverlay.RemoveScroll"), y3 = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, ...f } = a, p = ii(Fy, s);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ D.jsx(ex, { as: g3, allowPinchZoom: !0, shards: [p.contentRef], children: /* @__PURE__ */ D.jsx(
        an.div,
        {
          "data-state": gE(p.open),
          ...f,
          ref: u,
          style: { pointerEvents: "auto", ...f.style }
        }
      ) })
    );
  }
), Ec = "DialogContent", LD = L.forwardRef(
  (a, u) => {
    const s = ND(Ec, a.__scopeDialog), { forceMount: f = s.forceMount, ...p } = a, h = ii(Ec, a.__scopeDialog);
    return /* @__PURE__ */ D.jsx(oi, { present: f || h.open, children: h.modal ? /* @__PURE__ */ D.jsx(x3, { ...p, ref: u }) : /* @__PURE__ */ D.jsx(S3, { ...p, ref: u }) });
  }
);
LD.displayName = Ec;
var x3 = L.forwardRef(
  (a, u) => {
    const s = ii(Ec, a.__scopeDialog), f = L.useRef(null), p = Yn(u, s.contentRef, f);
    return L.useEffect(() => {
      const h = f.current;
      if (h) return eE(h);
    }, []), /* @__PURE__ */ D.jsx(
      jD,
      {
        ...a,
        ref: p,
        trapFocus: s.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: mt(a.onCloseAutoFocus, (h) => {
          var m;
          h.preventDefault(), (m = s.triggerRef.current) == null || m.focus();
        }),
        onPointerDownOutside: mt(a.onPointerDownOutside, (h) => {
          const m = h.detail.originalEvent, x = m.button === 0 && m.ctrlKey === !0;
          (m.button === 2 || x) && h.preventDefault();
        }),
        onFocusOutside: mt(
          a.onFocusOutside,
          (h) => h.preventDefault()
        )
      }
    );
  }
), S3 = L.forwardRef(
  (a, u) => {
    const s = ii(Ec, a.__scopeDialog), f = L.useRef(!1), p = L.useRef(!1);
    return /* @__PURE__ */ D.jsx(
      jD,
      {
        ...a,
        ref: u,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (h) => {
          var m, x;
          (m = a.onCloseAutoFocus) == null || m.call(a, h), h.defaultPrevented || (f.current || (x = s.triggerRef.current) == null || x.focus(), h.preventDefault()), f.current = !1, p.current = !1;
        },
        onInteractOutside: (h) => {
          var C, E;
          (C = a.onInteractOutside) == null || C.call(a, h), h.defaultPrevented || (f.current = !0, h.detail.originalEvent.type === "pointerdown" && (p.current = !0));
          const m = h.target;
          ((E = s.triggerRef.current) == null ? void 0 : E.contains(m)) && h.preventDefault(), h.detail.originalEvent.type === "focusin" && p.current && h.preventDefault();
        }
      }
    );
  }
), jD = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, trapFocus: f, onOpenAutoFocus: p, onCloseAutoFocus: h, ...m } = a, x = ii(Ec, s), C = L.useRef(null), E = Yn(u, C);
    return $C(), /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      /* @__PURE__ */ D.jsx(
        Gy,
        {
          asChild: !0,
          loop: !0,
          trapped: f,
          onMountAutoFocus: p,
          onUnmountAutoFocus: h,
          children: /* @__PURE__ */ D.jsx(
            Yy,
            {
              role: "dialog",
              id: x.contentId,
              "aria-describedby": x.descriptionId,
              "aria-labelledby": x.titleId,
              "data-state": gE(x.open),
              ...m,
              ref: E,
              onDismiss: () => x.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
        /* @__PURE__ */ D.jsx(b3, { titleId: x.titleId }),
        /* @__PURE__ */ D.jsx(E3, { contentRef: C, descriptionId: x.descriptionId })
      ] })
    ] });
  }
), mE = "DialogTitle", zD = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, ...f } = a, p = ii(mE, s);
    return /* @__PURE__ */ D.jsx(an.h2, { id: p.titleId, ...f, ref: u });
  }
);
zD.displayName = mE;
var ID = "DialogDescription", UD = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, ...f } = a, p = ii(ID, s);
    return /* @__PURE__ */ D.jsx(an.p, { id: p.descriptionId, ...f, ref: u });
  }
);
UD.displayName = ID;
var FD = "DialogClose", BD = L.forwardRef(
  (a, u) => {
    const { __scopeDialog: s, ...f } = a, p = ii(FD, s);
    return /* @__PURE__ */ D.jsx(
      an.button,
      {
        type: "button",
        ...f,
        ref: u,
        onClick: mt(a.onClick, () => p.onOpenChange(!1))
      }
    );
  }
);
BD.displayName = FD;
function gE(a) {
  return a ? "open" : "closed";
}
var HD = "DialogTitleWarning", [r4, $D] = gz(HD, {
  contentName: Ec,
  titleName: mE,
  docsSlug: "dialog"
}), b3 = ({ titleId: a }) => {
  const u = $D(HD), s = `\`${u.contentName}\` requires a \`${u.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${u.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${u.docsSlug}`;
  return L.useEffect(() => {
    a && (document.getElementById(a) || console.error(s));
  }, [s, a]), null;
}, C3 = "DialogDescriptionWarning", E3 = ({ contentRef: a, descriptionId: u }) => {
  const f = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${$D(C3).contentName}}.`;
  return L.useEffect(() => {
    var h;
    const p = (h = a.current) == null ? void 0 : h.getAttribute("aria-describedby");
    u && p && (document.getElementById(u) || console.warn(f));
  }, [f, a, u]), null;
}, w3 = DD, T3 = MD, R3 = AD, VD = PD, WD = LD, YD = zD, GD = UD, QD = BD;
const o4 = w3, a4 = T3, _3 = R3, i4 = QD, KD = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  VD,
  {
    ref: s,
    className: Un(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      a
    ),
    ...u
  }
));
KD.displayName = VD.displayName;
const O3 = L.forwardRef(({ className: a, children: u, ...s }, f) => /* @__PURE__ */ D.jsxs(_3, { children: [
  /* @__PURE__ */ D.jsx(KD, {}),
  /* @__PURE__ */ D.jsxs(
    WD,
    {
      ref: f,
      className: Un(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 bg-background p-6 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        a
      ),
      ...s,
      children: [
        u,
        /* @__PURE__ */ D.jsx(QD, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: /* @__PURE__ */ D.jsx("span", { className: "sr-only", children: "Close" }) })
      ]
    }
  )
] }));
O3.displayName = WD.displayName;
const D3 = ({
  className: a,
  ...u
}) => /* @__PURE__ */ D.jsx(
  "div",
  {
    className: Un(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      a
    ),
    ...u
  }
);
D3.displayName = "DialogHeader";
const k3 = ({
  className: a,
  ...u
}) => /* @__PURE__ */ D.jsx(
  "div",
  {
    className: Un(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      a
    ),
    ...u
  }
);
k3.displayName = "DialogFooter";
const M3 = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  YD,
  {
    ref: s,
    className: Un(
      "text-lg font-semibold leading-none tracking-tight",
      a
    ),
    ...u
  }
));
M3.displayName = YD.displayName;
const N3 = L.forwardRef(({ className: a, ...u }, s) => /* @__PURE__ */ D.jsx(
  GD,
  {
    ref: s,
    className: Un("text-sm text-muted-foreground", a),
    ...u
  }
));
N3.displayName = GD.displayName;
export {
  X3 as Accordion,
  e3 as AccordionContent,
  ZB as AccordionItem,
  JB as AccordionTrigger,
  g2 as Carousel,
  mz as Checkbox,
  F3 as Confetti,
  ky as DEFAULT_PROGRESS_BAR,
  vj as DEFAULT_PROGRESS_BAR_AMOUNT_BASED,
  pj as DEFAULT_PROGRESS_BAR_COUNT_BASED,
  e_ as DeviceType,
  o4 as Dialog,
  i4 as DialogClose,
  O3 as DialogContent,
  N3 as DialogDescription,
  k3 as DialogFooter,
  D3 as DialogHeader,
  KD as DialogOverlay,
  _3 as DialogPortal,
  M3 as DialogTitle,
  a4 as DialogTrigger,
  K3 as Dropdown,
  o_ as FONT_FAMILY,
  Ea as FocusedComponentType,
  vh as FocusedVia,
  Y3 as GenericCarousel,
  c1 as MILESTONE_TO_ICON_MAPPER,
  gy as MILESTONE_TYPES,
  Gl as MilestoneCategory,
  NC as PROGRESS_BAR_CONFIGURATION,
  Sc as PROGRESS_BAR_TYPE,
  Td as PROGRESS_BAR_WIDTH,
  J3 as Popover,
  t4 as PopoverAnchor,
  v3 as PopoverContent,
  e4 as PopoverTrigger,
  _2 as Popup,
  Tj as PopupChildItem,
  $3 as PopupCoupon,
  V3 as PopupDiscountCardSkeleton,
  P2 as PopupPostLogin,
  dC as PopupWindow,
  U3 as ProgressBar,
  xj as ProgressBarContainer,
  bj as ProgressBarHeader,
  J1 as ProgressBarStep,
  Sj as ProgressBarSteps,
  UL as RupeeIcon,
  h1 as adjustPixelValue,
  Rj as cardStyleType,
  sh as getHtmlBannerText,
  a_ as getTextLength,
  mj as hexToRgba,
  dj as interpolateTemplate,
  hj as isLightColor,
  qu as isMobilePreviewMode,
  u2 as loadCustomFontFace,
  B3 as loadFontFaces,
  s1 as parseCartProgressBar,
  z3 as parseCartResponse,
  H3 as parsePopupFromBackend,
  I3 as parseProgressBarForBackend,
  W3 as shadeColor
};
